window.theme = window.theme || {};
/*================ Vendor ================*/
/*!
 * enquire.js v2.1.6 - Awesome Media Queries in JavaScript
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT */

!function(a){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=a();else if("function"==typeof define&&define.amd)define([],a);else{var b;b="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,b.enquire=a()}}(function(){return function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a,b){this.query=a,this.isUnconditional=b,this.handlers=[],this.mql=window.matchMedia(a);var c=this;this.listener=function(a){c.mql=a.currentTarget||a,c.assess()},this.mql.addListener(this.listener)}var e=a(3),f=a(4).each;d.prototype={constuctor:d,addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var b=this.handlers;f(b,function(c,d){if(c.equals(a))return c.destroy(),!b.splice(d,1)})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){f(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";f(this.handlers,function(b){b[a]()})}},b.exports=d},{3:3,4:4}],2:[function(a,b,c){function d(){if(!window.matchMedia)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!window.matchMedia("only all").matches}var e=a(1),f=a(4),g=f.each,h=f.isFunction,i=f.isArray;d.prototype={constructor:d,register:function(a,b,c){var d=this.queries,f=c&&this.browserIsIncapable;return d[a]||(d[a]=new e(a,f)),h(b)&&(b={match:b}),i(b)||(b=[b]),g(b,function(b){h(b)&&(b={match:b}),d[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},b.exports=d},{1:1,4:4}],3:[function(a,b,c){function d(a){this.options=a,!a.deferSetup&&this.setup()}d.prototype={constructor:d,setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},b.exports=d},{}],4:[function(a,b,c){function d(a,b){var c=0,d=a.length;for(c;c<d&&b(a[c],c)!==!1;c++);}function e(a){return"[object Array]"===Object.prototype.toString.apply(a)}function f(a){return"function"==typeof a}b.exports={isFunction:f,isArray:e,each:d}},{}],5:[function(a,b,c){var d=a(2);b.exports=new d},{2:2}]},{},[5])(5)});
/**
 * Swiper 11.0.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: February 27, 2024
 */

var Swiper=function(){"use strict";function e(e){return null!==e&&"object"==typeof e&&"constructor"in e&&e.constructor===Object}function t(s,a){void 0===s&&(s={}),void 0===a&&(a={}),Object.keys(a).forEach((i=>{void 0===s[i]?s[i]=a[i]:e(a[i])&&e(s[i])&&Object.keys(a[i]).length>0&&t(s[i],a[i])}))}const s={body:{},addEventListener(){},removeEventListener(){},activeElement:{blur(){},nodeName:""},querySelector:()=>null,querySelectorAll:()=>[],getElementById:()=>null,createEvent:()=>({initEvent(){}}),createElement:()=>({children:[],childNodes:[],style:{},setAttribute(){},getElementsByTagName:()=>[]}),createElementNS:()=>({}),importNode:()=>null,location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};function a(){const e="undefined"!=typeof document?document:{};return t(e,s),e}const i={document:s,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState(){},pushState(){},go(){},back(){}},CustomEvent:function(){return this},addEventListener(){},removeEventListener(){},getComputedStyle:()=>({getPropertyValue:()=>""}),Image(){},Date(){},screen:{},setTimeout(){},clearTimeout(){},matchMedia:()=>({}),requestAnimationFrame:e=>"undefined"==typeof setTimeout?(e(),null):setTimeout(e,0),cancelAnimationFrame(e){"undefined"!=typeof setTimeout&&clearTimeout(e)}};function r(){const e="undefined"!=typeof window?window:{};return t(e,i),e}function n(e){return void 0===e&&(e=""),e.trim().split(" ").filter((e=>!!e.trim()))}function l(e,t){return void 0===t&&(t=0),setTimeout(e,t)}function o(){return Date.now()}function d(e,t){void 0===t&&(t="x");const s=r();let a,i,n;const l=function(e){const t=r();let s;return t.getComputedStyle&&(s=t.getComputedStyle(e,null)),!s&&e.currentStyle&&(s=e.currentStyle),s||(s=e.style),s}(e);return s.WebKitCSSMatrix?(i=l.transform||l.webkitTransform,i.split(",").length>6&&(i=i.split(", ").map((e=>e.replace(",","."))).join(", ")),n=new s.WebKitCSSMatrix("none"===i?"":i)):(n=l.MozTransform||l.OTransform||l.MsTransform||l.msTransform||l.transform||l.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,"),a=n.toString().split(",")),"x"===t&&(i=s.WebKitCSSMatrix?n.m41:16===a.length?parseFloat(a[12]):parseFloat(a[4])),"y"===t&&(i=s.WebKitCSSMatrix?n.m42:16===a.length?parseFloat(a[13]):parseFloat(a[5])),i||0}function c(e){return"object"==typeof e&&null!==e&&e.constructor&&"Object"===Object.prototype.toString.call(e).slice(8,-1)}function p(){const e=Object(arguments.length<=0?void 0:arguments[0]),t=["__proto__","constructor","prototype"];for(let a=1;a<arguments.length;a+=1){const i=a<0||arguments.length<=a?void 0:arguments[a];if(null!=i&&(s=i,!("undefined"!=typeof window&&void 0!==window.HTMLElement?s instanceof HTMLElement:s&&(1===s.nodeType||11===s.nodeType)))){const s=Object.keys(Object(i)).filter((e=>t.indexOf(e)<0));for(let t=0,a=s.length;t<a;t+=1){const a=s[t],r=Object.getOwnPropertyDescriptor(i,a);void 0!==r&&r.enumerable&&(c(e[a])&&c(i[a])?i[a].__swiper__?e[a]=i[a]:p(e[a],i[a]):!c(e[a])&&c(i[a])?(e[a]={},i[a].__swiper__?e[a]=i[a]:p(e[a],i[a])):e[a]=i[a])}}}var s;return e}function u(e,t,s){e.style.setProperty(t,s)}function m(e){let{swiper:t,targetPosition:s,side:a}=e;const i=r(),n=-t.translate;let l,o=null;const d=t.params.speed;t.wrapperEl.style.scrollSnapType="none",i.cancelAnimationFrame(t.cssModeFrameID);const c=s>n?"next":"prev",p=(e,t)=>"next"===c&&e>=t||"prev"===c&&e<=t,u=()=>{l=(new Date).getTime(),null===o&&(o=l);const e=Math.max(Math.min((l-o)/d,1),0),r=.5-Math.cos(e*Math.PI)/2;let c=n+r*(s-n);if(p(c,s)&&(c=s),t.wrapperEl.scrollTo({[a]:c}),p(c,s))return t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.scrollSnapType="",setTimeout((()=>{t.wrapperEl.style.overflow="",t.wrapperEl.scrollTo({[a]:c})})),void i.cancelAnimationFrame(t.cssModeFrameID);t.cssModeFrameID=i.requestAnimationFrame(u)};u()}function h(e){return e.querySelector(".swiper-slide-transform")||e.shadowRoot&&e.shadowRoot.querySelector(".swiper-slide-transform")||e}function f(e,t){return void 0===t&&(t=""),[...e.children].filter((e=>e.matches(t)))}function g(e){try{return void console.warn(e)}catch(e){}}function v(e,t){void 0===t&&(t=[]);const s=document.createElement(e);return s.classList.add(...Array.isArray(t)?t:n(t)),s}function w(e){const t=r(),s=a(),i=e.getBoundingClientRect(),n=s.body,l=e.clientTop||n.clientTop||0,o=e.clientLeft||n.clientLeft||0,d=e===t?t.scrollY:e.scrollTop,c=e===t?t.scrollX:e.scrollLeft;return{top:i.top+d-l,left:i.left+c-o}}function b(e,t){return r().getComputedStyle(e,null).getPropertyValue(t)}function y(e){let t,s=e;if(s){for(t=0;null!==(s=s.previousSibling);)1===s.nodeType&&(t+=1);return t}}function E(e,t){const s=[];let a=e.parentElement;for(;a;)t?a.matches(t)&&s.push(a):s.push(a),a=a.parentElement;return s}function x(e,t){t&&e.addEventListener("transitionend",(function s(a){a.target===e&&(t.call(e,a),e.removeEventListener("transitionend",s))}))}function S(e,t,s){const a=r();return s?e["width"===t?"offsetWidth":"offsetHeight"]+parseFloat(a.getComputedStyle(e,null).getPropertyValue("width"===t?"margin-right":"margin-top"))+parseFloat(a.getComputedStyle(e,null).getPropertyValue("width"===t?"margin-left":"margin-bottom")):e.offsetWidth}function T(e){return(Array.isArray(e)?e:[e]).filter((e=>!!e))}let M,C,P;function L(){return M||(M=function(){const e=r(),t=a();return{smoothScroll:t.documentElement&&t.documentElement.style&&"scrollBehavior"in t.documentElement.style,touch:!!("ontouchstart"in e||e.DocumentTouch&&t instanceof e.DocumentTouch)}}()),M}function I(e){return void 0===e&&(e={}),C||(C=function(e){let{userAgent:t}=void 0===e?{}:e;const s=L(),a=r(),i=a.navigator.platform,n=t||a.navigator.userAgent,l={ios:!1,android:!1},o=a.screen.width,d=a.screen.height,c=n.match(/(Android);?[\s\/]+([\d.]+)?/);let p=n.match(/(iPad).*OS\s([\d_]+)/);const u=n.match(/(iPod)(.*OS\s([\d_]+))?/),m=!p&&n.match(/(iPhone\sOS|iOS)\s([\d_]+)/),h="Win32"===i;let f="MacIntel"===i;return!p&&f&&s.touch&&["1024x1366","1366x1024","834x1194","1194x834","834x1112","1112x834","768x1024","1024x768","820x1180","1180x820","810x1080","1080x810"].indexOf(`${o}x${d}`)>=0&&(p=n.match(/(Version)\/([\d.]+)/),p||(p=[0,1,"13_0_0"]),f=!1),c&&!h&&(l.os="android",l.android=!0),(p||m||u)&&(l.os="ios",l.ios=!0),l}(e)),C}function z(){return P||(P=function(){const e=r(),t=I();let s=!1;function a(){const t=e.navigator.userAgent.toLowerCase();return t.indexOf("safari")>=0&&t.indexOf("chrome")<0&&t.indexOf("android")<0}if(a()){const t=String(e.navigator.userAgent);if(t.includes("Version/")){const[e,a]=t.split("Version/")[1].split(" ")[0].split(".").map((e=>Number(e)));s=e<16||16===e&&a<2}}const i=/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent),n=a();return{isSafari:s||n,needPerspectiveFix:s,need3dFix:n||i&&t.ios,isWebView:i}}()),P}var A={on(e,t,s){const a=this;if(!a.eventsListeners||a.destroyed)return a;if("function"!=typeof t)return a;const i=s?"unshift":"push";return e.split(" ").forEach((e=>{a.eventsListeners[e]||(a.eventsListeners[e]=[]),a.eventsListeners[e][i](t)})),a},once(e,t,s){const a=this;if(!a.eventsListeners||a.destroyed)return a;if("function"!=typeof t)return a;function i(){a.off(e,i),i.__emitterProxy&&delete i.__emitterProxy;for(var s=arguments.length,r=new Array(s),n=0;n<s;n++)r[n]=arguments[n];t.apply(a,r)}return i.__emitterProxy=t,a.on(e,i,s)},onAny(e,t){const s=this;if(!s.eventsListeners||s.destroyed)return s;if("function"!=typeof e)return s;const a=t?"unshift":"push";return s.eventsAnyListeners.indexOf(e)<0&&s.eventsAnyListeners[a](e),s},offAny(e){const t=this;if(!t.eventsListeners||t.destroyed)return t;if(!t.eventsAnyListeners)return t;const s=t.eventsAnyListeners.indexOf(e);return s>=0&&t.eventsAnyListeners.splice(s,1),t},off(e,t){const s=this;return!s.eventsListeners||s.destroyed?s:s.eventsListeners?(e.split(" ").forEach((e=>{void 0===t?s.eventsListeners[e]=[]:s.eventsListeners[e]&&s.eventsListeners[e].forEach(((a,i)=>{(a===t||a.__emitterProxy&&a.__emitterProxy===t)&&s.eventsListeners[e].splice(i,1)}))})),s):s},emit(){const e=this;if(!e.eventsListeners||e.destroyed)return e;if(!e.eventsListeners)return e;let t,s,a;for(var i=arguments.length,r=new Array(i),n=0;n<i;n++)r[n]=arguments[n];"string"==typeof r[0]||Array.isArray(r[0])?(t=r[0],s=r.slice(1,r.length),a=e):(t=r[0].events,s=r[0].data,a=r[0].context||e),s.unshift(a);return(Array.isArray(t)?t:t.split(" ")).forEach((t=>{e.eventsAnyListeners&&e.eventsAnyListeners.length&&e.eventsAnyListeners.forEach((e=>{e.apply(a,[t,...s])})),e.eventsListeners&&e.eventsListeners[t]&&e.eventsListeners[t].forEach((e=>{e.apply(a,s)}))})),e}};const $=(e,t)=>{if(!e||e.destroyed||!e.params)return;const s=t.closest(e.isElement?"swiper-slide":`.${e.params.slideClass}`);if(s){let t=s.querySelector(`.${e.params.lazyPreloaderClass}`);!t&&e.isElement&&(s.shadowRoot?t=s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`):requestAnimationFrame((()=>{s.shadowRoot&&(t=s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`),t&&t.remove())}))),t&&t.remove()}},k=(e,t)=>{if(!e.slides[t])return;const s=e.slides[t].querySelector('[loading="lazy"]');s&&s.removeAttribute("loading")},O=e=>{if(!e||e.destroyed||!e.params)return;let t=e.params.lazyPreloadPrevNext;const s=e.slides.length;if(!s||!t||t<0)return;t=Math.min(t,s);const a="auto"===e.params.slidesPerView?e.slidesPerViewDynamic():Math.ceil(e.params.slidesPerView),i=e.activeIndex;if(e.params.grid&&e.params.grid.rows>1){const s=i,r=[s-t];return r.push(...Array.from({length:t}).map(((e,t)=>s+a+t))),void e.slides.forEach(((t,s)=>{r.includes(t.column)&&k(e,s)}))}const r=i+a-1;if(e.params.rewind||e.params.loop)for(let a=i-t;a<=r+t;a+=1){const t=(a%s+s)%s;(t<i||t>r)&&k(e,t)}else for(let a=Math.max(i-t,0);a<=Math.min(r+t,s-1);a+=1)a!==i&&(a>r||a<i)&&k(e,a)};var D={updateSize:function(){const e=this;let t,s;const a=e.el;t=void 0!==e.params.width&&null!==e.params.width?e.params.width:a.clientWidth,s=void 0!==e.params.height&&null!==e.params.height?e.params.height:a.clientHeight,0===t&&e.isHorizontal()||0===s&&e.isVertical()||(t=t-parseInt(b(a,"padding-left")||0,10)-parseInt(b(a,"padding-right")||0,10),s=s-parseInt(b(a,"padding-top")||0,10)-parseInt(b(a,"padding-bottom")||0,10),Number.isNaN(t)&&(t=0),Number.isNaN(s)&&(s=0),Object.assign(e,{width:t,height:s,size:e.isHorizontal()?t:s}))},updateSlides:function(){const e=this;function t(t,s){return parseFloat(t.getPropertyValue(e.getDirectionLabel(s))||0)}const s=e.params,{wrapperEl:a,slidesEl:i,size:r,rtlTranslate:n,wrongRTL:l}=e,o=e.virtual&&s.virtual.enabled,d=o?e.virtual.slides.length:e.slides.length,c=f(i,`.${e.params.slideClass}, swiper-slide`),p=o?e.virtual.slides.length:c.length;let m=[];const h=[],g=[];let v=s.slidesOffsetBefore;"function"==typeof v&&(v=s.slidesOffsetBefore.call(e));let w=s.slidesOffsetAfter;"function"==typeof w&&(w=s.slidesOffsetAfter.call(e));const y=e.snapGrid.length,E=e.slidesGrid.length;let x=s.spaceBetween,T=-v,M=0,C=0;if(void 0===r)return;"string"==typeof x&&x.indexOf("%")>=0?x=parseFloat(x.replace("%",""))/100*r:"string"==typeof x&&(x=parseFloat(x)),e.virtualSize=-x,c.forEach((e=>{n?e.style.marginLeft="":e.style.marginRight="",e.style.marginBottom="",e.style.marginTop=""})),s.centeredSlides&&s.cssMode&&(u(a,"--swiper-centered-offset-before",""),u(a,"--swiper-centered-offset-after",""));const P=s.grid&&s.grid.rows>1&&e.grid;let L;P?e.grid.initSlides(c):e.grid&&e.grid.unsetSlides();const I="auto"===s.slidesPerView&&s.breakpoints&&Object.keys(s.breakpoints).filter((e=>void 0!==s.breakpoints[e].slidesPerView)).length>0;for(let a=0;a<p;a+=1){let i;if(L=0,c[a]&&(i=c[a]),P&&e.grid.updateSlide(a,i,c),!c[a]||"none"!==b(i,"display")){if("auto"===s.slidesPerView){I&&(c[a].style[e.getDirectionLabel("width")]="");const r=getComputedStyle(i),n=i.style.transform,l=i.style.webkitTransform;if(n&&(i.style.transform="none"),l&&(i.style.webkitTransform="none"),s.roundLengths)L=e.isHorizontal()?S(i,"width",!0):S(i,"height",!0);else{const e=t(r,"width"),s=t(r,"padding-left"),a=t(r,"padding-right"),n=t(r,"margin-left"),l=t(r,"margin-right"),o=r.getPropertyValue("box-sizing");if(o&&"border-box"===o)L=e+n+l;else{const{clientWidth:t,offsetWidth:r}=i;L=e+s+a+n+l+(r-t)}}n&&(i.style.transform=n),l&&(i.style.webkitTransform=l),s.roundLengths&&(L=Math.floor(L))}else L=(r-(s.slidesPerView-1)*x)/s.slidesPerView,s.roundLengths&&(L=Math.floor(L)),c[a]&&(c[a].style[e.getDirectionLabel("width")]=`${L}px`);c[a]&&(c[a].swiperSlideSize=L),g.push(L),s.centeredSlides?(T=T+L/2+M/2+x,0===M&&0!==a&&(T=T-r/2-x),0===a&&(T=T-r/2-x),Math.abs(T)<.001&&(T=0),s.roundLengths&&(T=Math.floor(T)),C%s.slidesPerGroup==0&&m.push(T),h.push(T)):(s.roundLengths&&(T=Math.floor(T)),(C-Math.min(e.params.slidesPerGroupSkip,C))%e.params.slidesPerGroup==0&&m.push(T),h.push(T),T=T+L+x),e.virtualSize+=L+x,M=L,C+=1}}if(e.virtualSize=Math.max(e.virtualSize,r)+w,n&&l&&("slide"===s.effect||"coverflow"===s.effect)&&(a.style.width=`${e.virtualSize+x}px`),s.setWrapperSize&&(a.style[e.getDirectionLabel("width")]=`${e.virtualSize+x}px`),P&&e.grid.updateWrapperSize(L,m),!s.centeredSlides){const t=[];for(let a=0;a<m.length;a+=1){let i=m[a];s.roundLengths&&(i=Math.floor(i)),m[a]<=e.virtualSize-r&&t.push(i)}m=t,Math.floor(e.virtualSize-r)-Math.floor(m[m.length-1])>1&&m.push(e.virtualSize-r)}if(o&&s.loop){const t=g[0]+x;if(s.slidesPerGroup>1){const a=Math.ceil((e.virtual.slidesBefore+e.virtual.slidesAfter)/s.slidesPerGroup),i=t*s.slidesPerGroup;for(let e=0;e<a;e+=1)m.push(m[m.length-1]+i)}for(let a=0;a<e.virtual.slidesBefore+e.virtual.slidesAfter;a+=1)1===s.slidesPerGroup&&m.push(m[m.length-1]+t),h.push(h[h.length-1]+t),e.virtualSize+=t}if(0===m.length&&(m=[0]),0!==x){const t=e.isHorizontal()&&n?"marginLeft":e.getDirectionLabel("marginRight");c.filter(((e,t)=>!(s.cssMode&&!s.loop)||t!==c.length-1)).forEach((e=>{e.style[t]=`${x}px`}))}if(s.centeredSlides&&s.centeredSlidesBounds){let e=0;g.forEach((t=>{e+=t+(x||0)})),e-=x;const t=e-r;m=m.map((e=>e<=0?-v:e>t?t+w:e))}if(s.centerInsufficientSlides){let e=0;if(g.forEach((t=>{e+=t+(x||0)})),e-=x,e<r){const t=(r-e)/2;m.forEach(((e,s)=>{m[s]=e-t})),h.forEach(((e,s)=>{h[s]=e+t}))}}if(Object.assign(e,{slides:c,snapGrid:m,slidesGrid:h,slidesSizesGrid:g}),s.centeredSlides&&s.cssMode&&!s.centeredSlidesBounds){u(a,"--swiper-centered-offset-before",-m[0]+"px"),u(a,"--swiper-centered-offset-after",e.size/2-g[g.length-1]/2+"px");const t=-e.snapGrid[0],s=-e.slidesGrid[0];e.snapGrid=e.snapGrid.map((e=>e+t)),e.slidesGrid=e.slidesGrid.map((e=>e+s))}if(p!==d&&e.emit("slidesLengthChange"),m.length!==y&&(e.params.watchOverflow&&e.checkOverflow(),e.emit("snapGridLengthChange")),h.length!==E&&e.emit("slidesGridLengthChange"),s.watchSlidesProgress&&e.updateSlidesOffset(),e.emit("slidesUpdated"),!(o||s.cssMode||"slide"!==s.effect&&"fade"!==s.effect)){const t=`${s.containerModifierClass}backface-hidden`,a=e.el.classList.contains(t);p<=s.maxBackfaceHiddenSlides?a||e.el.classList.add(t):a&&e.el.classList.remove(t)}},updateAutoHeight:function(e){const t=this,s=[],a=t.virtual&&t.params.virtual.enabled;let i,r=0;"number"==typeof e?t.setTransition(e):!0===e&&t.setTransition(t.params.speed);const n=e=>a?t.slides[t.getSlideIndexByData(e)]:t.slides[e];if("auto"!==t.params.slidesPerView&&t.params.slidesPerView>1)if(t.params.centeredSlides)(t.visibleSlides||[]).forEach((e=>{s.push(e)}));else for(i=0;i<Math.ceil(t.params.slidesPerView);i+=1){const e=t.activeIndex+i;if(e>t.slides.length&&!a)break;s.push(n(e))}else s.push(n(t.activeIndex));for(i=0;i<s.length;i+=1)if(void 0!==s[i]){const e=s[i].offsetHeight;r=e>r?e:r}(r||0===r)&&(t.wrapperEl.style.height=`${r}px`)},updateSlidesOffset:function(){const e=this,t=e.slides,s=e.isElement?e.isHorizontal()?e.wrapperEl.offsetLeft:e.wrapperEl.offsetTop:0;for(let a=0;a<t.length;a+=1)t[a].swiperSlideOffset=(e.isHorizontal()?t[a].offsetLeft:t[a].offsetTop)-s-e.cssOverflowAdjustment()},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);const t=this,s=t.params,{slides:a,rtlTranslate:i,snapGrid:r}=t;if(0===a.length)return;void 0===a[0].swiperSlideOffset&&t.updateSlidesOffset();let n=-e;i&&(n=e),a.forEach((e=>{e.classList.remove(s.slideVisibleClass,s.slideFullyVisibleClass)})),t.visibleSlidesIndexes=[],t.visibleSlides=[];let l=s.spaceBetween;"string"==typeof l&&l.indexOf("%")>=0?l=parseFloat(l.replace("%",""))/100*t.size:"string"==typeof l&&(l=parseFloat(l));for(let e=0;e<a.length;e+=1){const o=a[e];let d=o.swiperSlideOffset;s.cssMode&&s.centeredSlides&&(d-=a[0].swiperSlideOffset);const c=(n+(s.centeredSlides?t.minTranslate():0)-d)/(o.swiperSlideSize+l),p=(n-r[0]+(s.centeredSlides?t.minTranslate():0)-d)/(o.swiperSlideSize+l),u=-(n-d),m=u+t.slidesSizesGrid[e],h=u>=0&&u<=t.size-t.slidesSizesGrid[e];(u>=0&&u<t.size-1||m>1&&m<=t.size||u<=0&&m>=t.size)&&(t.visibleSlides.push(o),t.visibleSlidesIndexes.push(e),a[e].classList.add(s.slideVisibleClass)),h&&a[e].classList.add(s.slideFullyVisibleClass),o.progress=i?-c:c,o.originalProgress=i?-p:p}},updateProgress:function(e){const t=this;if(void 0===e){const s=t.rtlTranslate?-1:1;e=t&&t.translate&&t.translate*s||0}const s=t.params,a=t.maxTranslate()-t.minTranslate();let{progress:i,isBeginning:r,isEnd:n,progressLoop:l}=t;const o=r,d=n;if(0===a)i=0,r=!0,n=!0;else{i=(e-t.minTranslate())/a;const s=Math.abs(e-t.minTranslate())<1,l=Math.abs(e-t.maxTranslate())<1;r=s||i<=0,n=l||i>=1,s&&(i=0),l&&(i=1)}if(s.loop){const s=t.getSlideIndexByData(0),a=t.getSlideIndexByData(t.slides.length-1),i=t.slidesGrid[s],r=t.slidesGrid[a],n=t.slidesGrid[t.slidesGrid.length-1],o=Math.abs(e);l=o>=i?(o-i)/n:(o+n-r)/n,l>1&&(l-=1)}Object.assign(t,{progress:i,progressLoop:l,isBeginning:r,isEnd:n}),(s.watchSlidesProgress||s.centeredSlides&&s.autoHeight)&&t.updateSlidesProgress(e),r&&!o&&t.emit("reachBeginning toEdge"),n&&!d&&t.emit("reachEnd toEdge"),(o&&!r||d&&!n)&&t.emit("fromEdge"),t.emit("progress",i)},updateSlidesClasses:function(){const e=this,{slides:t,params:s,slidesEl:a,activeIndex:i}=e,r=e.virtual&&s.virtual.enabled,n=e.grid&&s.grid&&s.grid.rows>1,l=e=>f(a,`.${s.slideClass}${e}, swiper-slide${e}`)[0];let o,d,c;if(t.forEach((e=>{e.classList.remove(s.slideActiveClass,s.slideNextClass,s.slidePrevClass)})),r)if(s.loop){let t=i-e.virtual.slidesBefore;t<0&&(t=e.virtual.slides.length+t),t>=e.virtual.slides.length&&(t-=e.virtual.slides.length),o=l(`[data-swiper-slide-index="${t}"]`)}else o=l(`[data-swiper-slide-index="${i}"]`);else n?(o=t.filter((e=>e.column===i))[0],c=t.filter((e=>e.column===i+1))[0],d=t.filter((e=>e.column===i-1))[0]):o=t[i];o&&(o.classList.add(s.slideActiveClass),n?(c&&c.classList.add(s.slideNextClass),d&&d.classList.add(s.slidePrevClass)):(c=function(e,t){const s=[];for(;e.nextElementSibling;){const a=e.nextElementSibling;t?a.matches(t)&&s.push(a):s.push(a),e=a}return s}(o,`.${s.slideClass}, swiper-slide`)[0],s.loop&&!c&&(c=t[0]),c&&c.classList.add(s.slideNextClass),d=function(e,t){const s=[];for(;e.previousElementSibling;){const a=e.previousElementSibling;t?a.matches(t)&&s.push(a):s.push(a),e=a}return s}(o,`.${s.slideClass}, swiper-slide`)[0],s.loop&&0===!d&&(d=t[t.length-1]),d&&d.classList.add(s.slidePrevClass))),e.emitSlidesClasses()},updateActiveIndex:function(e){const t=this,s=t.rtlTranslate?t.translate:-t.translate,{snapGrid:a,params:i,activeIndex:r,realIndex:n,snapIndex:l}=t;let o,d=e;const c=e=>{let s=e-t.virtual.slidesBefore;return s<0&&(s=t.virtual.slides.length+s),s>=t.virtual.slides.length&&(s-=t.virtual.slides.length),s};if(void 0===d&&(d=function(e){const{slidesGrid:t,params:s}=e,a=e.rtlTranslate?e.translate:-e.translate;let i;for(let e=0;e<t.length;e+=1)void 0!==t[e+1]?a>=t[e]&&a<t[e+1]-(t[e+1]-t[e])/2?i=e:a>=t[e]&&a<t[e+1]&&(i=e+1):a>=t[e]&&(i=e);return s.normalizeSlideIndex&&(i<0||void 0===i)&&(i=0),i}(t)),a.indexOf(s)>=0)o=a.indexOf(s);else{const e=Math.min(i.slidesPerGroupSkip,d);o=e+Math.floor((d-e)/i.slidesPerGroup)}if(o>=a.length&&(o=a.length-1),d===r&&!t.params.loop)return void(o!==l&&(t.snapIndex=o,t.emit("snapIndexChange")));if(d===r&&t.params.loop&&t.virtual&&t.params.virtual.enabled)return void(t.realIndex=c(d));const p=t.grid&&i.grid&&i.grid.rows>1;let u;if(t.virtual&&i.virtual.enabled&&i.loop)u=c(d);else if(p){const e=t.slides.filter((e=>e.column===d))[0];let s=parseInt(e.getAttribute("data-swiper-slide-index"),10);Number.isNaN(s)&&(s=Math.max(t.slides.indexOf(e),0)),u=Math.floor(s/i.grid.rows)}else if(t.slides[d]){const e=t.slides[d].getAttribute("data-swiper-slide-index");u=e?parseInt(e,10):d}else u=d;Object.assign(t,{previousSnapIndex:l,snapIndex:o,previousRealIndex:n,realIndex:u,previousIndex:r,activeIndex:d}),t.initialized&&O(t),t.emit("activeIndexChange"),t.emit("snapIndexChange"),(t.initialized||t.params.runCallbacksOnInit)&&(n!==u&&t.emit("realIndexChange"),t.emit("slideChange"))},updateClickedSlide:function(e,t){const s=this,a=s.params;let i=e.closest(`.${a.slideClass}, swiper-slide`);!i&&s.isElement&&t&&t.length>1&&t.includes(e)&&[...t.slice(t.indexOf(e)+1,t.length)].forEach((e=>{!i&&e.matches&&e.matches(`.${a.slideClass}, swiper-slide`)&&(i=e)}));let r,n=!1;if(i)for(let e=0;e<s.slides.length;e+=1)if(s.slides[e]===i){n=!0,r=e;break}if(!i||!n)return s.clickedSlide=void 0,void(s.clickedIndex=void 0);s.clickedSlide=i,s.virtual&&s.params.virtual.enabled?s.clickedIndex=parseInt(i.getAttribute("data-swiper-slide-index"),10):s.clickedIndex=r,a.slideToClickedSlide&&void 0!==s.clickedIndex&&s.clickedIndex!==s.activeIndex&&s.slideToClickedSlide()}};var G={getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");const{params:t,rtlTranslate:s,translate:a,wrapperEl:i}=this;if(t.virtualTranslate)return s?-a:a;if(t.cssMode)return a;let r=d(i,e);return r+=this.cssOverflowAdjustment(),s&&(r=-r),r||0},setTranslate:function(e,t){const s=this,{rtlTranslate:a,params:i,wrapperEl:r,progress:n}=s;let l,o=0,d=0;s.isHorizontal()?o=a?-e:e:d=e,i.roundLengths&&(o=Math.floor(o),d=Math.floor(d)),s.previousTranslate=s.translate,s.translate=s.isHorizontal()?o:d,i.cssMode?r[s.isHorizontal()?"scrollLeft":"scrollTop"]=s.isHorizontal()?-o:-d:i.virtualTranslate||(s.isHorizontal()?o-=s.cssOverflowAdjustment():d-=s.cssOverflowAdjustment(),r.style.transform=`translate3d(${o}px, ${d}px, 0px)`);const c=s.maxTranslate()-s.minTranslate();l=0===c?0:(e-s.minTranslate())/c,l!==n&&s.updateProgress(e),s.emit("setTranslate",s.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,s,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),void 0===a&&(a=!0);const r=this,{params:n,wrapperEl:l}=r;if(r.animating&&n.preventInteractionOnTransition)return!1;const o=r.minTranslate(),d=r.maxTranslate();let c;if(c=a&&e>o?o:a&&e<d?d:e,r.updateProgress(c),n.cssMode){const e=r.isHorizontal();if(0===t)l[e?"scrollLeft":"scrollTop"]=-c;else{if(!r.support.smoothScroll)return m({swiper:r,targetPosition:-c,side:e?"left":"top"}),!0;l.scrollTo({[e?"left":"top"]:-c,behavior:"smooth"})}return!0}return 0===t?(r.setTransition(0),r.setTranslate(c),s&&(r.emit("beforeTransitionStart",t,i),r.emit("transitionEnd"))):(r.setTransition(t),r.setTranslate(c),s&&(r.emit("beforeTransitionStart",t,i),r.emit("transitionStart")),r.animating||(r.animating=!0,r.onTranslateToWrapperTransitionEnd||(r.onTranslateToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.wrapperEl.removeEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.onTranslateToWrapperTransitionEnd=null,delete r.onTranslateToWrapperTransitionEnd,s&&r.emit("transitionEnd"))}),r.wrapperEl.addEventListener("transitionend",r.onTranslateToWrapperTransitionEnd))),!0}};function N(e){let{swiper:t,runCallbacks:s,direction:a,step:i}=e;const{activeIndex:r,previousIndex:n}=t;let l=a;if(l||(l=r>n?"next":r<n?"prev":"reset"),t.emit(`transition${i}`),s&&r!==n){if("reset"===l)return void t.emit(`slideResetTransition${i}`);t.emit(`slideChangeTransition${i}`),"next"===l?t.emit(`slideNextTransition${i}`):t.emit(`slidePrevTransition${i}`)}}var H={slideTo:function(e,t,s,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),"string"==typeof e&&(e=parseInt(e,10));const r=this;let n=e;n<0&&(n=0);const{params:l,snapGrid:o,slidesGrid:d,previousIndex:c,activeIndex:p,rtlTranslate:u,wrapperEl:h,enabled:f}=r;if(r.animating&&l.preventInteractionOnTransition||!f&&!a&&!i||r.destroyed)return!1;const g=Math.min(r.params.slidesPerGroupSkip,n);let v=g+Math.floor((n-g)/r.params.slidesPerGroup);v>=o.length&&(v=o.length-1);const w=-o[v];if(l.normalizeSlideIndex)for(let e=0;e<d.length;e+=1){const t=-Math.floor(100*w),s=Math.floor(100*d[e]),a=Math.floor(100*d[e+1]);void 0!==d[e+1]?t>=s&&t<a-(a-s)/2?n=e:t>=s&&t<a&&(n=e+1):t>=s&&(n=e)}if(r.initialized&&n!==p){if(!r.allowSlideNext&&(u?w>r.translate&&w>r.minTranslate():w<r.translate&&w<r.minTranslate()))return!1;if(!r.allowSlidePrev&&w>r.translate&&w>r.maxTranslate()&&(p||0)!==n)return!1}let b;if(n!==(c||0)&&s&&r.emit("beforeSlideChangeStart"),r.updateProgress(w),b=n>p?"next":n<p?"prev":"reset",u&&-w===r.translate||!u&&w===r.translate)return r.updateActiveIndex(n),l.autoHeight&&r.updateAutoHeight(),r.updateSlidesClasses(),"slide"!==l.effect&&r.setTranslate(w),"reset"!==b&&(r.transitionStart(s,b),r.transitionEnd(s,b)),!1;if(l.cssMode){const e=r.isHorizontal(),s=u?w:-w;if(0===t){const t=r.virtual&&r.params.virtual.enabled;t&&(r.wrapperEl.style.scrollSnapType="none",r._immediateVirtual=!0),t&&!r._cssModeVirtualInitialSet&&r.params.initialSlide>0?(r._cssModeVirtualInitialSet=!0,requestAnimationFrame((()=>{h[e?"scrollLeft":"scrollTop"]=s}))):h[e?"scrollLeft":"scrollTop"]=s,t&&requestAnimationFrame((()=>{r.wrapperEl.style.scrollSnapType="",r._immediateVirtual=!1}))}else{if(!r.support.smoothScroll)return m({swiper:r,targetPosition:s,side:e?"left":"top"}),!0;h.scrollTo({[e?"left":"top"]:s,behavior:"smooth"})}return!0}return r.setTransition(t),r.setTranslate(w),r.updateActiveIndex(n),r.updateSlidesClasses(),r.emit("beforeTransitionStart",t,a),r.transitionStart(s,b),0===t?r.transitionEnd(s,b):r.animating||(r.animating=!0,r.onSlideToWrapperTransitionEnd||(r.onSlideToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.wrapperEl.removeEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.onSlideToWrapperTransitionEnd=null,delete r.onSlideToWrapperTransitionEnd,r.transitionEnd(s,b))}),r.wrapperEl.addEventListener("transitionend",r.onSlideToWrapperTransitionEnd)),!0},slideToLoop:function(e,t,s,a){if(void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),"string"==typeof e){e=parseInt(e,10)}const i=this;if(i.destroyed)return;const r=i.grid&&i.params.grid&&i.params.grid.rows>1;let n=e;if(i.params.loop)if(i.virtual&&i.params.virtual.enabled)n+=i.virtual.slidesBefore;else{let e;if(r){const t=n*i.params.grid.rows;e=i.slides.filter((e=>1*e.getAttribute("data-swiper-slide-index")===t))[0].column}else e=i.getSlideIndexByData(n);const t=r?Math.ceil(i.slides.length/i.params.grid.rows):i.slides.length,{centeredSlides:s}=i.params;let a=i.params.slidesPerView;"auto"===a?a=i.slidesPerViewDynamic():(a=Math.ceil(parseFloat(i.params.slidesPerView,10)),s&&a%2==0&&(a+=1));let l=t-e<a;if(s&&(l=l||e<Math.ceil(a/2)),l){const a=s?e<i.activeIndex?"prev":"next":e-i.activeIndex-1<i.params.slidesPerView?"next":"prev";i.loopFix({direction:a,slideTo:!0,activeSlideIndex:"next"===a?e+1:e-t+1,slideRealIndex:"next"===a?i.realIndex:void 0})}if(r){const e=n*i.params.grid.rows;n=i.slides.filter((t=>1*t.getAttribute("data-swiper-slide-index")===e))[0].column}else n=i.getSlideIndexByData(n)}return requestAnimationFrame((()=>{i.slideTo(n,t,s,a)})),i},slideNext:function(e,t,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const a=this,{enabled:i,params:r,animating:n}=a;if(!i||a.destroyed)return a;let l=r.slidesPerGroup;"auto"===r.slidesPerView&&1===r.slidesPerGroup&&r.slidesPerGroupAuto&&(l=Math.max(a.slidesPerViewDynamic("current",!0),1));const o=a.activeIndex<r.slidesPerGroupSkip?1:l,d=a.virtual&&r.virtual.enabled;if(r.loop){if(n&&!d&&r.loopPreventsSliding)return!1;if(a.loopFix({direction:"next"}),a._clientLeft=a.wrapperEl.clientLeft,a.activeIndex===a.slides.length-1&&r.cssMode)return requestAnimationFrame((()=>{a.slideTo(a.activeIndex+o,e,t,s)})),!0}return r.rewind&&a.isEnd?a.slideTo(0,e,t,s):a.slideTo(a.activeIndex+o,e,t,s)},slidePrev:function(e,t,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const a=this,{params:i,snapGrid:r,slidesGrid:n,rtlTranslate:l,enabled:o,animating:d}=a;if(!o||a.destroyed)return a;const c=a.virtual&&i.virtual.enabled;if(i.loop){if(d&&!c&&i.loopPreventsSliding)return!1;a.loopFix({direction:"prev"}),a._clientLeft=a.wrapperEl.clientLeft}function p(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}const u=p(l?a.translate:-a.translate),m=r.map((e=>p(e)));let h=r[m.indexOf(u)-1];if(void 0===h&&i.cssMode){let e;r.forEach(((t,s)=>{u>=t&&(e=s)})),void 0!==e&&(h=r[e>0?e-1:e])}let f=0;if(void 0!==h&&(f=n.indexOf(h),f<0&&(f=a.activeIndex-1),"auto"===i.slidesPerView&&1===i.slidesPerGroup&&i.slidesPerGroupAuto&&(f=f-a.slidesPerViewDynamic("previous",!0)+1,f=Math.max(f,0))),i.rewind&&a.isBeginning){const i=a.params.virtual&&a.params.virtual.enabled&&a.virtual?a.virtual.slides.length-1:a.slides.length-1;return a.slideTo(i,e,t,s)}return i.loop&&0===a.activeIndex&&i.cssMode?(requestAnimationFrame((()=>{a.slideTo(f,e,t,s)})),!0):a.slideTo(f,e,t,s)},slideReset:function(e,t,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const a=this;if(!a.destroyed)return a.slideTo(a.activeIndex,e,t,s)},slideToClosest:function(e,t,s,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===a&&(a=.5);const i=this;if(i.destroyed)return;let r=i.activeIndex;const n=Math.min(i.params.slidesPerGroupSkip,r),l=n+Math.floor((r-n)/i.params.slidesPerGroup),o=i.rtlTranslate?i.translate:-i.translate;if(o>=i.snapGrid[l]){const e=i.snapGrid[l];o-e>(i.snapGrid[l+1]-e)*a&&(r+=i.params.slidesPerGroup)}else{const e=i.snapGrid[l-1];o-e<=(i.snapGrid[l]-e)*a&&(r-=i.params.slidesPerGroup)}return r=Math.max(r,0),r=Math.min(r,i.slidesGrid.length-1),i.slideTo(r,e,t,s)},slideToClickedSlide:function(){const e=this;if(e.destroyed)return;const{params:t,slidesEl:s}=e,a="auto"===t.slidesPerView?e.slidesPerViewDynamic():t.slidesPerView;let i,r=e.clickedIndex;const n=e.isElement?"swiper-slide":`.${t.slideClass}`;if(t.loop){if(e.animating)return;i=parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"),10),t.centeredSlides?r<e.loopedSlides-a/2||r>e.slides.length-e.loopedSlides+a/2?(e.loopFix(),r=e.getSlideIndex(f(s,`${n}[data-swiper-slide-index="${i}"]`)[0]),l((()=>{e.slideTo(r)}))):e.slideTo(r):r>e.slides.length-a?(e.loopFix(),r=e.getSlideIndex(f(s,`${n}[data-swiper-slide-index="${i}"]`)[0]),l((()=>{e.slideTo(r)}))):e.slideTo(r)}else e.slideTo(r)}};var X={loopCreate:function(e){const t=this,{params:s,slidesEl:a}=t;if(!s.loop||t.virtual&&t.params.virtual.enabled)return;const i=()=>{f(a,`.${s.slideClass}, swiper-slide`).forEach(((e,t)=>{e.setAttribute("data-swiper-slide-index",t)}))},r=t.grid&&s.grid&&s.grid.rows>1,n=s.slidesPerGroup*(r?s.grid.rows:1),l=t.slides.length%n!=0,o=r&&t.slides.length%s.grid.rows!=0,d=e=>{for(let a=0;a<e;a+=1){const e=t.isElement?v("swiper-slide",[s.slideBlankClass]):v("div",[s.slideClass,s.slideBlankClass]);t.slidesEl.append(e)}};if(l){if(s.loopAddBlankSlides){d(n-t.slides.length%n),t.recalcSlides(),t.updateSlides()}else g("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");i()}else if(o){if(s.loopAddBlankSlides){d(s.grid.rows-t.slides.length%s.grid.rows),t.recalcSlides(),t.updateSlides()}else g("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");i()}else i();t.loopFix({slideRealIndex:e,direction:s.centeredSlides?void 0:"next"})},loopFix:function(e){let{slideRealIndex:t,slideTo:s=!0,direction:a,setTranslate:i,activeSlideIndex:r,byController:n,byMousewheel:l}=void 0===e?{}:e;const o=this;if(!o.params.loop)return;o.emit("beforeLoopFix");const{slides:d,allowSlidePrev:c,allowSlideNext:p,slidesEl:u,params:m}=o,{centeredSlides:h}=m;if(o.allowSlidePrev=!0,o.allowSlideNext=!0,o.virtual&&m.virtual.enabled)return s&&(m.centeredSlides||0!==o.snapIndex?m.centeredSlides&&o.snapIndex<m.slidesPerView?o.slideTo(o.virtual.slides.length+o.snapIndex,0,!1,!0):o.snapIndex===o.snapGrid.length-1&&o.slideTo(o.virtual.slidesBefore,0,!1,!0):o.slideTo(o.virtual.slides.length,0,!1,!0)),o.allowSlidePrev=c,o.allowSlideNext=p,void o.emit("loopFix");let f=m.slidesPerView;"auto"===f?f=o.slidesPerViewDynamic():(f=Math.ceil(parseFloat(m.slidesPerView,10)),h&&f%2==0&&(f+=1));const v=m.slidesPerGroupAuto?f:m.slidesPerGroup;let w=v;w%v!=0&&(w+=v-w%v),w+=m.loopAdditionalSlides,o.loopedSlides=w;const b=o.grid&&m.grid&&m.grid.rows>1;d.length<f+w?g("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters"):b&&"row"===m.grid.fill&&g("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");const y=[],E=[];let x=o.activeIndex;void 0===r?r=o.getSlideIndex(d.filter((e=>e.classList.contains(m.slideActiveClass)))[0]):x=r;const S="next"===a||!a,T="prev"===a||!a;let M=0,C=0;const P=b?Math.ceil(d.length/m.grid.rows):d.length,L=(b?d[r].column:r)+(h&&void 0===i?-f/2+.5:0);if(L<w){M=Math.max(w-L,v);for(let e=0;e<w-L;e+=1){const t=e-Math.floor(e/P)*P;if(b){const e=P-t-1;for(let t=d.length-1;t>=0;t-=1)d[t].column===e&&y.push(t)}else y.push(P-t-1)}}else if(L+f>P-w){C=Math.max(L-(P-2*w),v);for(let e=0;e<C;e+=1){const t=e-Math.floor(e/P)*P;b?d.forEach(((e,s)=>{e.column===t&&E.push(s)})):E.push(t)}}if(o.__preventObserver__=!0,requestAnimationFrame((()=>{o.__preventObserver__=!1})),T&&y.forEach((e=>{d[e].swiperLoopMoveDOM=!0,u.prepend(d[e]),d[e].swiperLoopMoveDOM=!1})),S&&E.forEach((e=>{d[e].swiperLoopMoveDOM=!0,u.append(d[e]),d[e].swiperLoopMoveDOM=!1})),o.recalcSlides(),"auto"===m.slidesPerView?o.updateSlides():b&&(y.length>0&&T||E.length>0&&S)&&o.slides.forEach(((e,t)=>{o.grid.updateSlide(t,e,o.slides)})),m.watchSlidesProgress&&o.updateSlidesOffset(),s)if(y.length>0&&T){if(void 0===t){const e=o.slidesGrid[x],t=o.slidesGrid[x+M]-e;l?o.setTranslate(o.translate-t):(o.slideTo(x+Math.ceil(M),0,!1,!0),i&&(o.touchEventsData.startTranslate=o.touchEventsData.startTranslate-t,o.touchEventsData.currentTranslate=o.touchEventsData.currentTranslate-t))}else if(i){const e=b?y.length/m.grid.rows:y.length;o.slideTo(o.activeIndex+e,0,!1,!0),o.touchEventsData.currentTranslate=o.translate}}else if(E.length>0&&S)if(void 0===t){const e=o.slidesGrid[x],t=o.slidesGrid[x-C]-e;l?o.setTranslate(o.translate-t):(o.slideTo(x-C,0,!1,!0),i&&(o.touchEventsData.startTranslate=o.touchEventsData.startTranslate-t,o.touchEventsData.currentTranslate=o.touchEventsData.currentTranslate-t))}else{const e=b?E.length/m.grid.rows:E.length;o.slideTo(o.activeIndex-e,0,!1,!0)}if(o.allowSlidePrev=c,o.allowSlideNext=p,o.controller&&o.controller.control&&!n){const e={slideRealIndex:t,direction:a,setTranslate:i,activeSlideIndex:r,byController:!0};Array.isArray(o.controller.control)?o.controller.control.forEach((t=>{!t.destroyed&&t.params.loop&&t.loopFix({...e,slideTo:t.params.slidesPerView===m.slidesPerView&&s})})):o.controller.control instanceof o.constructor&&o.controller.control.params.loop&&o.controller.control.loopFix({...e,slideTo:o.controller.control.params.slidesPerView===m.slidesPerView&&s})}o.emit("loopFix")},loopDestroy:function(){const e=this,{params:t,slidesEl:s}=e;if(!t.loop||e.virtual&&e.params.virtual.enabled)return;e.recalcSlides();const a=[];e.slides.forEach((e=>{const t=void 0===e.swiperSlideIndex?1*e.getAttribute("data-swiper-slide-index"):e.swiperSlideIndex;a[t]=e})),e.slides.forEach((e=>{e.removeAttribute("data-swiper-slide-index")})),a.forEach((e=>{s.append(e)})),e.recalcSlides(),e.slideTo(e.realIndex,0)}};function Y(e,t,s){const a=r(),{params:i}=e,n=i.edgeSwipeDetection,l=i.edgeSwipeThreshold;return!n||!(s<=l||s>=a.innerWidth-l)||"prevent"===n&&(t.preventDefault(),!0)}function B(e){const t=this,s=a();let i=e;i.originalEvent&&(i=i.originalEvent);const n=t.touchEventsData;if("pointerdown"===i.type){if(null!==n.pointerId&&n.pointerId!==i.pointerId)return;n.pointerId=i.pointerId}else"touchstart"===i.type&&1===i.targetTouches.length&&(n.touchId=i.targetTouches[0].identifier);if("touchstart"===i.type)return void Y(t,i,i.targetTouches[0].pageX);const{params:l,touches:d,enabled:c}=t;if(!c)return;if(!l.simulateTouch&&"mouse"===i.pointerType)return;if(t.animating&&l.preventInteractionOnTransition)return;!t.animating&&l.cssMode&&l.loop&&t.loopFix();let p=i.target;if("wrapper"===l.touchEventsTarget&&!t.wrapperEl.contains(p))return;if("which"in i&&3===i.which)return;if("button"in i&&i.button>0)return;if(n.isTouched&&n.isMoved)return;const u=!!l.noSwipingClass&&""!==l.noSwipingClass,m=i.composedPath?i.composedPath():i.path;u&&i.target&&i.target.shadowRoot&&m&&(p=m[0]);const h=l.noSwipingSelector?l.noSwipingSelector:`.${l.noSwipingClass}`,f=!(!i.target||!i.target.shadowRoot);if(l.noSwiping&&(f?function(e,t){return void 0===t&&(t=this),function t(s){if(!s||s===a()||s===r())return null;s.assignedSlot&&(s=s.assignedSlot);const i=s.closest(e);return i||s.getRootNode?i||t(s.getRootNode().host):null}(t)}(h,p):p.closest(h)))return void(t.allowClick=!0);if(l.swipeHandler&&!p.closest(l.swipeHandler))return;d.currentX=i.pageX,d.currentY=i.pageY;const g=d.currentX,v=d.currentY;if(!Y(t,i,g))return;Object.assign(n,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),d.startX=g,d.startY=v,n.touchStartTime=o(),t.allowClick=!0,t.updateSize(),t.swipeDirection=void 0,l.threshold>0&&(n.allowThresholdMove=!1);let w=!0;p.matches(n.focusableElements)&&(w=!1,"SELECT"===p.nodeName&&(n.isTouched=!1)),s.activeElement&&s.activeElement.matches(n.focusableElements)&&s.activeElement!==p&&s.activeElement.blur();const b=w&&t.allowTouchMove&&l.touchStartPreventDefault;!l.touchStartForcePreventDefault&&!b||p.isContentEditable||i.preventDefault(),l.freeMode&&l.freeMode.enabled&&t.freeMode&&t.animating&&!l.cssMode&&t.freeMode.onTouchStart(),t.emit("touchStart",i)}function R(e){const t=a(),s=this,i=s.touchEventsData,{params:r,touches:n,rtlTranslate:l,enabled:d}=s;if(!d)return;if(!r.simulateTouch&&"mouse"===e.pointerType)return;let c,p=e;if(p.originalEvent&&(p=p.originalEvent),"pointermove"===p.type){if(null!==i.touchId)return;if(p.pointerId!==i.pointerId)return}if("touchmove"===p.type){if(c=[...p.changedTouches].filter((e=>e.identifier===i.touchId))[0],!c||c.identifier!==i.touchId)return}else c=p;if(!i.isTouched)return void(i.startMoving&&i.isScrolling&&s.emit("touchMoveOpposite",p));const u=c.pageX,m=c.pageY;if(p.preventedByNestedSwiper)return n.startX=u,void(n.startY=m);if(!s.allowTouchMove)return p.target.matches(i.focusableElements)||(s.allowClick=!1),void(i.isTouched&&(Object.assign(n,{startX:u,startY:m,currentX:u,currentY:m}),i.touchStartTime=o()));if(r.touchReleaseOnEdges&&!r.loop)if(s.isVertical()){if(m<n.startY&&s.translate<=s.maxTranslate()||m>n.startY&&s.translate>=s.minTranslate())return i.isTouched=!1,void(i.isMoved=!1)}else if(u<n.startX&&s.translate<=s.maxTranslate()||u>n.startX&&s.translate>=s.minTranslate())return;if(t.activeElement&&p.target===t.activeElement&&p.target.matches(i.focusableElements))return i.isMoved=!0,void(s.allowClick=!1);i.allowTouchCallbacks&&s.emit("touchMove",p),n.previousX=n.currentX,n.previousY=n.currentY,n.currentX=u,n.currentY=m;const h=n.currentX-n.startX,f=n.currentY-n.startY;if(s.params.threshold&&Math.sqrt(h**2+f**2)<s.params.threshold)return;if(void 0===i.isScrolling){let e;s.isHorizontal()&&n.currentY===n.startY||s.isVertical()&&n.currentX===n.startX?i.isScrolling=!1:h*h+f*f>=25&&(e=180*Math.atan2(Math.abs(f),Math.abs(h))/Math.PI,i.isScrolling=s.isHorizontal()?e>r.touchAngle:90-e>r.touchAngle)}if(i.isScrolling&&s.emit("touchMoveOpposite",p),void 0===i.startMoving&&(n.currentX===n.startX&&n.currentY===n.startY||(i.startMoving=!0)),i.isScrolling)return void(i.isTouched=!1);if(!i.startMoving)return;s.allowClick=!1,!r.cssMode&&p.cancelable&&p.preventDefault(),r.touchMoveStopPropagation&&!r.nested&&p.stopPropagation();let g=s.isHorizontal()?h:f,v=s.isHorizontal()?n.currentX-n.previousX:n.currentY-n.previousY;r.oneWayMovement&&(g=Math.abs(g)*(l?1:-1),v=Math.abs(v)*(l?1:-1)),n.diff=g,g*=r.touchRatio,l&&(g=-g,v=-v);const w=s.touchesDirection;s.swipeDirection=g>0?"prev":"next",s.touchesDirection=v>0?"prev":"next";const b=s.params.loop&&!r.cssMode,y="next"===s.touchesDirection&&s.allowSlideNext||"prev"===s.touchesDirection&&s.allowSlidePrev;if(!i.isMoved){if(b&&y&&s.loopFix({direction:s.swipeDirection}),i.startTranslate=s.getTranslate(),s.setTransition(0),s.animating){const e=new window.CustomEvent("transitionend",{bubbles:!0,cancelable:!0});s.wrapperEl.dispatchEvent(e)}i.allowMomentumBounce=!1,!r.grabCursor||!0!==s.allowSlideNext&&!0!==s.allowSlidePrev||s.setGrabCursor(!0),s.emit("sliderFirstMove",p)}if((new Date).getTime(),i.isMoved&&i.allowThresholdMove&&w!==s.touchesDirection&&b&&y&&Math.abs(g)>=1)return Object.assign(n,{startX:u,startY:m,currentX:u,currentY:m,startTranslate:i.currentTranslate}),i.loopSwapReset=!0,void(i.startTranslate=i.currentTranslate);s.emit("sliderMove",p),i.isMoved=!0,i.currentTranslate=g+i.startTranslate;let E=!0,x=r.resistanceRatio;if(r.touchReleaseOnEdges&&(x=0),g>0?(b&&y&&i.allowThresholdMove&&i.currentTranslate>(r.centeredSlides?s.minTranslate()-s.slidesSizesGrid[s.activeIndex+1]:s.minTranslate())&&s.loopFix({direction:"prev",setTranslate:!0,activeSlideIndex:0}),i.currentTranslate>s.minTranslate()&&(E=!1,r.resistance&&(i.currentTranslate=s.minTranslate()-1+(-s.minTranslate()+i.startTranslate+g)**x))):g<0&&(b&&y&&i.allowThresholdMove&&i.currentTranslate<(r.centeredSlides?s.maxTranslate()+s.slidesSizesGrid[s.slidesSizesGrid.length-1]:s.maxTranslate())&&s.loopFix({direction:"next",setTranslate:!0,activeSlideIndex:s.slides.length-("auto"===r.slidesPerView?s.slidesPerViewDynamic():Math.ceil(parseFloat(r.slidesPerView,10)))}),i.currentTranslate<s.maxTranslate()&&(E=!1,r.resistance&&(i.currentTranslate=s.maxTranslate()+1-(s.maxTranslate()-i.startTranslate-g)**x))),E&&(p.preventedByNestedSwiper=!0),!s.allowSlideNext&&"next"===s.swipeDirection&&i.currentTranslate<i.startTranslate&&(i.currentTranslate=i.startTranslate),!s.allowSlidePrev&&"prev"===s.swipeDirection&&i.currentTranslate>i.startTranslate&&(i.currentTranslate=i.startTranslate),s.allowSlidePrev||s.allowSlideNext||(i.currentTranslate=i.startTranslate),r.threshold>0){if(!(Math.abs(g)>r.threshold||i.allowThresholdMove))return void(i.currentTranslate=i.startTranslate);if(!i.allowThresholdMove)return i.allowThresholdMove=!0,n.startX=n.currentX,n.startY=n.currentY,i.currentTranslate=i.startTranslate,void(n.diff=s.isHorizontal()?n.currentX-n.startX:n.currentY-n.startY)}r.followFinger&&!r.cssMode&&((r.freeMode&&r.freeMode.enabled&&s.freeMode||r.watchSlidesProgress)&&(s.updateActiveIndex(),s.updateSlidesClasses()),r.freeMode&&r.freeMode.enabled&&s.freeMode&&s.freeMode.onTouchMove(),s.updateProgress(i.currentTranslate),s.setTranslate(i.currentTranslate))}function q(e){const t=this,s=t.touchEventsData;let a,i=e;i.originalEvent&&(i=i.originalEvent);if("touchend"===i.type||"touchcancel"===i.type){if(a=[...i.changedTouches].filter((e=>e.identifier===s.touchId))[0],!a||a.identifier!==s.touchId)return}else{if(null!==s.touchId)return;if(i.pointerId!==s.pointerId)return;a=i}if(["pointercancel","pointerout","pointerleave","contextmenu"].includes(i.type)){if(!(["pointercancel","contextmenu"].includes(i.type)&&(t.browser.isSafari||t.browser.isWebView)))return}s.pointerId=null,s.touchId=null;const{params:r,touches:n,rtlTranslate:d,slidesGrid:c,enabled:p}=t;if(!p)return;if(!r.simulateTouch&&"mouse"===i.pointerType)return;if(s.allowTouchCallbacks&&t.emit("touchEnd",i),s.allowTouchCallbacks=!1,!s.isTouched)return s.isMoved&&r.grabCursor&&t.setGrabCursor(!1),s.isMoved=!1,void(s.startMoving=!1);r.grabCursor&&s.isMoved&&s.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);const u=o(),m=u-s.touchStartTime;if(t.allowClick){const e=i.path||i.composedPath&&i.composedPath();t.updateClickedSlide(e&&e[0]||i.target,e),t.emit("tap click",i),m<300&&u-s.lastClickTime<300&&t.emit("doubleTap doubleClick",i)}if(s.lastClickTime=o(),l((()=>{t.destroyed||(t.allowClick=!0)})),!s.isTouched||!s.isMoved||!t.swipeDirection||0===n.diff&&!s.loopSwapReset||s.currentTranslate===s.startTranslate&&!s.loopSwapReset)return s.isTouched=!1,s.isMoved=!1,void(s.startMoving=!1);let h;if(s.isTouched=!1,s.isMoved=!1,s.startMoving=!1,h=r.followFinger?d?t.translate:-t.translate:-s.currentTranslate,r.cssMode)return;if(r.freeMode&&r.freeMode.enabled)return void t.freeMode.onTouchEnd({currentPos:h});const f=h>=-t.maxTranslate()&&!t.params.loop;let g=0,v=t.slidesSizesGrid[0];for(let e=0;e<c.length;e+=e<r.slidesPerGroupSkip?1:r.slidesPerGroup){const t=e<r.slidesPerGroupSkip-1?1:r.slidesPerGroup;void 0!==c[e+t]?(f||h>=c[e]&&h<c[e+t])&&(g=e,v=c[e+t]-c[e]):(f||h>=c[e])&&(g=e,v=c[c.length-1]-c[c.length-2])}let w=null,b=null;r.rewind&&(t.isBeginning?b=r.virtual&&r.virtual.enabled&&t.virtual?t.virtual.slides.length-1:t.slides.length-1:t.isEnd&&(w=0));const y=(h-c[g])/v,E=g<r.slidesPerGroupSkip-1?1:r.slidesPerGroup;if(m>r.longSwipesMs){if(!r.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(y>=r.longSwipesRatio?t.slideTo(r.rewind&&t.isEnd?w:g+E):t.slideTo(g)),"prev"===t.swipeDirection&&(y>1-r.longSwipesRatio?t.slideTo(g+E):null!==b&&y<0&&Math.abs(y)>r.longSwipesRatio?t.slideTo(b):t.slideTo(g))}else{if(!r.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(i.target===t.navigation.nextEl||i.target===t.navigation.prevEl)?i.target===t.navigation.nextEl?t.slideTo(g+E):t.slideTo(g):("next"===t.swipeDirection&&t.slideTo(null!==w?w:g+E),"prev"===t.swipeDirection&&t.slideTo(null!==b?b:g))}}function F(){const e=this,{params:t,el:s}=e;if(s&&0===s.offsetWidth)return;t.breakpoints&&e.setBreakpoint();const{allowSlideNext:a,allowSlidePrev:i,snapGrid:r}=e,n=e.virtual&&e.params.virtual.enabled;e.allowSlideNext=!0,e.allowSlidePrev=!0,e.updateSize(),e.updateSlides(),e.updateSlidesClasses();const l=n&&t.loop;!("auto"===t.slidesPerView||t.slidesPerView>1)||!e.isEnd||e.isBeginning||e.params.centeredSlides||l?e.params.loop&&!n?e.slideToLoop(e.realIndex,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0):e.slideTo(e.slides.length-1,0,!1,!0),e.autoplay&&e.autoplay.running&&e.autoplay.paused&&(clearTimeout(e.autoplay.resizeTimeout),e.autoplay.resizeTimeout=setTimeout((()=>{e.autoplay&&e.autoplay.running&&e.autoplay.paused&&e.autoplay.resume()}),500)),e.allowSlidePrev=i,e.allowSlideNext=a,e.params.watchOverflow&&r!==e.snapGrid&&e.checkOverflow()}function V(e){const t=this;t.enabled&&(t.allowClick||(t.params.preventClicks&&e.preventDefault(),t.params.preventClicksPropagation&&t.animating&&(e.stopPropagation(),e.stopImmediatePropagation())))}function _(){const e=this,{wrapperEl:t,rtlTranslate:s,enabled:a}=e;if(!a)return;let i;e.previousTranslate=e.translate,e.isHorizontal()?e.translate=-t.scrollLeft:e.translate=-t.scrollTop,0===e.translate&&(e.translate=0),e.updateActiveIndex(),e.updateSlidesClasses();const r=e.maxTranslate()-e.minTranslate();i=0===r?0:(e.translate-e.minTranslate())/r,i!==e.progress&&e.updateProgress(s?-e.translate:e.translate),e.emit("setTranslate",e.translate,!1)}function W(e){const t=this;$(t,e.target),t.params.cssMode||"auto"!==t.params.slidesPerView&&!t.params.autoHeight||t.update()}function j(){const e=this;e.documentTouchHandlerProceeded||(e.documentTouchHandlerProceeded=!0,e.params.touchReleaseOnEdges&&(e.el.style.touchAction="auto"))}const U=(e,t)=>{const s=a(),{params:i,el:r,wrapperEl:n,device:l}=e,o=!!i.nested,d="on"===t?"addEventListener":"removeEventListener",c=t;s[d]("touchstart",e.onDocumentTouchStart,{passive:!1,capture:o}),r[d]("touchstart",e.onTouchStart,{passive:!1}),r[d]("pointerdown",e.onTouchStart,{passive:!1}),s[d]("touchmove",e.onTouchMove,{passive:!1,capture:o}),s[d]("pointermove",e.onTouchMove,{passive:!1,capture:o}),s[d]("touchend",e.onTouchEnd,{passive:!0}),s[d]("pointerup",e.onTouchEnd,{passive:!0}),s[d]("pointercancel",e.onTouchEnd,{passive:!0}),s[d]("touchcancel",e.onTouchEnd,{passive:!0}),s[d]("pointerout",e.onTouchEnd,{passive:!0}),s[d]("pointerleave",e.onTouchEnd,{passive:!0}),s[d]("contextmenu",e.onTouchEnd,{passive:!0}),(i.preventClicks||i.preventClicksPropagation)&&r[d]("click",e.onClick,!0),i.cssMode&&n[d]("scroll",e.onScroll),i.updateOnWindowResize?e[c](l.ios||l.android?"resize orientationchange observerUpdate":"resize observerUpdate",F,!0):e[c]("observerUpdate",F,!0),r[d]("load",e.onLoad,{capture:!0})};const K=(e,t)=>e.grid&&t.grid&&t.grid.rows>1;var Z={init:!0,direction:"horizontal",oneWayMovement:!1,swiperElementNodeName:"SWIPER-CONTAINER",touchEventsTarget:"wrapper",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,resizeObserver:!0,nested:!1,createElements:!1,eventsPrefix:"swiper",enabled:!0,focusableElements:"input, select, option, textarea, button, video, label",width:null,height:null,preventInteractionOnTransition:!1,userAgent:null,url:null,edgeSwipeDetection:!1,edgeSwipeThreshold:20,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsBase:"window",spaceBetween:0,slidesPerView:1,slidesPerGroup:1,slidesPerGroupSkip:0,slidesPerGroupAuto:!1,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!0,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:5,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,loop:!1,loopAddBlankSlides:!0,loopAdditionalSlides:0,loopPreventsSliding:!0,rewind:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,maxBackfaceHiddenSlides:10,containerModifierClass:"swiper-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-blank",slideActiveClass:"swiper-slide-active",slideVisibleClass:"swiper-slide-visible",slideFullyVisibleClass:"swiper-slide-fully-visible",slideNextClass:"swiper-slide-next",slidePrevClass:"swiper-slide-prev",wrapperClass:"swiper-wrapper",lazyPreloaderClass:"swiper-lazy-preloader",lazyPreloadPrevNext:0,runCallbacksOnInit:!0,_emitClasses:!1};function Q(e,t){return function(s){void 0===s&&(s={});const a=Object.keys(s)[0],i=s[a];"object"==typeof i&&null!==i?(!0===e[a]&&(e[a]={enabled:!0}),"navigation"===a&&e[a]&&e[a].enabled&&!e[a].prevEl&&!e[a].nextEl&&(e[a].auto=!0),["pagination","scrollbar"].indexOf(a)>=0&&e[a]&&e[a].enabled&&!e[a].el&&(e[a].auto=!0),a in e&&"enabled"in i?("object"!=typeof e[a]||"enabled"in e[a]||(e[a].enabled=!0),e[a]||(e[a]={enabled:!1}),p(t,s)):p(t,s)):p(t,s)}}const J={eventsEmitter:A,update:D,translate:G,transition:{setTransition:function(e,t){const s=this;s.params.cssMode||(s.wrapperEl.style.transitionDuration=`${e}ms`,s.wrapperEl.style.transitionDelay=0===e?"0ms":""),s.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);const s=this,{params:a}=s;a.cssMode||(a.autoHeight&&s.updateAutoHeight(),N({swiper:s,runCallbacks:e,direction:t,step:"Start"}))},transitionEnd:function(e,t){void 0===e&&(e=!0);const s=this,{params:a}=s;s.animating=!1,a.cssMode||(s.setTransition(0),N({swiper:s,runCallbacks:e,direction:t,step:"End"}))}},slide:H,loop:X,grabCursor:{setGrabCursor:function(e){const t=this;if(!t.params.simulateTouch||t.params.watchOverflow&&t.isLocked||t.params.cssMode)return;const s="container"===t.params.touchEventsTarget?t.el:t.wrapperEl;t.isElement&&(t.__preventObserver__=!0),s.style.cursor="move",s.style.cursor=e?"grabbing":"grab",t.isElement&&requestAnimationFrame((()=>{t.__preventObserver__=!1}))},unsetGrabCursor:function(){const e=this;e.params.watchOverflow&&e.isLocked||e.params.cssMode||(e.isElement&&(e.__preventObserver__=!0),e["container"===e.params.touchEventsTarget?"el":"wrapperEl"].style.cursor="",e.isElement&&requestAnimationFrame((()=>{e.__preventObserver__=!1})))}},events:{attachEvents:function(){const e=this,{params:t}=e;e.onTouchStart=B.bind(e),e.onTouchMove=R.bind(e),e.onTouchEnd=q.bind(e),e.onDocumentTouchStart=j.bind(e),t.cssMode&&(e.onScroll=_.bind(e)),e.onClick=V.bind(e),e.onLoad=W.bind(e),U(e,"on")},detachEvents:function(){U(this,"off")}},breakpoints:{setBreakpoint:function(){const e=this,{realIndex:t,initialized:s,params:a,el:i}=e,r=a.breakpoints;if(!r||r&&0===Object.keys(r).length)return;const n=e.getBreakpoint(r,e.params.breakpointsBase,e.el);if(!n||e.currentBreakpoint===n)return;const l=(n in r?r[n]:void 0)||e.originalParams,o=K(e,a),d=K(e,l),c=a.enabled;o&&!d?(i.classList.remove(`${a.containerModifierClass}grid`,`${a.containerModifierClass}grid-column`),e.emitContainerClasses()):!o&&d&&(i.classList.add(`${a.containerModifierClass}grid`),(l.grid.fill&&"column"===l.grid.fill||!l.grid.fill&&"column"===a.grid.fill)&&i.classList.add(`${a.containerModifierClass}grid-column`),e.emitContainerClasses()),["navigation","pagination","scrollbar"].forEach((t=>{if(void 0===l[t])return;const s=a[t]&&a[t].enabled,i=l[t]&&l[t].enabled;s&&!i&&e[t].disable(),!s&&i&&e[t].enable()}));const u=l.direction&&l.direction!==a.direction,m=a.loop&&(l.slidesPerView!==a.slidesPerView||u),h=a.loop;u&&s&&e.changeDirection(),p(e.params,l);const f=e.params.enabled,g=e.params.loop;Object.assign(e,{allowTouchMove:e.params.allowTouchMove,allowSlideNext:e.params.allowSlideNext,allowSlidePrev:e.params.allowSlidePrev}),c&&!f?e.disable():!c&&f&&e.enable(),e.currentBreakpoint=n,e.emit("_beforeBreakpoint",l),s&&(m?(e.loopDestroy(),e.loopCreate(t),e.updateSlides()):!h&&g?(e.loopCreate(t),e.updateSlides()):h&&!g&&e.loopDestroy()),e.emit("breakpoint",l)},getBreakpoint:function(e,t,s){if(void 0===t&&(t="window"),!e||"container"===t&&!s)return;let a=!1;const i=r(),n="window"===t?i.innerHeight:s.clientHeight,l=Object.keys(e).map((e=>{if("string"==typeof e&&0===e.indexOf("@")){const t=parseFloat(e.substr(1));return{value:n*t,point:e}}return{value:e,point:e}}));l.sort(((e,t)=>parseInt(e.value,10)-parseInt(t.value,10)));for(let e=0;e<l.length;e+=1){const{point:r,value:n}=l[e];"window"===t?i.matchMedia(`(min-width: ${n}px)`).matches&&(a=r):n<=s.clientWidth&&(a=r)}return a||"max"}},checkOverflow:{checkOverflow:function(){const e=this,{isLocked:t,params:s}=e,{slidesOffsetBefore:a}=s;if(a){const t=e.slides.length-1,s=e.slidesGrid[t]+e.slidesSizesGrid[t]+2*a;e.isLocked=e.size>s}else e.isLocked=1===e.snapGrid.length;!0===s.allowSlideNext&&(e.allowSlideNext=!e.isLocked),!0===s.allowSlidePrev&&(e.allowSlidePrev=!e.isLocked),t&&t!==e.isLocked&&(e.isEnd=!1),t!==e.isLocked&&e.emit(e.isLocked?"lock":"unlock")}},classes:{addClasses:function(){const e=this,{classNames:t,params:s,rtl:a,el:i,device:r}=e,n=function(e,t){const s=[];return e.forEach((e=>{"object"==typeof e?Object.keys(e).forEach((a=>{e[a]&&s.push(t+a)})):"string"==typeof e&&s.push(t+e)})),s}(["initialized",s.direction,{"free-mode":e.params.freeMode&&s.freeMode.enabled},{autoheight:s.autoHeight},{rtl:a},{grid:s.grid&&s.grid.rows>1},{"grid-column":s.grid&&s.grid.rows>1&&"column"===s.grid.fill},{android:r.android},{ios:r.ios},{"css-mode":s.cssMode},{centered:s.cssMode&&s.centeredSlides},{"watch-progress":s.watchSlidesProgress}],s.containerModifierClass);t.push(...n),i.classList.add(...t),e.emitContainerClasses()},removeClasses:function(){const{el:e,classNames:t}=this;e.classList.remove(...t),this.emitContainerClasses()}}},ee={};class te{constructor(){let e,t;for(var s=arguments.length,i=new Array(s),r=0;r<s;r++)i[r]=arguments[r];1===i.length&&i[0].constructor&&"Object"===Object.prototype.toString.call(i[0]).slice(8,-1)?t=i[0]:[e,t]=i,t||(t={}),t=p({},t),e&&!t.el&&(t.el=e);const n=a();if(t.el&&"string"==typeof t.el&&n.querySelectorAll(t.el).length>1){const e=[];return n.querySelectorAll(t.el).forEach((s=>{const a=p({},t,{el:s});e.push(new te(a))})),e}const l=this;l.__swiper__=!0,l.support=L(),l.device=I({userAgent:t.userAgent}),l.browser=z(),l.eventsListeners={},l.eventsAnyListeners=[],l.modules=[...l.__modules__],t.modules&&Array.isArray(t.modules)&&l.modules.push(...t.modules);const o={};l.modules.forEach((e=>{e({params:t,swiper:l,extendParams:Q(t,o),on:l.on.bind(l),once:l.once.bind(l),off:l.off.bind(l),emit:l.emit.bind(l)})}));const d=p({},Z,o);return l.params=p({},d,ee,t),l.originalParams=p({},l.params),l.passedParams=p({},t),l.params&&l.params.on&&Object.keys(l.params.on).forEach((e=>{l.on(e,l.params.on[e])})),l.params&&l.params.onAny&&l.onAny(l.params.onAny),Object.assign(l,{enabled:l.params.enabled,el:e,classNames:[],slides:[],slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:()=>"horizontal"===l.params.direction,isVertical:()=>"vertical"===l.params.direction,activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,cssOverflowAdjustment(){return Math.trunc(this.translate/2**23)*2**23},allowSlideNext:l.params.allowSlideNext,allowSlidePrev:l.params.allowSlidePrev,touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,focusableElements:l.params.focusableElements,lastClickTime:0,clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,startMoving:void 0,pointerId:null,touchId:null},allowClick:!0,allowTouchMove:l.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),l.emit("_swiper"),l.params.init&&l.init(),l}getDirectionLabel(e){return this.isHorizontal()?e:{width:"height","margin-top":"margin-left","margin-bottom ":"margin-right","margin-left":"margin-top","margin-right":"margin-bottom","padding-left":"padding-top","padding-right":"padding-bottom",marginRight:"marginBottom"}[e]}getSlideIndex(e){const{slidesEl:t,params:s}=this,a=y(f(t,`.${s.slideClass}, swiper-slide`)[0]);return y(e)-a}getSlideIndexByData(e){return this.getSlideIndex(this.slides.filter((t=>1*t.getAttribute("data-swiper-slide-index")===e))[0])}recalcSlides(){const{slidesEl:e,params:t}=this;this.slides=f(e,`.${t.slideClass}, swiper-slide`)}enable(){const e=this;e.enabled||(e.enabled=!0,e.params.grabCursor&&e.setGrabCursor(),e.emit("enable"))}disable(){const e=this;e.enabled&&(e.enabled=!1,e.params.grabCursor&&e.unsetGrabCursor(),e.emit("disable"))}setProgress(e,t){const s=this;e=Math.min(Math.max(e,0),1);const a=s.minTranslate(),i=(s.maxTranslate()-a)*e+a;s.translateTo(i,void 0===t?0:t),s.updateActiveIndex(),s.updateSlidesClasses()}emitContainerClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=e.el.className.split(" ").filter((t=>0===t.indexOf("swiper")||0===t.indexOf(e.params.containerModifierClass)));e.emit("_containerClasses",t.join(" "))}getSlideClasses(e){const t=this;return t.destroyed?"":e.className.split(" ").filter((e=>0===e.indexOf("swiper-slide")||0===e.indexOf(t.params.slideClass))).join(" ")}emitSlidesClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=[];e.slides.forEach((s=>{const a=e.getSlideClasses(s);t.push({slideEl:s,classNames:a}),e.emit("_slideClass",s,a)})),e.emit("_slideClasses",t)}slidesPerViewDynamic(e,t){void 0===e&&(e="current"),void 0===t&&(t=!1);const{params:s,slides:a,slidesGrid:i,slidesSizesGrid:r,size:n,activeIndex:l}=this;let o=1;if("number"==typeof s.slidesPerView)return s.slidesPerView;if(s.centeredSlides){let e,t=a[l]?Math.ceil(a[l].swiperSlideSize):0;for(let s=l+1;s<a.length;s+=1)a[s]&&!e&&(t+=Math.ceil(a[s].swiperSlideSize),o+=1,t>n&&(e=!0));for(let s=l-1;s>=0;s-=1)a[s]&&!e&&(t+=a[s].swiperSlideSize,o+=1,t>n&&(e=!0))}else if("current"===e)for(let e=l+1;e<a.length;e+=1){(t?i[e]+r[e]-i[l]<n:i[e]-i[l]<n)&&(o+=1)}else for(let e=l-1;e>=0;e-=1){i[l]-i[e]<n&&(o+=1)}return o}update(){const e=this;if(!e||e.destroyed)return;const{snapGrid:t,params:s}=e;function a(){const t=e.rtlTranslate?-1*e.translate:e.translate,s=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(s),e.updateActiveIndex(),e.updateSlidesClasses()}let i;if(s.breakpoints&&e.setBreakpoint(),[...e.el.querySelectorAll('[loading="lazy"]')].forEach((t=>{t.complete&&$(e,t)})),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),s.freeMode&&s.freeMode.enabled&&!s.cssMode)a(),s.autoHeight&&e.updateAutoHeight();else{if(("auto"===s.slidesPerView||s.slidesPerView>1)&&e.isEnd&&!s.centeredSlides){const t=e.virtual&&s.virtual.enabled?e.virtual.slides:e.slides;i=e.slideTo(t.length-1,0,!1,!0)}else i=e.slideTo(e.activeIndex,0,!1,!0);i||a()}s.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}changeDirection(e,t){void 0===t&&(t=!0);const s=this,a=s.params.direction;return e||(e="horizontal"===a?"vertical":"horizontal"),e===a||"horizontal"!==e&&"vertical"!==e||(s.el.classList.remove(`${s.params.containerModifierClass}${a}`),s.el.classList.add(`${s.params.containerModifierClass}${e}`),s.emitContainerClasses(),s.params.direction=e,s.slides.forEach((t=>{"vertical"===e?t.style.width="":t.style.height=""})),s.emit("changeDirection"),t&&s.update()),s}changeLanguageDirection(e){const t=this;t.rtl&&"rtl"===e||!t.rtl&&"ltr"===e||(t.rtl="rtl"===e,t.rtlTranslate="horizontal"===t.params.direction&&t.rtl,t.rtl?(t.el.classList.add(`${t.params.containerModifierClass}rtl`),t.el.dir="rtl"):(t.el.classList.remove(`${t.params.containerModifierClass}rtl`),t.el.dir="ltr"),t.update())}mount(e){const t=this;if(t.mounted)return!0;let s=e||t.params.el;if("string"==typeof s&&(s=document.querySelector(s)),!s)return!1;s.swiper=t,s.parentNode&&s.parentNode.host&&s.parentNode.host.nodeName===t.params.swiperElementNodeName.toUpperCase()&&(t.isElement=!0);const a=()=>`.${(t.params.wrapperClass||"").trim().split(" ").join(".")}`;let i=(()=>{if(s&&s.shadowRoot&&s.shadowRoot.querySelector){return s.shadowRoot.querySelector(a())}return f(s,a())[0]})();return!i&&t.params.createElements&&(i=v("div",t.params.wrapperClass),s.append(i),f(s,`.${t.params.slideClass}`).forEach((e=>{i.append(e)}))),Object.assign(t,{el:s,wrapperEl:i,slidesEl:t.isElement&&!s.parentNode.host.slideSlots?s.parentNode.host:i,hostEl:t.isElement?s.parentNode.host:s,mounted:!0,rtl:"rtl"===s.dir.toLowerCase()||"rtl"===b(s,"direction"),rtlTranslate:"horizontal"===t.params.direction&&("rtl"===s.dir.toLowerCase()||"rtl"===b(s,"direction")),wrongRTL:"-webkit-box"===b(i,"display")}),!0}init(e){const t=this;if(t.initialized)return t;if(!1===t.mount(e))return t;t.emit("beforeInit"),t.params.breakpoints&&t.setBreakpoint(),t.addClasses(),t.updateSize(),t.updateSlides(),t.params.watchOverflow&&t.checkOverflow(),t.params.grabCursor&&t.enabled&&t.setGrabCursor(),t.params.loop&&t.virtual&&t.params.virtual.enabled?t.slideTo(t.params.initialSlide+t.virtual.slidesBefore,0,t.params.runCallbacksOnInit,!1,!0):t.slideTo(t.params.initialSlide,0,t.params.runCallbacksOnInit,!1,!0),t.params.loop&&t.loopCreate(),t.attachEvents();const s=[...t.el.querySelectorAll('[loading="lazy"]')];return t.isElement&&s.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),s.forEach((e=>{e.complete?$(t,e):e.addEventListener("load",(e=>{$(t,e.target)}))})),O(t),t.initialized=!0,O(t),t.emit("init"),t.emit("afterInit"),t}destroy(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);const s=this,{params:a,el:i,wrapperEl:r,slides:n}=s;return void 0===s.params||s.destroyed||(s.emit("beforeDestroy"),s.initialized=!1,s.detachEvents(),a.loop&&s.loopDestroy(),t&&(s.removeClasses(),i.removeAttribute("style"),r.removeAttribute("style"),n&&n.length&&n.forEach((e=>{e.classList.remove(a.slideVisibleClass,a.slideFullyVisibleClass,a.slideActiveClass,a.slideNextClass,a.slidePrevClass),e.removeAttribute("style"),e.removeAttribute("data-swiper-slide-index")}))),s.emit("destroy"),Object.keys(s.eventsListeners).forEach((e=>{s.off(e)})),!1!==e&&(s.el.swiper=null,function(e){const t=e;Object.keys(t).forEach((e=>{try{t[e]=null}catch(e){}try{delete t[e]}catch(e){}}))}(s)),s.destroyed=!0),null}static extendDefaults(e){p(ee,e)}static get extendedDefaults(){return ee}static get defaults(){return Z}static installModule(e){te.prototype.__modules__||(te.prototype.__modules__=[]);const t=te.prototype.__modules__;"function"==typeof e&&t.indexOf(e)<0&&t.push(e)}static use(e){return Array.isArray(e)?(e.forEach((e=>te.installModule(e))),te):(te.installModule(e),te)}}function se(e,t,s,a){return e.params.createElements&&Object.keys(a).forEach((i=>{if(!s[i]&&!0===s.auto){let r=f(e.el,`.${a[i]}`)[0];r||(r=v("div",a[i]),r.className=a[i],e.el.append(r)),s[i]=r,t[i]=r}})),s}function ae(e){return void 0===e&&(e=""),`.${e.trim().replace(/([\.:!+\/])/g,"\\$1").replace(/ /g,".")}`}function ie(e){const t=this,{params:s,slidesEl:a}=t;s.loop&&t.loopDestroy();const i=e=>{if("string"==typeof e){const t=document.createElement("div");t.innerHTML=e,a.append(t.children[0]),t.innerHTML=""}else a.append(e)};if("object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&i(e[t]);else i(e);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update()}function re(e){const t=this,{params:s,activeIndex:a,slidesEl:i}=t;s.loop&&t.loopDestroy();let r=a+1;const n=e=>{if("string"==typeof e){const t=document.createElement("div");t.innerHTML=e,i.prepend(t.children[0]),t.innerHTML=""}else i.prepend(e)};if("object"==typeof e&&"length"in e){for(let t=0;t<e.length;t+=1)e[t]&&n(e[t]);r=a+e.length}else n(e);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update(),t.slideTo(r,0,!1)}function ne(e,t){const s=this,{params:a,activeIndex:i,slidesEl:r}=s;let n=i;a.loop&&(n-=s.loopedSlides,s.loopDestroy(),s.recalcSlides());const l=s.slides.length;if(e<=0)return void s.prependSlide(t);if(e>=l)return void s.appendSlide(t);let o=n>e?n+1:n;const d=[];for(let t=l-1;t>=e;t-=1){const e=s.slides[t];e.remove(),d.unshift(e)}if("object"==typeof t&&"length"in t){for(let e=0;e<t.length;e+=1)t[e]&&r.append(t[e]);o=n>e?n+t.length:n}else r.append(t);for(let e=0;e<d.length;e+=1)r.append(d[e]);s.recalcSlides(),a.loop&&s.loopCreate(),a.observer&&!s.isElement||s.update(),a.loop?s.slideTo(o+s.loopedSlides,0,!1):s.slideTo(o,0,!1)}function le(e){const t=this,{params:s,activeIndex:a}=t;let i=a;s.loop&&(i-=t.loopedSlides,t.loopDestroy());let r,n=i;if("object"==typeof e&&"length"in e){for(let s=0;s<e.length;s+=1)r=e[s],t.slides[r]&&t.slides[r].remove(),r<n&&(n-=1);n=Math.max(n,0)}else r=e,t.slides[r]&&t.slides[r].remove(),r<n&&(n-=1),n=Math.max(n,0);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update(),s.loop?t.slideTo(n+t.loopedSlides,0,!1):t.slideTo(n,0,!1)}function oe(){const e=this,t=[];for(let s=0;s<e.slides.length;s+=1)t.push(s);e.removeSlide(t)}function de(e){const{effect:t,swiper:s,on:a,setTranslate:i,setTransition:r,overwriteParams:n,perspective:l,recreateShadows:o,getEffectParams:d}=e;let c;a("beforeInit",(()=>{if(s.params.effect!==t)return;s.classNames.push(`${s.params.containerModifierClass}${t}`),l&&l()&&s.classNames.push(`${s.params.containerModifierClass}3d`);const e=n?n():{};Object.assign(s.params,e),Object.assign(s.originalParams,e)})),a("setTranslate",(()=>{s.params.effect===t&&i()})),a("setTransition",((e,a)=>{s.params.effect===t&&r(a)})),a("transitionEnd",(()=>{if(s.params.effect===t&&o){if(!d||!d().slideShadows)return;s.slides.forEach((e=>{e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e=>e.remove()))})),o()}})),a("virtualUpdate",(()=>{s.params.effect===t&&(s.slides.length||(c=!0),requestAnimationFrame((()=>{c&&s.slides&&s.slides.length&&(i(),c=!1)})))}))}function ce(e,t){const s=h(t);return s!==t&&(s.style.backfaceVisibility="hidden",s.style["-webkit-backface-visibility"]="hidden"),s}function pe(e){let{swiper:t,duration:s,transformElements:a,allSlides:i}=e;const{activeIndex:r}=t;if(t.params.virtualTranslate&&0!==s){let e,s=!1;e=i?a:a.filter((e=>{const s=e.classList.contains("swiper-slide-transform")?(e=>{if(!e.parentElement)return t.slides.filter((t=>t.shadowRoot&&t.shadowRoot===e.parentNode))[0];return e.parentElement})(e):e;return t.getSlideIndex(s)===r})),e.forEach((e=>{x(e,(()=>{if(s)return;if(!t||t.destroyed)return;s=!0,t.animating=!1;const e=new window.CustomEvent("transitionend",{bubbles:!0,cancelable:!0});t.wrapperEl.dispatchEvent(e)}))}))}}function ue(e,t,s){const a=`swiper-slide-shadow${s?`-${s}`:""}${e?` swiper-slide-shadow-${e}`:""}`,i=h(t);let r=i.querySelector(`.${a.split(" ").join(".")}`);return r||(r=v("div",a.split(" ")),i.append(r)),r}Object.keys(J).forEach((e=>{Object.keys(J[e]).forEach((t=>{te.prototype[t]=J[e][t]}))})),te.use([function(e){let{swiper:t,on:s,emit:a}=e;const i=r();let n=null,l=null;const o=()=>{t&&!t.destroyed&&t.initialized&&(a("beforeResize"),a("resize"))},d=()=>{t&&!t.destroyed&&t.initialized&&a("orientationchange")};s("init",(()=>{t.params.resizeObserver&&void 0!==i.ResizeObserver?t&&!t.destroyed&&t.initialized&&(n=new ResizeObserver((e=>{l=i.requestAnimationFrame((()=>{const{width:s,height:a}=t;let i=s,r=a;e.forEach((e=>{let{contentBoxSize:s,contentRect:a,target:n}=e;n&&n!==t.el||(i=a?a.width:(s[0]||s).inlineSize,r=a?a.height:(s[0]||s).blockSize)})),i===s&&r===a||o()}))})),n.observe(t.el)):(i.addEventListener("resize",o),i.addEventListener("orientationchange",d))})),s("destroy",(()=>{l&&i.cancelAnimationFrame(l),n&&n.unobserve&&t.el&&(n.unobserve(t.el),n=null),i.removeEventListener("resize",o),i.removeEventListener("orientationchange",d)}))},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=[],l=r(),o=function(e,s){void 0===s&&(s={});const a=new(l.MutationObserver||l.WebkitMutationObserver)((e=>{if(t.__preventObserver__)return;if(1===e.length)return void i("observerUpdate",e[0]);const s=function(){i("observerUpdate",e[0])};l.requestAnimationFrame?l.requestAnimationFrame(s):l.setTimeout(s,0)}));a.observe(e,{attributes:void 0===s.attributes||s.attributes,childList:void 0===s.childList||s.childList,characterData:void 0===s.characterData||s.characterData}),n.push(a)};s({observer:!1,observeParents:!1,observeSlideChildren:!1}),a("init",(()=>{if(t.params.observer){if(t.params.observeParents){const e=E(t.hostEl);for(let t=0;t<e.length;t+=1)o(e[t])}o(t.hostEl,{childList:t.params.observeSlideChildren}),o(t.wrapperEl,{attributes:!1})}})),a("destroy",(()=>{n.forEach((e=>{e.disconnect()})),n.splice(0,n.length)}))}]);const me=[function(e){let t,{swiper:s,extendParams:i,on:r,emit:n}=e;i({virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,renderExternalUpdate:!0,addSlidesBefore:0,addSlidesAfter:0}});const l=a();s.virtual={cache:{},from:void 0,to:void 0,slides:[],offset:0,slidesGrid:[]};const o=l.createElement("div");function d(e,t){const a=s.params.virtual;if(a.cache&&s.virtual.cache[t])return s.virtual.cache[t];let i;return a.renderSlide?(i=a.renderSlide.call(s,e,t),"string"==typeof i&&(o.innerHTML=i,i=o.children[0])):i=s.isElement?v("swiper-slide"):v("div",s.params.slideClass),i.setAttribute("data-swiper-slide-index",t),a.renderSlide||(i.innerHTML=e),a.cache&&(s.virtual.cache[t]=i),i}function c(e){const{slidesPerView:t,slidesPerGroup:a,centeredSlides:i,loop:r}=s.params,{addSlidesBefore:l,addSlidesAfter:o}=s.params.virtual,{from:c,to:p,slides:u,slidesGrid:m,offset:h}=s.virtual;s.params.cssMode||s.updateActiveIndex();const g=s.activeIndex||0;let v,w,b;v=s.rtlTranslate?"right":s.isHorizontal()?"left":"top",i?(w=Math.floor(t/2)+a+o,b=Math.floor(t/2)+a+l):(w=t+(a-1)+o,b=(r?t:a)+l);let y=g-b,E=g+w;r||(y=Math.max(y,0),E=Math.min(E,u.length-1));let x=(s.slidesGrid[y]||0)-(s.slidesGrid[0]||0);function S(){s.updateSlides(),s.updateProgress(),s.updateSlidesClasses(),n("virtualUpdate")}if(r&&g>=b?(y-=b,i||(x+=s.slidesGrid[0])):r&&g<b&&(y=-b,i&&(x+=s.slidesGrid[0])),Object.assign(s.virtual,{from:y,to:E,offset:x,slidesGrid:s.slidesGrid,slidesBefore:b,slidesAfter:w}),c===y&&p===E&&!e)return s.slidesGrid!==m&&x!==h&&s.slides.forEach((e=>{e.style[v]=x-Math.abs(s.cssOverflowAdjustment())+"px"})),s.updateProgress(),void n("virtualUpdate");if(s.params.virtual.renderExternal)return s.params.virtual.renderExternal.call(s,{offset:x,from:y,to:E,slides:function(){const e=[];for(let t=y;t<=E;t+=1)e.push(u[t]);return e}()}),void(s.params.virtual.renderExternalUpdate?S():n("virtualUpdate"));const T=[],M=[],C=e=>{let t=e;return e<0?t=u.length+e:t>=u.length&&(t-=u.length),t};if(e)s.slides.filter((e=>e.matches(`.${s.params.slideClass}, swiper-slide`))).forEach((e=>{e.remove()}));else for(let e=c;e<=p;e+=1)if(e<y||e>E){const t=C(e);s.slides.filter((e=>e.matches(`.${s.params.slideClass}[data-swiper-slide-index="${t}"], swiper-slide[data-swiper-slide-index="${t}"]`))).forEach((e=>{e.remove()}))}const P=r?-u.length:0,L=r?2*u.length:u.length;for(let t=P;t<L;t+=1)if(t>=y&&t<=E){const s=C(t);void 0===p||e?M.push(s):(t>p&&M.push(s),t<c&&T.push(s))}if(M.forEach((e=>{s.slidesEl.append(d(u[e],e))})),r)for(let e=T.length-1;e>=0;e-=1){const t=T[e];s.slidesEl.prepend(d(u[t],t))}else T.sort(((e,t)=>t-e)),T.forEach((e=>{s.slidesEl.prepend(d(u[e],e))}));f(s.slidesEl,".swiper-slide, swiper-slide").forEach((e=>{e.style[v]=x-Math.abs(s.cssOverflowAdjustment())+"px"})),S()}r("beforeInit",(()=>{if(!s.params.virtual.enabled)return;let e;if(void 0===s.passedParams.virtual.slides){const t=[...s.slidesEl.children].filter((e=>e.matches(`.${s.params.slideClass}, swiper-slide`)));t&&t.length&&(s.virtual.slides=[...t],e=!0,t.forEach(((e,t)=>{e.setAttribute("data-swiper-slide-index",t),s.virtual.cache[t]=e,e.remove()})))}e||(s.virtual.slides=s.params.virtual.slides),s.classNames.push(`${s.params.containerModifierClass}virtual`),s.params.watchSlidesProgress=!0,s.originalParams.watchSlidesProgress=!0,c()})),r("setTranslate",(()=>{s.params.virtual.enabled&&(s.params.cssMode&&!s._immediateVirtual?(clearTimeout(t),t=setTimeout((()=>{c()}),100)):c())})),r("init update resize",(()=>{s.params.virtual.enabled&&s.params.cssMode&&u(s.wrapperEl,"--swiper-virtual-size",`${s.virtualSize}px`)})),Object.assign(s.virtual,{appendSlide:function(e){if("object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.push(e[t]);else s.virtual.slides.push(e);c(!0)},prependSlide:function(e){const t=s.activeIndex;let a=t+1,i=1;if(Array.isArray(e)){for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.unshift(e[t]);a=t+e.length,i=e.length}else s.virtual.slides.unshift(e);if(s.params.virtual.cache){const e=s.virtual.cache,t={};Object.keys(e).forEach((s=>{const a=e[s],r=a.getAttribute("data-swiper-slide-index");r&&a.setAttribute("data-swiper-slide-index",parseInt(r,10)+i),t[parseInt(s,10)+i]=a})),s.virtual.cache=t}c(!0),s.slideTo(a,0)},removeSlide:function(e){if(null==e)return;let t=s.activeIndex;if(Array.isArray(e))for(let a=e.length-1;a>=0;a-=1)s.params.virtual.cache&&(delete s.virtual.cache[e[a]],Object.keys(s.virtual.cache).forEach((t=>{t>e&&(s.virtual.cache[t-1]=s.virtual.cache[t],s.virtual.cache[t-1].setAttribute("data-swiper-slide-index",t-1),delete s.virtual.cache[t])}))),s.virtual.slides.splice(e[a],1),e[a]<t&&(t-=1),t=Math.max(t,0);else s.params.virtual.cache&&(delete s.virtual.cache[e],Object.keys(s.virtual.cache).forEach((t=>{t>e&&(s.virtual.cache[t-1]=s.virtual.cache[t],s.virtual.cache[t-1].setAttribute("data-swiper-slide-index",t-1),delete s.virtual.cache[t])}))),s.virtual.slides.splice(e,1),e<t&&(t-=1),t=Math.max(t,0);c(!0),s.slideTo(t,0)},removeAllSlides:function(){s.virtual.slides=[],s.params.virtual.cache&&(s.virtual.cache={}),c(!0),s.slideTo(0,0)},update:c})},function(e){let{swiper:t,extendParams:s,on:i,emit:n}=e;const l=a(),o=r();function d(e){if(!t.enabled)return;const{rtlTranslate:s}=t;let a=e;a.originalEvent&&(a=a.originalEvent);const i=a.keyCode||a.charCode,r=t.params.keyboard.pageUpDown,d=r&&33===i,c=r&&34===i,p=37===i,u=39===i,m=38===i,h=40===i;if(!t.allowSlideNext&&(t.isHorizontal()&&u||t.isVertical()&&h||c))return!1;if(!t.allowSlidePrev&&(t.isHorizontal()&&p||t.isVertical()&&m||d))return!1;if(!(a.shiftKey||a.altKey||a.ctrlKey||a.metaKey||l.activeElement&&l.activeElement.nodeName&&("input"===l.activeElement.nodeName.toLowerCase()||"textarea"===l.activeElement.nodeName.toLowerCase()))){if(t.params.keyboard.onlyInViewport&&(d||c||p||u||m||h)){let e=!1;if(E(t.el,`.${t.params.slideClass}, swiper-slide`).length>0&&0===E(t.el,`.${t.params.slideActiveClass}`).length)return;const a=t.el,i=a.clientWidth,r=a.clientHeight,n=o.innerWidth,l=o.innerHeight,d=w(a);s&&(d.left-=a.scrollLeft);const c=[[d.left,d.top],[d.left+i,d.top],[d.left,d.top+r],[d.left+i,d.top+r]];for(let t=0;t<c.length;t+=1){const s=c[t];if(s[0]>=0&&s[0]<=n&&s[1]>=0&&s[1]<=l){if(0===s[0]&&0===s[1])continue;e=!0}}if(!e)return}t.isHorizontal()?((d||c||p||u)&&(a.preventDefault?a.preventDefault():a.returnValue=!1),((c||u)&&!s||(d||p)&&s)&&t.slideNext(),((d||p)&&!s||(c||u)&&s)&&t.slidePrev()):((d||c||m||h)&&(a.preventDefault?a.preventDefault():a.returnValue=!1),(c||h)&&t.slideNext(),(d||m)&&t.slidePrev()),n("keyPress",i)}}function c(){t.keyboard.enabled||(l.addEventListener("keydown",d),t.keyboard.enabled=!0)}function p(){t.keyboard.enabled&&(l.removeEventListener("keydown",d),t.keyboard.enabled=!1)}t.keyboard={enabled:!1},s({keyboard:{enabled:!1,onlyInViewport:!0,pageUpDown:!0}}),i("init",(()=>{t.params.keyboard.enabled&&c()})),i("destroy",(()=>{t.keyboard.enabled&&p()})),Object.assign(t.keyboard,{enable:c,disable:p})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=r();let d;s({mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarget:"container",thresholdDelta:null,thresholdTime:null,noMousewheelClass:"swiper-no-mousewheel"}}),t.mousewheel={enabled:!1};let c,p=o();const u=[];function m(){t.enabled&&(t.mouseEntered=!0)}function h(){t.enabled&&(t.mouseEntered=!1)}function f(e){return!(t.params.mousewheel.thresholdDelta&&e.delta<t.params.mousewheel.thresholdDelta)&&(!(t.params.mousewheel.thresholdTime&&o()-p<t.params.mousewheel.thresholdTime)&&(e.delta>=6&&o()-p<60||(e.direction<0?t.isEnd&&!t.params.loop||t.animating||(t.slideNext(),i("scroll",e.raw)):t.isBeginning&&!t.params.loop||t.animating||(t.slidePrev(),i("scroll",e.raw)),p=(new n.Date).getTime(),!1)))}function g(e){let s=e,a=!0;if(!t.enabled)return;if(e.target.closest(`.${t.params.mousewheel.noMousewheelClass}`))return;const r=t.params.mousewheel;t.params.cssMode&&s.preventDefault();let n=t.el;"container"!==t.params.mousewheel.eventsTarget&&(n=document.querySelector(t.params.mousewheel.eventsTarget));const p=n&&n.contains(s.target);if(!t.mouseEntered&&!p&&!r.releaseOnEdges)return!0;s.originalEvent&&(s=s.originalEvent);let m=0;const h=t.rtlTranslate?-1:1,g=function(e){let t=0,s=0,a=0,i=0;return"detail"in e&&(s=e.detail),"wheelDelta"in e&&(s=-e.wheelDelta/120),"wheelDeltaY"in e&&(s=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=s,s=0),a=10*t,i=10*s,"deltaY"in e&&(i=e.deltaY),"deltaX"in e&&(a=e.deltaX),e.shiftKey&&!a&&(a=i,i=0),(a||i)&&e.deltaMode&&(1===e.deltaMode?(a*=40,i*=40):(a*=800,i*=800)),a&&!t&&(t=a<1?-1:1),i&&!s&&(s=i<1?-1:1),{spinX:t,spinY:s,pixelX:a,pixelY:i}}(s);if(r.forceToAxis)if(t.isHorizontal()){if(!(Math.abs(g.pixelX)>Math.abs(g.pixelY)))return!0;m=-g.pixelX*h}else{if(!(Math.abs(g.pixelY)>Math.abs(g.pixelX)))return!0;m=-g.pixelY}else m=Math.abs(g.pixelX)>Math.abs(g.pixelY)?-g.pixelX*h:-g.pixelY;if(0===m)return!0;r.invert&&(m=-m);let v=t.getTranslate()+m*r.sensitivity;if(v>=t.minTranslate()&&(v=t.minTranslate()),v<=t.maxTranslate()&&(v=t.maxTranslate()),a=!!t.params.loop||!(v===t.minTranslate()||v===t.maxTranslate()),a&&t.params.nested&&s.stopPropagation(),t.params.freeMode&&t.params.freeMode.enabled){const e={time:o(),delta:Math.abs(m),direction:Math.sign(m)},a=c&&e.time<c.time+500&&e.delta<=c.delta&&e.direction===c.direction;if(!a){c=void 0;let n=t.getTranslate()+m*r.sensitivity;const o=t.isBeginning,p=t.isEnd;if(n>=t.minTranslate()&&(n=t.minTranslate()),n<=t.maxTranslate()&&(n=t.maxTranslate()),t.setTransition(0),t.setTranslate(n),t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses(),(!o&&t.isBeginning||!p&&t.isEnd)&&t.updateSlidesClasses(),t.params.loop&&t.loopFix({direction:e.direction<0?"next":"prev",byMousewheel:!0}),t.params.freeMode.sticky){clearTimeout(d),d=void 0,u.length>=15&&u.shift();const s=u.length?u[u.length-1]:void 0,a=u[0];if(u.push(e),s&&(e.delta>s.delta||e.direction!==s.direction))u.splice(0);else if(u.length>=15&&e.time-a.time<500&&a.delta-e.delta>=1&&e.delta<=6){const s=m>0?.8:.2;c=e,u.splice(0),d=l((()=>{t.slideToClosest(t.params.speed,!0,void 0,s)}),0)}d||(d=l((()=>{c=e,u.splice(0),t.slideToClosest(t.params.speed,!0,void 0,.5)}),500))}if(a||i("scroll",s),t.params.autoplay&&t.params.autoplayDisableOnInteraction&&t.autoplay.stop(),r.releaseOnEdges&&(n===t.minTranslate()||n===t.maxTranslate()))return!0}}else{const s={time:o(),delta:Math.abs(m),direction:Math.sign(m),raw:e};u.length>=2&&u.shift();const a=u.length?u[u.length-1]:void 0;if(u.push(s),a?(s.direction!==a.direction||s.delta>a.delta||s.time>a.time+150)&&f(s):f(s),function(e){const s=t.params.mousewheel;if(e.direction<0){if(t.isEnd&&!t.params.loop&&s.releaseOnEdges)return!0}else if(t.isBeginning&&!t.params.loop&&s.releaseOnEdges)return!0;return!1}(s))return!0}return s.preventDefault?s.preventDefault():s.returnValue=!1,!1}function v(e){let s=t.el;"container"!==t.params.mousewheel.eventsTarget&&(s=document.querySelector(t.params.mousewheel.eventsTarget)),s[e]("mouseenter",m),s[e]("mouseleave",h),s[e]("wheel",g)}function w(){return t.params.cssMode?(t.wrapperEl.removeEventListener("wheel",g),!0):!t.mousewheel.enabled&&(v("addEventListener"),t.mousewheel.enabled=!0,!0)}function b(){return t.params.cssMode?(t.wrapperEl.addEventListener(event,g),!0):!!t.mousewheel.enabled&&(v("removeEventListener"),t.mousewheel.enabled=!1,!0)}a("init",(()=>{!t.params.mousewheel.enabled&&t.params.cssMode&&b(),t.params.mousewheel.enabled&&w()})),a("destroy",(()=>{t.params.cssMode&&w(),t.mousewheel.enabled&&b()})),Object.assign(t.mousewheel,{enable:w,disable:b})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;function r(e){let s;return e&&"string"==typeof e&&t.isElement&&(s=t.el.querySelector(e),s)?s:(e&&("string"==typeof e&&(s=[...document.querySelectorAll(e)]),t.params.uniqueNavElements&&"string"==typeof e&&s.length>1&&1===t.el.querySelectorAll(e).length&&(s=t.el.querySelector(e))),e&&!s?e:s)}function n(e,s){const a=t.params.navigation;(e=T(e)).forEach((e=>{e&&(e.classList[s?"add":"remove"](...a.disabledClass.split(" ")),"BUTTON"===e.tagName&&(e.disabled=s),t.params.watchOverflow&&t.enabled&&e.classList[t.isLocked?"add":"remove"](a.lockClass))}))}function l(){const{nextEl:e,prevEl:s}=t.navigation;if(t.params.loop)return n(s,!1),void n(e,!1);n(s,t.isBeginning&&!t.params.rewind),n(e,t.isEnd&&!t.params.rewind)}function o(e){e.preventDefault(),(!t.isBeginning||t.params.loop||t.params.rewind)&&(t.slidePrev(),i("navigationPrev"))}function d(e){e.preventDefault(),(!t.isEnd||t.params.loop||t.params.rewind)&&(t.slideNext(),i("navigationNext"))}function c(){const e=t.params.navigation;if(t.params.navigation=se(t,t.originalParams.navigation,t.params.navigation,{nextEl:"swiper-button-next",prevEl:"swiper-button-prev"}),!e.nextEl&&!e.prevEl)return;let s=r(e.nextEl),a=r(e.prevEl);Object.assign(t.navigation,{nextEl:s,prevEl:a}),s=T(s),a=T(a);const i=(s,a)=>{s&&s.addEventListener("click","next"===a?d:o),!t.enabled&&s&&s.classList.add(...e.lockClass.split(" "))};s.forEach((e=>i(e,"next"))),a.forEach((e=>i(e,"prev")))}function p(){let{nextEl:e,prevEl:s}=t.navigation;e=T(e),s=T(s);const a=(e,s)=>{e.removeEventListener("click","next"===s?d:o),e.classList.remove(...t.params.navigation.disabledClass.split(" "))};e.forEach((e=>a(e,"next"))),s.forEach((e=>a(e,"prev")))}s({navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock",navigationDisabledClass:"swiper-navigation-disabled"}}),t.navigation={nextEl:null,prevEl:null},a("init",(()=>{!1===t.params.navigation.enabled?u():(c(),l())})),a("toEdge fromEdge lock unlock",(()=>{l()})),a("destroy",(()=>{p()})),a("enable disable",(()=>{let{nextEl:e,prevEl:s}=t.navigation;e=T(e),s=T(s),t.enabled?l():[...e,...s].filter((e=>!!e)).forEach((e=>e.classList.add(t.params.navigation.lockClass)))})),a("click",((e,s)=>{let{nextEl:a,prevEl:r}=t.navigation;a=T(a),r=T(r);const n=s.target;if(t.params.navigation.hideOnClick&&!r.includes(n)&&!a.includes(n)){if(t.pagination&&t.params.pagination&&t.params.pagination.clickable&&(t.pagination.el===n||t.pagination.el.contains(n)))return;let e;a.length?e=a[0].classList.contains(t.params.navigation.hiddenClass):r.length&&(e=r[0].classList.contains(t.params.navigation.hiddenClass)),i(!0===e?"navigationShow":"navigationHide"),[...a,...r].filter((e=>!!e)).forEach((e=>e.classList.toggle(t.params.navigation.hiddenClass)))}}));const u=()=>{t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")),p()};Object.assign(t.navigation,{enable:()=>{t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")),c(),l()},disable:u,update:l,init:c,destroy:p})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const r="swiper-pagination";let n;s({pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:e=>e,formatFractionTotal:e=>e,bulletClass:`${r}-bullet`,bulletActiveClass:`${r}-bullet-active`,modifierClass:`${r}-`,currentClass:`${r}-current`,totalClass:`${r}-total`,hiddenClass:`${r}-hidden`,progressbarFillClass:`${r}-progressbar-fill`,progressbarOppositeClass:`${r}-progressbar-opposite`,clickableClass:`${r}-clickable`,lockClass:`${r}-lock`,horizontalClass:`${r}-horizontal`,verticalClass:`${r}-vertical`,paginationDisabledClass:`${r}-disabled`}}),t.pagination={el:null,bullets:[]};let l=0;function o(){return!t.params.pagination.el||!t.pagination.el||Array.isArray(t.pagination.el)&&0===t.pagination.el.length}function d(e,s){const{bulletActiveClass:a}=t.params.pagination;e&&(e=e[("prev"===s?"previous":"next")+"ElementSibling"])&&(e.classList.add(`${a}-${s}`),(e=e[("prev"===s?"previous":"next")+"ElementSibling"])&&e.classList.add(`${a}-${s}-${s}`))}function c(e){const s=e.target.closest(ae(t.params.pagination.bulletClass));if(!s)return;e.preventDefault();const a=y(s)*t.params.slidesPerGroup;if(t.params.loop){if(t.realIndex===a)return;t.slideToLoop(a)}else t.slideTo(a)}function p(){const e=t.rtl,s=t.params.pagination;if(o())return;let a,r,c=t.pagination.el;c=T(c);const p=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.slides.length,u=t.params.loop?Math.ceil(p/t.params.slidesPerGroup):t.snapGrid.length;if(t.params.loop?(r=t.previousRealIndex||0,a=t.params.slidesPerGroup>1?Math.floor(t.realIndex/t.params.slidesPerGroup):t.realIndex):void 0!==t.snapIndex?(a=t.snapIndex,r=t.previousSnapIndex):(r=t.previousIndex||0,a=t.activeIndex||0),"bullets"===s.type&&t.pagination.bullets&&t.pagination.bullets.length>0){const i=t.pagination.bullets;let o,p,u;if(s.dynamicBullets&&(n=S(i[0],t.isHorizontal()?"width":"height",!0),c.forEach((e=>{e.style[t.isHorizontal()?"width":"height"]=n*(s.dynamicMainBullets+4)+"px"})),s.dynamicMainBullets>1&&void 0!==r&&(l+=a-(r||0),l>s.dynamicMainBullets-1?l=s.dynamicMainBullets-1:l<0&&(l=0)),o=Math.max(a-l,0),p=o+(Math.min(i.length,s.dynamicMainBullets)-1),u=(p+o)/2),i.forEach((e=>{const t=[...["","-next","-next-next","-prev","-prev-prev","-main"].map((e=>`${s.bulletActiveClass}${e}`))].map((e=>"string"==typeof e&&e.includes(" ")?e.split(" "):e)).flat();e.classList.remove(...t)})),c.length>1)i.forEach((e=>{const i=y(e);i===a?e.classList.add(...s.bulletActiveClass.split(" ")):t.isElement&&e.setAttribute("part","bullet"),s.dynamicBullets&&(i>=o&&i<=p&&e.classList.add(...`${s.bulletActiveClass}-main`.split(" ")),i===o&&d(e,"prev"),i===p&&d(e,"next"))}));else{const e=i[a];if(e&&e.classList.add(...s.bulletActiveClass.split(" ")),t.isElement&&i.forEach(((e,t)=>{e.setAttribute("part",t===a?"bullet-active":"bullet")})),s.dynamicBullets){const e=i[o],t=i[p];for(let e=o;e<=p;e+=1)i[e]&&i[e].classList.add(...`${s.bulletActiveClass}-main`.split(" "));d(e,"prev"),d(t,"next")}}if(s.dynamicBullets){const a=Math.min(i.length,s.dynamicMainBullets+4),r=(n*a-n)/2-u*n,l=e?"right":"left";i.forEach((e=>{e.style[t.isHorizontal()?l:"top"]=`${r}px`}))}}c.forEach(((e,r)=>{if("fraction"===s.type&&(e.querySelectorAll(ae(s.currentClass)).forEach((e=>{e.textContent=s.formatFractionCurrent(a+1)})),e.querySelectorAll(ae(s.totalClass)).forEach((e=>{e.textContent=s.formatFractionTotal(u)}))),"progressbar"===s.type){let i;i=s.progressbarOpposite?t.isHorizontal()?"vertical":"horizontal":t.isHorizontal()?"horizontal":"vertical";const r=(a+1)/u;let n=1,l=1;"horizontal"===i?n=r:l=r,e.querySelectorAll(ae(s.progressbarFillClass)).forEach((e=>{e.style.transform=`translate3d(0,0,0) scaleX(${n}) scaleY(${l})`,e.style.transitionDuration=`${t.params.speed}ms`}))}"custom"===s.type&&s.renderCustom?(e.innerHTML=s.renderCustom(t,a+1,u),0===r&&i("paginationRender",e)):(0===r&&i("paginationRender",e),i("paginationUpdate",e)),t.params.watchOverflow&&t.enabled&&e.classList[t.isLocked?"add":"remove"](s.lockClass)}))}function u(){const e=t.params.pagination;if(o())return;const s=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.grid&&t.params.grid.rows>1?t.slides.length/Math.ceil(t.params.grid.rows):t.slides.length;let a=t.pagination.el;a=T(a);let r="";if("bullets"===e.type){let a=t.params.loop?Math.ceil(s/t.params.slidesPerGroup):t.snapGrid.length;t.params.freeMode&&t.params.freeMode.enabled&&a>s&&(a=s);for(let s=0;s<a;s+=1)e.renderBullet?r+=e.renderBullet.call(t,s,e.bulletClass):r+=`<${e.bulletElement} ${t.isElement?'part="bullet"':""} class="${e.bulletClass}"></${e.bulletElement}>`}"fraction"===e.type&&(r=e.renderFraction?e.renderFraction.call(t,e.currentClass,e.totalClass):`<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),"progressbar"===e.type&&(r=e.renderProgressbar?e.renderProgressbar.call(t,e.progressbarFillClass):`<span class="${e.progressbarFillClass}"></span>`),t.pagination.bullets=[],a.forEach((s=>{"custom"!==e.type&&(s.innerHTML=r||""),"bullets"===e.type&&t.pagination.bullets.push(...s.querySelectorAll(ae(e.bulletClass)))})),"custom"!==e.type&&i("paginationRender",a[0])}function m(){t.params.pagination=se(t,t.originalParams.pagination,t.params.pagination,{el:"swiper-pagination"});const e=t.params.pagination;if(!e.el)return;let s;"string"==typeof e.el&&t.isElement&&(s=t.el.querySelector(e.el)),s||"string"!=typeof e.el||(s=[...document.querySelectorAll(e.el)]),s||(s=e.el),s&&0!==s.length&&(t.params.uniqueNavElements&&"string"==typeof e.el&&Array.isArray(s)&&s.length>1&&(s=[...t.el.querySelectorAll(e.el)],s.length>1&&(s=s.filter((e=>E(e,".swiper")[0]===t.el))[0])),Array.isArray(s)&&1===s.length&&(s=s[0]),Object.assign(t.pagination,{el:s}),s=T(s),s.forEach((s=>{"bullets"===e.type&&e.clickable&&s.classList.add(...(e.clickableClass||"").split(" ")),s.classList.add(e.modifierClass+e.type),s.classList.add(t.isHorizontal()?e.horizontalClass:e.verticalClass),"bullets"===e.type&&e.dynamicBullets&&(s.classList.add(`${e.modifierClass}${e.type}-dynamic`),l=0,e.dynamicMainBullets<1&&(e.dynamicMainBullets=1)),"progressbar"===e.type&&e.progressbarOpposite&&s.classList.add(e.progressbarOppositeClass),e.clickable&&s.addEventListener("click",c),t.enabled||s.classList.add(e.lockClass)})))}function h(){const e=t.params.pagination;if(o())return;let s=t.pagination.el;s&&(s=T(s),s.forEach((s=>{s.classList.remove(e.hiddenClass),s.classList.remove(e.modifierClass+e.type),s.classList.remove(t.isHorizontal()?e.horizontalClass:e.verticalClass),e.clickable&&(s.classList.remove(...(e.clickableClass||"").split(" ")),s.removeEventListener("click",c))}))),t.pagination.bullets&&t.pagination.bullets.forEach((t=>t.classList.remove(...e.bulletActiveClass.split(" "))))}a("changeDirection",(()=>{if(!t.pagination||!t.pagination.el)return;const e=t.params.pagination;let{el:s}=t.pagination;s=T(s),s.forEach((s=>{s.classList.remove(e.horizontalClass,e.verticalClass),s.classList.add(t.isHorizontal()?e.horizontalClass:e.verticalClass)}))})),a("init",(()=>{!1===t.params.pagination.enabled?f():(m(),u(),p())})),a("activeIndexChange",(()=>{void 0===t.snapIndex&&p()})),a("snapIndexChange",(()=>{p()})),a("snapGridLengthChange",(()=>{u(),p()})),a("destroy",(()=>{h()})),a("enable disable",(()=>{let{el:e}=t.pagination;e&&(e=T(e),e.forEach((e=>e.classList[t.enabled?"remove":"add"](t.params.pagination.lockClass))))})),a("lock unlock",(()=>{p()})),a("click",((e,s)=>{const a=s.target,r=T(t.pagination.el);if(t.params.pagination.el&&t.params.pagination.hideOnClick&&r&&r.length>0&&!a.classList.contains(t.params.pagination.bulletClass)){if(t.navigation&&(t.navigation.nextEl&&a===t.navigation.nextEl||t.navigation.prevEl&&a===t.navigation.prevEl))return;const e=r[0].classList.contains(t.params.pagination.hiddenClass);i(!0===e?"paginationShow":"paginationHide"),r.forEach((e=>e.classList.toggle(t.params.pagination.hiddenClass)))}}));const f=()=>{t.el.classList.add(t.params.pagination.paginationDisabledClass);let{el:e}=t.pagination;e&&(e=T(e),e.forEach((e=>e.classList.add(t.params.pagination.paginationDisabledClass)))),h()};Object.assign(t.pagination,{enable:()=>{t.el.classList.remove(t.params.pagination.paginationDisabledClass);let{el:e}=t.pagination;e&&(e=T(e),e.forEach((e=>e.classList.remove(t.params.pagination.paginationDisabledClass)))),m(),u(),p()},disable:f,render:u,update:p,init:m,destroy:h})},function(e){let{swiper:t,extendParams:s,on:i,emit:r}=e;const o=a();let d,c,p,u,m=!1,h=null,f=null;function g(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e,rtlTranslate:s}=t,{dragEl:a,el:i}=e,r=t.params.scrollbar,n=t.params.loop?t.progressLoop:t.progress;let l=c,o=(p-c)*n;s?(o=-o,o>0?(l=c-o,o=0):-o+c>p&&(l=p+o)):o<0?(l=c+o,o=0):o+c>p&&(l=p-o),t.isHorizontal()?(a.style.transform=`translate3d(${o}px, 0, 0)`,a.style.width=`${l}px`):(a.style.transform=`translate3d(0px, ${o}px, 0)`,a.style.height=`${l}px`),r.hide&&(clearTimeout(h),i.style.opacity=1,h=setTimeout((()=>{i.style.opacity=0,i.style.transitionDuration="400ms"}),1e3))}function b(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e}=t,{dragEl:s,el:a}=e;s.style.width="",s.style.height="",p=t.isHorizontal()?a.offsetWidth:a.offsetHeight,u=t.size/(t.virtualSize+t.params.slidesOffsetBefore-(t.params.centeredSlides?t.snapGrid[0]:0)),c="auto"===t.params.scrollbar.dragSize?p*u:parseInt(t.params.scrollbar.dragSize,10),t.isHorizontal()?s.style.width=`${c}px`:s.style.height=`${c}px`,a.style.display=u>=1?"none":"",t.params.scrollbar.hide&&(a.style.opacity=0),t.params.watchOverflow&&t.enabled&&e.el.classList[t.isLocked?"add":"remove"](t.params.scrollbar.lockClass)}function y(e){return t.isHorizontal()?e.clientX:e.clientY}function E(e){const{scrollbar:s,rtlTranslate:a}=t,{el:i}=s;let r;r=(y(e)-w(i)[t.isHorizontal()?"left":"top"]-(null!==d?d:c/2))/(p-c),r=Math.max(Math.min(r,1),0),a&&(r=1-r);const n=t.minTranslate()+(t.maxTranslate()-t.minTranslate())*r;t.updateProgress(n),t.setTranslate(n),t.updateActiveIndex(),t.updateSlidesClasses()}function x(e){const s=t.params.scrollbar,{scrollbar:a,wrapperEl:i}=t,{el:n,dragEl:l}=a;m=!0,d=e.target===l?y(e)-e.target.getBoundingClientRect()[t.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),i.style.transitionDuration="100ms",l.style.transitionDuration="100ms",E(e),clearTimeout(f),n.style.transitionDuration="0ms",s.hide&&(n.style.opacity=1),t.params.cssMode&&(t.wrapperEl.style["scroll-snap-type"]="none"),r("scrollbarDragStart",e)}function S(e){const{scrollbar:s,wrapperEl:a}=t,{el:i,dragEl:n}=s;m&&(e.preventDefault?e.preventDefault():e.returnValue=!1,E(e),a.style.transitionDuration="0ms",i.style.transitionDuration="0ms",n.style.transitionDuration="0ms",r("scrollbarDragMove",e))}function M(e){const s=t.params.scrollbar,{scrollbar:a,wrapperEl:i}=t,{el:n}=a;m&&(m=!1,t.params.cssMode&&(t.wrapperEl.style["scroll-snap-type"]="",i.style.transitionDuration=""),s.hide&&(clearTimeout(f),f=l((()=>{n.style.opacity=0,n.style.transitionDuration="400ms"}),1e3)),r("scrollbarDragEnd",e),s.snapOnRelease&&t.slideToClosest())}function C(e){const{scrollbar:s,params:a}=t,i=s.el;if(!i)return;const r=i,n=!!a.passiveListeners&&{passive:!1,capture:!1},l=!!a.passiveListeners&&{passive:!0,capture:!1};if(!r)return;const d="on"===e?"addEventListener":"removeEventListener";r[d]("pointerdown",x,n),o[d]("pointermove",S,n),o[d]("pointerup",M,l)}function P(){const{scrollbar:e,el:s}=t;t.params.scrollbar=se(t,t.originalParams.scrollbar,t.params.scrollbar,{el:"swiper-scrollbar"});const a=t.params.scrollbar;if(!a.el)return;let i,r;if("string"==typeof a.el&&t.isElement&&(i=t.el.querySelector(a.el)),i||"string"!=typeof a.el)i||(i=a.el);else if(i=o.querySelectorAll(a.el),!i.length)return;t.params.uniqueNavElements&&"string"==typeof a.el&&i.length>1&&1===s.querySelectorAll(a.el).length&&(i=s.querySelector(a.el)),i.length>0&&(i=i[0]),i.classList.add(t.isHorizontal()?a.horizontalClass:a.verticalClass),i&&(r=i.querySelector(ae(t.params.scrollbar.dragClass)),r||(r=v("div",t.params.scrollbar.dragClass),i.append(r))),Object.assign(e,{el:i,dragEl:r}),a.draggable&&t.params.scrollbar.el&&t.scrollbar.el&&C("on"),i&&i.classList[t.enabled?"remove":"add"](...n(t.params.scrollbar.lockClass))}function L(){const e=t.params.scrollbar,s=t.scrollbar.el;s&&s.classList.remove(...n(t.isHorizontal()?e.horizontalClass:e.verticalClass)),t.params.scrollbar.el&&t.scrollbar.el&&C("off")}s({scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag",scrollbarDisabledClass:"swiper-scrollbar-disabled",horizontalClass:"swiper-scrollbar-horizontal",verticalClass:"swiper-scrollbar-vertical"}}),t.scrollbar={el:null,dragEl:null},i("changeDirection",(()=>{if(!t.scrollbar||!t.scrollbar.el)return;const e=t.params.scrollbar;let{el:s}=t.scrollbar;s=T(s),s.forEach((s=>{s.classList.remove(e.horizontalClass,e.verticalClass),s.classList.add(t.isHorizontal()?e.horizontalClass:e.verticalClass)}))})),i("init",(()=>{!1===t.params.scrollbar.enabled?I():(P(),b(),g())})),i("update resize observerUpdate lock unlock changeDirection",(()=>{b()})),i("setTranslate",(()=>{g()})),i("setTransition",((e,s)=>{!function(e){t.params.scrollbar.el&&t.scrollbar.el&&(t.scrollbar.dragEl.style.transitionDuration=`${e}ms`)}(s)})),i("enable disable",(()=>{const{el:e}=t.scrollbar;e&&e.classList[t.enabled?"remove":"add"](...n(t.params.scrollbar.lockClass))})),i("destroy",(()=>{L()}));const I=()=>{t.el.classList.add(...n(t.params.scrollbar.scrollbarDisabledClass)),t.scrollbar.el&&t.scrollbar.el.classList.add(...n(t.params.scrollbar.scrollbarDisabledClass)),L()};Object.assign(t.scrollbar,{enable:()=>{t.el.classList.remove(...n(t.params.scrollbar.scrollbarDisabledClass)),t.scrollbar.el&&t.scrollbar.el.classList.remove(...n(t.params.scrollbar.scrollbarDisabledClass)),P(),b(),g()},disable:I,updateSize:b,setTranslate:g,init:P,destroy:L})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({parallax:{enabled:!1}});const i="[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",r=(e,s)=>{const{rtl:a}=t,i=a?-1:1,r=e.getAttribute("data-swiper-parallax")||"0";let n=e.getAttribute("data-swiper-parallax-x"),l=e.getAttribute("data-swiper-parallax-y");const o=e.getAttribute("data-swiper-parallax-scale"),d=e.getAttribute("data-swiper-parallax-opacity"),c=e.getAttribute("data-swiper-parallax-rotate");if(n||l?(n=n||"0",l=l||"0"):t.isHorizontal()?(n=r,l="0"):(l=r,n="0"),n=n.indexOf("%")>=0?parseInt(n,10)*s*i+"%":n*s*i+"px",l=l.indexOf("%")>=0?parseInt(l,10)*s+"%":l*s+"px",null!=d){const t=d-(d-1)*(1-Math.abs(s));e.style.opacity=t}let p=`translate3d(${n}, ${l}, 0px)`;if(null!=o){p+=` scale(${o-(o-1)*(1-Math.abs(s))})`}if(c&&null!=c){p+=` rotate(${c*s*-1}deg)`}e.style.transform=p},n=()=>{const{el:e,slides:s,progress:a,snapGrid:n,isElement:l}=t,o=f(e,i);t.isElement&&o.push(...f(t.hostEl,i)),o.forEach((e=>{r(e,a)})),s.forEach(((e,s)=>{let l=e.progress;t.params.slidesPerGroup>1&&"auto"!==t.params.slidesPerView&&(l+=Math.ceil(s/2)-a*(n.length-1)),l=Math.min(Math.max(l,-1),1),e.querySelectorAll(`${i}, [data-swiper-parallax-rotate]`).forEach((e=>{r(e,l)}))}))};a("beforeInit",(()=>{t.params.parallax.enabled&&(t.params.watchSlidesProgress=!0,t.originalParams.watchSlidesProgress=!0)})),a("init",(()=>{t.params.parallax.enabled&&n()})),a("setTranslate",(()=>{t.params.parallax.enabled&&n()})),a("setTransition",((e,s)=>{t.params.parallax.enabled&&function(e){void 0===e&&(e=t.params.speed);const{el:s,hostEl:a}=t,r=[...s.querySelectorAll(i)];t.isElement&&r.push(...a.querySelectorAll(i)),r.forEach((t=>{let s=parseInt(t.getAttribute("data-swiper-parallax-duration"),10)||e;0===e&&(s=0),t.style.transitionDuration=`${s}ms`}))}(s)}))},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=r();s({zoom:{enabled:!1,limitToOriginalSize:!1,maxRatio:3,minRatio:1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}}),t.zoom={enabled:!1};let l,o,c=1,p=!1;const u=[],m={originX:0,originY:0,slideEl:void 0,slideWidth:void 0,slideHeight:void 0,imageEl:void 0,imageWrapEl:void 0,maxRatio:3},h={isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},g={x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0};let v=1;function b(){if(u.length<2)return 1;const e=u[0].pageX,t=u[0].pageY,s=u[1].pageX,a=u[1].pageY;return Math.sqrt((s-e)**2+(a-t)**2)}function y(){const e=t.params.zoom,s=m.imageWrapEl.getAttribute("data-swiper-zoom")||e.maxRatio;if(e.limitToOriginalSize&&m.imageEl&&m.imageEl.naturalWidth){const e=m.imageEl.naturalWidth/m.imageEl.offsetWidth;return Math.min(e,s)}return s}function x(e){const s=t.isElement?"swiper-slide":`.${t.params.slideClass}`;return!!e.target.matches(s)||t.slides.filter((t=>t.contains(e.target))).length>0}function S(e){if("mouse"===e.pointerType&&u.splice(0,u.length),!x(e))return;const s=t.params.zoom;if(l=!1,o=!1,u.push(e),!(u.length<2)){if(l=!0,m.scaleStart=b(),!m.slideEl){m.slideEl=e.target.closest(`.${t.params.slideClass}, swiper-slide`),m.slideEl||(m.slideEl=t.slides[t.activeIndex]);let a=m.slideEl.querySelector(`.${s.containerClass}`);if(a&&(a=a.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),m.imageEl=a,m.imageWrapEl=a?E(m.imageEl,`.${s.containerClass}`)[0]:void 0,!m.imageWrapEl)return void(m.imageEl=void 0);m.maxRatio=y()}if(m.imageEl){const[e,t]=function(){if(u.length<2)return{x:null,y:null};const e=m.imageEl.getBoundingClientRect();return[(u[0].pageX+(u[1].pageX-u[0].pageX)/2-e.x-n.scrollX)/c,(u[0].pageY+(u[1].pageY-u[0].pageY)/2-e.y-n.scrollY)/c]}();m.originX=e,m.originY=t,m.imageEl.style.transitionDuration="0ms"}p=!0}}function T(e){if(!x(e))return;const s=t.params.zoom,a=t.zoom,i=u.findIndex((t=>t.pointerId===e.pointerId));i>=0&&(u[i]=e),u.length<2||(o=!0,m.scaleMove=b(),m.imageEl&&(a.scale=m.scaleMove/m.scaleStart*c,a.scale>m.maxRatio&&(a.scale=m.maxRatio-1+(a.scale-m.maxRatio+1)**.5),a.scale<s.minRatio&&(a.scale=s.minRatio+1-(s.minRatio-a.scale+1)**.5),m.imageEl.style.transform=`translate3d(0,0,0) scale(${a.scale})`))}function M(e){if(!x(e))return;if("mouse"===e.pointerType&&"pointerout"===e.type)return;const s=t.params.zoom,a=t.zoom,i=u.findIndex((t=>t.pointerId===e.pointerId));i>=0&&u.splice(i,1),l&&o&&(l=!1,o=!1,m.imageEl&&(a.scale=Math.max(Math.min(a.scale,m.maxRatio),s.minRatio),m.imageEl.style.transitionDuration=`${t.params.speed}ms`,m.imageEl.style.transform=`translate3d(0,0,0) scale(${a.scale})`,c=a.scale,p=!1,a.scale>1&&m.slideEl?m.slideEl.classList.add(`${s.zoomedSlideClass}`):a.scale<=1&&m.slideEl&&m.slideEl.classList.remove(`${s.zoomedSlideClass}`),1===a.scale&&(m.originX=0,m.originY=0,m.slideEl=void 0)))}function C(e){if(!x(e)||!function(e){const s=`.${t.params.zoom.containerClass}`;return!!e.target.matches(s)||[...t.hostEl.querySelectorAll(s)].filter((t=>t.contains(e.target))).length>0}(e))return;const s=t.zoom;if(!m.imageEl)return;if(!h.isTouched||!m.slideEl)return;h.isMoved||(h.width=m.imageEl.offsetWidth,h.height=m.imageEl.offsetHeight,h.startX=d(m.imageWrapEl,"x")||0,h.startY=d(m.imageWrapEl,"y")||0,m.slideWidth=m.slideEl.offsetWidth,m.slideHeight=m.slideEl.offsetHeight,m.imageWrapEl.style.transitionDuration="0ms");const a=h.width*s.scale,i=h.height*s.scale;if(a<m.slideWidth&&i<m.slideHeight)return;h.minX=Math.min(m.slideWidth/2-a/2,0),h.maxX=-h.minX,h.minY=Math.min(m.slideHeight/2-i/2,0),h.maxY=-h.minY,h.touchesCurrent.x=u.length>0?u[0].pageX:e.pageX,h.touchesCurrent.y=u.length>0?u[0].pageY:e.pageY;if(Math.max(Math.abs(h.touchesCurrent.x-h.touchesStart.x),Math.abs(h.touchesCurrent.y-h.touchesStart.y))>5&&(t.allowClick=!1),!h.isMoved&&!p){if(t.isHorizontal()&&(Math.floor(h.minX)===Math.floor(h.startX)&&h.touchesCurrent.x<h.touchesStart.x||Math.floor(h.maxX)===Math.floor(h.startX)&&h.touchesCurrent.x>h.touchesStart.x))return void(h.isTouched=!1);if(!t.isHorizontal()&&(Math.floor(h.minY)===Math.floor(h.startY)&&h.touchesCurrent.y<h.touchesStart.y||Math.floor(h.maxY)===Math.floor(h.startY)&&h.touchesCurrent.y>h.touchesStart.y))return void(h.isTouched=!1)}e.cancelable&&e.preventDefault(),e.stopPropagation(),h.isMoved=!0;const r=(s.scale-c)/(m.maxRatio-t.params.zoom.minRatio),{originX:n,originY:l}=m;h.currentX=h.touchesCurrent.x-h.touchesStart.x+h.startX+r*(h.width-2*n),h.currentY=h.touchesCurrent.y-h.touchesStart.y+h.startY+r*(h.height-2*l),h.currentX<h.minX&&(h.currentX=h.minX+1-(h.minX-h.currentX+1)**.8),h.currentX>h.maxX&&(h.currentX=h.maxX-1+(h.currentX-h.maxX+1)**.8),h.currentY<h.minY&&(h.currentY=h.minY+1-(h.minY-h.currentY+1)**.8),h.currentY>h.maxY&&(h.currentY=h.maxY-1+(h.currentY-h.maxY+1)**.8),g.prevPositionX||(g.prevPositionX=h.touchesCurrent.x),g.prevPositionY||(g.prevPositionY=h.touchesCurrent.y),g.prevTime||(g.prevTime=Date.now()),g.x=(h.touchesCurrent.x-g.prevPositionX)/(Date.now()-g.prevTime)/2,g.y=(h.touchesCurrent.y-g.prevPositionY)/(Date.now()-g.prevTime)/2,Math.abs(h.touchesCurrent.x-g.prevPositionX)<2&&(g.x=0),Math.abs(h.touchesCurrent.y-g.prevPositionY)<2&&(g.y=0),g.prevPositionX=h.touchesCurrent.x,g.prevPositionY=h.touchesCurrent.y,g.prevTime=Date.now(),m.imageWrapEl.style.transform=`translate3d(${h.currentX}px, ${h.currentY}px,0)`}function P(){const e=t.zoom;m.slideEl&&t.activeIndex!==t.slides.indexOf(m.slideEl)&&(m.imageEl&&(m.imageEl.style.transform="translate3d(0,0,0) scale(1)"),m.imageWrapEl&&(m.imageWrapEl.style.transform="translate3d(0,0,0)"),m.slideEl.classList.remove(`${t.params.zoom.zoomedSlideClass}`),e.scale=1,c=1,m.slideEl=void 0,m.imageEl=void 0,m.imageWrapEl=void 0,m.originX=0,m.originY=0)}function L(e){const s=t.zoom,a=t.params.zoom;if(!m.slideEl){e&&e.target&&(m.slideEl=e.target.closest(`.${t.params.slideClass}, swiper-slide`)),m.slideEl||(t.params.virtual&&t.params.virtual.enabled&&t.virtual?m.slideEl=f(t.slidesEl,`.${t.params.slideActiveClass}`)[0]:m.slideEl=t.slides[t.activeIndex]);let s=m.slideEl.querySelector(`.${a.containerClass}`);s&&(s=s.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),m.imageEl=s,m.imageWrapEl=s?E(m.imageEl,`.${a.containerClass}`)[0]:void 0}if(!m.imageEl||!m.imageWrapEl)return;let i,r,l,o,d,p,u,g,v,b,x,S,T,M,C,P,L,I;t.params.cssMode&&(t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.touchAction="none"),m.slideEl.classList.add(`${a.zoomedSlideClass}`),void 0===h.touchesStart.x&&e?(i=e.pageX,r=e.pageY):(i=h.touchesStart.x,r=h.touchesStart.y);const z="number"==typeof e?e:null;1===c&&z&&(i=void 0,r=void 0);const A=y();s.scale=z||A,c=z||A,!e||1===c&&z?(u=0,g=0):(L=m.slideEl.offsetWidth,I=m.slideEl.offsetHeight,l=w(m.slideEl).left+n.scrollX,o=w(m.slideEl).top+n.scrollY,d=l+L/2-i,p=o+I/2-r,v=m.imageEl.offsetWidth,b=m.imageEl.offsetHeight,x=v*s.scale,S=b*s.scale,T=Math.min(L/2-x/2,0),M=Math.min(I/2-S/2,0),C=-T,P=-M,u=d*s.scale,g=p*s.scale,u<T&&(u=T),u>C&&(u=C),g<M&&(g=M),g>P&&(g=P)),z&&1===s.scale&&(m.originX=0,m.originY=0),m.imageWrapEl.style.transitionDuration="300ms",m.imageWrapEl.style.transform=`translate3d(${u}px, ${g}px,0)`,m.imageEl.style.transitionDuration="300ms",m.imageEl.style.transform=`translate3d(0,0,0) scale(${s.scale})`}function I(){const e=t.zoom,s=t.params.zoom;if(!m.slideEl){t.params.virtual&&t.params.virtual.enabled&&t.virtual?m.slideEl=f(t.slidesEl,`.${t.params.slideActiveClass}`)[0]:m.slideEl=t.slides[t.activeIndex];let e=m.slideEl.querySelector(`.${s.containerClass}`);e&&(e=e.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),m.imageEl=e,m.imageWrapEl=e?E(m.imageEl,`.${s.containerClass}`)[0]:void 0}m.imageEl&&m.imageWrapEl&&(t.params.cssMode&&(t.wrapperEl.style.overflow="",t.wrapperEl.style.touchAction=""),e.scale=1,c=1,m.imageWrapEl.style.transitionDuration="300ms",m.imageWrapEl.style.transform="translate3d(0,0,0)",m.imageEl.style.transitionDuration="300ms",m.imageEl.style.transform="translate3d(0,0,0) scale(1)",m.slideEl.classList.remove(`${s.zoomedSlideClass}`),m.slideEl=void 0,m.originX=0,m.originY=0)}function z(e){const s=t.zoom;s.scale&&1!==s.scale?I():L(e)}function A(){return{passiveListener:!!t.params.passiveListeners&&{passive:!0,capture:!1},activeListenerWithCapture:!t.params.passiveListeners||{passive:!1,capture:!0}}}function $(){const e=t.zoom;if(e.enabled)return;e.enabled=!0;const{passiveListener:s,activeListenerWithCapture:a}=A();t.wrapperEl.addEventListener("pointerdown",S,s),t.wrapperEl.addEventListener("pointermove",T,a),["pointerup","pointercancel","pointerout"].forEach((e=>{t.wrapperEl.addEventListener(e,M,s)})),t.wrapperEl.addEventListener("pointermove",C,a)}function k(){const e=t.zoom;if(!e.enabled)return;e.enabled=!1;const{passiveListener:s,activeListenerWithCapture:a}=A();t.wrapperEl.removeEventListener("pointerdown",S,s),t.wrapperEl.removeEventListener("pointermove",T,a),["pointerup","pointercancel","pointerout"].forEach((e=>{t.wrapperEl.removeEventListener(e,M,s)})),t.wrapperEl.removeEventListener("pointermove",C,a)}Object.defineProperty(t.zoom,"scale",{get:()=>v,set(e){if(v!==e){const t=m.imageEl,s=m.slideEl;i("zoomChange",e,t,s)}v=e}}),a("init",(()=>{t.params.zoom.enabled&&$()})),a("destroy",(()=>{k()})),a("touchStart",((e,s)=>{t.zoom.enabled&&function(e){const s=t.device;if(!m.imageEl)return;if(h.isTouched)return;s.android&&e.cancelable&&e.preventDefault(),h.isTouched=!0;const a=u.length>0?u[0]:e;h.touchesStart.x=a.pageX,h.touchesStart.y=a.pageY}(s)})),a("touchEnd",((e,s)=>{t.zoom.enabled&&function(){const e=t.zoom;if(!m.imageEl)return;if(!h.isTouched||!h.isMoved)return h.isTouched=!1,void(h.isMoved=!1);h.isTouched=!1,h.isMoved=!1;let s=300,a=300;const i=g.x*s,r=h.currentX+i,n=g.y*a,l=h.currentY+n;0!==g.x&&(s=Math.abs((r-h.currentX)/g.x)),0!==g.y&&(a=Math.abs((l-h.currentY)/g.y));const o=Math.max(s,a);h.currentX=r,h.currentY=l;const d=h.width*e.scale,c=h.height*e.scale;h.minX=Math.min(m.slideWidth/2-d/2,0),h.maxX=-h.minX,h.minY=Math.min(m.slideHeight/2-c/2,0),h.maxY=-h.minY,h.currentX=Math.max(Math.min(h.currentX,h.maxX),h.minX),h.currentY=Math.max(Math.min(h.currentY,h.maxY),h.minY),m.imageWrapEl.style.transitionDuration=`${o}ms`,m.imageWrapEl.style.transform=`translate3d(${h.currentX}px, ${h.currentY}px,0)`}()})),a("doubleTap",((e,s)=>{!t.animating&&t.params.zoom.enabled&&t.zoom.enabled&&t.params.zoom.toggle&&z(s)})),a("transitionEnd",(()=>{t.zoom.enabled&&t.params.zoom.enabled&&P()})),a("slideChange",(()=>{t.zoom.enabled&&t.params.zoom.enabled&&t.params.cssMode&&P()})),Object.assign(t.zoom,{enable:$,disable:k,in:L,out:I,toggle:z})},function(e){let{swiper:t,extendParams:s,on:a}=e;function i(e,t){const s=function(){let e,t,s;return(a,i)=>{for(t=-1,e=a.length;e-t>1;)s=e+t>>1,a[s]<=i?t=s:e=s;return e}}();let a,i;return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(i=s(this.x,e),a=i-1,(e-this.x[a])*(this.y[i]-this.y[a])/(this.x[i]-this.x[a])+this.y[a]):0},this}function r(){t.controller.control&&t.controller.spline&&(t.controller.spline=void 0,delete t.controller.spline)}s({controller:{control:void 0,inverse:!1,by:"slide"}}),t.controller={control:void 0},a("beforeInit",(()=>{if("undefined"!=typeof window&&("string"==typeof t.params.controller.control||t.params.controller.control instanceof HTMLElement)){const e=document.querySelector(t.params.controller.control);if(e&&e.swiper)t.controller.control=e.swiper;else if(e){const s=a=>{t.controller.control=a.detail[0],t.update(),e.removeEventListener("init",s)};e.addEventListener("init",s)}}else t.controller.control=t.params.controller.control})),a("update",(()=>{r()})),a("resize",(()=>{r()})),a("observerUpdate",(()=>{r()})),a("setTranslate",((e,s,a)=>{t.controller.control&&!t.controller.control.destroyed&&t.controller.setTranslate(s,a)})),a("setTransition",((e,s,a)=>{t.controller.control&&!t.controller.control.destroyed&&t.controller.setTransition(s,a)})),Object.assign(t.controller,{setTranslate:function(e,s){const a=t.controller.control;let r,n;const l=t.constructor;function o(e){if(e.destroyed)return;const s=t.rtlTranslate?-t.translate:t.translate;"slide"===t.params.controller.by&&(!function(e){t.controller.spline=t.params.loop?new i(t.slidesGrid,e.slidesGrid):new i(t.snapGrid,e.snapGrid)}(e),n=-t.controller.spline.interpolate(-s)),n&&"container"!==t.params.controller.by||(r=(e.maxTranslate()-e.minTranslate())/(t.maxTranslate()-t.minTranslate()),!Number.isNaN(r)&&Number.isFinite(r)||(r=1),n=(s-t.minTranslate())*r+e.minTranslate()),t.params.controller.inverse&&(n=e.maxTranslate()-n),e.updateProgress(n),e.setTranslate(n,t),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(a))for(let e=0;e<a.length;e+=1)a[e]!==s&&a[e]instanceof l&&o(a[e]);else a instanceof l&&s!==a&&o(a)},setTransition:function(e,s){const a=t.constructor,i=t.controller.control;let r;function n(s){s.destroyed||(s.setTransition(e,t),0!==e&&(s.transitionStart(),s.params.autoHeight&&l((()=>{s.updateAutoHeight()})),x(s.wrapperEl,(()=>{i&&s.transitionEnd()}))))}if(Array.isArray(i))for(r=0;r<i.length;r+=1)i[r]!==s&&i[r]instanceof a&&n(i[r]);else i instanceof a&&s!==i&&n(i)}})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",slideLabelMessage:"{{index}} / {{slidesLength}}",containerMessage:null,containerRoleDescriptionMessage:null,itemRoleDescriptionMessage:null,slideRole:"group",id:null}}),t.a11y={clicked:!1};let i=null;function r(e){const t=i;0!==t.length&&(t.innerHTML="",t.innerHTML=e)}function n(e){(e=T(e)).forEach((e=>{e.setAttribute("tabIndex","0")}))}function l(e){(e=T(e)).forEach((e=>{e.setAttribute("tabIndex","-1")}))}function o(e,t){(e=T(e)).forEach((e=>{e.setAttribute("role",t)}))}function d(e,t){(e=T(e)).forEach((e=>{e.setAttribute("aria-roledescription",t)}))}function c(e,t){(e=T(e)).forEach((e=>{e.setAttribute("aria-label",t)}))}function p(e){(e=T(e)).forEach((e=>{e.setAttribute("aria-disabled",!0)}))}function u(e){(e=T(e)).forEach((e=>{e.setAttribute("aria-disabled",!1)}))}function m(e){if(13!==e.keyCode&&32!==e.keyCode)return;const s=t.params.a11y,a=e.target;t.pagination&&t.pagination.el&&(a===t.pagination.el||t.pagination.el.contains(e.target))&&!e.target.matches(ae(t.params.pagination.bulletClass))||(t.navigation&&t.navigation.nextEl&&a===t.navigation.nextEl&&(t.isEnd&&!t.params.loop||t.slideNext(),t.isEnd?r(s.lastSlideMessage):r(s.nextSlideMessage)),t.navigation&&t.navigation.prevEl&&a===t.navigation.prevEl&&(t.isBeginning&&!t.params.loop||t.slidePrev(),t.isBeginning?r(s.firstSlideMessage):r(s.prevSlideMessage)),t.pagination&&a.matches(ae(t.params.pagination.bulletClass))&&a.click())}function h(){return t.pagination&&t.pagination.bullets&&t.pagination.bullets.length}function f(){return h()&&t.params.pagination.clickable}const g=(e,t,s)=>{n(e),"BUTTON"!==e.tagName&&(o(e,"button"),e.addEventListener("keydown",m)),c(e,s),function(e,t){(e=T(e)).forEach((e=>{e.setAttribute("aria-controls",t)}))}(e,t)},w=()=>{t.a11y.clicked=!0},b=()=>{requestAnimationFrame((()=>{requestAnimationFrame((()=>{t.destroyed||(t.a11y.clicked=!1)}))}))},E=e=>{if(t.a11y.clicked)return;const s=e.target.closest(`.${t.params.slideClass}, swiper-slide`);if(!s||!t.slides.includes(s))return;const a=t.slides.indexOf(s)===t.activeIndex,i=t.params.watchSlidesProgress&&t.visibleSlides&&t.visibleSlides.includes(s);a||i||e.sourceCapabilities&&e.sourceCapabilities.firesTouchEvents||(t.isHorizontal()?t.el.scrollLeft=0:t.el.scrollTop=0,t.slideTo(t.slides.indexOf(s),0))},x=()=>{const e=t.params.a11y;e.itemRoleDescriptionMessage&&d(t.slides,e.itemRoleDescriptionMessage),e.slideRole&&o(t.slides,e.slideRole);const s=t.slides.length;e.slideLabelMessage&&t.slides.forEach(((a,i)=>{const r=t.params.loop?parseInt(a.getAttribute("data-swiper-slide-index"),10):i;c(a,e.slideLabelMessage.replace(/\{\{index\}\}/,r+1).replace(/\{\{slidesLength\}\}/,s))}))},S=()=>{const e=t.params.a11y;t.el.append(i);const s=t.el;e.containerRoleDescriptionMessage&&d(s,e.containerRoleDescriptionMessage),e.containerMessage&&c(s,e.containerMessage);const a=t.wrapperEl,r=e.id||a.getAttribute("id")||`swiper-wrapper-${n=16,void 0===n&&(n=16),"x".repeat(n).replace(/x/g,(()=>Math.round(16*Math.random()).toString(16)))}`;var n;const l=t.params.autoplay&&t.params.autoplay.enabled?"off":"polite";var o;o=r,T(a).forEach((e=>{e.setAttribute("id",o)})),function(e,t){(e=T(e)).forEach((e=>{e.setAttribute("aria-live",t)}))}(a,l),x();let{nextEl:p,prevEl:u}=t.navigation?t.navigation:{};if(p=T(p),u=T(u),p&&p.forEach((t=>g(t,r,e.nextSlideMessage))),u&&u.forEach((t=>g(t,r,e.prevSlideMessage))),f()){T(t.pagination.el).forEach((e=>{e.addEventListener("keydown",m)}))}t.el.addEventListener("focus",E,!0),t.el.addEventListener("pointerdown",w,!0),t.el.addEventListener("pointerup",b,!0)};a("beforeInit",(()=>{i=v("span",t.params.a11y.notificationClass),i.setAttribute("aria-live","assertive"),i.setAttribute("aria-atomic","true")})),a("afterInit",(()=>{t.params.a11y.enabled&&S()})),a("slidesLengthChange snapGridLengthChange slidesGridLengthChange",(()=>{t.params.a11y.enabled&&x()})),a("fromEdge toEdge afterInit lock unlock",(()=>{t.params.a11y.enabled&&function(){if(t.params.loop||t.params.rewind||!t.navigation)return;const{nextEl:e,prevEl:s}=t.navigation;s&&(t.isBeginning?(p(s),l(s)):(u(s),n(s))),e&&(t.isEnd?(p(e),l(e)):(u(e),n(e)))}()})),a("paginationUpdate",(()=>{t.params.a11y.enabled&&function(){const e=t.params.a11y;h()&&t.pagination.bullets.forEach((s=>{t.params.pagination.clickable&&(n(s),t.params.pagination.renderBullet||(o(s,"button"),c(s,e.paginationBulletMessage.replace(/\{\{index\}\}/,y(s)+1)))),s.matches(ae(t.params.pagination.bulletActiveClass))?s.setAttribute("aria-current","true"):s.removeAttribute("aria-current")}))}()})),a("destroy",(()=>{t.params.a11y.enabled&&function(){i&&i.remove();let{nextEl:e,prevEl:s}=t.navigation?t.navigation:{};e=T(e),s=T(s),e&&e.forEach((e=>e.removeEventListener("keydown",m))),s&&s.forEach((e=>e.removeEventListener("keydown",m))),f()&&T(t.pagination.el).forEach((e=>{e.removeEventListener("keydown",m)}));t.el.removeEventListener("focus",E,!0),t.el.removeEventListener("pointerdown",w,!0),t.el.removeEventListener("pointerup",b,!0)}()}))},function(e){let{swiper:t,extendParams:s,on:a}=e;s({history:{enabled:!1,root:"",replaceState:!1,key:"slides",keepQuery:!1}});let i=!1,n={};const l=e=>e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,""),o=e=>{const t=r();let s;s=e?new URL(e):t.location;const a=s.pathname.slice(1).split("/").filter((e=>""!==e)),i=a.length;return{key:a[i-2],value:a[i-1]}},d=(e,s)=>{const a=r();if(!i||!t.params.history.enabled)return;let n;n=t.params.url?new URL(t.params.url):a.location;const o=t.virtual&&t.params.virtual.enabled?t.slidesEl.querySelector(`[data-swiper-slide-index="${s}"]`):t.slides[s];let d=l(o.getAttribute("data-history"));if(t.params.history.root.length>0){let s=t.params.history.root;"/"===s[s.length-1]&&(s=s.slice(0,s.length-1)),d=`${s}/${e?`${e}/`:""}${d}`}else n.pathname.includes(e)||(d=`${e?`${e}/`:""}${d}`);t.params.history.keepQuery&&(d+=n.search);const c=a.history.state;c&&c.value===d||(t.params.history.replaceState?a.history.replaceState({value:d},null,d):a.history.pushState({value:d},null,d))},c=(e,s,a)=>{if(s)for(let i=0,r=t.slides.length;i<r;i+=1){const r=t.slides[i];if(l(r.getAttribute("data-history"))===s){const s=t.getSlideIndex(r);t.slideTo(s,e,a)}}else t.slideTo(0,e,a)},p=()=>{n=o(t.params.url),c(t.params.speed,n.value,!1)};a("init",(()=>{t.params.history.enabled&&(()=>{const e=r();if(t.params.history){if(!e.history||!e.history.pushState)return t.params.history.enabled=!1,void(t.params.hashNavigation.enabled=!0);i=!0,n=o(t.params.url),n.key||n.value?(c(0,n.value,t.params.runCallbacksOnInit),t.params.history.replaceState||e.addEventListener("popstate",p)):t.params.history.replaceState||e.addEventListener("popstate",p)}})()})),a("destroy",(()=>{t.params.history.enabled&&(()=>{const e=r();t.params.history.replaceState||e.removeEventListener("popstate",p)})()})),a("transitionEnd _freeModeNoMomentumRelease",(()=>{i&&d(t.params.history.key,t.activeIndex)})),a("slideChange",(()=>{i&&t.params.cssMode&&d(t.params.history.key,t.activeIndex)}))},function(e){let{swiper:t,extendParams:s,emit:i,on:n}=e,l=!1;const o=a(),d=r();s({hashNavigation:{enabled:!1,replaceState:!1,watchState:!1,getSlideIndex(e,s){if(t.virtual&&t.params.virtual.enabled){const e=t.slides.filter((e=>e.getAttribute("data-hash")===s))[0];if(!e)return 0;return parseInt(e.getAttribute("data-swiper-slide-index"),10)}return t.getSlideIndex(f(t.slidesEl,`.${t.params.slideClass}[data-hash="${s}"], swiper-slide[data-hash="${s}"]`)[0])}}});const c=()=>{i("hashChange");const e=o.location.hash.replace("#",""),s=t.virtual&&t.params.virtual.enabled?t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`):t.slides[t.activeIndex];if(e!==(s?s.getAttribute("data-hash"):"")){const s=t.params.hashNavigation.getSlideIndex(t,e);if(void 0===s||Number.isNaN(s))return;t.slideTo(s)}},p=()=>{if(!l||!t.params.hashNavigation.enabled)return;const e=t.virtual&&t.params.virtual.enabled?t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`):t.slides[t.activeIndex],s=e?e.getAttribute("data-hash")||e.getAttribute("data-history"):"";t.params.hashNavigation.replaceState&&d.history&&d.history.replaceState?(d.history.replaceState(null,null,`#${s}`||""),i("hashSet")):(o.location.hash=s||"",i("hashSet"))};n("init",(()=>{t.params.hashNavigation.enabled&&(()=>{if(!t.params.hashNavigation.enabled||t.params.history&&t.params.history.enabled)return;l=!0;const e=o.location.hash.replace("#","");if(e){const s=0,a=t.params.hashNavigation.getSlideIndex(t,e);t.slideTo(a||0,s,t.params.runCallbacksOnInit,!0)}t.params.hashNavigation.watchState&&d.addEventListener("hashchange",c)})()})),n("destroy",(()=>{t.params.hashNavigation.enabled&&t.params.hashNavigation.watchState&&d.removeEventListener("hashchange",c)})),n("transitionEnd _freeModeNoMomentumRelease",(()=>{l&&p()})),n("slideChange",(()=>{l&&t.params.cssMode&&p()}))},function(e){let t,s,{swiper:i,extendParams:r,on:n,emit:l,params:o}=e;i.autoplay={running:!1,paused:!1,timeLeft:0},r({autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!1,stopOnLastSlide:!1,reverseDirection:!1,pauseOnMouseEnter:!1}});let d,c,p,u,m,h,f,g,v=o&&o.autoplay?o.autoplay.delay:3e3,w=o&&o.autoplay?o.autoplay.delay:3e3,b=(new Date).getTime();function y(e){i&&!i.destroyed&&i.wrapperEl&&e.target===i.wrapperEl&&(i.wrapperEl.removeEventListener("transitionend",y),g||C())}const E=()=>{if(i.destroyed||!i.autoplay.running)return;i.autoplay.paused?c=!0:c&&(w=d,c=!1);const e=i.autoplay.paused?d:b+w-(new Date).getTime();i.autoplay.timeLeft=e,l("autoplayTimeLeft",e,e/v),s=requestAnimationFrame((()=>{E()}))},x=e=>{if(i.destroyed||!i.autoplay.running)return;cancelAnimationFrame(s),E();let a=void 0===e?i.params.autoplay.delay:e;v=i.params.autoplay.delay,w=i.params.autoplay.delay;const r=(()=>{let e;if(e=i.virtual&&i.params.virtual.enabled?i.slides.filter((e=>e.classList.contains("swiper-slide-active")))[0]:i.slides[i.activeIndex],!e)return;return parseInt(e.getAttribute("data-swiper-autoplay"),10)})();!Number.isNaN(r)&&r>0&&void 0===e&&(a=r,v=r,w=r),d=a;const n=i.params.speed,o=()=>{i&&!i.destroyed&&(i.params.autoplay.reverseDirection?!i.isBeginning||i.params.loop||i.params.rewind?(i.slidePrev(n,!0,!0),l("autoplay")):i.params.autoplay.stopOnLastSlide||(i.slideTo(i.slides.length-1,n,!0,!0),l("autoplay")):!i.isEnd||i.params.loop||i.params.rewind?(i.slideNext(n,!0,!0),l("autoplay")):i.params.autoplay.stopOnLastSlide||(i.slideTo(0,n,!0,!0),l("autoplay")),i.params.cssMode&&(b=(new Date).getTime(),requestAnimationFrame((()=>{x()}))))};return a>0?(clearTimeout(t),t=setTimeout((()=>{o()}),a)):requestAnimationFrame((()=>{o()})),a},S=()=>{b=(new Date).getTime(),i.autoplay.running=!0,x(),l("autoplayStart")},T=()=>{i.autoplay.running=!1,clearTimeout(t),cancelAnimationFrame(s),l("autoplayStop")},M=(e,s)=>{if(i.destroyed||!i.autoplay.running)return;clearTimeout(t),e||(f=!0);const a=()=>{l("autoplayPause"),i.params.autoplay.waitForTransition?i.wrapperEl.addEventListener("transitionend",y):C()};if(i.autoplay.paused=!0,s)return h&&(d=i.params.autoplay.delay),h=!1,void a();const r=d||i.params.autoplay.delay;d=r-((new Date).getTime()-b),i.isEnd&&d<0&&!i.params.loop||(d<0&&(d=0),a())},C=()=>{i.isEnd&&d<0&&!i.params.loop||i.destroyed||!i.autoplay.running||(b=(new Date).getTime(),f?(f=!1,x(d)):x(),i.autoplay.paused=!1,l("autoplayResume"))},P=()=>{if(i.destroyed||!i.autoplay.running)return;const e=a();"hidden"===e.visibilityState&&(f=!0,M(!0)),"visible"===e.visibilityState&&C()},L=e=>{"mouse"===e.pointerType&&(f=!0,g=!0,i.animating||i.autoplay.paused||M(!0))},I=e=>{"mouse"===e.pointerType&&(g=!1,i.autoplay.paused&&C())};n("init",(()=>{i.params.autoplay.enabled&&(i.params.autoplay.pauseOnMouseEnter&&(i.el.addEventListener("pointerenter",L),i.el.addEventListener("pointerleave",I)),a().addEventListener("visibilitychange",P),S())})),n("destroy",(()=>{i.el.removeEventListener("pointerenter",L),i.el.removeEventListener("pointerleave",I),a().removeEventListener("visibilitychange",P),i.autoplay.running&&T()})),n("_freeModeStaticRelease",(()=>{(u||f)&&C()})),n("_freeModeNoMomentumRelease",(()=>{i.params.autoplay.disableOnInteraction?T():M(!0,!0)})),n("beforeTransitionStart",((e,t,s)=>{!i.destroyed&&i.autoplay.running&&(s||!i.params.autoplay.disableOnInteraction?M(!0,!0):T())})),n("sliderFirstMove",(()=>{!i.destroyed&&i.autoplay.running&&(i.params.autoplay.disableOnInteraction?T():(p=!0,u=!1,f=!1,m=setTimeout((()=>{f=!0,u=!0,M(!0)}),200)))})),n("touchEnd",(()=>{if(!i.destroyed&&i.autoplay.running&&p){if(clearTimeout(m),clearTimeout(t),i.params.autoplay.disableOnInteraction)return u=!1,void(p=!1);u&&i.params.cssMode&&C(),u=!1,p=!1}})),n("slideChange",(()=>{!i.destroyed&&i.autoplay.running&&(h=!0)})),Object.assign(i.autoplay,{start:S,stop:T,pause:M,resume:C})},function(e){let{swiper:t,extendParams:s,on:i}=e;s({thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-thumbs"}});let r=!1,n=!1;function l(){const e=t.thumbs.swiper;if(!e||e.destroyed)return;const s=e.clickedIndex,a=e.clickedSlide;if(a&&a.classList.contains(t.params.thumbs.slideThumbActiveClass))return;if(null==s)return;let i;i=e.params.loop?parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"),10):s,t.params.loop?t.slideToLoop(i):t.slideTo(i)}function o(){const{thumbs:e}=t.params;if(r)return!1;r=!0;const s=t.constructor;if(e.swiper instanceof s)t.thumbs.swiper=e.swiper,Object.assign(t.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),Object.assign(t.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1}),t.thumbs.swiper.update();else if(c(e.swiper)){const a=Object.assign({},e.swiper);Object.assign(a,{watchSlidesProgress:!0,slideToClickedSlide:!1}),t.thumbs.swiper=new s(a),n=!0}return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass),t.thumbs.swiper.on("tap",l),!0}function d(e){const s=t.thumbs.swiper;if(!s||s.destroyed)return;const a="auto"===s.params.slidesPerView?s.slidesPerViewDynamic():s.params.slidesPerView;let i=1;const r=t.params.thumbs.slideThumbActiveClass;if(t.params.slidesPerView>1&&!t.params.centeredSlides&&(i=t.params.slidesPerView),t.params.thumbs.multipleActiveThumbs||(i=1),i=Math.floor(i),s.slides.forEach((e=>e.classList.remove(r))),s.params.loop||s.params.virtual&&s.params.virtual.enabled)for(let e=0;e<i;e+=1)f(s.slidesEl,`[data-swiper-slide-index="${t.realIndex+e}"]`).forEach((e=>{e.classList.add(r)}));else for(let e=0;e<i;e+=1)s.slides[t.realIndex+e]&&s.slides[t.realIndex+e].classList.add(r);const n=t.params.thumbs.autoScrollOffset,l=n&&!s.params.loop;if(t.realIndex!==s.realIndex||l){const i=s.activeIndex;let r,o;if(s.params.loop){const e=s.slides.filter((e=>e.getAttribute("data-swiper-slide-index")===`${t.realIndex}`))[0];r=s.slides.indexOf(e),o=t.activeIndex>t.previousIndex?"next":"prev"}else r=t.realIndex,o=r>t.previousIndex?"next":"prev";l&&(r+="next"===o?n:-1*n),s.visibleSlidesIndexes&&s.visibleSlidesIndexes.indexOf(r)<0&&(s.params.centeredSlides?r=r>i?r-Math.floor(a/2)+1:r+Math.floor(a/2)-1:r>i&&s.params.slidesPerGroup,s.slideTo(r,e?0:void 0))}}t.thumbs={swiper:null},i("beforeInit",(()=>{const{thumbs:e}=t.params;if(e&&e.swiper)if("string"==typeof e.swiper||e.swiper instanceof HTMLElement){const s=a(),i=()=>{const a="string"==typeof e.swiper?s.querySelector(e.swiper):e.swiper;if(a&&a.swiper)e.swiper=a.swiper,o(),d(!0);else if(a){const s=i=>{e.swiper=i.detail[0],a.removeEventListener("init",s),o(),d(!0),e.swiper.update(),t.update()};a.addEventListener("init",s)}return a},r=()=>{if(t.destroyed)return;i()||requestAnimationFrame(r)};requestAnimationFrame(r)}else o(),d(!0)})),i("slideChange update resize observerUpdate",(()=>{d()})),i("setTransition",((e,s)=>{const a=t.thumbs.swiper;a&&!a.destroyed&&a.setTransition(s)})),i("beforeDestroy",(()=>{const e=t.thumbs.swiper;e&&!e.destroyed&&n&&e.destroy()})),Object.assign(t.thumbs,{init:o,update:d})},function(e){let{swiper:t,extendParams:s,emit:a,once:i}=e;s({freeMode:{enabled:!1,momentum:!0,momentumRatio:1,momentumBounce:!0,momentumBounceRatio:1,momentumVelocityRatio:1,sticky:!1,minimumVelocity:.02}}),Object.assign(t,{freeMode:{onTouchStart:function(){if(t.params.cssMode)return;const e=t.getTranslate();t.setTranslate(e),t.setTransition(0),t.touchEventsData.velocities.length=0,t.freeMode.onTouchEnd({currentPos:t.rtl?t.translate:-t.translate})},onTouchMove:function(){if(t.params.cssMode)return;const{touchEventsData:e,touches:s}=t;0===e.velocities.length&&e.velocities.push({position:s[t.isHorizontal()?"startX":"startY"],time:e.touchStartTime}),e.velocities.push({position:s[t.isHorizontal()?"currentX":"currentY"],time:o()})},onTouchEnd:function(e){let{currentPos:s}=e;if(t.params.cssMode)return;const{params:r,wrapperEl:n,rtlTranslate:l,snapGrid:d,touchEventsData:c}=t,p=o()-c.touchStartTime;if(s<-t.minTranslate())t.slideTo(t.activeIndex);else if(s>-t.maxTranslate())t.slides.length<d.length?t.slideTo(d.length-1):t.slideTo(t.slides.length-1);else{if(r.freeMode.momentum){if(c.velocities.length>1){const e=c.velocities.pop(),s=c.velocities.pop(),a=e.position-s.position,i=e.time-s.time;t.velocity=a/i,t.velocity/=2,Math.abs(t.velocity)<r.freeMode.minimumVelocity&&(t.velocity=0),(i>150||o()-e.time>300)&&(t.velocity=0)}else t.velocity=0;t.velocity*=r.freeMode.momentumVelocityRatio,c.velocities.length=0;let e=1e3*r.freeMode.momentumRatio;const s=t.velocity*e;let p=t.translate+s;l&&(p=-p);let u,m=!1;const h=20*Math.abs(t.velocity)*r.freeMode.momentumBounceRatio;let f;if(p<t.maxTranslate())r.freeMode.momentumBounce?(p+t.maxTranslate()<-h&&(p=t.maxTranslate()-h),u=t.maxTranslate(),m=!0,c.allowMomentumBounce=!0):p=t.maxTranslate(),r.loop&&r.centeredSlides&&(f=!0);else if(p>t.minTranslate())r.freeMode.momentumBounce?(p-t.minTranslate()>h&&(p=t.minTranslate()+h),u=t.minTranslate(),m=!0,c.allowMomentumBounce=!0):p=t.minTranslate(),r.loop&&r.centeredSlides&&(f=!0);else if(r.freeMode.sticky){let e;for(let t=0;t<d.length;t+=1)if(d[t]>-p){e=t;break}p=Math.abs(d[e]-p)<Math.abs(d[e-1]-p)||"next"===t.swipeDirection?d[e]:d[e-1],p=-p}if(f&&i("transitionEnd",(()=>{t.loopFix()})),0!==t.velocity){if(e=l?Math.abs((-p-t.translate)/t.velocity):Math.abs((p-t.translate)/t.velocity),r.freeMode.sticky){const s=Math.abs((l?-p:p)-t.translate),a=t.slidesSizesGrid[t.activeIndex];e=s<a?r.speed:s<2*a?1.5*r.speed:2.5*r.speed}}else if(r.freeMode.sticky)return void t.slideToClosest();r.freeMode.momentumBounce&&m?(t.updateProgress(u),t.setTransition(e),t.setTranslate(p),t.transitionStart(!0,t.swipeDirection),t.animating=!0,x(n,(()=>{t&&!t.destroyed&&c.allowMomentumBounce&&(a("momentumBounce"),t.setTransition(r.speed),setTimeout((()=>{t.setTranslate(u),x(n,(()=>{t&&!t.destroyed&&t.transitionEnd()}))}),0))}))):t.velocity?(a("_freeModeNoMomentumRelease"),t.updateProgress(p),t.setTransition(e),t.setTranslate(p),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,x(n,(()=>{t&&!t.destroyed&&t.transitionEnd()})))):t.updateProgress(p),t.updateActiveIndex(),t.updateSlidesClasses()}else{if(r.freeMode.sticky)return void t.slideToClosest();r.freeMode&&a("_freeModeNoMomentumRelease")}(!r.freeMode.momentum||p>=r.longSwipesMs)&&(a("_freeModeStaticRelease"),t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}}}})},function(e){let t,s,a,i,{swiper:r,extendParams:n,on:l}=e;n({grid:{rows:1,fill:"column"}});const o=()=>{let e=r.params.spaceBetween;return"string"==typeof e&&e.indexOf("%")>=0?e=parseFloat(e.replace("%",""))/100*r.size:"string"==typeof e&&(e=parseFloat(e)),e};l("init",(()=>{i=r.params.grid&&r.params.grid.rows>1})),l("update",(()=>{const{params:e,el:t}=r,s=e.grid&&e.grid.rows>1;i&&!s?(t.classList.remove(`${e.containerModifierClass}grid`,`${e.containerModifierClass}grid-column`),a=1,r.emitContainerClasses()):!i&&s&&(t.classList.add(`${e.containerModifierClass}grid`),"column"===e.grid.fill&&t.classList.add(`${e.containerModifierClass}grid-column`),r.emitContainerClasses()),i=s})),r.grid={initSlides:e=>{const{slidesPerView:i}=r.params,{rows:n,fill:l}=r.params.grid,o=r.virtual&&r.params.virtual.enabled?r.virtual.slides.length:e.length;a=Math.floor(o/n),t=Math.floor(o/n)===o/n?o:Math.ceil(o/n)*n,"auto"!==i&&"row"===l&&(t=Math.max(t,i*n)),s=t/n},unsetSlides:()=>{r.slides&&r.slides.forEach((e=>{e.swiperSlideGridSet&&(e.style.height="",e.style[r.getDirectionLabel("margin-top")]="")}))},updateSlide:(e,i,n)=>{const{slidesPerGroup:l}=r.params,d=o(),{rows:c,fill:p}=r.params.grid,u=r.virtual&&r.params.virtual.enabled?r.virtual.slides.length:n.length;let m,h,f;if("row"===p&&l>1){const s=Math.floor(e/(l*c)),a=e-c*l*s,r=0===s?l:Math.min(Math.ceil((u-s*c*l)/c),l);f=Math.floor(a/r),h=a-f*r+s*l,m=h+f*t/c,i.style.order=m}else"column"===p?(h=Math.floor(e/c),f=e-h*c,(h>a||h===a&&f===c-1)&&(f+=1,f>=c&&(f=0,h+=1))):(f=Math.floor(e/s),h=e-f*s);i.row=f,i.column=h,i.style.height=`calc((100% - ${(c-1)*d}px) / ${c})`,i.style[r.getDirectionLabel("margin-top")]=0!==f?d&&`${d}px`:"",i.swiperSlideGridSet=!0},updateWrapperSize:(e,s)=>{const{centeredSlides:a,roundLengths:i}=r.params,n=o(),{rows:l}=r.params.grid;if(r.virtualSize=(e+n)*t,r.virtualSize=Math.ceil(r.virtualSize/l)-n,r.params.cssMode||(r.wrapperEl.style[r.getDirectionLabel("width")]=`${r.virtualSize+n}px`),a){const e=[];for(let t=0;t<s.length;t+=1){let a=s[t];i&&(a=Math.floor(a)),s[t]<r.virtualSize+s[0]&&e.push(a)}s.splice(0,s.length),s.push(...e)}}}},function(e){let{swiper:t}=e;Object.assign(t,{appendSlide:ie.bind(t),prependSlide:re.bind(t),addSlide:ne.bind(t),removeSlide:le.bind(t),removeAllSlides:oe.bind(t)})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({fadeEffect:{crossFade:!1}}),de({effect:"fade",swiper:t,on:a,setTranslate:()=>{const{slides:e}=t;t.params.fadeEffect;for(let s=0;s<e.length;s+=1){const e=t.slides[s];let a=-e.swiperSlideOffset;t.params.virtualTranslate||(a-=t.translate);let i=0;t.isHorizontal()||(i=a,a=0);const r=t.params.fadeEffect.crossFade?Math.max(1-Math.abs(e.progress),0):1+Math.min(Math.max(e.progress,-1),0),n=ce(0,e);n.style.opacity=r,n.style.transform=`translate3d(${a}px, ${i}px, 0px)`}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`})),pe({swiper:t,duration:e,transformElements:s,allSlides:!0})},overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}});const i=(e,t,s)=>{let a=s?e.querySelector(".swiper-slide-shadow-left"):e.querySelector(".swiper-slide-shadow-top"),i=s?e.querySelector(".swiper-slide-shadow-right"):e.querySelector(".swiper-slide-shadow-bottom");a||(a=v("div",("swiper-slide-shadow-cube swiper-slide-shadow-"+(s?"left":"top")).split(" ")),e.append(a)),i||(i=v("div",("swiper-slide-shadow-cube swiper-slide-shadow-"+(s?"right":"bottom")).split(" ")),e.append(i)),a&&(a.style.opacity=Math.max(-t,0)),i&&(i.style.opacity=Math.max(t,0))};de({effect:"cube",swiper:t,on:a,setTranslate:()=>{const{el:e,wrapperEl:s,slides:a,width:r,height:n,rtlTranslate:l,size:o,browser:d}=t,c=t.params.cubeEffect,p=t.isHorizontal(),u=t.virtual&&t.params.virtual.enabled;let m,h=0;c.shadow&&(p?(m=t.wrapperEl.querySelector(".swiper-cube-shadow"),m||(m=v("div","swiper-cube-shadow"),t.wrapperEl.append(m)),m.style.height=`${r}px`):(m=e.querySelector(".swiper-cube-shadow"),m||(m=v("div","swiper-cube-shadow"),e.append(m))));for(let e=0;e<a.length;e+=1){const s=a[e];let r=e;u&&(r=parseInt(s.getAttribute("data-swiper-slide-index"),10));let n=90*r,d=Math.floor(n/360);l&&(n=-n,d=Math.floor(-n/360));const m=Math.max(Math.min(s.progress,1),-1);let f=0,g=0,v=0;r%4==0?(f=4*-d*o,v=0):(r-1)%4==0?(f=0,v=4*-d*o):(r-2)%4==0?(f=o+4*d*o,v=o):(r-3)%4==0&&(f=-o,v=3*o+4*o*d),l&&(f=-f),p||(g=f,f=0);const w=`rotateX(${p?0:-n}deg) rotateY(${p?n:0}deg) translate3d(${f}px, ${g}px, ${v}px)`;m<=1&&m>-1&&(h=90*r+90*m,l&&(h=90*-r-90*m),t.browser&&t.browser.need3dFix&&Math.abs(h)/90%2==1&&(h+=.001)),s.style.transform=w,c.slideShadows&&i(s,m,p)}if(s.style.transformOrigin=`50% 50% -${o/2}px`,s.style["-webkit-transform-origin"]=`50% 50% -${o/2}px`,c.shadow)if(p)m.style.transform=`translate3d(0px, ${r/2+c.shadowOffset}px, ${-r/2}px) rotateX(89.99deg) rotateZ(0deg) scale(${c.shadowScale})`;else{const e=Math.abs(h)-90*Math.floor(Math.abs(h)/90),t=1.5-(Math.sin(2*e*Math.PI/360)/2+Math.cos(2*e*Math.PI/360)/2),s=c.shadowScale,a=c.shadowScale/t,i=c.shadowOffset;m.style.transform=`scale3d(${s}, 1, ${a}) translate3d(0px, ${n/2+i}px, ${-n/2/a}px) rotateX(-89.99deg)`}const f=(d.isSafari||d.isWebView)&&d.needPerspectiveFix?-o/2:0;s.style.transform=`translate3d(0px,0,${f}px) rotateX(${t.isHorizontal()?0:h}deg) rotateY(${t.isHorizontal()?-h:0}deg)`,s.style.setProperty("--swiper-cube-translate-z",`${f}px`)},setTransition:e=>{const{el:s,slides:a}=t;if(a.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),t.params.cubeEffect.shadow&&!t.isHorizontal()){const t=s.querySelector(".swiper-cube-shadow");t&&(t.style.transitionDuration=`${e}ms`)}},recreateShadows:()=>{const e=t.isHorizontal();t.slides.forEach((t=>{const s=Math.max(Math.min(t.progress,1),-1);i(t,s,e)}))},getEffectParams:()=>t.params.cubeEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({flipEffect:{slideShadows:!0,limitRotation:!0}});const i=(e,s)=>{let a=t.isHorizontal()?e.querySelector(".swiper-slide-shadow-left"):e.querySelector(".swiper-slide-shadow-top"),i=t.isHorizontal()?e.querySelector(".swiper-slide-shadow-right"):e.querySelector(".swiper-slide-shadow-bottom");a||(a=ue("flip",e,t.isHorizontal()?"left":"top")),i||(i=ue("flip",e,t.isHorizontal()?"right":"bottom")),a&&(a.style.opacity=Math.max(-s,0)),i&&(i.style.opacity=Math.max(s,0))};de({effect:"flip",swiper:t,on:a,setTranslate:()=>{const{slides:e,rtlTranslate:s}=t,a=t.params.flipEffect;for(let r=0;r<e.length;r+=1){const n=e[r];let l=n.progress;t.params.flipEffect.limitRotation&&(l=Math.max(Math.min(n.progress,1),-1));const o=n.swiperSlideOffset;let d=-180*l,c=0,p=t.params.cssMode?-o-t.translate:-o,u=0;t.isHorizontal()?s&&(d=-d):(u=p,p=0,c=-d,d=0),t.browser&&t.browser.need3dFix&&(Math.abs(d)/90%2==1&&(d+=.001),Math.abs(c)/90%2==1&&(c+=.001)),n.style.zIndex=-Math.abs(Math.round(l))+e.length,a.slideShadows&&i(n,l);const m=`translate3d(${p}px, ${u}px, 0px) rotateX(${c}deg) rotateY(${d}deg)`;ce(0,n).style.transform=m}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),pe({swiper:t,duration:e,transformElements:s})},recreateShadows:()=>{t.params.flipEffect,t.slides.forEach((e=>{let s=e.progress;t.params.flipEffect.limitRotation&&(s=Math.max(Math.min(e.progress,1),-1)),i(e,s)}))},getEffectParams:()=>t.params.flipEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({coverflowEffect:{rotate:50,stretch:0,depth:100,scale:1,modifier:1,slideShadows:!0}}),de({effect:"coverflow",swiper:t,on:a,setTranslate:()=>{const{width:e,height:s,slides:a,slidesSizesGrid:i}=t,r=t.params.coverflowEffect,n=t.isHorizontal(),l=t.translate,o=n?e/2-l:s/2-l,d=n?r.rotate:-r.rotate,c=r.depth;for(let e=0,s=a.length;e<s;e+=1){const s=a[e],l=i[e],p=(o-s.swiperSlideOffset-l/2)/l,u="function"==typeof r.modifier?r.modifier(p):p*r.modifier;let m=n?d*u:0,h=n?0:d*u,f=-c*Math.abs(u),g=r.stretch;"string"==typeof g&&-1!==g.indexOf("%")&&(g=parseFloat(r.stretch)/100*l);let v=n?0:g*u,w=n?g*u:0,b=1-(1-r.scale)*Math.abs(u);Math.abs(w)<.001&&(w=0),Math.abs(v)<.001&&(v=0),Math.abs(f)<.001&&(f=0),Math.abs(m)<.001&&(m=0),Math.abs(h)<.001&&(h=0),Math.abs(b)<.001&&(b=0),t.browser&&t.browser.need3dFix&&(Math.abs(m)/90%2==1&&(m+=.001),Math.abs(h)/90%2==1&&(h+=.001));const y=`translate3d(${w}px,${v}px,${f}px)  rotateX(${h}deg) rotateY(${m}deg) scale(${b})`;if(ce(0,s).style.transform=y,s.style.zIndex=1-Math.abs(Math.round(u)),r.slideShadows){let e=n?s.querySelector(".swiper-slide-shadow-left"):s.querySelector(".swiper-slide-shadow-top"),t=n?s.querySelector(".swiper-slide-shadow-right"):s.querySelector(".swiper-slide-shadow-bottom");e||(e=ue("coverflow",s,n?"left":"top")),t||(t=ue("coverflow",s,n?"right":"bottom")),e&&(e.style.opacity=u>0?u:0),t&&(t.style.opacity=-u>0?-u:0)}}},setTransition:e=>{t.slides.map((e=>h(e))).forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))}))},perspective:()=>!0,overwriteParams:()=>({watchSlidesProgress:!0})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({creativeEffect:{limitProgress:1,shadowPerProgress:!1,progressMultiplier:1,perspective:!0,prev:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1},next:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1}}});const i=e=>"string"==typeof e?e:`${e}px`;de({effect:"creative",swiper:t,on:a,setTranslate:()=>{const{slides:e,wrapperEl:s,slidesSizesGrid:a}=t,r=t.params.creativeEffect,{progressMultiplier:n}=r,l=t.params.centeredSlides;if(l){const e=a[0]/2-t.params.slidesOffsetBefore||0;s.style.transform=`translateX(calc(50% - ${e}px))`}for(let s=0;s<e.length;s+=1){const a=e[s],o=a.progress,d=Math.min(Math.max(a.progress,-r.limitProgress),r.limitProgress);let c=d;l||(c=Math.min(Math.max(a.originalProgress,-r.limitProgress),r.limitProgress));const p=a.swiperSlideOffset,u=[t.params.cssMode?-p-t.translate:-p,0,0],m=[0,0,0];let h=!1;t.isHorizontal()||(u[1]=u[0],u[0]=0);let f={translate:[0,0,0],rotate:[0,0,0],scale:1,opacity:1};d<0?(f=r.next,h=!0):d>0&&(f=r.prev,h=!0),u.forEach(((e,t)=>{u[t]=`calc(${e}px + (${i(f.translate[t])} * ${Math.abs(d*n)}))`})),m.forEach(((e,s)=>{let a=f.rotate[s]*Math.abs(d*n);t.browser&&t.browser.need3dFix&&Math.abs(a)/90%2==1&&(a+=.001),m[s]=a})),a.style.zIndex=-Math.abs(Math.round(o))+e.length;const g=u.join(", "),v=`rotateX(${m[0]}deg) rotateY(${m[1]}deg) rotateZ(${m[2]}deg)`,w=c<0?`scale(${1+(1-f.scale)*c*n})`:`scale(${1-(1-f.scale)*c*n})`,b=c<0?1+(1-f.opacity)*c*n:1-(1-f.opacity)*c*n,y=`translate3d(${g}) ${v} ${w}`;if(h&&f.shadow||!h){let e=a.querySelector(".swiper-slide-shadow");if(!e&&f.shadow&&(e=ue("creative",a)),e){const t=r.shadowPerProgress?d*(1/r.limitProgress):d;e.style.opacity=Math.min(Math.max(Math.abs(t),0),1)}}const E=ce(0,a);E.style.transform=y,E.style.opacity=b,f.origin&&(E.style.transformOrigin=f.origin)}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),pe({swiper:t,duration:e,transformElements:s,allSlides:!0})},perspective:()=>t.params.creativeEffect.perspective,overwriteParams:()=>({watchSlidesProgress:!0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({cardsEffect:{slideShadows:!0,rotate:!0,perSlideRotate:2,perSlideOffset:8}}),de({effect:"cards",swiper:t,on:a,setTranslate:()=>{const{slides:e,activeIndex:s,rtlTranslate:a}=t,i=t.params.cardsEffect,{startTranslate:r,isTouched:n}=t.touchEventsData,l=a?-t.translate:t.translate;for(let o=0;o<e.length;o+=1){const d=e[o],c=d.progress,p=Math.min(Math.max(c,-4),4);let u=d.swiperSlideOffset;t.params.centeredSlides&&!t.params.cssMode&&(t.wrapperEl.style.transform=`translateX(${t.minTranslate()}px)`),t.params.centeredSlides&&t.params.cssMode&&(u-=e[0].swiperSlideOffset);let m=t.params.cssMode?-u-t.translate:-u,h=0;const f=-100*Math.abs(p);let g=1,v=-i.perSlideRotate*p,w=i.perSlideOffset-.75*Math.abs(p);const b=t.virtual&&t.params.virtual.enabled?t.virtual.from+o:o,y=(b===s||b===s-1)&&p>0&&p<1&&(n||t.params.cssMode)&&l<r,E=(b===s||b===s+1)&&p<0&&p>-1&&(n||t.params.cssMode)&&l>r;if(y||E){const e=(1-Math.abs((Math.abs(p)-.5)/.5))**.5;v+=-28*p*e,g+=-.5*e,w+=96*e,h=-25*e*Math.abs(p)+"%"}if(m=p<0?`calc(${m}px ${a?"-":"+"} (${w*Math.abs(p)}%))`:p>0?`calc(${m}px ${a?"-":"+"} (-${w*Math.abs(p)}%))`:`${m}px`,!t.isHorizontal()){const e=h;h=m,m=e}const x=p<0?""+(1+(1-g)*p):""+(1-(1-g)*p),S=`\n        translate3d(${m}, ${h}, ${f}px)\n        rotateZ(${i.rotate?a?-v:v:0}deg)\n        scale(${x})\n      `;if(i.slideShadows){let e=d.querySelector(".swiper-slide-shadow");e||(e=ue("cards",d)),e&&(e.style.opacity=Math.min(Math.max((Math.abs(p)-.5)/.5,0),1))}d.style.zIndex=-Math.abs(Math.round(c))+e.length;ce(0,d).style.transform=S}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),pe({swiper:t,duration:e,transformElements:s})},perspective:()=>!0,overwriteParams:()=>({watchSlidesProgress:!0,virtualTranslate:!t.params.cssMode})})}];return te.use(me),te}();
//# sourceMappingURL=swiper-bundle.min.js.map
/*!
 * GSAP 3.12.5
 * https://gsap.com
 * 
 * @license Copyright 2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t=t||self).window=t.window||{})}(this,function(e){"use strict";function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _assertThisInitialized(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function r(t){return"string"==typeof t}function s(t){return"function"==typeof t}function t(t){return"number"==typeof t}function u(t){return void 0===t}function v(t){return"object"==typeof t}function w(t){return!1!==t}function x(){return"undefined"!=typeof window}function y(t){return s(t)||r(t)}function P(t){return(i=yt(t,ot))&&ze}function Q(t,e){return console.warn("Invalid property",t,"set to",e,"Missing plugin? gsap.registerPlugin()")}function R(t,e){return!e&&console.warn(t)}function S(t,e){return t&&(ot[t]=e)&&i&&(i[t]=e)||ot}function T(){return 0}function ea(t){var e,r,i=t[0];if(v(i)||s(i)||(t=[t]),!(e=(i._gsap||{}).harness)){for(r=gt.length;r--&&!gt[r].targetTest(i););e=gt[r]}for(r=t.length;r--;)t[r]&&(t[r]._gsap||(t[r]._gsap=new Vt(t[r],e)))||t.splice(r,1);return t}function fa(t){return t._gsap||ea(Mt(t))[0]._gsap}function ga(t,e,r){return(r=t[e])&&s(r)?t[e]():u(r)&&t.getAttribute&&t.getAttribute(e)||r}function ha(t,e){return(t=t.split(",")).forEach(e)||t}function ia(t){return Math.round(1e5*t)/1e5||0}function ja(t){return Math.round(1e7*t)/1e7||0}function ka(t,e){var r=e.charAt(0),i=parseFloat(e.substr(2));return t=parseFloat(t),"+"===r?t+i:"-"===r?t-i:"*"===r?t*i:t/i}function la(t,e){for(var r=e.length,i=0;t.indexOf(e[i])<0&&++i<r;);return i<r}function ma(){var t,e,r=dt.length,i=dt.slice(0);for(ct={},t=dt.length=0;t<r;t++)(e=i[t])&&e._lazy&&(e.render(e._lazy[0],e._lazy[1],!0)._lazy=0)}function na(t,e,r,i){dt.length&&!L&&ma(),t.render(e,r,i||L&&e<0&&(t._initted||t._startAt)),dt.length&&!L&&ma()}function oa(t){var e=parseFloat(t);return(e||0===e)&&(t+"").match(at).length<2?e:r(t)?t.trim():t}function pa(t){return t}function qa(t,e){for(var r in e)r in t||(t[r]=e[r]);return t}function ta(t,e){for(var r in e)"__proto__"!==r&&"constructor"!==r&&"prototype"!==r&&(t[r]=v(e[r])?ta(t[r]||(t[r]={}),e[r]):e[r]);return t}function ua(t,e){var r,i={};for(r in t)r in e||(i[r]=t[r]);return i}function va(t){var e=t.parent||I,r=t.keyframes?function _setKeyframeDefaults(i){return function(t,e){for(var r in e)r in t||"duration"===r&&i||"ease"===r||(t[r]=e[r])}}(Z(t.keyframes)):qa;if(w(t.inherit))for(;e;)r(t,e.vars.defaults),e=e.parent||e._dp;return t}function xa(t,e,r,i,n){void 0===r&&(r="_first"),void 0===i&&(i="_last");var a,s=t[i];if(n)for(a=e[n];s&&s[n]>a;)s=s._prev;return s?(e._next=s._next,s._next=e):(e._next=t[r],t[r]=e),e._next?e._next._prev=e:t[i]=e,e._prev=s,e.parent=e._dp=t,e}function ya(t,e,r,i){void 0===r&&(r="_first"),void 0===i&&(i="_last");var n=e._prev,a=e._next;n?n._next=a:t[r]===e&&(t[r]=a),a?a._prev=n:t[i]===e&&(t[i]=n),e._next=e._prev=e.parent=null}function za(t,e){t.parent&&(!e||t.parent.autoRemoveChildren)&&t.parent.remove&&t.parent.remove(t),t._act=0}function Aa(t,e){if(t&&(!e||e._end>t._dur||e._start<0))for(var r=t;r;)r._dirty=1,r=r.parent;return t}function Ca(t,e,r,i){return t._startAt&&(L?t._startAt.revert(ht):t.vars.immediateRender&&!t.vars.autoRevert||t._startAt.render(e,!0,i))}function Ea(t){return t._repeat?Tt(t._tTime,t=t.duration()+t._rDelay)*t:0}function Ga(t,e){return(t-e._start)*e._ts+(0<=e._ts?0:e._dirty?e.totalDuration():e._tDur)}function Ha(t){return t._end=ja(t._start+(t._tDur/Math.abs(t._ts||t._rts||X)||0))}function Ia(t,e){var r=t._dp;return r&&r.smoothChildTiming&&t._ts&&(t._start=ja(r._time-(0<t._ts?e/t._ts:((t._dirty?t.totalDuration():t._tDur)-e)/-t._ts)),Ha(t),r._dirty||Aa(r,t)),t}function Ja(t,e){var r;if((e._time||!e._dur&&e._initted||e._start<t._time&&(e._dur||!e.add))&&(r=Ga(t.rawTime(),e),(!e._dur||Ot(0,e.totalDuration(),r)-e._tTime>X)&&e.render(r,!0)),Aa(t,e)._dp&&t._initted&&t._time>=t._dur&&t._ts){if(t._dur<t.duration())for(r=t;r._dp;)0<=r.rawTime()&&r.totalTime(r._tTime),r=r._dp;t._zTime=-X}}function Ka(e,r,i,n){return r.parent&&za(r),r._start=ja((t(i)?i:i||e!==I?xt(e,i,r):e._time)+r._delay),r._end=ja(r._start+(r.totalDuration()/Math.abs(r.timeScale())||0)),xa(e,r,"_first","_last",e._sort?"_start":0),bt(r)||(e._recent=r),n||Ja(e,r),e._ts<0&&Ia(e,e._tTime),e}function La(t,e){return(ot.ScrollTrigger||Q("scrollTrigger",e))&&ot.ScrollTrigger.create(e,t)}function Ma(t,e,r,i,n){return Qt(t,e,n),t._initted?!r&&t._pt&&!L&&(t._dur&&!1!==t.vars.lazy||!t._dur&&t.vars.lazy)&&f!==Rt.frame?(dt.push(t),t._lazy=[n,i],1):void 0:1}function Ra(t,e,r,i){var n=t._repeat,a=ja(e)||0,s=t._tTime/t._tDur;return s&&!i&&(t._time*=a/t._dur),t._dur=a,t._tDur=n?n<0?1e10:ja(a*(n+1)+t._rDelay*n):a,0<s&&!i&&Ia(t,t._tTime=t._tDur*s),t.parent&&Ha(t),r||Aa(t.parent,t),t}function Sa(t){return t instanceof Xt?Aa(t):Ra(t,t._dur)}function Va(e,r,i){var n,a,s=t(r[1]),o=(s?2:1)+(e<2?0:1),u=r[o];if(s&&(u.duration=r[1]),u.parent=i,e){for(n=u,a=i;a&&!("immediateRender"in n);)n=a.vars.defaults||{},a=w(a.vars.inherit)&&a.parent;u.immediateRender=w(n.immediateRender),e<2?u.runBackwards=1:u.startAt=r[o-1]}return new $t(r[0],u,r[1+o])}function Wa(t,e){return t||0===t?e(t):e}function Ya(t,e){return r(t)&&(e=st.exec(t))?e[1]:""}function _a(t,e){return t&&v(t)&&"length"in t&&(!e&&!t.length||t.length-1 in t&&v(t[0]))&&!t.nodeType&&t!==h}function cb(r){return r=Mt(r)[0]||R("Invalid scope")||{},function(t){var e=r.current||r.nativeElement||r;return Mt(t,e.querySelectorAll?e:e===r?R("Invalid scope")||a.createElement("div"):r)}}function db(t){return t.sort(function(){return.5-Math.random()})}function eb(t){if(s(t))return t;var p=v(t)?t:{each:t},_=jt(p.ease),m=p.from||0,g=parseFloat(p.base)||0,y={},e=0<m&&m<1,T=isNaN(m)||e,b=p.axis,w=m,x=m;return r(m)?w=x={center:.5,edges:.5,end:1}[m]||0:!e&&T&&(w=m[0],x=m[1]),function(t,e,r){var i,n,a,s,o,u,h,l,f,d=(r||p).length,c=y[d];if(!c){if(!(f="auto"===p.grid?0:(p.grid||[1,U])[1])){for(h=-U;h<(h=r[f++].getBoundingClientRect().left)&&f<d;);f<d&&f--}for(c=y[d]=[],i=T?Math.min(f,d)*w-.5:m%f,n=f===U?0:T?d*x/f-.5:m/f|0,l=U,u=h=0;u<d;u++)a=u%f-i,s=n-(u/f|0),c[u]=o=b?Math.abs("y"===b?s:a):K(a*a+s*s),h<o&&(h=o),o<l&&(l=o);"random"===m&&db(c),c.max=h-l,c.min=l,c.v=d=(parseFloat(p.amount)||parseFloat(p.each)*(d<f?d-1:b?"y"===b?d/f:f:Math.max(f,d/f))||0)*("edges"===m?-1:1),c.b=d<0?g-d:g,c.u=Ya(p.amount||p.each)||0,_=_&&d<0?Yt(_):_}return d=(c[t]-c.min)/c.max||0,ja(c.b+(_?_(d):d)*c.v)+c.u}}function fb(i){var n=Math.pow(10,((i+"").split(".")[1]||"").length);return function(e){var r=ja(Math.round(parseFloat(e)/i)*i*n);return(r-r%1)/n+(t(e)?0:Ya(e))}}function gb(h,e){var l,f,r=Z(h);return!r&&v(h)&&(l=r=h.radius||U,h.values?(h=Mt(h.values),(f=!t(h[0]))&&(l*=l)):h=fb(h.increment)),Wa(e,r?s(h)?function(t){return f=h(t),Math.abs(f-t)<=l?f:t}:function(e){for(var r,i,n=parseFloat(f?e.x:e),a=parseFloat(f?e.y:0),s=U,o=0,u=h.length;u--;)(r=f?(r=h[u].x-n)*r+(i=h[u].y-a)*i:Math.abs(h[u]-n))<s&&(s=r,o=u);return o=!l||s<=l?h[o]:e,f||o===e||t(e)?o:o+Ya(e)}:fb(h))}function hb(t,e,r,i){return Wa(Z(t)?!e:!0===r?!!(r=0):!i,function(){return Z(t)?t[~~(Math.random()*t.length)]:(r=r||1e-5)&&(i=r<1?Math.pow(10,(r+"").length-2):1)&&Math.floor(Math.round((t-r/2+Math.random()*(e-t+.99*r))/r)*r*i)/i})}function lb(e,r,t){return Wa(t,function(t){return e[~~r(t)]})}function ob(t){for(var e,r,i,n,a=0,s="";~(e=t.indexOf("random(",a));)i=t.indexOf(")",e),n="["===t.charAt(e+7),r=t.substr(e+7,i-e-7).match(n?at:tt),s+=t.substr(a,e-a)+hb(n?r:+r[0],n?0:+r[1],+r[2]||1e-5),a=i+1;return s+t.substr(a,t.length-a)}function rb(t,e,r){var i,n,a,s=t.labels,o=U;for(i in s)(n=s[i]-e)<0==!!r&&n&&o>(n=Math.abs(n))&&(a=i,o=n);return a}function tb(t){return za(t),t.scrollTrigger&&t.scrollTrigger.kill(!!L),t.progress()<1&&Ct(t,"onInterrupt"),t}function wb(t){if(t)if(t=!t.name&&t.default||t,x()||t.headless){var e=t.name,r=s(t),i=e&&!r&&t.init?function(){this._props=[]}:t,n={init:T,render:he,add:Wt,kill:ce,modifier:fe,rawVars:0},a={targetTest:0,get:0,getSetter:ne,aliases:{},register:0};if(Ft(),t!==i){if(pt[e])return;qa(i,qa(ua(t,n),a)),yt(i.prototype,yt(n,ua(t,a))),pt[i.prop=e]=i,t.targetTest&&(gt.push(i),ft[e]=1),e=("css"===e?"CSS":e.charAt(0).toUpperCase()+e.substr(1))+"Plugin"}S(e,i),t.register&&t.register(ze,i,_e)}else At.push(t)}function zb(t,e,r){return(6*(t+=t<0?1:1<t?-1:0)<1?e+(r-e)*t*6:t<.5?r:3*t<2?e+(r-e)*(2/3-t)*6:e)*St+.5|0}function Ab(e,r,i){var n,a,s,o,u,h,l,f,d,c,p=e?t(e)?[e>>16,e>>8&St,e&St]:0:zt.black;if(!p){if(","===e.substr(-1)&&(e=e.substr(0,e.length-1)),zt[e])p=zt[e];else if("#"===e.charAt(0)){if(e.length<6&&(e="#"+(n=e.charAt(1))+n+(a=e.charAt(2))+a+(s=e.charAt(3))+s+(5===e.length?e.charAt(4)+e.charAt(4):"")),9===e.length)return[(p=parseInt(e.substr(1,6),16))>>16,p>>8&St,p&St,parseInt(e.substr(7),16)/255];p=[(e=parseInt(e.substr(1),16))>>16,e>>8&St,e&St]}else if("hsl"===e.substr(0,3))if(p=c=e.match(tt),r){if(~e.indexOf("="))return p=e.match(et),i&&p.length<4&&(p[3]=1),p}else o=+p[0]%360/360,u=p[1]/100,n=2*(h=p[2]/100)-(a=h<=.5?h*(u+1):h+u-h*u),3<p.length&&(p[3]*=1),p[0]=zb(o+1/3,n,a),p[1]=zb(o,n,a),p[2]=zb(o-1/3,n,a);else p=e.match(tt)||zt.transparent;p=p.map(Number)}return r&&!c&&(n=p[0]/St,a=p[1]/St,s=p[2]/St,h=((l=Math.max(n,a,s))+(f=Math.min(n,a,s)))/2,l===f?o=u=0:(d=l-f,u=.5<h?d/(2-l-f):d/(l+f),o=l===n?(a-s)/d+(a<s?6:0):l===a?(s-n)/d+2:(n-a)/d+4,o*=60),p[0]=~~(o+.5),p[1]=~~(100*u+.5),p[2]=~~(100*h+.5)),i&&p.length<4&&(p[3]=1),p}function Bb(t){var r=[],i=[],n=-1;return t.split(Et).forEach(function(t){var e=t.match(rt)||[];r.push.apply(r,e),i.push(n+=e.length+1)}),r.c=i,r}function Cb(t,e,r){var i,n,a,s,o="",u=(t+o).match(Et),h=e?"hsla(":"rgba(",l=0;if(!u)return t;if(u=u.map(function(t){return(t=Ab(t,e,1))&&h+(e?t[0]+","+t[1]+"%,"+t[2]+"%,"+t[3]:t.join(","))+")"}),r&&(a=Bb(t),(i=r.c).join(o)!==a.c.join(o)))for(s=(n=t.replace(Et,"1").split(rt)).length-1;l<s;l++)o+=n[l]+(~i.indexOf(l)?u.shift()||h+"0,0,0,0)":(a.length?a:u.length?u:r).shift());if(!n)for(s=(n=t.split(Et)).length-1;l<s;l++)o+=n[l]+u[l];return o+n[s]}function Fb(t){var e,r=t.join(" ");if(Et.lastIndex=0,Et.test(r))return e=Dt.test(r),t[1]=Cb(t[1],e),t[0]=Cb(t[0],e,Bb(t[1])),!0}function Ob(t){var e=(t+"").split("("),r=Lt[e[0]];return r&&1<e.length&&r.config?r.config.apply(null,~t.indexOf("{")?[function _parseObjectInString(t){for(var e,r,i,n={},a=t.substr(1,t.length-3).split(":"),s=a[0],o=1,u=a.length;o<u;o++)r=a[o],e=o!==u-1?r.lastIndexOf(","):r.length,i=r.substr(0,e),n[s]=isNaN(i)?i.replace(Bt,"").trim():+i,s=r.substr(e+1).trim();return n}(e[1])]:function _valueInParentheses(t){var e=t.indexOf("(")+1,r=t.indexOf(")"),i=t.indexOf("(",e);return t.substring(e,~i&&i<r?t.indexOf(")",r+1):r)}(t).split(",").map(oa)):Lt._CE&&It.test(t)?Lt._CE("",t):r}function Qb(t,e){for(var r,i=t._first;i;)i instanceof Xt?Qb(i,e):!i.vars.yoyoEase||i._yoyo&&i._repeat||i._yoyo===e||(i.timeline?Qb(i.timeline,e):(r=i._ease,i._ease=i._yEase,i._yEase=r,i._yoyo=e)),i=i._next}function Sb(t,e,r,i){void 0===r&&(r=function easeOut(t){return 1-e(1-t)}),void 0===i&&(i=function easeInOut(t){return t<.5?e(2*t)/2:1-e(2*(1-t))/2});var n,a={easeIn:e,easeOut:r,easeInOut:i};return ha(t,function(t){for(var e in Lt[t]=ot[t]=a,Lt[n=t.toLowerCase()]=r,a)Lt[n+("easeIn"===e?".in":"easeOut"===e?".out":".inOut")]=Lt[t+"."+e]=a[e]}),a}function Tb(e){return function(t){return t<.5?(1-e(1-2*t))/2:.5+e(2*(t-.5))/2}}function Ub(r,t,e){function Jm(t){return 1===t?1:i*Math.pow(2,-10*t)*H((t-a)*n)+1}var i=1<=t?t:1,n=(e||(r?.3:.45))/(t<1?t:1),a=n/N*(Math.asin(1/i)||0),s="out"===r?Jm:"in"===r?function(t){return 1-Jm(1-t)}:Tb(Jm);return n=N/n,s.config=function(t,e){return Ub(r,t,e)},s}function Vb(e,r){function Rm(t){return t?--t*t*((r+1)*t+r)+1:0}void 0===r&&(r=1.70158);var t="out"===e?Rm:"in"===e?function(t){return 1-Rm(1-t)}:Tb(Rm);return t.config=function(t){return Vb(e,t)},t}var F,L,l,I,h,n,a,i,o,f,d,c,p,_,m,g,b,O,k,M,C,A,z,E,D,B,Y,j,q={autoSleep:120,force3D:"auto",nullTargetWarn:1,units:{lineHeight:""}},V={duration:.5,overwrite:!1,delay:0},U=1e8,X=1/U,N=2*Math.PI,G=N/4,W=0,K=Math.sqrt,J=Math.cos,H=Math.sin,$="function"==typeof ArrayBuffer&&ArrayBuffer.isView||function(){},Z=Array.isArray,tt=/(?:-?\.?\d|\.)+/gi,et=/[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,rt=/[-+=.]*\d+[.e-]*\d*[a-z%]*/g,it=/[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,nt=/[+-]=-?[.\d]+/,at=/[^,'"\[\]\s]+/gi,st=/^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,ot={},ut={suppressEvents:!0,isStart:!0,kill:!1},ht={suppressEvents:!0,kill:!1},lt={suppressEvents:!0},ft={},dt=[],ct={},pt={},_t={},mt=30,gt=[],vt="",yt=function _merge(t,e){for(var r in e)t[r]=e[r];return t},Tt=function _animationCycle(t,e){var r=Math.floor(t/=e);return t&&r===t?r-1:r},bt=function _isFromOrFromStart(t){var e=t.data;return"isFromStart"===e||"isStart"===e},wt={_start:0,endTime:T,totalDuration:T},xt=function _parsePosition(t,e,i){var n,a,s,o=t.labels,u=t._recent||wt,h=t.duration()>=U?u.endTime(!1):t._dur;return r(e)&&(isNaN(e)||e in o)?(a=e.charAt(0),s="%"===e.substr(-1),n=e.indexOf("="),"<"===a||">"===a?(0<=n&&(e=e.replace(/=/,"")),("<"===a?u._start:u.endTime(0<=u._repeat))+(parseFloat(e.substr(1))||0)*(s?(n<0?u:i).totalDuration()/100:1)):n<0?(e in o||(o[e]=h),o[e]):(a=parseFloat(e.charAt(n-1)+e.substr(n+1)),s&&i&&(a=a/100*(Z(i)?i[0]:i).totalDuration()),1<n?_parsePosition(t,e.substr(0,n-1),i)+a:h+a)):null==e?h:+e},Ot=function _clamp(t,e,r){return r<t?t:e<r?e:r},kt=[].slice,Mt=function toArray(t,e,i){return l&&!e&&l.selector?l.selector(t):!r(t)||i||!n&&Ft()?Z(t)?function _flatten(t,e,i){return void 0===i&&(i=[]),t.forEach(function(t){return r(t)&&!e||_a(t,1)?i.push.apply(i,Mt(t)):i.push(t)})||i}(t,i):_a(t)?kt.call(t,0):t?[t]:[]:kt.call((e||a).querySelectorAll(t),0)},Pt=function mapRange(e,t,r,i,n){var a=t-e,s=i-r;return Wa(n,function(t){return r+((t-e)/a*s||0)})},Ct=function _callback(t,e,r){var i,n,a,s=t.vars,o=s[e],u=l,h=t._ctx;if(o)return i=s[e+"Params"],n=s.callbackScope||t,r&&dt.length&&ma(),h&&(l=h),a=i?o.apply(n,i):o.call(n),l=u,a},At=[],St=255,zt={aqua:[0,St,St],lime:[0,St,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,St],navy:[0,0,128],white:[St,St,St],olive:[128,128,0],yellow:[St,St,0],orange:[St,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[St,0,0],pink:[St,192,203],cyan:[0,St,St],transparent:[St,St,St,0]},Et=function(){var t,e="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";for(t in zt)e+="|"+t+"\\b";return new RegExp(e+")","gi")}(),Dt=/hsl[a]?\(/,Rt=(k=Date.now,M=500,C=33,A=k(),z=A,D=E=1e3/240,g={time:0,frame:0,tick:function tick(){yl(!0)},deltaRatio:function deltaRatio(t){return b/(1e3/(t||60))},wake:function wake(){o&&(!n&&x()&&(h=n=window,a=h.document||{},ot.gsap=ze,(h.gsapVersions||(h.gsapVersions=[])).push(ze.version),P(i||h.GreenSockGlobals||!h.gsap&&h||{}),At.forEach(wb)),m="undefined"!=typeof requestAnimationFrame&&requestAnimationFrame,p&&g.sleep(),_=m||function(t){return setTimeout(t,D-1e3*g.time+1|0)},c=1,yl(2))},sleep:function sleep(){(m?cancelAnimationFrame:clearTimeout)(p),c=0,_=T},lagSmoothing:function lagSmoothing(t,e){M=t||1/0,C=Math.min(e||33,M)},fps:function fps(t){E=1e3/(t||240),D=1e3*g.time+E},add:function add(n,t,e){var a=t?function(t,e,r,i){n(t,e,r,i),g.remove(a)}:n;return g.remove(n),B[e?"unshift":"push"](a),Ft(),a},remove:function remove(t,e){~(e=B.indexOf(t))&&B.splice(e,1)&&e<=O&&O--},_listeners:B=[]}),Ft=function _wake(){return!c&&Rt.wake()},Lt={},It=/^[\d.\-M][\d.\-,\s]/,Bt=/["']/g,Yt=function _invertEase(e){return function(t){return 1-e(1-t)}},jt=function _parseEase(t,e){return t&&(s(t)?t:Lt[t]||Ob(t))||e};function yl(t){var e,r,i,n,a=k()-z,s=!0===t;if((M<a||a<0)&&(A+=a-C),(0<(e=(i=(z+=a)-A)-D)||s)&&(n=++g.frame,b=i-1e3*g.time,g.time=i/=1e3,D+=e+(E<=e?4:E-e),r=1),s||(p=_(yl)),r)for(O=0;O<B.length;O++)B[O](i,b,n,t)}function gn(t){return t<j?Y*t*t:t<.7272727272727273?Y*Math.pow(t-1.5/2.75,2)+.75:t<.9090909090909092?Y*(t-=2.25/2.75)*t+.9375:Y*Math.pow(t-2.625/2.75,2)+.984375}ha("Linear,Quad,Cubic,Quart,Quint,Strong",function(t,e){var r=e<5?e+1:e;Sb(t+",Power"+(r-1),e?function(t){return Math.pow(t,r)}:function(t){return t},function(t){return 1-Math.pow(1-t,r)},function(t){return t<.5?Math.pow(2*t,r)/2:1-Math.pow(2*(1-t),r)/2})}),Lt.Linear.easeNone=Lt.none=Lt.Linear.easeIn,Sb("Elastic",Ub("in"),Ub("out"),Ub()),Y=7.5625,j=1/2.75,Sb("Bounce",function(t){return 1-gn(1-t)},gn),Sb("Expo",function(t){return t?Math.pow(2,10*(t-1)):0}),Sb("Circ",function(t){return-(K(1-t*t)-1)}),Sb("Sine",function(t){return 1===t?1:1-J(t*G)}),Sb("Back",Vb("in"),Vb("out"),Vb()),Lt.SteppedEase=Lt.steps=ot.SteppedEase={config:function config(t,e){void 0===t&&(t=1);var r=1/t,i=t+(e?0:1),n=e?1:0;return function(t){return((i*Ot(0,.99999999,t)|0)+n)*r}}},V.ease=Lt["quad.out"],ha("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",function(t){return vt+=t+","+t+"Params,"});var qt,Vt=function GSCache(t,e){this.id=W++,(t._gsap=this).target=t,this.harness=e,this.get=e?e.get:ga,this.set=e?e.getSetter:ne},Ut=((qt=Animation.prototype).delay=function delay(t){return t||0===t?(this.parent&&this.parent.smoothChildTiming&&this.startTime(this._start+t-this._delay),this._delay=t,this):this._delay},qt.duration=function duration(t){return arguments.length?this.totalDuration(0<this._repeat?t+(t+this._rDelay)*this._repeat:t):this.totalDuration()&&this._dur},qt.totalDuration=function totalDuration(t){return arguments.length?(this._dirty=0,Ra(this,this._repeat<0?t:(t-this._repeat*this._rDelay)/(this._repeat+1))):this._tDur},qt.totalTime=function totalTime(t,e){if(Ft(),!arguments.length)return this._tTime;var r=this._dp;if(r&&r.smoothChildTiming&&this._ts){for(Ia(this,t),!r._dp||r.parent||Ja(r,this);r&&r.parent;)r.parent._time!==r._start+(0<=r._ts?r._tTime/r._ts:(r.totalDuration()-r._tTime)/-r._ts)&&r.totalTime(r._tTime,!0),r=r.parent;!this.parent&&this._dp.autoRemoveChildren&&(0<this._ts&&t<this._tDur||this._ts<0&&0<t||!this._tDur&&!t)&&Ka(this._dp,this,this._start-this._delay)}return(this._tTime!==t||!this._dur&&!e||this._initted&&Math.abs(this._zTime)===X||!t&&!this._initted&&(this.add||this._ptLookup))&&(this._ts||(this._pTime=t),na(this,t,e)),this},qt.time=function time(t,e){return arguments.length?this.totalTime(Math.min(this.totalDuration(),t+Ea(this))%(this._dur+this._rDelay)||(t?this._dur:0),e):this._time},qt.totalProgress=function totalProgress(t,e){return arguments.length?this.totalTime(this.totalDuration()*t,e):this.totalDuration()?Math.min(1,this._tTime/this._tDur):0<this.rawTime()?1:0},qt.progress=function progress(t,e){return arguments.length?this.totalTime(this.duration()*(!this._yoyo||1&this.iteration()?t:1-t)+Ea(this),e):this.duration()?Math.min(1,this._time/this._dur):0<this.rawTime()?1:0},qt.iteration=function iteration(t,e){var r=this.duration()+this._rDelay;return arguments.length?this.totalTime(this._time+(t-1)*r,e):this._repeat?Tt(this._tTime,r)+1:1},qt.timeScale=function timeScale(t,e){if(!arguments.length)return this._rts===-X?0:this._rts;if(this._rts===t)return this;var r=this.parent&&this._ts?Ga(this.parent._time,this):this._tTime;return this._rts=+t||0,this._ts=this._ps||t===-X?0:this._rts,this.totalTime(Ot(-Math.abs(this._delay),this._tDur,r),!1!==e),Ha(this),function _recacheAncestors(t){for(var e=t.parent;e&&e.parent;)e._dirty=1,e.totalDuration(),e=e.parent;return t}(this)},qt.paused=function paused(t){return arguments.length?(this._ps!==t&&((this._ps=t)?(this._pTime=this._tTime||Math.max(-this._delay,this.rawTime()),this._ts=this._act=0):(Ft(),this._ts=this._rts,this.totalTime(this.parent&&!this.parent.smoothChildTiming?this.rawTime():this._tTime||this._pTime,1===this.progress()&&Math.abs(this._zTime)!==X&&(this._tTime-=X)))),this):this._ps},qt.startTime=function startTime(t){if(arguments.length){this._start=t;var e=this.parent||this._dp;return!e||!e._sort&&this.parent||Ka(e,this,t-this._delay),this}return this._start},qt.endTime=function endTime(t){return this._start+(w(t)?this.totalDuration():this.duration())/Math.abs(this._ts||1)},qt.rawTime=function rawTime(t){var e=this.parent||this._dp;return e?t&&(!this._ts||this._repeat&&this._time&&this.totalProgress()<1)?this._tTime%(this._dur+this._rDelay):this._ts?Ga(e.rawTime(t),this):this._tTime:this._tTime},qt.revert=function revert(t){void 0===t&&(t=lt);var e=L;return L=t,(this._initted||this._startAt)&&(this.timeline&&this.timeline.revert(t),this.totalTime(-.01,t.suppressEvents)),"nested"!==this.data&&!1!==t.kill&&this.kill(),L=e,this},qt.globalTime=function globalTime(t){for(var e=this,r=arguments.length?t:e.rawTime();e;)r=e._start+r/(Math.abs(e._ts)||1),e=e._dp;return!this.parent&&this._sat?this._sat.globalTime(t):r},qt.repeat=function repeat(t){return arguments.length?(this._repeat=t===1/0?-2:t,Sa(this)):-2===this._repeat?1/0:this._repeat},qt.repeatDelay=function repeatDelay(t){if(arguments.length){var e=this._time;return this._rDelay=t,Sa(this),e?this.time(e):this}return this._rDelay},qt.yoyo=function yoyo(t){return arguments.length?(this._yoyo=t,this):this._yoyo},qt.seek=function seek(t,e){return this.totalTime(xt(this,t),w(e))},qt.restart=function restart(t,e){return this.play().totalTime(t?-this._delay:0,w(e))},qt.play=function play(t,e){return null!=t&&this.seek(t,e),this.reversed(!1).paused(!1)},qt.reverse=function reverse(t,e){return null!=t&&this.seek(t||this.totalDuration(),e),this.reversed(!0).paused(!1)},qt.pause=function pause(t,e){return null!=t&&this.seek(t,e),this.paused(!0)},qt.resume=function resume(){return this.paused(!1)},qt.reversed=function reversed(t){return arguments.length?(!!t!==this.reversed()&&this.timeScale(-this._rts||(t?-X:0)),this):this._rts<0},qt.invalidate=function invalidate(){return this._initted=this._act=0,this._zTime=-X,this},qt.isActive=function isActive(){var t,e=this.parent||this._dp,r=this._start;return!(e&&!(this._ts&&this._initted&&e.isActive()&&(t=e.rawTime(!0))>=r&&t<this.endTime(!0)-X))},qt.eventCallback=function eventCallback(t,e,r){var i=this.vars;return 1<arguments.length?(e?(i[t]=e,r&&(i[t+"Params"]=r),"onUpdate"===t&&(this._onUpdate=e)):delete i[t],this):i[t]},qt.then=function then(t){var i=this;return new Promise(function(e){function Co(){var t=i.then;i.then=null,s(r)&&(r=r(i))&&(r.then||r===i)&&(i.then=t),e(r),i.then=t}var r=s(t)?t:pa;i._initted&&1===i.totalProgress()&&0<=i._ts||!i._tTime&&i._ts<0?Co():i._prom=Co})},qt.kill=function kill(){tb(this)},Animation);function Animation(t){this.vars=t,this._delay=+t.delay||0,(this._repeat=t.repeat===1/0?-2:t.repeat||0)&&(this._rDelay=t.repeatDelay||0,this._yoyo=!!t.yoyo||!!t.yoyoEase),this._ts=1,Ra(this,+t.duration,1,1),this.data=t.data,l&&(this._ctx=l).data.push(this),c||Rt.wake()}qa(Ut.prototype,{_time:0,_start:0,_end:0,_tTime:0,_tDur:0,_dirty:0,_repeat:0,_yoyo:!1,parent:null,_initted:!1,_rDelay:0,_ts:1,_dp:0,ratio:0,_zTime:-X,_prom:0,_ps:!1,_rts:1});var Xt=function(i){function Timeline(t,e){var r;return void 0===t&&(t={}),(r=i.call(this,t)||this).labels={},r.smoothChildTiming=!!t.smoothChildTiming,r.autoRemoveChildren=!!t.autoRemoveChildren,r._sort=w(t.sortChildren),I&&Ka(t.parent||I,_assertThisInitialized(r),e),t.reversed&&r.reverse(),t.paused&&r.paused(!0),t.scrollTrigger&&La(_assertThisInitialized(r),t.scrollTrigger),r}_inheritsLoose(Timeline,i);var e=Timeline.prototype;return e.to=function to(t,e,r){return Va(0,arguments,this),this},e.from=function from(t,e,r){return Va(1,arguments,this),this},e.fromTo=function fromTo(t,e,r,i){return Va(2,arguments,this),this},e.set=function set(t,e,r){return e.duration=0,e.parent=this,va(e).repeatDelay||(e.repeat=0),e.immediateRender=!!e.immediateRender,new $t(t,e,xt(this,r),1),this},e.call=function call(t,e,r){return Ka(this,$t.delayedCall(0,t,e),r)},e.staggerTo=function staggerTo(t,e,r,i,n,a,s){return r.duration=e,r.stagger=r.stagger||i,r.onComplete=a,r.onCompleteParams=s,r.parent=this,new $t(t,r,xt(this,n)),this},e.staggerFrom=function staggerFrom(t,e,r,i,n,a,s){return r.runBackwards=1,va(r).immediateRender=w(r.immediateRender),this.staggerTo(t,e,r,i,n,a,s)},e.staggerFromTo=function staggerFromTo(t,e,r,i,n,a,s,o){return i.startAt=r,va(i).immediateRender=w(i.immediateRender),this.staggerTo(t,e,i,n,a,s,o)},e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d,c,p,_=this._time,m=this._dirty?this.totalDuration():this._tDur,g=this._dur,v=t<=0?0:ja(t),y=this._zTime<0!=t<0&&(this._initted||!g);if(this!==I&&m<v&&0<=t&&(v=m),v!==this._tTime||r||y){if(_!==this._time&&g&&(v+=this._time-_,t+=this._time-_),i=v,f=this._start,u=!(l=this._ts),y&&(g||(_=this._zTime),!t&&e||(this._zTime=t)),this._repeat){if(c=this._yoyo,o=g+this._rDelay,this._repeat<-1&&t<0)return this.totalTime(100*o+t,e,r);if(i=ja(v%o),v===m?(s=this._repeat,i=g):((s=~~(v/o))&&s===v/o&&(i=g,s--),g<i&&(i=g)),d=Tt(this._tTime,o),!_&&this._tTime&&d!==s&&this._tTime-d*o-this._dur<=0&&(d=s),c&&1&s&&(i=g-i,p=1),s!==d&&!this._lock){var T=c&&1&d,b=T===(c&&1&s);if(s<d&&(T=!T),_=T?0:v%g?g:v,this._lock=1,this.render(_||(p?0:ja(s*o)),e,!g)._lock=0,this._tTime=v,!e&&this.parent&&Ct(this,"onRepeat"),this.vars.repeatRefresh&&!p&&(this.invalidate()._lock=1),_&&_!==this._time||u!=!this._ts||this.vars.onRepeat&&!this.parent&&!this._act)return this;if(g=this._dur,m=this._tDur,b&&(this._lock=2,_=T?g:-1e-4,this.render(_,!0),this.vars.repeatRefresh&&!p&&this.invalidate()),this._lock=0,!this._ts&&!u)return this;Qb(this,p)}}if(this._hasPause&&!this._forcing&&this._lock<2&&(h=function _findNextPauseTween(t,e,r){var i;if(e<r)for(i=t._first;i&&i._start<=r;){if("isPause"===i.data&&i._start>e)return i;i=i._next}else for(i=t._last;i&&i._start>=r;){if("isPause"===i.data&&i._start<e)return i;i=i._prev}}(this,ja(_),ja(i)))&&(v-=i-(i=h._start)),this._tTime=v,this._time=i,this._act=!l,this._initted||(this._onUpdate=this.vars.onUpdate,this._initted=1,this._zTime=t,_=0),!_&&i&&!e&&!s&&(Ct(this,"onStart"),this._tTime!==v))return this;if(_<=i&&0<=t)for(n=this._first;n;){if(a=n._next,(n._act||i>=n._start)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(i-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(i-n._start)*n._ts,e,r),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=-X);break}}n=a}else{n=this._last;for(var w=t<0?t:i;n;){if(a=n._prev,(n._act||w<=n._end)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(w-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(w-n._start)*n._ts,e,r||L&&(n._initted||n._startAt)),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=w?-X:X);break}}n=a}}if(h&&!e&&(this.pause(),h.render(_<=i?0:-X)._zTime=_<=i?1:-1,this._ts))return this._start=f,Ha(this),this.render(t,e,r);this._onUpdate&&!e&&Ct(this,"onUpdate",!0),(v===m&&this._tTime>=this.totalDuration()||!v&&_)&&(f!==this._start&&Math.abs(l)===Math.abs(this._ts)||this._lock||(!t&&g||!(v===m&&0<this._ts||!v&&this._ts<0)||za(this,1),e||t<0&&!_||!v&&!_&&m||(Ct(this,v===m&&0<=t?"onComplete":"onReverseComplete",!0),!this._prom||v<m&&0<this.timeScale()||this._prom())))}return this},e.add=function add(e,i){var n=this;if(t(i)||(i=xt(this,i,e)),!(e instanceof Ut)){if(Z(e))return e.forEach(function(t){return n.add(t,i)}),this;if(r(e))return this.addLabel(e,i);if(!s(e))return this;e=$t.delayedCall(0,e)}return this!==e?Ka(this,e,i):this},e.getChildren=function getChildren(t,e,r,i){void 0===t&&(t=!0),void 0===e&&(e=!0),void 0===r&&(r=!0),void 0===i&&(i=-U);for(var n=[],a=this._first;a;)a._start>=i&&(a instanceof $t?e&&n.push(a):(r&&n.push(a),t&&n.push.apply(n,a.getChildren(!0,e,r)))),a=a._next;return n},e.getById=function getById(t){for(var e=this.getChildren(1,1,1),r=e.length;r--;)if(e[r].vars.id===t)return e[r]},e.remove=function remove(t){return r(t)?this.removeLabel(t):s(t)?this.killTweensOf(t):(ya(this,t),t===this._recent&&(this._recent=this._last),Aa(this))},e.totalTime=function totalTime(t,e){return arguments.length?(this._forcing=1,!this._dp&&this._ts&&(this._start=ja(Rt.time-(0<this._ts?t/this._ts:(this.totalDuration()-t)/-this._ts))),i.prototype.totalTime.call(this,t,e),this._forcing=0,this):this._tTime},e.addLabel=function addLabel(t,e){return this.labels[t]=xt(this,e),this},e.removeLabel=function removeLabel(t){return delete this.labels[t],this},e.addPause=function addPause(t,e,r){var i=$t.delayedCall(0,e||T,r);return i.data="isPause",this._hasPause=1,Ka(this,i,xt(this,t))},e.removePause=function removePause(t){var e=this._first;for(t=xt(this,t);e;)e._start===t&&"isPause"===e.data&&za(e),e=e._next},e.killTweensOf=function killTweensOf(t,e,r){for(var i=this.getTweensOf(t,r),n=i.length;n--;)Nt!==i[n]&&i[n].kill(t,e);return this},e.getTweensOf=function getTweensOf(e,r){for(var i,n=[],a=Mt(e),s=this._first,o=t(r);s;)s instanceof $t?la(s._targets,a)&&(o?(!Nt||s._initted&&s._ts)&&s.globalTime(0)<=r&&s.globalTime(s.totalDuration())>r:!r||s.isActive())&&n.push(s):(i=s.getTweensOf(a,r)).length&&n.push.apply(n,i),s=s._next;return n},e.tweenTo=function tweenTo(t,e){e=e||{};var r,i=this,n=xt(i,t),a=e.startAt,s=e.onStart,o=e.onStartParams,u=e.immediateRender,h=$t.to(i,qa({ease:e.ease||"none",lazy:!1,immediateRender:!1,time:n,overwrite:"auto",duration:e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale())||X,onStart:function onStart(){if(i.pause(),!r){var t=e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale());h._dur!==t&&Ra(h,t,0,1).render(h._time,!0,!0),r=1}s&&s.apply(h,o||[])}},e));return u?h.render(0):h},e.tweenFromTo=function tweenFromTo(t,e,r){return this.tweenTo(e,qa({startAt:{time:xt(this,t)}},r))},e.recent=function recent(){return this._recent},e.nextLabel=function nextLabel(t){return void 0===t&&(t=this._time),rb(this,xt(this,t))},e.previousLabel=function previousLabel(t){return void 0===t&&(t=this._time),rb(this,xt(this,t),1)},e.currentLabel=function currentLabel(t){return arguments.length?this.seek(t,!0):this.previousLabel(this._time+X)},e.shiftChildren=function shiftChildren(t,e,r){void 0===r&&(r=0);for(var i,n=this._first,a=this.labels;n;)n._start>=r&&(n._start+=t,n._end+=t),n=n._next;if(e)for(i in a)a[i]>=r&&(a[i]+=t);return Aa(this)},e.invalidate=function invalidate(t){var e=this._first;for(this._lock=0;e;)e.invalidate(t),e=e._next;return i.prototype.invalidate.call(this,t)},e.clear=function clear(t){void 0===t&&(t=!0);for(var e,r=this._first;r;)e=r._next,this.remove(r),r=e;return this._dp&&(this._time=this._tTime=this._pTime=0),t&&(this.labels={}),Aa(this)},e.totalDuration=function totalDuration(t){var e,r,i,n=0,a=this,s=a._last,o=U;if(arguments.length)return a.timeScale((a._repeat<0?a.duration():a.totalDuration())/(a.reversed()?-t:t));if(a._dirty){for(i=a.parent;s;)e=s._prev,s._dirty&&s.totalDuration(),o<(r=s._start)&&a._sort&&s._ts&&!a._lock?(a._lock=1,Ka(a,s,r-s._delay,1)._lock=0):o=r,r<0&&s._ts&&(n-=r,(!i&&!a._dp||i&&i.smoothChildTiming)&&(a._start+=r/a._ts,a._time-=r,a._tTime-=r),a.shiftChildren(-r,!1,-Infinity),o=0),s._end>n&&s._ts&&(n=s._end),s=e;Ra(a,a===I&&a._time>n?a._time:n,1,1),a._dirty=0}return a._tDur},Timeline.updateRoot=function updateRoot(t){if(I._ts&&(na(I,Ga(t,I)),f=Rt.frame),Rt.frame>=mt){mt+=q.autoSleep||120;var e=I._first;if((!e||!e._ts)&&q.autoSleep&&Rt._listeners.length<2){for(;e&&!e._ts;)e=e._next;e||Rt.sleep()}}},Timeline}(Ut);qa(Xt.prototype,{_lock:0,_hasPause:0,_forcing:0});function ac(t,e,i,n,a,o){var u,h,l,f;if(pt[t]&&!1!==(u=new pt[t]).init(a,u.rawVars?e[t]:function _processVars(t,e,i,n,a){if(s(t)&&(t=Kt(t,a,e,i,n)),!v(t)||t.style&&t.nodeType||Z(t)||$(t))return r(t)?Kt(t,a,e,i,n):t;var o,u={};for(o in t)u[o]=Kt(t[o],a,e,i,n);return u}(e[t],n,a,o,i),i,n,o)&&(i._pt=h=new _e(i._pt,a,t,0,1,u.render,u,0,u.priority),i!==d))for(l=i._ptLookup[i._targets.indexOf(a)],f=u._props.length;f--;)l[u._props[f]]=h;return u}function gc(t,r,e,i){var n,a,s=r.ease||i||"power1.inOut";if(Z(r))a=e[t]||(e[t]=[]),r.forEach(function(t,e){return a.push({t:e/(r.length-1)*100,v:t,e:s})});else for(n in r)a=e[n]||(e[n]=[]),"ease"===n||a.push({t:parseFloat(t),v:r[n],e:s})}var Nt,Gt,Wt=function _addPropTween(t,e,i,n,a,o,u,h,l,f){s(n)&&(n=n(a||0,t,o));var d,c=t[e],p="get"!==i?i:s(c)?l?t[e.indexOf("set")||!s(t["get"+e.substr(3)])?e:"get"+e.substr(3)](l):t[e]():c,_=s(c)?l?re:te:Zt;if(r(n)&&(~n.indexOf("random(")&&(n=ob(n)),"="===n.charAt(1)&&(!(d=ka(p,n)+(Ya(p)||0))&&0!==d||(n=d))),!f||p!==n||Gt)return isNaN(p*n)||""===n?(c||e in t||Q(e,n),function _addComplexStringPropTween(t,e,r,i,n,a,s){var o,u,h,l,f,d,c,p,_=new _e(this._pt,t,e,0,1,ue,null,n),m=0,g=0;for(_.b=r,_.e=i,r+="",(c=~(i+="").indexOf("random("))&&(i=ob(i)),a&&(a(p=[r,i],t,e),r=p[0],i=p[1]),u=r.match(it)||[];o=it.exec(i);)l=o[0],f=i.substring(m,o.index),h?h=(h+1)%5:"rgba("===f.substr(-5)&&(h=1),l!==u[g++]&&(d=parseFloat(u[g-1])||0,_._pt={_next:_._pt,p:f||1===g?f:",",s:d,c:"="===l.charAt(1)?ka(d,l)-d:parseFloat(l)-d,m:h&&h<4?Math.round:0},m=it.lastIndex);return _.c=m<i.length?i.substring(m,i.length):"",_.fp=s,(nt.test(i)||c)&&(_.e=0),this._pt=_}.call(this,t,e,p,n,_,h||q.stringFilter,l)):(d=new _e(this._pt,t,e,+p||0,n-(p||0),"boolean"==typeof c?se:ae,0,_),l&&(d.fp=l),u&&d.modifier(u,this,t),this._pt=d)},Qt=function _initTween(t,e,r){var i,n,a,s,o,u,h,l,f,d,c,p,_,m=t.vars,g=m.ease,v=m.startAt,y=m.immediateRender,T=m.lazy,b=m.onUpdate,x=m.runBackwards,O=m.yoyoEase,k=m.keyframes,M=m.autoRevert,P=t._dur,C=t._startAt,A=t._targets,S=t.parent,z=S&&"nested"===S.data?S.vars.targets:A,E="auto"===t._overwrite&&!F,D=t.timeline;if(!D||k&&g||(g="none"),t._ease=jt(g,V.ease),t._yEase=O?Yt(jt(!0===O?g:O,V.ease)):0,O&&t._yoyo&&!t._repeat&&(O=t._yEase,t._yEase=t._ease,t._ease=O),t._from=!D&&!!m.runBackwards,!D||k&&!m.stagger){if(p=(l=A[0]?fa(A[0]).harness:0)&&m[l.prop],i=ua(m,ft),C&&(C._zTime<0&&C.progress(1),e<0&&x&&y&&!M?C.render(-1,!0):C.revert(x&&P?ht:ut),C._lazy=0),v){if(za(t._startAt=$t.set(A,qa({data:"isStart",overwrite:!1,parent:S,immediateRender:!0,lazy:!C&&w(T),startAt:null,delay:0,onUpdate:b&&function(){return Ct(t,"onUpdate")},stagger:0},v))),t._startAt._dp=0,t._startAt._sat=t,e<0&&(L||!y&&!M)&&t._startAt.revert(ht),y&&P&&e<=0&&r<=0)return void(e&&(t._zTime=e))}else if(x&&P&&!C)if(e&&(y=!1),a=qa({overwrite:!1,data:"isFromStart",lazy:y&&!C&&w(T),immediateRender:y,stagger:0,parent:S},i),p&&(a[l.prop]=p),za(t._startAt=$t.set(A,a)),t._startAt._dp=0,t._startAt._sat=t,e<0&&(L?t._startAt.revert(ht):t._startAt.render(-1,!0)),t._zTime=e,y){if(!e)return}else _initTween(t._startAt,X,X);for(t._pt=t._ptCache=0,T=P&&w(T)||T&&!P,n=0;n<A.length;n++){if(h=(o=A[n])._gsap||ea(A)[n]._gsap,t._ptLookup[n]=d={},ct[h.id]&&dt.length&&ma(),c=z===A?n:z.indexOf(o),l&&!1!==(f=new l).init(o,p||i,t,c,z)&&(t._pt=s=new _e(t._pt,o,f.name,0,1,f.render,f,0,f.priority),f._props.forEach(function(t){d[t]=s}),f.priority&&(u=1)),!l||p)for(a in i)pt[a]&&(f=ac(a,i,t,c,o,z))?f.priority&&(u=1):d[a]=s=Wt.call(t,o,a,"get",i[a],c,z,0,m.stringFilter);t._op&&t._op[n]&&t.kill(o,t._op[n]),E&&t._pt&&(Nt=t,I.killTweensOf(o,d,t.globalTime(e)),_=!t.parent,Nt=0),t._pt&&T&&(ct[h.id]=1)}u&&pe(t),t._onInit&&t._onInit(t)}t._onUpdate=b,t._initted=(!t._op||t._pt)&&!_,k&&e<=0&&D.render(U,!0,!0)},Kt=function _parseFuncOrString(t,e,i,n,a){return s(t)?t.call(e,i,n,a):r(t)&&~t.indexOf("random(")?ob(t):t},Jt=vt+"repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",Ht={};ha(Jt+",id,stagger,delay,duration,paused,scrollTrigger",function(t){return Ht[t]=1});var $t=function(D){function Tween(e,r,i,n){var a;"number"==typeof r&&(i.duration=r,r=i,i=null);var s,o,u,h,l,f,d,c,p=(a=D.call(this,n?r:va(r))||this).vars,_=p.duration,m=p.delay,g=p.immediateRender,T=p.stagger,b=p.overwrite,x=p.keyframes,O=p.defaults,k=p.scrollTrigger,M=p.yoyoEase,P=r.parent||I,C=(Z(e)||$(e)?t(e[0]):"length"in r)?[e]:Mt(e);if(a._targets=C.length?ea(C):R("GSAP target "+e+" not found. https://gsap.com",!q.nullTargetWarn)||[],a._ptLookup=[],a._overwrite=b,x||T||y(_)||y(m)){if(r=a.vars,(s=a.timeline=new Xt({data:"nested",defaults:O||{},targets:P&&"nested"===P.data?P.vars.targets:C})).kill(),s.parent=s._dp=_assertThisInitialized(a),s._start=0,T||y(_)||y(m)){if(h=C.length,d=T&&eb(T),v(T))for(l in T)~Jt.indexOf(l)&&((c=c||{})[l]=T[l]);for(o=0;o<h;o++)(u=ua(r,Ht)).stagger=0,M&&(u.yoyoEase=M),c&&yt(u,c),f=C[o],u.duration=+Kt(_,_assertThisInitialized(a),o,f,C),u.delay=(+Kt(m,_assertThisInitialized(a),o,f,C)||0)-a._delay,!T&&1===h&&u.delay&&(a._delay=m=u.delay,a._start+=m,u.delay=0),s.to(f,u,d?d(o,f,C):0),s._ease=Lt.none;s.duration()?_=m=0:a.timeline=0}else if(x){va(qa(s.vars.defaults,{ease:"none"})),s._ease=jt(x.ease||r.ease||"none");var A,S,z,E=0;if(Z(x))x.forEach(function(t){return s.to(C,t,">")}),s.duration();else{for(l in u={},x)"ease"===l||"easeEach"===l||gc(l,x[l],u,x.easeEach);for(l in u)for(A=u[l].sort(function(t,e){return t.t-e.t}),o=E=0;o<A.length;o++)(z={ease:(S=A[o]).e,duration:(S.t-(o?A[o-1].t:0))/100*_})[l]=S.v,s.to(C,z,E),E+=z.duration;s.duration()<_&&s.to({},{duration:_-s.duration()})}}_||a.duration(_=s.duration())}else a.timeline=0;return!0!==b||F||(Nt=_assertThisInitialized(a),I.killTweensOf(C),Nt=0),Ka(P,_assertThisInitialized(a),i),r.reversed&&a.reverse(),r.paused&&a.paused(!0),(g||!_&&!x&&a._start===ja(P._time)&&w(g)&&function _hasNoPausedAncestors(t){return!t||t._ts&&_hasNoPausedAncestors(t.parent)}(_assertThisInitialized(a))&&"nested"!==P.data)&&(a._tTime=-X,a.render(Math.max(0,-m)||0)),k&&La(_assertThisInitialized(a),k),a}_inheritsLoose(Tween,D);var e=Tween.prototype;return e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d=this._time,c=this._tDur,p=this._dur,_=t<0,m=c-X<t&&!_?c:t<X?0:t;if(p){if(m!==this._tTime||!t||r||!this._initted&&this._tTime||this._startAt&&this._zTime<0!=_){if(i=m,l=this.timeline,this._repeat){if(s=p+this._rDelay,this._repeat<-1&&_)return this.totalTime(100*s+t,e,r);if(i=ja(m%s),m===c?(a=this._repeat,i=p):((a=~~(m/s))&&a===ja(m/s)&&(i=p,a--),p<i&&(i=p)),(u=this._yoyo&&1&a)&&(f=this._yEase,i=p-i),o=Tt(this._tTime,s),i===d&&!r&&this._initted&&a===o)return this._tTime=m,this;a!==o&&(l&&this._yEase&&Qb(l,u),this.vars.repeatRefresh&&!u&&!this._lock&&this._time!==s&&this._initted&&(this._lock=r=1,this.render(ja(s*a),!0).invalidate()._lock=0))}if(!this._initted){if(Ma(this,_?t:i,r,e,m))return this._tTime=0,this;if(!(d===this._time||r&&this.vars.repeatRefresh&&a!==o))return this;if(p!==this._dur)return this.render(t,e,r)}if(this._tTime=m,this._time=i,!this._act&&this._ts&&(this._act=1,this._lazy=0),this.ratio=h=(f||this._ease)(i/p),this._from&&(this.ratio=h=1-h),i&&!d&&!e&&!a&&(Ct(this,"onStart"),this._tTime!==m))return this;for(n=this._pt;n;)n.r(h,n.d),n=n._next;l&&l.render(t<0?t:l._dur*l._ease(i/this._dur),e,r)||this._startAt&&(this._zTime=t),this._onUpdate&&!e&&(_&&Ca(this,t,0,r),Ct(this,"onUpdate")),this._repeat&&a!==o&&this.vars.onRepeat&&!e&&this.parent&&Ct(this,"onRepeat"),m!==this._tDur&&m||this._tTime!==m||(_&&!this._onUpdate&&Ca(this,t,0,!0),!t&&p||!(m===this._tDur&&0<this._ts||!m&&this._ts<0)||za(this,1),e||_&&!d||!(m||d||u)||(Ct(this,m===c?"onComplete":"onReverseComplete",!0),!this._prom||m<c&&0<this.timeScale()||this._prom()))}}else!function _renderZeroDurationTween(t,e,r,i){var n,a,s,o=t.ratio,u=e<0||!e&&(!t._start&&function _parentPlayheadIsBeforeStart(t){var e=t.parent;return e&&e._ts&&e._initted&&!e._lock&&(e.rawTime()<0||_parentPlayheadIsBeforeStart(e))}(t)&&(t._initted||!bt(t))||(t._ts<0||t._dp._ts<0)&&!bt(t))?0:1,h=t._rDelay,l=0;if(h&&t._repeat&&(l=Ot(0,t._tDur,e),a=Tt(l,h),t._yoyo&&1&a&&(u=1-u),a!==Tt(t._tTime,h)&&(o=1-u,t.vars.repeatRefresh&&t._initted&&t.invalidate())),u!==o||L||i||t._zTime===X||!e&&t._zTime){if(!t._initted&&Ma(t,e,i,r,l))return;for(s=t._zTime,t._zTime=e||(r?X:0),r=r||e&&!s,t.ratio=u,t._from&&(u=1-u),t._time=0,t._tTime=l,n=t._pt;n;)n.r(u,n.d),n=n._next;e<0&&Ca(t,e,0,!0),t._onUpdate&&!r&&Ct(t,"onUpdate"),l&&t._repeat&&!r&&t.parent&&Ct(t,"onRepeat"),(e>=t._tDur||e<0)&&t.ratio===u&&(u&&za(t,1),r||L||(Ct(t,u?"onComplete":"onReverseComplete",!0),t._prom&&t._prom()))}else t._zTime||(t._zTime=e)}(this,t,e,r);return this},e.targets=function targets(){return this._targets},e.invalidate=function invalidate(t){return t&&this.vars.runBackwards||(this._startAt=0),this._pt=this._op=this._onUpdate=this._lazy=this.ratio=0,this._ptLookup=[],this.timeline&&this.timeline.invalidate(t),D.prototype.invalidate.call(this,t)},e.resetTo=function resetTo(t,e,r,i,n){c||Rt.wake(),this._ts||this.play();var a,s=Math.min(this._dur,(this._dp._time-this._start)*this._ts);return this._initted||Qt(this,s),a=this._ease(s/this._dur),function _updatePropTweens(t,e,r,i,n,a,s,o){var u,h,l,f,d=(t._pt&&t._ptCache||(t._ptCache={}))[e];if(!d)for(d=t._ptCache[e]=[],l=t._ptLookup,f=t._targets.length;f--;){if((u=l[f][e])&&u.d&&u.d._pt)for(u=u.d._pt;u&&u.p!==e&&u.fp!==e;)u=u._next;if(!u)return Gt=1,t.vars[e]="+=0",Qt(t,s),Gt=0,o?R(e+" not eligible for reset"):1;d.push(u)}for(f=d.length;f--;)(u=(h=d[f])._pt||h).s=!i&&0!==i||n?u.s+(i||0)+a*u.c:i,u.c=r-u.s,h.e&&(h.e=ia(r)+Ya(h.e)),h.b&&(h.b=u.s+Ya(h.b))}(this,t,e,r,i,a,s,n)?this.resetTo(t,e,r,i,1):(Ia(this,0),this.parent||xa(this._dp,this,"_first","_last",this._dp._sort?"_start":0),this.render(0))},e.kill=function kill(t,e){if(void 0===e&&(e="all"),!(t||e&&"all"!==e))return this._lazy=this._pt=0,this.parent?tb(this):this;if(this.timeline){var i=this.timeline.totalDuration();return this.timeline.killTweensOf(t,e,Nt&&!0!==Nt.vars.overwrite)._first||tb(this),this.parent&&i!==this.timeline.totalDuration()&&Ra(this,this._dur*this.timeline._tDur/i,0,1),this}var n,a,s,o,u,h,l,f=this._targets,d=t?Mt(t):f,c=this._ptLookup,p=this._pt;if((!e||"all"===e)&&function _arraysMatch(t,e){for(var r=t.length,i=r===e.length;i&&r--&&t[r]===e[r];);return r<0}(f,d))return"all"===e&&(this._pt=0),tb(this);for(n=this._op=this._op||[],"all"!==e&&(r(e)&&(u={},ha(e,function(t){return u[t]=1}),e=u),e=function _addAliasesToVars(t,e){var r,i,n,a,s=t[0]?fa(t[0]).harness:0,o=s&&s.aliases;if(!o)return e;for(i in r=yt({},e),o)if(i in r)for(n=(a=o[i].split(",")).length;n--;)r[a[n]]=r[i];return r}(f,e)),l=f.length;l--;)if(~d.indexOf(f[l]))for(u in a=c[l],"all"===e?(n[l]=e,o=a,s={}):(s=n[l]=n[l]||{},o=e),o)(h=a&&a[u])&&("kill"in h.d&&!0!==h.d.kill(u)||ya(this,h,"_pt"),delete a[u]),"all"!==s&&(s[u]=1);return this._initted&&!this._pt&&p&&tb(this),this},Tween.to=function to(t,e,r){return new Tween(t,e,r)},Tween.from=function from(t,e){return Va(1,arguments)},Tween.delayedCall=function delayedCall(t,e,r,i){return new Tween(e,0,{immediateRender:!1,lazy:!1,overwrite:!1,delay:t,onComplete:e,onReverseComplete:e,onCompleteParams:r,onReverseCompleteParams:r,callbackScope:i})},Tween.fromTo=function fromTo(t,e,r){return Va(2,arguments)},Tween.set=function set(t,e){return e.duration=0,e.repeatDelay||(e.repeat=0),new Tween(t,e)},Tween.killTweensOf=function killTweensOf(t,e,r){return I.killTweensOf(t,e,r)},Tween}(Ut);qa($t.prototype,{_targets:[],_lazy:0,_startAt:0,_op:0,_onInit:0}),ha("staggerTo,staggerFrom,staggerFromTo",function(r){$t[r]=function(){var t=new Xt,e=kt.call(arguments,0);return e.splice("staggerFromTo"===r?5:4,0,0),t[r].apply(t,e)}});function oc(t,e,r){return t.setAttribute(e,r)}function wc(t,e,r,i){i.mSet(t,e,i.m.call(i.tween,r,i.mt),i)}var Zt=function _setterPlain(t,e,r){return t[e]=r},te=function _setterFunc(t,e,r){return t[e](r)},re=function _setterFuncWithParam(t,e,r,i){return t[e](i.fp,r)},ne=function _getSetter(t,e){return s(t[e])?te:u(t[e])&&t.setAttribute?oc:Zt},ae=function _renderPlain(t,e){return e.set(e.t,e.p,Math.round(1e6*(e.s+e.c*t))/1e6,e)},se=function _renderBoolean(t,e){return e.set(e.t,e.p,!!(e.s+e.c*t),e)},ue=function _renderComplexString(t,e){var r=e._pt,i="";if(!t&&e.b)i=e.b;else if(1===t&&e.e)i=e.e;else{for(;r;)i=r.p+(r.m?r.m(r.s+r.c*t):Math.round(1e4*(r.s+r.c*t))/1e4)+i,r=r._next;i+=e.c}e.set(e.t,e.p,i,e)},he=function _renderPropTweens(t,e){for(var r=e._pt;r;)r.r(t,r.d),r=r._next},fe=function _addPluginModifier(t,e,r,i){for(var n,a=this._pt;a;)n=a._next,a.p===i&&a.modifier(t,e,r),a=n},ce=function _killPropTweensOf(t){for(var e,r,i=this._pt;i;)r=i._next,i.p===t&&!i.op||i.op===t?ya(this,i,"_pt"):i.dep||(e=1),i=r;return!e},pe=function _sortPropTweensByPriority(t){for(var e,r,i,n,a=t._pt;a;){for(e=a._next,r=i;r&&r.pr>a.pr;)r=r._next;(a._prev=r?r._prev:n)?a._prev._next=a:i=a,(a._next=r)?r._prev=a:n=a,a=e}t._pt=i},_e=(PropTween.prototype.modifier=function modifier(t,e,r){this.mSet=this.mSet||this.set,this.set=wc,this.m=t,this.mt=r,this.tween=e},PropTween);function PropTween(t,e,r,i,n,a,s,o,u){this.t=e,this.s=i,this.c=n,this.p=r,this.r=a||ae,this.d=s||this,this.set=o||Zt,this.pr=u||0,(this._next=t)&&(t._prev=this)}ha(vt+"parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",function(t){return ft[t]=1}),ot.TweenMax=ot.TweenLite=$t,ot.TimelineLite=ot.TimelineMax=Xt,I=new Xt({sortChildren:!1,defaults:V,autoRemoveChildren:!0,id:"root",smoothChildTiming:!0}),q.stringFilter=Fb;function Ec(t){return(ye[t]||Te).map(function(t){return t()})}function Fc(){var t=Date.now(),o=[];2<t-Oe&&(Ec("matchMediaInit"),ge.forEach(function(t){var e,r,i,n,a=t.queries,s=t.conditions;for(r in a)(e=h.matchMedia(a[r]).matches)&&(i=1),e!==s[r]&&(s[r]=e,n=1);n&&(t.revert(),i&&o.push(t))}),Ec("matchMediaRevert"),o.forEach(function(e){return e.onMatch(e,function(t){return e.add(null,t)})}),Oe=t,Ec("matchMedia"))}var me,ge=[],ye={},Te=[],Oe=0,Me=0,Pe=((me=Context.prototype).add=function add(t,i,n){function Gw(){var t,e=l,r=a.selector;return e&&e!==a&&e.data.push(a),n&&(a.selector=cb(n)),l=a,t=i.apply(a,arguments),s(t)&&a._r.push(t),l=e,a.selector=r,a.isReverted=!1,t}s(t)&&(n=i,i=t,t=s);var a=this;return a.last=Gw,t===s?Gw(a,function(t){return a.add(null,t)}):t?a[t]=Gw:Gw},me.ignore=function ignore(t){var e=l;l=null,t(this),l=e},me.getTweens=function getTweens(){var e=[];return this.data.forEach(function(t){return t instanceof Context?e.push.apply(e,t.getTweens()):t instanceof $t&&!(t.parent&&"nested"===t.parent.data)&&e.push(t)}),e},me.clear=function clear(){this._r.length=this.data.length=0},me.kill=function kill(i,t){var n=this;if(i?function(){for(var t,e=n.getTweens(),r=n.data.length;r--;)"isFlip"===(t=n.data[r]).data&&(t.revert(),t.getChildren(!0,!0,!1).forEach(function(t){return e.splice(e.indexOf(t),1)}));for(e.map(function(t){return{g:t._dur||t._delay||t._sat&&!t._sat.vars.immediateRender?t.globalTime(0):-1/0,t:t}}).sort(function(t,e){return e.g-t.g||-1/0}).forEach(function(t){return t.t.revert(i)}),r=n.data.length;r--;)(t=n.data[r])instanceof Xt?"nested"!==t.data&&(t.scrollTrigger&&t.scrollTrigger.revert(),t.kill()):t instanceof $t||!t.revert||t.revert(i);n._r.forEach(function(t){return t(i,n)}),n.isReverted=!0}():this.data.forEach(function(t){return t.kill&&t.kill()}),this.clear(),t)for(var e=ge.length;e--;)ge[e].id===this.id&&ge.splice(e,1)},me.revert=function revert(t){this.kill(t||{})},Context);function Context(t,e){this.selector=e&&cb(e),this.data=[],this._r=[],this.isReverted=!1,this.id=Me++,t&&this.add(t)}var Ce,Ae=((Ce=MatchMedia.prototype).add=function add(t,e,r){v(t)||(t={matches:t});var i,n,a,s=new Pe(0,r||this.scope),o=s.conditions={};for(n in l&&!s.selector&&(s.selector=l.selector),this.contexts.push(s),e=s.add("onMatch",e),s.queries=t)"all"===n?a=1:(i=h.matchMedia(t[n]))&&(ge.indexOf(s)<0&&ge.push(s),(o[n]=i.matches)&&(a=1),i.addListener?i.addListener(Fc):i.addEventListener("change",Fc));return a&&e(s,function(t){return s.add(null,t)}),this},Ce.revert=function revert(t){this.kill(t||{})},Ce.kill=function kill(e){this.contexts.forEach(function(t){return t.kill(e,!0)})},MatchMedia);function MatchMedia(t){this.contexts=[],this.scope=t,l&&l.data.push(this)}var Se={registerPlugin:function registerPlugin(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];e.forEach(function(t){return wb(t)})},timeline:function timeline(t){return new Xt(t)},getTweensOf:function getTweensOf(t,e){return I.getTweensOf(t,e)},getProperty:function getProperty(i,t,e,n){r(i)&&(i=Mt(i)[0]);var a=fa(i||{}).get,s=e?pa:oa;return"native"===e&&(e=""),i?t?s((pt[t]&&pt[t].get||a)(i,t,e,n)):function(t,e,r){return s((pt[t]&&pt[t].get||a)(i,t,e,r))}:i},quickSetter:function quickSetter(r,e,i){if(1<(r=Mt(r)).length){var n=r.map(function(t){return ze.quickSetter(t,e,i)}),a=n.length;return function(t){for(var e=a;e--;)n[e](t)}}r=r[0]||{};var s=pt[e],o=fa(r),u=o.harness&&(o.harness.aliases||{})[e]||e,h=s?function(t){var e=new s;d._pt=0,e.init(r,i?t+i:t,d,0,[r]),e.render(1,e),d._pt&&he(1,d)}:o.set(r,u);return s?h:function(t){return h(r,u,i?t+i:t,o,1)}},quickTo:function quickTo(t,i,e){function $x(t,e,r){return n.resetTo(i,t,e,r)}var r,n=ze.to(t,yt(((r={})[i]="+=0.1",r.paused=!0,r),e||{}));return $x.tween=n,$x},isTweening:function isTweening(t){return 0<I.getTweensOf(t,!0).length},defaults:function defaults(t){return t&&t.ease&&(t.ease=jt(t.ease,V.ease)),ta(V,t||{})},config:function config(t){return ta(q,t||{})},registerEffect:function registerEffect(t){var i=t.name,n=t.effect,e=t.plugins,a=t.defaults,r=t.extendTimeline;(e||"").split(",").forEach(function(t){return t&&!pt[t]&&!ot[t]&&R(i+" effect requires "+t+" plugin.")}),_t[i]=function(t,e,r){return n(Mt(t),qa(e||{},a),r)},r&&(Xt.prototype[i]=function(t,e,r){return this.add(_t[i](t,v(e)?e:(r=e)&&{},this),r)})},registerEase:function registerEase(t,e){Lt[t]=jt(e)},parseEase:function parseEase(t,e){return arguments.length?jt(t,e):Lt},getById:function getById(t){return I.getById(t)},exportRoot:function exportRoot(t,e){void 0===t&&(t={});var r,i,n=new Xt(t);for(n.smoothChildTiming=w(t.smoothChildTiming),I.remove(n),n._dp=0,n._time=n._tTime=I._time,r=I._first;r;)i=r._next,!e&&!r._dur&&r instanceof $t&&r.vars.onComplete===r._targets[0]||Ka(n,r,r._start-r._delay),r=i;return Ka(I,n,0),n},context:function context(t,e){return t?new Pe(t,e):l},matchMedia:function matchMedia(t){return new Ae(t)},matchMediaRefresh:function matchMediaRefresh(){return ge.forEach(function(t){var e,r,i=t.conditions;for(r in i)i[r]&&(i[r]=!1,e=1);e&&t.revert()})||Fc()},addEventListener:function addEventListener(t,e){var r=ye[t]||(ye[t]=[]);~r.indexOf(e)||r.push(e)},removeEventListener:function removeEventListener(t,e){var r=ye[t],i=r&&r.indexOf(e);0<=i&&r.splice(i,1)},utils:{wrap:function wrap(e,t,r){var i=t-e;return Z(e)?lb(e,wrap(0,e.length),t):Wa(r,function(t){return(i+(t-e)%i)%i+e})},wrapYoyo:function wrapYoyo(e,t,r){var i=t-e,n=2*i;return Z(e)?lb(e,wrapYoyo(0,e.length-1),t):Wa(r,function(t){return e+(i<(t=(n+(t-e)%n)%n||0)?n-t:t)})},distribute:eb,random:hb,snap:gb,normalize:function normalize(t,e,r){return Pt(t,e,0,1,r)},getUnit:Ya,clamp:function clamp(e,r,t){return Wa(t,function(t){return Ot(e,r,t)})},splitColor:Ab,toArray:Mt,selector:cb,mapRange:Pt,pipe:function pipe(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];return function(t){return e.reduce(function(t,e){return e(t)},t)}},unitize:function unitize(e,r){return function(t){return e(parseFloat(t))+(r||Ya(t))}},interpolate:function interpolate(e,i,t,n){var a=isNaN(e+i)?0:function(t){return(1-t)*e+t*i};if(!a){var s,o,u,h,l,f=r(e),d={};if(!0===t&&(n=1)&&(t=null),f)e={p:e},i={p:i};else if(Z(e)&&!Z(i)){for(u=[],h=e.length,l=h-2,o=1;o<h;o++)u.push(interpolate(e[o-1],e[o]));h--,a=function func(t){t*=h;var e=Math.min(l,~~t);return u[e](t-e)},t=i}else n||(e=yt(Z(e)?[]:{},e));if(!u){for(s in i)Wt.call(d,e,s,"get",i[s]);a=function func(t){return he(t,d)||(f?e.p:e)}}}return Wa(t,a)},shuffle:db},install:P,effects:_t,ticker:Rt,updateRoot:Xt.updateRoot,plugins:pt,globalTimeline:I,core:{PropTween:_e,globals:S,Tween:$t,Timeline:Xt,Animation:Ut,getCache:fa,_removeLinkedListItem:ya,reverting:function reverting(){return L},context:function context(t){return t&&l&&(l.data.push(t),t._ctx=l),l},suppressOverwrites:function suppressOverwrites(t){return F=t}}};ha("to,from,fromTo,delayedCall,set,killTweensOf",function(t){return Se[t]=$t[t]}),Rt.add(Xt.updateRoot),d=Se.to({},{duration:0});function Jc(t,e){for(var r=t._pt;r&&r.p!==e&&r.op!==e&&r.fp!==e;)r=r._next;return r}function Lc(t,a){return{name:t,rawVars:1,init:function init(t,n,e){e._onInit=function(t){var e,i;if(r(n)&&(e={},ha(n,function(t){return e[t]=1}),n=e),a){for(i in e={},n)e[i]=a(n[i]);n=e}!function _addModifiers(t,e){var r,i,n,a=t._targets;for(r in e)for(i=a.length;i--;)(n=(n=t._ptLookup[i][r])&&n.d)&&(n._pt&&(n=Jc(n,r)),n&&n.modifier&&n.modifier(e[r],t,a[i],r))}(t,n)}}}}var ze=Se.registerPlugin({name:"attr",init:function init(t,e,r,i,n){var a,s,o;for(a in this.tween=r,e)o=t.getAttribute(a)||"",(s=this.add(t,"setAttribute",(o||0)+"",e[a],i,n,0,0,a)).op=a,s.b=o,this._props.push(a)},render:function render(t,e){for(var r=e._pt;r;)L?r.set(r.t,r.p,r.b,r):r.r(t,r.d),r=r._next}},{name:"endArray",init:function init(t,e){for(var r=e.length;r--;)this.add(t,r,t[r]||0,e[r],0,0,0,0,0,1)}},Lc("roundProps",fb),Lc("modifiers"),Lc("snap",gb))||Se;$t.version=Xt.version=ze.version="3.12.5",o=1,x()&&Ft();function vd(t,e){return e.set(e.t,e.p,Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function wd(t,e){return e.set(e.t,e.p,1===t?e.e:Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function xd(t,e){return e.set(e.t,e.p,t?Math.round(1e4*(e.s+e.c*t))/1e4+e.u:e.b,e)}function yd(t,e){var r=e.s+e.c*t;e.set(e.t,e.p,~~(r+(r<0?-.5:.5))+e.u,e)}function zd(t,e){return e.set(e.t,e.p,t?e.e:e.b,e)}function Ad(t,e){return e.set(e.t,e.p,1!==t?e.b:e.e,e)}function Bd(t,e,r){return t.style[e]=r}function Cd(t,e,r){return t.style.setProperty(e,r)}function Dd(t,e,r){return t._gsap[e]=r}function Ed(t,e,r){return t._gsap.scaleX=t._gsap.scaleY=r}function Fd(t,e,r,i,n){var a=t._gsap;a.scaleX=a.scaleY=r,a.renderTransform(n,a)}function Gd(t,e,r,i,n){var a=t._gsap;a[e]=r,a.renderTransform(n,a)}function Jd(t,e){var r=this,i=this.target,n=i.style,a=i._gsap;if(t in ar&&n){if(this.tfm=this.tfm||{},"transform"===t)return dr.transform.split(",").forEach(function(t){return Jd.call(r,t,e)});if(~(t=dr[t]||t).indexOf(",")?t.split(",").forEach(function(t){return r.tfm[t]=yr(i,t)}):this.tfm[t]=a.x?a[t]:yr(i,t),t===pr&&(this.tfm.zOrigin=a.zOrigin),0<=this.props.indexOf(cr))return;a.svg&&(this.svgo=i.getAttribute("data-svg-origin"),this.props.push(pr,e,"")),t=cr}(n||e)&&this.props.push(t,e,n[t])}function Kd(t){t.translate&&(t.removeProperty("translate"),t.removeProperty("scale"),t.removeProperty("rotate"))}function Ld(){var t,e,r=this.props,i=this.target,n=i.style,a=i._gsap;for(t=0;t<r.length;t+=3)r[t+1]?i[r[t]]=r[t+2]:r[t+2]?n[r[t]]=r[t+2]:n.removeProperty("--"===r[t].substr(0,2)?r[t]:r[t].replace(hr,"-$1").toLowerCase());if(this.tfm){for(e in this.tfm)a[e]=this.tfm[e];a.svg&&(a.renderTransform(),i.setAttribute("data-svg-origin",this.svgo||"")),(t=Be())&&t.isStart||n[cr]||(Kd(n),a.zOrigin&&n[pr]&&(n[pr]+=" "+a.zOrigin+"px",a.zOrigin=0,a.renderTransform()),a.uncache=1)}}function Md(t,e){var r={target:t,props:[],revert:Ld,save:Jd};return t._gsap||ze.core.getCache(t),e&&e.split(",").forEach(function(t){return r.save(t)}),r}function Od(t,e){var r=De.createElementNS?De.createElementNS((e||"http://www.w3.org/1999/xhtml").replace(/^https/,"http"),t):De.createElement(t);return r&&r.style?r:De.createElement(t)}function Pd(t,e,r){var i=getComputedStyle(t);return i[e]||i.getPropertyValue(e.replace(hr,"-$1").toLowerCase())||i.getPropertyValue(e)||!r&&Pd(t,mr(e)||e,1)||""}function Sd(){(function _windowExists(){return"undefined"!=typeof window})()&&window.document&&(Ee=window,De=Ee.document,Re=De.documentElement,Le=Od("div")||{style:{}},Od("div"),cr=mr(cr),pr=cr+"Origin",Le.style.cssText="border-width:0;line-height:0;position:absolute;padding:0",Ye=!!mr("perspective"),Be=ze.core.reverting,Fe=1)}function Td(t){var e,r=Od("svg",this.ownerSVGElement&&this.ownerSVGElement.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),i=this.parentNode,n=this.nextSibling,a=this.style.cssText;if(Re.appendChild(r),r.appendChild(this),this.style.display="block",t)try{e=this.getBBox(),this._gsapBBox=this.getBBox,this.getBBox=Td}catch(t){}else this._gsapBBox&&(e=this._gsapBBox());return i&&(n?i.insertBefore(this,n):i.appendChild(this)),Re.removeChild(r),this.style.cssText=a,e}function Ud(t,e){for(var r=e.length;r--;)if(t.hasAttribute(e[r]))return t.getAttribute(e[r])}function Vd(e){var r;try{r=e.getBBox()}catch(t){r=Td.call(e,!0)}return r&&(r.width||r.height)||e.getBBox===Td||(r=Td.call(e,!0)),!r||r.width||r.x||r.y?r:{x:+Ud(e,["x","cx","x1"])||0,y:+Ud(e,["y","cy","y1"])||0,width:0,height:0}}function Wd(t){return!(!t.getCTM||t.parentNode&&!t.ownerSVGElement||!Vd(t))}function Xd(t,e){if(e){var r,i=t.style;e in ar&&e!==pr&&(e=cr),i.removeProperty?("ms"!==(r=e.substr(0,2))&&"webkit"!==e.substr(0,6)||(e="-"+e),i.removeProperty("--"===r?e:e.replace(hr,"-$1").toLowerCase())):i.removeAttribute(e)}}function Yd(t,e,r,i,n,a){var s=new _e(t._pt,e,r,0,1,a?Ad:zd);return(t._pt=s).b=i,s.e=n,t._props.push(r),s}function _d(t,e,r,i){var n,a,s,o,u=parseFloat(r)||0,h=(r+"").trim().substr((u+"").length)||"px",l=Le.style,f=lr.test(e),d="svg"===t.tagName.toLowerCase(),c=(d?"client":"offset")+(f?"Width":"Height"),p="px"===i,_="%"===i;if(i===h||!u||gr[i]||gr[h])return u;if("px"===h||p||(u=_d(t,e,r,"px")),o=t.getCTM&&Wd(t),(_||"%"===h)&&(ar[e]||~e.indexOf("adius")))return n=o?t.getBBox()[f?"width":"height"]:t[c],ia(_?u/n*100:u/100*n);if(l[f?"width":"height"]=100+(p?h:i),a=~e.indexOf("adius")||"em"===i&&t.appendChild&&!d?t:t.parentNode,o&&(a=(t.ownerSVGElement||{}).parentNode),a&&a!==De&&a.appendChild||(a=De.body),(s=a._gsap)&&_&&s.width&&f&&s.time===Rt.time&&!s.uncache)return ia(u/s.width*100);if(!_||"height"!==e&&"width"!==e)!_&&"%"!==h||vr[Pd(a,"display")]||(l.position=Pd(t,"position")),a===t&&(l.position="static"),a.appendChild(Le),n=Le[c],a.removeChild(Le),l.position="absolute";else{var m=t.style[e];t.style[e]=100+i,n=t[c],m?t.style[e]=m:Xd(t,e)}return f&&_&&((s=fa(a)).time=Rt.time,s.width=a[c]),ia(p?n*u/100:n&&u?100/n*u:0)}function be(t,e,r,i){if(!r||"none"===r){var n=mr(e,t,1),a=n&&Pd(t,n,1);a&&a!==r?(e=n,r=a):"borderColor"===e&&(r=Pd(t,"borderTopColor"))}var s,o,u,h,l,f,d,c,p,_,m,g=new _e(this._pt,t.style,e,0,1,ue),v=0,y=0;if(g.b=r,g.e=i,r+="","auto"===(i+="")&&(f=t.style[e],t.style[e]=i,i=Pd(t,e)||i,f?t.style[e]=f:Xd(t,e)),Fb(s=[r,i]),i=s[1],u=(r=s[0]).match(rt)||[],(i.match(rt)||[]).length){for(;o=rt.exec(i);)d=o[0],p=i.substring(v,o.index),l?l=(l+1)%5:"rgba("!==p.substr(-5)&&"hsla("!==p.substr(-5)||(l=1),d!==(f=u[y++]||"")&&(h=parseFloat(f)||0,m=f.substr((h+"").length),"="===d.charAt(1)&&(d=ka(h,d)+m),c=parseFloat(d),_=d.substr((c+"").length),v=rt.lastIndex-_.length,_||(_=_||q.units[e]||m,v===i.length&&(i+=_,g.e+=_)),m!==_&&(h=_d(t,e,f,_)||0),g._pt={_next:g._pt,p:p||1===y?p:",",s:h,c:c-h,m:l&&l<4||"zIndex"===e?Math.round:0});g.c=v<i.length?i.substring(v,i.length):""}else g.r="display"===e&&"none"===i?Ad:zd;return nt.test(i)&&(g.e=0),this._pt=g}function de(t){var e=t.split(" "),r=e[0],i=e[1]||"50%";return"top"!==r&&"bottom"!==r&&"left"!==i&&"right"!==i||(t=r,r=i,i=t),e[0]=Tr[r]||r,e[1]=Tr[i]||i,e.join(" ")}function ee(t,e){if(e.tween&&e.tween._time===e.tween._dur){var r,i,n,a=e.t,s=a.style,o=e.u,u=a._gsap;if("all"===o||!0===o)s.cssText="",i=1;else for(n=(o=o.split(",")).length;-1<--n;)r=o[n],ar[r]&&(i=1,r="transformOrigin"===r?pr:cr),Xd(a,r);i&&(Xd(a,cr),u&&(u.svg&&a.removeAttribute("transform"),Or(a,1),u.uncache=1,Kd(s)))}}function ie(t){return"matrix(1, 0, 0, 1, 0, 0)"===t||"none"===t||!t}function je(t){var e=Pd(t,cr);return ie(e)?wr:e.substr(7).match(et).map(ia)}function ke(t,e){var r,i,n,a,s=t._gsap||fa(t),o=t.style,u=je(t);return s.svg&&t.getAttribute("transform")?"1,0,0,1,0,0"===(u=[(n=t.transform.baseVal.consolidate().matrix).a,n.b,n.c,n.d,n.e,n.f]).join(",")?wr:u:(u!==wr||t.offsetParent||t===Re||s.svg||(n=o.display,o.display="block",(r=t.parentNode)&&t.offsetParent||(a=1,i=t.nextElementSibling,Re.appendChild(t)),u=je(t),n?o.display=n:Xd(t,"display"),a&&(i?r.insertBefore(t,i):r?r.appendChild(t):Re.removeChild(t))),e&&6<u.length?[u[0],u[1],u[4],u[5],u[12],u[13]]:u)}function le(t,e,r,i,n,a){var s,o,u,h=t._gsap,l=n||ke(t,!0),f=h.xOrigin||0,d=h.yOrigin||0,c=h.xOffset||0,p=h.yOffset||0,_=l[0],m=l[1],g=l[2],v=l[3],y=l[4],T=l[5],b=e.split(" "),w=parseFloat(b[0])||0,x=parseFloat(b[1])||0;r?l!==wr&&(o=_*v-m*g)&&(u=w*(-m/o)+x*(_/o)-(_*T-m*y)/o,w=w*(v/o)+x*(-g/o)+(g*T-v*y)/o,x=u):(w=(s=Vd(t)).x+(~b[0].indexOf("%")?w/100*s.width:w),x=s.y+(~(b[1]||b[0]).indexOf("%")?x/100*s.height:x)),i||!1!==i&&h.smooth?(y=w-f,T=x-d,h.xOffset=c+(y*_+T*g)-y,h.yOffset=p+(y*m+T*v)-T):h.xOffset=h.yOffset=0,h.xOrigin=w,h.yOrigin=x,h.smooth=!!i,h.origin=e,h.originIsAbsolute=!!r,t.style[pr]="0px 0px",a&&(Yd(a,h,"xOrigin",f,w),Yd(a,h,"yOrigin",d,x),Yd(a,h,"xOffset",c,h.xOffset),Yd(a,h,"yOffset",p,h.yOffset)),t.setAttribute("data-svg-origin",w+" "+x)}function oe(t,e,r){var i=Ya(e);return ia(parseFloat(e)+parseFloat(_d(t,"x",r+"px",i)))+i}function ve(t,e,i,n,a){var s,o,u=360,h=r(a),l=parseFloat(a)*(h&&~a.indexOf("rad")?sr:1)-n,f=n+l+"deg";return h&&("short"===(s=a.split("_")[1])&&(l%=u)!==l%180&&(l+=l<0?u:-u),"cw"===s&&l<0?l=(l+36e9)%u-~~(l/u)*u:"ccw"===s&&0<l&&(l=(l-36e9)%u-~~(l/u)*u)),t._pt=o=new _e(t._pt,e,i,n,l,wd),o.e=f,o.u="deg",t._props.push(i),o}function we(t,e){for(var r in e)t[r]=e[r];return t}function xe(t,e,r){var i,n,a,s,o,u,h,l=we({},r._gsap),f=r.style;for(n in l.svg?(a=r.getAttribute("transform"),r.setAttribute("transform",""),f[cr]=e,i=Or(r,1),Xd(r,cr),r.setAttribute("transform",a)):(a=getComputedStyle(r)[cr],f[cr]=e,i=Or(r,1),f[cr]=a),ar)(a=l[n])!==(s=i[n])&&"perspective,force3D,transformOrigin,svgOrigin".indexOf(n)<0&&(o=Ya(a)!==(h=Ya(s))?_d(r,n,a,h):parseFloat(a),u=parseFloat(s),t._pt=new _e(t._pt,i,n,o,u-o,vd),t._pt.u=h||0,t._props.push(n));we(i,l)}var Ee,De,Re,Fe,Le,Ie,Be,Ye,qe=Lt.Power0,Ve=Lt.Power1,Ue=Lt.Power2,Xe=Lt.Power3,Ne=Lt.Power4,Ge=Lt.Linear,We=Lt.Quad,Qe=Lt.Cubic,Ke=Lt.Quart,Je=Lt.Quint,He=Lt.Strong,$e=Lt.Elastic,Ze=Lt.Back,tr=Lt.SteppedEase,er=Lt.Bounce,rr=Lt.Sine,ir=Lt.Expo,nr=Lt.Circ,ar={},sr=180/Math.PI,or=Math.PI/180,ur=Math.atan2,hr=/([A-Z])/g,lr=/(left|right|width|margin|padding|x)/i,fr=/[\s,\(]\S/,dr={autoAlpha:"opacity,visibility",scale:"scaleX,scaleY",alpha:"opacity"},cr="transform",pr=cr+"Origin",_r="O,Moz,ms,Ms,Webkit".split(","),mr=function _checkPropPrefix(t,e,r){var i=(e||Le).style,n=5;if(t in i&&!r)return t;for(t=t.charAt(0).toUpperCase()+t.substr(1);n--&&!(_r[n]+t in i););return n<0?null:(3===n?"ms":0<=n?_r[n]:"")+t},gr={deg:1,rad:1,turn:1},vr={grid:1,flex:1},yr=function _get(t,e,r,i){var n;return Fe||Sd(),e in dr&&"transform"!==e&&~(e=dr[e]).indexOf(",")&&(e=e.split(",")[0]),ar[e]&&"transform"!==e?(n=Or(t,i),n="transformOrigin"!==e?n[e]:n.svg?n.origin:kr(Pd(t,pr))+" "+n.zOrigin+"px"):(n=t.style[e])&&"auto"!==n&&!i&&!~(n+"").indexOf("calc(")||(n=br[e]&&br[e](t,e,r)||Pd(t,e)||ga(t,e)||("opacity"===e?1:0)),r&&!~(n+"").trim().indexOf(" ")?_d(t,e,n,r)+r:n},Tr={top:"0%",bottom:"100%",left:"0%",right:"100%",center:"50%"},br={clearProps:function clearProps(t,e,r,i,n){if("isFromStart"!==n.data){var a=t._pt=new _e(t._pt,e,r,0,0,ee);return a.u=i,a.pr=-10,a.tween=n,t._props.push(r),1}}},wr=[1,0,0,1,0,0],xr={},Or=function _parseTransform(t,e){var r=t._gsap||new Vt(t);if("x"in r&&!e&&!r.uncache)return r;var i,n,a,s,o,u,h,l,f,d,c,p,_,m,g,v,y,T,b,w,x,O,k,M,P,C,A,S,z,E,D,R,F=t.style,L=r.scaleX<0,I="deg",B=getComputedStyle(t),Y=Pd(t,pr)||"0";return i=n=a=u=h=l=f=d=c=0,s=o=1,r.svg=!(!t.getCTM||!Wd(t)),B.translate&&("none"===B.translate&&"none"===B.scale&&"none"===B.rotate||(F[cr]=("none"!==B.translate?"translate3d("+(B.translate+" 0 0").split(" ").slice(0,3).join(", ")+") ":"")+("none"!==B.rotate?"rotate("+B.rotate+") ":"")+("none"!==B.scale?"scale("+B.scale.split(" ").join(",")+") ":"")+("none"!==B[cr]?B[cr]:"")),F.scale=F.rotate=F.translate="none"),m=ke(t,r.svg),r.svg&&(M=r.uncache?(P=t.getBBox(),Y=r.xOrigin-P.x+"px "+(r.yOrigin-P.y)+"px",""):!e&&t.getAttribute("data-svg-origin"),le(t,M||Y,!!M||r.originIsAbsolute,!1!==r.smooth,m)),p=r.xOrigin||0,_=r.yOrigin||0,m!==wr&&(T=m[0],b=m[1],w=m[2],x=m[3],i=O=m[4],n=k=m[5],6===m.length?(s=Math.sqrt(T*T+b*b),o=Math.sqrt(x*x+w*w),u=T||b?ur(b,T)*sr:0,(f=w||x?ur(w,x)*sr+u:0)&&(o*=Math.abs(Math.cos(f*or))),r.svg&&(i-=p-(p*T+_*w),n-=_-(p*b+_*x))):(R=m[6],E=m[7],A=m[8],S=m[9],z=m[10],D=m[11],i=m[12],n=m[13],a=m[14],h=(g=ur(R,z))*sr,g&&(M=O*(v=Math.cos(-g))+A*(y=Math.sin(-g)),P=k*v+S*y,C=R*v+z*y,A=O*-y+A*v,S=k*-y+S*v,z=R*-y+z*v,D=E*-y+D*v,O=M,k=P,R=C),l=(g=ur(-w,z))*sr,g&&(v=Math.cos(-g),D=x*(y=Math.sin(-g))+D*v,T=M=T*v-A*y,b=P=b*v-S*y,w=C=w*v-z*y),u=(g=ur(b,T))*sr,g&&(M=T*(v=Math.cos(g))+b*(y=Math.sin(g)),P=O*v+k*y,b=b*v-T*y,k=k*v-O*y,T=M,O=P),h&&359.9<Math.abs(h)+Math.abs(u)&&(h=u=0,l=180-l),s=ia(Math.sqrt(T*T+b*b+w*w)),o=ia(Math.sqrt(k*k+R*R)),g=ur(O,k),f=2e-4<Math.abs(g)?g*sr:0,c=D?1/(D<0?-D:D):0),r.svg&&(M=t.getAttribute("transform"),r.forceCSS=t.setAttribute("transform","")||!ie(Pd(t,cr)),M&&t.setAttribute("transform",M))),90<Math.abs(f)&&Math.abs(f)<270&&(L?(s*=-1,f+=u<=0?180:-180,u+=u<=0?180:-180):(o*=-1,f+=f<=0?180:-180)),e=e||r.uncache,r.x=i-((r.xPercent=i&&(!e&&r.xPercent||(Math.round(t.offsetWidth/2)===Math.round(-i)?-50:0)))?t.offsetWidth*r.xPercent/100:0)+"px",r.y=n-((r.yPercent=n&&(!e&&r.yPercent||(Math.round(t.offsetHeight/2)===Math.round(-n)?-50:0)))?t.offsetHeight*r.yPercent/100:0)+"px",r.z=a+"px",r.scaleX=ia(s),r.scaleY=ia(o),r.rotation=ia(u)+I,r.rotationX=ia(h)+I,r.rotationY=ia(l)+I,r.skewX=f+I,r.skewY=d+I,r.transformPerspective=c+"px",(r.zOrigin=parseFloat(Y.split(" ")[2])||!e&&r.zOrigin||0)&&(F[pr]=kr(Y)),r.xOffset=r.yOffset=0,r.force3D=q.force3D,r.renderTransform=r.svg?zr:Ye?Sr:Mr,r.uncache=0,r},kr=function _firstTwoOnly(t){return(t=t.split(" "))[0]+" "+t[1]},Mr=function _renderNon3DTransforms(t,e){e.z="0px",e.rotationY=e.rotationX="0deg",e.force3D=0,Sr(t,e)},Pr="0deg",Cr="0px",Ar=") ",Sr=function _renderCSSTransforms(t,e){var r=e||this,i=r.xPercent,n=r.yPercent,a=r.x,s=r.y,o=r.z,u=r.rotation,h=r.rotationY,l=r.rotationX,f=r.skewX,d=r.skewY,c=r.scaleX,p=r.scaleY,_=r.transformPerspective,m=r.force3D,g=r.target,v=r.zOrigin,y="",T="auto"===m&&t&&1!==t||!0===m;if(v&&(l!==Pr||h!==Pr)){var b,w=parseFloat(h)*or,x=Math.sin(w),O=Math.cos(w);w=parseFloat(l)*or,b=Math.cos(w),a=oe(g,a,x*b*-v),s=oe(g,s,-Math.sin(w)*-v),o=oe(g,o,O*b*-v+v)}_!==Cr&&(y+="perspective("+_+Ar),(i||n)&&(y+="translate("+i+"%, "+n+"%) "),!T&&a===Cr&&s===Cr&&o===Cr||(y+=o!==Cr||T?"translate3d("+a+", "+s+", "+o+") ":"translate("+a+", "+s+Ar),u!==Pr&&(y+="rotate("+u+Ar),h!==Pr&&(y+="rotateY("+h+Ar),l!==Pr&&(y+="rotateX("+l+Ar),f===Pr&&d===Pr||(y+="skew("+f+", "+d+Ar),1===c&&1===p||(y+="scale("+c+", "+p+Ar),g.style[cr]=y||"translate(0, 0)"},zr=function _renderSVGTransforms(t,e){var r,i,n,a,s,o=e||this,u=o.xPercent,h=o.yPercent,l=o.x,f=o.y,d=o.rotation,c=o.skewX,p=o.skewY,_=o.scaleX,m=o.scaleY,g=o.target,v=o.xOrigin,y=o.yOrigin,T=o.xOffset,b=o.yOffset,w=o.forceCSS,x=parseFloat(l),O=parseFloat(f);d=parseFloat(d),c=parseFloat(c),(p=parseFloat(p))&&(c+=p=parseFloat(p),d+=p),d||c?(d*=or,c*=or,r=Math.cos(d)*_,i=Math.sin(d)*_,n=Math.sin(d-c)*-m,a=Math.cos(d-c)*m,c&&(p*=or,s=Math.tan(c-p),n*=s=Math.sqrt(1+s*s),a*=s,p&&(s=Math.tan(p),r*=s=Math.sqrt(1+s*s),i*=s)),r=ia(r),i=ia(i),n=ia(n),a=ia(a)):(r=_,a=m,i=n=0),(x&&!~(l+"").indexOf("px")||O&&!~(f+"").indexOf("px"))&&(x=_d(g,"x",l,"px"),O=_d(g,"y",f,"px")),(v||y||T||b)&&(x=ia(x+v-(v*r+y*n)+T),O=ia(O+y-(v*i+y*a)+b)),(u||h)&&(s=g.getBBox(),x=ia(x+u/100*s.width),O=ia(O+h/100*s.height)),s="matrix("+r+","+i+","+n+","+a+","+x+","+O+")",g.setAttribute("transform",s),w&&(g.style[cr]=s)};ha("padding,margin,Width,Radius",function(e,r){var t="Right",i="Bottom",n="Left",o=(r<3?["Top",t,i,n]:["Top"+n,"Top"+t,i+t,i+n]).map(function(t){return r<2?e+t:"border"+t+e});br[1<r?"border"+e:e]=function(e,t,r,i,n){var a,s;if(arguments.length<4)return a=o.map(function(t){return yr(e,t,r)}),5===(s=a.join(" ")).split(a[0]).length?a[0]:s;a=(i+"").split(" "),s={},o.forEach(function(t,e){return s[t]=a[e]=a[e]||a[(e-1)/2|0]}),e.init(t,s,n)}});var Er,Dr,Rr,Fr={name:"css",register:Sd,targetTest:function targetTest(t){return t.style&&t.nodeType},init:function init(t,e,i,n,a){var s,o,u,h,l,f,d,c,p,_,m,g,v,y,T,b,w=this._props,x=t.style,O=i.vars.startAt;for(d in Fe||Sd(),this.styles=this.styles||Md(t),b=this.styles.props,this.tween=i,e)if("autoRound"!==d&&(o=e[d],!pt[d]||!ac(d,e,i,n,t,a)))if(l=typeof o,f=br[d],"function"===l&&(l=typeof(o=o.call(i,n,t,a))),"string"===l&&~o.indexOf("random(")&&(o=ob(o)),f)f(this,t,d,o,i)&&(T=1);else if("--"===d.substr(0,2))s=(getComputedStyle(t).getPropertyValue(d)+"").trim(),o+="",Et.lastIndex=0,Et.test(s)||(c=Ya(s),p=Ya(o)),p?c!==p&&(s=_d(t,d,s,p)+p):c&&(o+=c),this.add(x,"setProperty",s,o,n,a,0,0,d),w.push(d),b.push(d,0,x[d]);else if("undefined"!==l){if(O&&d in O?(s="function"==typeof O[d]?O[d].call(i,n,t,a):O[d],r(s)&&~s.indexOf("random(")&&(s=ob(s)),Ya(s+"")||"auto"===s||(s+=q.units[d]||Ya(yr(t,d))||""),"="===(s+"").charAt(1)&&(s=yr(t,d))):s=yr(t,d),h=parseFloat(s),(_="string"===l&&"="===o.charAt(1)&&o.substr(0,2))&&(o=o.substr(2)),u=parseFloat(o),d in dr&&("autoAlpha"===d&&(1===h&&"hidden"===yr(t,"visibility")&&u&&(h=0),b.push("visibility",0,x.visibility),Yd(this,x,"visibility",h?"inherit":"hidden",u?"inherit":"hidden",!u)),"scale"!==d&&"transform"!==d&&~(d=dr[d]).indexOf(",")&&(d=d.split(",")[0])),m=d in ar)if(this.styles.save(d),g||((v=t._gsap).renderTransform&&!e.parseTransform||Or(t,e.parseTransform),y=!1!==e.smoothOrigin&&v.smooth,(g=this._pt=new _e(this._pt,x,cr,0,1,v.renderTransform,v,0,-1)).dep=1),"scale"===d)this._pt=new _e(this._pt,v,"scaleY",v.scaleY,(_?ka(v.scaleY,_+u):u)-v.scaleY||0,vd),this._pt.u=0,w.push("scaleY",d),d+="X";else{if("transformOrigin"===d){b.push(pr,0,x[pr]),o=de(o),v.svg?le(t,o,0,y,0,this):((p=parseFloat(o.split(" ")[2])||0)!==v.zOrigin&&Yd(this,v,"zOrigin",v.zOrigin,p),Yd(this,x,d,kr(s),kr(o)));continue}if("svgOrigin"===d){le(t,o,1,y,0,this);continue}if(d in xr){ve(this,v,d,h,_?ka(h,_+o):o);continue}if("smoothOrigin"===d){Yd(this,v,"smooth",v.smooth,o);continue}if("force3D"===d){v[d]=o;continue}if("transform"===d){xe(this,o,t);continue}}else d in x||(d=mr(d)||d);if(m||(u||0===u)&&(h||0===h)&&!fr.test(o)&&d in x)u=u||0,(c=(s+"").substr((h+"").length))!==(p=Ya(o)||(d in q.units?q.units[d]:c))&&(h=_d(t,d,s,p)),this._pt=new _e(this._pt,m?v:x,d,h,(_?ka(h,_+u):u)-h,m||"px"!==p&&"zIndex"!==d||!1===e.autoRound?vd:yd),this._pt.u=p||0,c!==p&&"%"!==p&&(this._pt.b=s,this._pt.r=xd);else if(d in x)be.call(this,t,d,s,_?_+o:o);else if(d in t)this.add(t,d,s||t[d],_?_+o:o,n,a);else if("parseTransform"!==d){Q(d,o);continue}m||(d in x?b.push(d,0,x[d]):b.push(d,1,s||t[d])),w.push(d)}T&&pe(this)},render:function render(t,e){if(e.tween._time||!Be())for(var r=e._pt;r;)r.r(t,r.d),r=r._next;else e.styles.revert()},get:yr,aliases:dr,getSetter:function getSetter(t,e,r){var i=dr[e];return i&&i.indexOf(",")<0&&(e=i),e in ar&&e!==pr&&(t._gsap.x||yr(t,"x"))?r&&Ie===r?"scale"===e?Ed:Dd:(Ie=r||{})&&("scale"===e?Fd:Gd):t.style&&!u(t.style[e])?Bd:~e.indexOf("-")?Cd:ne(t,e)},core:{_removeProperty:Xd,_getMatrix:ke}};ze.utils.checkPrefix=mr,ze.core.getStyleSaver=Md,Rr=ha((Er="x,y,z,scale,scaleX,scaleY,xPercent,yPercent")+","+(Dr="rotation,rotationX,rotationY,skewX,skewY")+",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",function(t){ar[t]=1}),ha(Dr,function(t){q.units[t]="deg",xr[t]=1}),dr[Rr[13]]=Er+","+Dr,ha("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",function(t){var e=t.split(":");dr[e[1]]=Rr[e[0]]}),ha("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",function(t){q.units[t]="px"}),ze.registerPlugin(Fr);var Lr=ze.registerPlugin(Fr)||ze,Ir=Lr.core.Tween;e.Back=Ze,e.Bounce=er,e.CSSPlugin=Fr,e.Circ=nr,e.Cubic=Qe,e.Elastic=$e,e.Expo=ir,e.Linear=Ge,e.Power0=qe,e.Power1=Ve,e.Power2=Ue,e.Power3=Xe,e.Power4=Ne,e.Quad=We,e.Quart=Ke,e.Quint=Je,e.Sine=rr,e.SteppedEase=tr,e.Strong=He,e.TimelineLite=Xt,e.TimelineMax=Xt,e.TweenLite=$t,e.TweenMax=Ir,e.default=Lr,e.gsap=Lr;if (typeof(window)==="undefined"||window!==e){Object.defineProperty(e,"__esModule",{value:!0})} else {delete e.default}});

/*!
 * ScrollTrigger 3.12.5
 * https://gsap.com
 * 
 * @license Copyright 2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */

!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t((e=e||self).window=e.window||{})}(this,function(e){"use strict";function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function r(){return Ce||"undefined"!=typeof window&&(Ce=window.gsap)&&Ce.registerPlugin&&Ce}function z(e,t){return~Le.indexOf(e)&&Le[Le.indexOf(e)+1][t]}function A(e){return!!~t.indexOf(e)}function B(e,t,r,n,o){return e.addEventListener(t,r,{passive:!1!==n,capture:!!o})}function C(e,t,r,n){return e.removeEventListener(t,r,!!n)}function F(){return De&&De.isPressed||Ie.cache++}function G(r,n){function dd(e){if(e||0===e){o&&(Se.history.scrollRestoration="manual");var t=De&&De.isPressed;e=dd.v=Math.round(e)||(De&&De.iOS?1:0),r(e),dd.cacheID=Ie.cache,t&&i("ss",e)}else(n||Ie.cache!==dd.cacheID||i("ref"))&&(dd.cacheID=Ie.cache,dd.v=r());return dd.v+dd.offset}return dd.offset=0,r&&dd}function J(e,t){return(t&&t._ctx&&t._ctx.selector||Ce.utils.toArray)(e)[0]||("string"==typeof e&&!1!==Ce.config().nullTargetWarn?console.warn("Element not found:",e):null)}function K(t,e){var r=e.s,n=e.sc;A(t)&&(t=ke.scrollingElement||Pe);var o=Ie.indexOf(t),i=n===Fe.sc?1:2;~o||(o=Ie.push(t)-1),Ie[o+i]||B(t,"scroll",F);var a=Ie[o+i],s=a||(Ie[o+i]=G(z(t,r),!0)||(A(t)?n:G(function(e){return arguments.length?t[r]=e:t[r]})));return s.target=t,a||(s.smooth="smooth"===Ce.getProperty(t,"scrollBehavior")),s}function L(e,t,o){function Cd(e,t){var r=ze();t||n<r-s?(a=i,i=e,l=s,s=r):o?i+=e:i=a+(e-a)/(r-l)*(s-l)}var i=e,a=e,s=ze(),l=s,n=t||50,c=Math.max(500,3*n);return{update:Cd,reset:function reset(){a=i=o?0:i,l=s=0},getVelocity:function getVelocity(e){var t=l,r=a,n=ze();return!e&&0!==e||e===i||Cd(e),s===l||c<n-l?0:(i+(o?r:-r))/((o?n:s)-t)*1e3}}}function M(e,t){return t&&!e._gsapAllow&&e.preventDefault(),e.changedTouches?e.changedTouches[0]:e}function N(e){var t=Math.max.apply(Math,e),r=Math.min.apply(Math,e);return Math.abs(t)>=Math.abs(r)?t:r}function O(){(Ae=Ce.core.globals().ScrollTrigger)&&Ae.core&&function _integrate(){var e=Ae.core,r=e.bridge||{},t=e._scrollers,n=e._proxies;t.push.apply(t,Ie),n.push.apply(n,Le),Ie=t,Le=n,i=function _bridge(e,t){return r[e](t)}}()}function P(e){return Ce=e||r(),!Te&&Ce&&"undefined"!=typeof document&&document.body&&(Se=window,Pe=(ke=document).documentElement,Me=ke.body,t=[Se,ke,Pe,Me],Ce.utils.clamp,Be=Ce.core.context||function(){},Oe="onpointerenter"in Me?"pointer":"mouse",Ee=k.isTouch=Se.matchMedia&&Se.matchMedia("(hover: none), (pointer: coarse)").matches?1:"ontouchstart"in Se||0<navigator.maxTouchPoints||0<navigator.msMaxTouchPoints?2:0,Re=k.eventTypes=("ontouchstart"in Pe?"touchstart,touchmove,touchcancel,touchend":"onpointerdown"in Pe?"pointerdown,pointermove,pointercancel,pointerup":"mousedown,mousemove,mouseup,mouseup").split(","),setTimeout(function(){return o=0},500),O(),Te=1),Te}var Ce,Te,Se,ke,Pe,Me,Ee,Oe,Ae,t,De,Re,Be,o=1,qe=[],Ie=[],Le=[],ze=Date.now,i=function _bridge(e,t){return t},n="scrollLeft",a="scrollTop",Ye={s:n,p:"left",p2:"Left",os:"right",os2:"Right",d:"width",d2:"Width",a:"x",sc:G(function(e){return arguments.length?Se.scrollTo(e,Fe.sc()):Se.pageXOffset||ke[n]||Pe[n]||Me[n]||0})},Fe={s:a,p:"top",p2:"Top",os:"bottom",os2:"Bottom",d:"height",d2:"Height",a:"y",op:Ye,sc:G(function(e){return arguments.length?Se.scrollTo(Ye.sc(),e):Se.pageYOffset||ke[a]||Pe[a]||Me[a]||0})};Ye.op=Fe,Ie.cache=0;var k=(Observer.prototype.init=function init(e){Te||P(Ce)||console.warn("Please gsap.registerPlugin(Observer)"),Ae||O();var o=e.tolerance,a=e.dragMinimum,t=e.type,i=e.target,r=e.lineHeight,n=e.debounce,s=e.preventDefault,l=e.onStop,c=e.onStopDelay,u=e.ignore,f=e.wheelSpeed,d=e.event,p=e.onDragStart,g=e.onDragEnd,h=e.onDrag,v=e.onPress,b=e.onRelease,m=e.onRight,y=e.onLeft,x=e.onUp,w=e.onDown,_=e.onChangeX,T=e.onChangeY,S=e.onChange,k=e.onToggleX,E=e.onToggleY,D=e.onHover,R=e.onHoverEnd,q=e.onMove,I=e.ignoreCheck,z=e.isNormalizer,Y=e.onGestureStart,H=e.onGestureEnd,X=e.onWheel,W=e.onEnable,V=e.onDisable,U=e.onClick,j=e.scrollSpeed,G=e.capture,Q=e.allowClicks,Z=e.lockAxis,$=e.onLockAxis;function cf(){return xe=ze()}function df(e,t){return(se.event=e)&&u&&~u.indexOf(e.target)||t&&he&&"touch"!==e.pointerType||I&&I(e,t)}function ff(){var e=se.deltaX=N(me),t=se.deltaY=N(ye),r=Math.abs(e)>=o,n=Math.abs(t)>=o;S&&(r||n)&&S(se,e,t,me,ye),r&&(m&&0<se.deltaX&&m(se),y&&se.deltaX<0&&y(se),_&&_(se),k&&se.deltaX<0!=le<0&&k(se),le=se.deltaX,me[0]=me[1]=me[2]=0),n&&(w&&0<se.deltaY&&w(se),x&&se.deltaY<0&&x(se),T&&T(se),E&&se.deltaY<0!=ce<0&&E(se),ce=se.deltaY,ye[0]=ye[1]=ye[2]=0),(ne||re)&&(q&&q(se),re&&(h(se),re=!1),ne=!1),ie&&!(ie=!1)&&$&&$(se),oe&&(X(se),oe=!1),ee=0}function gf(e,t,r){me[r]+=e,ye[r]+=t,se._vx.update(e),se._vy.update(t),n?ee=ee||requestAnimationFrame(ff):ff()}function hf(e,t){Z&&!ae&&(se.axis=ae=Math.abs(e)>Math.abs(t)?"x":"y",ie=!0),"y"!==ae&&(me[2]+=e,se._vx.update(e,!0)),"x"!==ae&&(ye[2]+=t,se._vy.update(t,!0)),n?ee=ee||requestAnimationFrame(ff):ff()}function jf(e){if(!df(e,1)){var t=(e=M(e,s)).clientX,r=e.clientY,n=t-se.x,o=r-se.y,i=se.isDragging;se.x=t,se.y=r,(i||Math.abs(se.startX-t)>=a||Math.abs(se.startY-r)>=a)&&(h&&(re=!0),i||(se.isDragging=!0),hf(n,o),i||p&&p(se))}}function mf(e){return e.touches&&1<e.touches.length&&(se.isGesturing=!0)&&Y(e,se.isDragging)}function nf(){return(se.isGesturing=!1)||H(se)}function of(e){if(!df(e)){var t=fe(),r=de();gf((t-pe)*j,(r-ge)*j,1),pe=t,ge=r,l&&te.restart(!0)}}function pf(e){if(!df(e)){e=M(e,s),X&&(oe=!0);var t=(1===e.deltaMode?r:2===e.deltaMode?Se.innerHeight:1)*f;gf(e.deltaX*t,e.deltaY*t,0),l&&!z&&te.restart(!0)}}function qf(e){if(!df(e)){var t=e.clientX,r=e.clientY,n=t-se.x,o=r-se.y;se.x=t,se.y=r,ne=!0,l&&te.restart(!0),(n||o)&&hf(n,o)}}function rf(e){se.event=e,D(se)}function sf(e){se.event=e,R(se)}function tf(e){return df(e)||M(e,s)&&U(se)}this.target=i=J(i)||Pe,this.vars=e,u=u&&Ce.utils.toArray(u),o=o||1e-9,a=a||0,f=f||1,j=j||1,t=t||"wheel,touch,pointer",n=!1!==n,r=r||parseFloat(Se.getComputedStyle(Me).lineHeight)||22;var ee,te,re,ne,oe,ie,ae,se=this,le=0,ce=0,ue=e.passive||!s,fe=K(i,Ye),de=K(i,Fe),pe=fe(),ge=de(),he=~t.indexOf("touch")&&!~t.indexOf("pointer")&&"pointerdown"===Re[0],ve=A(i),be=i.ownerDocument||ke,me=[0,0,0],ye=[0,0,0],xe=0,we=se.onPress=function(e){df(e,1)||e&&e.button||(se.axis=ae=null,te.pause(),se.isPressed=!0,e=M(e),le=ce=0,se.startX=se.x=e.clientX,se.startY=se.y=e.clientY,se._vx.reset(),se._vy.reset(),B(z?i:be,Re[1],jf,ue,!0),se.deltaX=se.deltaY=0,v&&v(se))},_e=se.onRelease=function(t){if(!df(t,1)){C(z?i:be,Re[1],jf,!0);var e=!isNaN(se.y-se.startY),r=se.isDragging,n=r&&(3<Math.abs(se.x-se.startX)||3<Math.abs(se.y-se.startY)),o=M(t);!n&&e&&(se._vx.reset(),se._vy.reset(),s&&Q&&Ce.delayedCall(.08,function(){if(300<ze()-xe&&!t.defaultPrevented)if(t.target.click)t.target.click();else if(be.createEvent){var e=be.createEvent("MouseEvents");e.initMouseEvent("click",!0,!0,Se,1,o.screenX,o.screenY,o.clientX,o.clientY,!1,!1,!1,!1,0,null),t.target.dispatchEvent(e)}})),se.isDragging=se.isGesturing=se.isPressed=!1,l&&r&&!z&&te.restart(!0),g&&r&&g(se),b&&b(se,n)}};te=se._dc=Ce.delayedCall(c||.25,function onStopFunc(){se._vx.reset(),se._vy.reset(),te.pause(),l&&l(se)}).pause(),se.deltaX=se.deltaY=0,se._vx=L(0,50,!0),se._vy=L(0,50,!0),se.scrollX=fe,se.scrollY=de,se.isDragging=se.isGesturing=se.isPressed=!1,Be(this),se.enable=function(e){return se.isEnabled||(B(ve?be:i,"scroll",F),0<=t.indexOf("scroll")&&B(ve?be:i,"scroll",of,ue,G),0<=t.indexOf("wheel")&&B(i,"wheel",pf,ue,G),(0<=t.indexOf("touch")&&Ee||0<=t.indexOf("pointer"))&&(B(i,Re[0],we,ue,G),B(be,Re[2],_e),B(be,Re[3],_e),Q&&B(i,"click",cf,!0,!0),U&&B(i,"click",tf),Y&&B(be,"gesturestart",mf),H&&B(be,"gestureend",nf),D&&B(i,Oe+"enter",rf),R&&B(i,Oe+"leave",sf),q&&B(i,Oe+"move",qf)),se.isEnabled=!0,e&&e.type&&we(e),W&&W(se)),se},se.disable=function(){se.isEnabled&&(qe.filter(function(e){return e!==se&&A(e.target)}).length||C(ve?be:i,"scroll",F),se.isPressed&&(se._vx.reset(),se._vy.reset(),C(z?i:be,Re[1],jf,!0)),C(ve?be:i,"scroll",of,G),C(i,"wheel",pf,G),C(i,Re[0],we,G),C(be,Re[2],_e),C(be,Re[3],_e),C(i,"click",cf,!0),C(i,"click",tf),C(be,"gesturestart",mf),C(be,"gestureend",nf),C(i,Oe+"enter",rf),C(i,Oe+"leave",sf),C(i,Oe+"move",qf),se.isEnabled=se.isPressed=se.isDragging=!1,V&&V(se))},se.kill=se.revert=function(){se.disable();var e=qe.indexOf(se);0<=e&&qe.splice(e,1),De===se&&(De=0)},qe.push(se),z&&A(i)&&(De=se),se.enable(d)},function _createClass(e,t,r){return t&&_defineProperties(e.prototype,t),r&&_defineProperties(e,r),e}(Observer,[{key:"velocityX",get:function get(){return this._vx.getVelocity()}},{key:"velocityY",get:function get(){return this._vy.getVelocity()}}]),Observer);function Observer(e){this.init(e)}k.version="3.12.5",k.create=function(e){return new k(e)},k.register=P,k.getAll=function(){return qe.slice()},k.getById=function(t){return qe.filter(function(e){return e.vars.id===t})[0]},r()&&Ce.registerPlugin(k);function Ca(e,t,r){var n=ct(e)&&("clamp("===e.substr(0,6)||-1<e.indexOf("max"));return(r["_"+t+"Clamp"]=n)?e.substr(6,e.length-7):e}function Da(e,t){return!t||ct(e)&&"clamp("===e.substr(0,6)?e:"clamp("+e+")"}function Fa(){return Ge=1}function Ga(){return Ge=0}function Ha(e){return e}function Ia(e){return Math.round(1e5*e)/1e5||0}function Ja(){return"undefined"!=typeof window}function Ka(){return He||Ja()&&(He=window.gsap)&&He.registerPlugin&&He}function La(e){return!!~l.indexOf(e)}function Ma(e){return("Height"===e?T:Ne["inner"+e])||Je["client"+e]||We["client"+e]}function Na(e){return z(e,"getBoundingClientRect")||(La(e)?function(){return Ot.width=Ne.innerWidth,Ot.height=T,Ot}:function(){return wt(e)})}function Qa(e,t){var r=t.s,n=t.d2,o=t.d,i=t.a;return Math.max(0,(r="scroll"+n)&&(i=z(e,r))?i()-Na(e)()[o]:La(e)?(Je[r]||We[r])-Ma(n):e[r]-e["offset"+n])}function Ra(e,t){for(var r=0;r<g.length;r+=3)t&&!~t.indexOf(g[r+1])||e(g[r],g[r+1],g[r+2])}function Ta(e){return"function"==typeof e}function Ua(e){return"number"==typeof e}function Va(e){return"object"==typeof e}function Wa(e,t,r){return e&&e.progress(t?0:1)&&r&&e.pause()}function Xa(e,t){if(e.enabled){var r=e._ctx?e._ctx.add(function(){return t(e)}):t(e);r&&r.totalTime&&(e.callbackAnimation=r)}}function mb(e){return Ne.getComputedStyle(e)}function ob(e,t){for(var r in t)r in e||(e[r]=t[r]);return e}function qb(e,t){var r=t.d2;return e["offset"+r]||e["client"+r]||0}function rb(e){var t,r=[],n=e.labels,o=e.duration();for(t in n)r.push(n[t]/o);return r}function tb(o){var i=He.utils.snap(o),a=Array.isArray(o)&&o.slice(0).sort(function(e,t){return e-t});return a?function(e,t,r){var n;if(void 0===r&&(r=.001),!t)return i(e);if(0<t){for(e-=r,n=0;n<a.length;n++)if(a[n]>=e)return a[n];return a[n-1]}for(n=a.length,e+=r;n--;)if(a[n]<=e)return a[n];return a[0]}:function(e,t,r){void 0===r&&(r=.001);var n=i(e);return!t||Math.abs(n-e)<r||n-e<0==t<0?n:i(t<0?e-o:e+o)}}function vb(t,r,e,n){return e.split(",").forEach(function(e){return t(r,e,n)})}function wb(e,t,r,n,o){return e.addEventListener(t,r,{passive:!n,capture:!!o})}function xb(e,t,r,n){return e.removeEventListener(t,r,!!n)}function yb(e,t,r){(r=r&&r.wheelHandler)&&(e(t,"wheel",r),e(t,"touchmove",r))}function Cb(e,t){if(ct(e)){var r=e.indexOf("="),n=~r?(e.charAt(r-1)+1)*parseFloat(e.substr(r+1)):0;~r&&(e.indexOf("%")>r&&(n*=t/100),e=e.substr(0,r-1)),e=n+(e in H?H[e]*t:~e.indexOf("%")?parseFloat(e)*t/100:parseFloat(e)||0)}return e}function Db(e,t,r,n,o,i,a,s){var l=o.startColor,c=o.endColor,u=o.fontSize,f=o.indent,d=o.fontWeight,p=Xe.createElement("div"),g=La(r)||"fixed"===z(r,"pinType"),h=-1!==e.indexOf("scroller"),v=g?We:r,b=-1!==e.indexOf("start"),m=b?l:c,y="border-color:"+m+";font-size:"+u+";color:"+m+";font-weight:"+d+";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";return y+="position:"+((h||s)&&g?"fixed;":"absolute;"),!h&&!s&&g||(y+=(n===Fe?q:I)+":"+(i+parseFloat(f))+"px;"),a&&(y+="box-sizing:border-box;text-align:left;width:"+a.offsetWidth+"px;"),p._isStart=b,p.setAttribute("class","gsap-marker-"+e+(t?" marker-"+t:"")),p.style.cssText=y,p.innerText=t||0===t?e+"-"+t:e,v.children[0]?v.insertBefore(p,v.children[0]):v.appendChild(p),p._offset=p["offset"+n.op.d2],X(p,0,n,b),p}function Ib(){return 34<at()-st&&(D=D||requestAnimationFrame(Z))}function Jb(){v&&v.isPressed&&!(v.startX>We.clientWidth)||(Ie.cache++,v?D=D||requestAnimationFrame(Z):Z(),st||U("scrollStart"),st=at())}function Kb(){y=Ne.innerWidth,m=Ne.innerHeight}function Lb(){Ie.cache++,je||h||Xe.fullscreenElement||Xe.webkitFullscreenElement||b&&y===Ne.innerWidth&&!(Math.abs(Ne.innerHeight-m)>.25*Ne.innerHeight)||c.restart(!0)}function Ob(){return xb(ne,"scrollEnd",Ob)||Pt(!0)}function Rb(e){for(var t=0;t<j.length;t+=5)(!e||j[t+4]&&j[t+4].query===e)&&(j[t].style.cssText=j[t+1],j[t].getBBox&&j[t].setAttribute("transform",j[t+2]||""),j[t+3].uncache=1)}function Sb(e,t){var r;for(Qe=0;Qe<Tt.length;Qe++)!(r=Tt[Qe])||t&&r._ctx!==t||(e?r.kill(1):r.revert(!0,!0));S=!0,t&&Rb(t),t||U("revert")}function Tb(e,t){Ie.cache++,!t&&rt||Ie.forEach(function(e){return Ta(e)&&e.cacheID++&&(e.rec=0)}),ct(e)&&(Ne.history.scrollRestoration=w=e)}function Yb(){We.appendChild(_),T=!v&&_.offsetHeight||Ne.innerHeight,We.removeChild(_)}function Zb(t){return Ve(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(e){return e.style.display=t?"none":"block"})}function gc(e,t,r,n){if(!e._gsap.swappedIn){for(var o,i=$.length,a=t.style,s=e.style;i--;)a[o=$[i]]=r[o];a.position="absolute"===r.position?"absolute":"relative","inline"===r.display&&(a.display="inline-block"),s[I]=s[q]="auto",a.flexBasis=r.flexBasis||"auto",a.overflow="visible",a.boxSizing="border-box",a[ft]=qb(e,Ye)+xt,a[dt]=qb(e,Fe)+xt,a[bt]=s[mt]=s.top=s.left="0",Et(n),s[ft]=s.maxWidth=r[ft],s[dt]=s.maxHeight=r[dt],s[bt]=r[bt],e.parentNode!==t&&(e.parentNode.insertBefore(t,e),t.appendChild(e)),e._gsap.swappedIn=!0}}function jc(e){for(var t=ee.length,r=e.style,n=[],o=0;o<t;o++)n.push(ee[o],r[ee[o]]);return n.t=e,n}function mc(e,t,r,n,o,i,a,s,l,c,u,f,d,p){Ta(e)&&(e=e(s)),ct(e)&&"max"===e.substr(0,3)&&(e=f+("="===e.charAt(4)?Cb("0"+e.substr(3),r):0));var g,h,v,b=d?d.time():0;if(d&&d.seek(0),isNaN(e)||(e=+e),Ua(e))d&&(e=He.utils.mapRange(d.scrollTrigger.start,d.scrollTrigger.end,0,f,e)),a&&X(a,r,n,!0);else{Ta(t)&&(t=t(s));var m,y,x,w,_=(e||"0").split(" ");v=J(t,s)||We,(m=wt(v)||{})&&(m.left||m.top)||"none"!==mb(v).display||(w=v.style.display,v.style.display="block",m=wt(v),w?v.style.display=w:v.style.removeProperty("display")),y=Cb(_[0],m[n.d]),x=Cb(_[1]||"0",r),e=m[n.p]-l[n.p]-c+y+o-x,a&&X(a,x,n,r-x<20||a._isStart&&20<x),r-=r-x}if(p&&(s[p]=e||-.001,e<0&&(e=0)),i){var C=e+r,T=i._isStart;g="scroll"+n.d2,X(i,C,n,T&&20<C||!T&&(u?Math.max(We[g],Je[g]):i.parentNode[g])<=C+1),u&&(l=wt(a),u&&(i.style[n.op.p]=l[n.op.p]-n.op.m-i._offset+xt))}return d&&v&&(g=wt(v),d.seek(f),h=wt(v),d._caScrollDist=g[n.p]-h[n.p],e=e/d._caScrollDist*f),d&&d.seek(b),d?e:Math.round(e)}function oc(e,t,r,n){if(e.parentNode!==t){var o,i,a=e.style;if(t===We){for(o in e._stOrig=a.cssText,i=mb(e))+o||re.test(o)||!i[o]||"string"!=typeof a[o]||"0"===o||(a[o]=i[o]);a.top=r,a.left=n}else a.cssText=e._stOrig;He.core.getCache(e).uncache=1,t.appendChild(e)}}function pc(r,e,n){var o=e,i=o;return function(e){var t=Math.round(r());return t!==o&&t!==i&&3<Math.abs(t-o)&&3<Math.abs(t-i)&&(e=t,n&&n()),i=o,o=e}}function qc(e,t,r){var n={};n[t.p]="+="+r,He.set(e,n)}function rc(c,e){function Ck(e,t,r,n,o){var i=Ck.tween,a=t.onComplete,s={};r=r||u();var l=pc(u,r,function(){i.kill(),Ck.tween=0});return o=n&&o||0,n=n||e-r,i&&i.kill(),t[f]=e,t.inherit=!1,(t.modifiers=s)[f]=function(){return l(r+n*i.ratio+o*i.ratio*i.ratio)},t.onUpdate=function(){Ie.cache++,Ck.tween&&Z()},t.onComplete=function(){Ck.tween=0,a&&a.call(i)},i=Ck.tween=He.to(c,t)}var u=K(c,e),f="_scroll"+e.p2;return(c[f]=u).wheelHandler=function(){return Ck.tween&&Ck.tween.kill()&&(Ck.tween=0)},wb(c,"wheel",u.wheelHandler),ne.isTouch&&wb(c,"touchmove",u.wheelHandler),Ck}var He,s,Ne,Xe,Je,We,l,c,Ve,Ue,Ke,u,je,Ge,f,Qe,d,p,g,Ze,$e,h,v,b,m,y,E,x,w,_,T,S,et,tt,D,rt,nt,ot,it=1,at=Date.now,R=at(),st=0,lt=0,ct=function _isString(e){return"string"==typeof e},ut=Math.abs,q="right",I="bottom",ft="width",dt="height",pt="Right",gt="Left",ht="Top",vt="Bottom",bt="padding",mt="margin",yt="Width",Y="Height",xt="px",wt=function _getBounds(e,t){var r=t&&"matrix(1, 0, 0, 1, 0, 0)"!==mb(e)[f]&&He.to(e,{x:0,y:0,xPercent:0,yPercent:0,rotation:0,rotationX:0,rotationY:0,scale:1,skewX:0,skewY:0}).progress(1),n=e.getBoundingClientRect();return r&&r.progress(0).kill(),n},_t={startColor:"green",endColor:"red",indent:0,fontSize:"16px",fontWeight:"normal"},Ct={toggleActions:"play",anticipatePin:0},H={top:0,left:0,center:.5,bottom:1,right:1},X=function _positionMarker(e,t,r,n){var o={display:"block"},i=r[n?"os2":"p2"],a=r[n?"p2":"os2"];e._isFlipped=n,o[r.a+"Percent"]=n?-100:0,o[r.a]=n?"1px":0,o["border"+i+yt]=1,o["border"+a+yt]=0,o[r.p]=t+"px",He.set(e,o)},Tt=[],St={},W={},V=[],U=function _dispatch(e){return W[e]&&W[e].map(function(e){return e()})||V},j=[],kt=0,Pt=function _refreshAll(e,t){if(!st||e||S){Yb(),rt=ne.isRefreshing=!0,Ie.forEach(function(e){return Ta(e)&&++e.cacheID&&(e.rec=e())});var r=U("refreshInit");Ze&&ne.sort(),t||Sb(),Ie.forEach(function(e){Ta(e)&&(e.smooth&&(e.target.style.scrollBehavior="auto"),e(0))}),Tt.slice(0).forEach(function(e){return e.refresh()}),S=!1,Tt.forEach(function(e){if(e._subPinOffset&&e.pin){var t=e.vars.horizontal?"offsetWidth":"offsetHeight",r=e.pin[t];e.revert(!0,1),e.adjustPinSpacing(e.pin[t]-r),e.refresh()}}),et=1,Zb(!0),Tt.forEach(function(e){var t=Qa(e.scroller,e._dir),r="max"===e.vars.end||e._endClamp&&e.end>t,n=e._startClamp&&e.start>=t;(r||n)&&e.setPositions(n?t-1:e.start,r?Math.max(n?t:e.start+1,t):e.end,!0)}),Zb(!1),et=0,r.forEach(function(e){return e&&e.render&&e.render(-1)}),Ie.forEach(function(e){Ta(e)&&(e.smooth&&requestAnimationFrame(function(){return e.target.style.scrollBehavior="smooth"}),e.rec&&e(e.rec))}),Tb(w,1),c.pause(),kt++,Z(rt=2),Tt.forEach(function(e){return Ta(e.vars.onRefresh)&&e.vars.onRefresh(e)}),rt=ne.isRefreshing=!1,U("refresh")}else wb(ne,"scrollEnd",Ob)},Q=0,Mt=1,Z=function _updateAll(e){if(2===e||!rt&&!S){ne.isUpdating=!0,ot&&ot.update(0);var t=Tt.length,r=at(),n=50<=r-R,o=t&&Tt[0].scroll();if(Mt=o<Q?-1:1,rt||(Q=o),n&&(st&&!Ge&&200<r-st&&(st=0,U("scrollEnd")),Ke=R,R=r),Mt<0){for(Qe=t;0<Qe--;)Tt[Qe]&&Tt[Qe].update(0,n);Mt=1}else for(Qe=0;Qe<t;Qe++)Tt[Qe]&&Tt[Qe].update(0,n);ne.isUpdating=!1}D=0},$=["left","top",I,q,mt+vt,mt+pt,mt+ht,mt+gt,"display","flexShrink","float","zIndex","gridColumnStart","gridColumnEnd","gridRowStart","gridRowEnd","gridArea","justifySelf","alignSelf","placeSelf","order"],ee=$.concat([ft,dt,"boxSizing","max"+yt,"max"+Y,"position",mt,bt,bt+ht,bt+pt,bt+vt,bt+gt]),te=/([A-Z])/g,Et=function _setState(e){if(e){var t,r,n=e.t.style,o=e.length,i=0;for((e.t._gsap||He.core.getCache(e.t)).uncache=1;i<o;i+=2)r=e[i+1],t=e[i],r?n[t]=r:n[t]&&n.removeProperty(t.replace(te,"-$1").toLowerCase())}},Ot={left:0,top:0},re=/(webkit|moz|length|cssText|inset)/i,ne=(ScrollTrigger.prototype.init=function init(E,O){if(this.progress=this.start=0,this.vars&&this.kill(!0,!0),lt){var A,n,p,D,R,B,q,I,L,Y,F,e,H,N,X,W,V,U,t,j,b,G,Q,m,Z,y,$,x,r,w,_,ee,o,g,te,re,ne,C,i,T=(E=ob(ct(E)||Ua(E)||E.nodeType?{trigger:E}:E,Ct)).onUpdate,S=E.toggleClass,a=E.id,k=E.onToggle,oe=E.onRefresh,P=E.scrub,ie=E.trigger,ae=E.pin,se=E.pinSpacing,le=E.invalidateOnRefresh,M=E.anticipatePin,s=E.onScrubComplete,h=E.onSnapComplete,ce=E.once,ue=E.snap,fe=E.pinReparent,l=E.pinSpacer,de=E.containerAnimation,pe=E.fastScrollEnd,ge=E.preventOverlaps,he=E.horizontal||E.containerAnimation&&!1!==E.horizontal?Ye:Fe,ve=!P&&0!==P,be=J(E.scroller||Ne),c=He.core.getCache(be),me=La(be),ye="fixed"===("pinType"in E?E.pinType:z(be,"pinType")||me&&"fixed"),xe=[E.onEnter,E.onLeave,E.onEnterBack,E.onLeaveBack],we=ve&&E.toggleActions.split(" "),_e="markers"in E?E.markers:Ct.markers,Ce=me?0:parseFloat(mb(be)["border"+he.p2+yt])||0,Te=this,Se=E.onRefreshInit&&function(){return E.onRefreshInit(Te)},ke=function _getSizeFunc(e,t,r){var n=r.d,o=r.d2,i=r.a;return(i=z(e,"getBoundingClientRect"))?function(){return i()[n]}:function(){return(t?Ma(o):e["client"+o])||0}}(be,me,he),Pe=function _getOffsetsFunc(e,t){return!t||~Le.indexOf(e)?Na(e):function(){return Ot}}(be,me),Me=0,Ee=0,Oe=0,Ae=K(be,he);if(Te._startClamp=Te._endClamp=!1,Te._dir=he,M*=45,Te.scroller=be,Te.scroll=de?de.time.bind(de):Ae,D=Ae(),Te.vars=E,O=O||E.animation,"refreshPriority"in E&&(Ze=1,-9999===E.refreshPriority&&(ot=Te)),c.tweenScroll=c.tweenScroll||{top:rc(be,Fe),left:rc(be,Ye)},Te.tweenTo=A=c.tweenScroll[he.p],Te.scrubDuration=function(e){(o=Ua(e)&&e)?ee?ee.duration(e):ee=He.to(O,{ease:"expo",totalProgress:"+=0",inherit:!1,duration:o,paused:!0,onComplete:function onComplete(){return s&&s(Te)}}):(ee&&ee.progress(1).kill(),ee=0)},O&&(O.vars.lazy=!1,O._initted&&!Te.isReverted||!1!==O.vars.immediateRender&&!1!==E.immediateRender&&O.duration()&&O.render(0,!0,!0),Te.animation=O.pause(),(O.scrollTrigger=Te).scrubDuration(P),w=0,a=a||O.vars.id),ue&&(Va(ue)&&!ue.push||(ue={snapTo:ue}),"scrollBehavior"in We.style&&He.set(me?[We,Je]:be,{scrollBehavior:"auto"}),Ie.forEach(function(e){return Ta(e)&&e.target===(me?Xe.scrollingElement||Je:be)&&(e.smooth=!1)}),p=Ta(ue.snapTo)?ue.snapTo:"labels"===ue.snapTo?function _getClosestLabel(t){return function(e){return He.utils.snap(rb(t),e)}}(O):"labelsDirectional"===ue.snapTo?function _getLabelAtDirection(r){return function(e,t){return tb(rb(r))(e,t.direction)}}(O):!1!==ue.directional?function(e,t){return tb(ue.snapTo)(e,at()-Ee<500?0:t.direction)}:He.utils.snap(ue.snapTo),g=ue.duration||{min:.1,max:2},g=Va(g)?Ue(g.min,g.max):Ue(g,g),te=He.delayedCall(ue.delay||o/2||.1,function(){var e=Ae(),t=at()-Ee<500,r=A.tween;if(!(t||Math.abs(Te.getVelocity())<10)||r||Ge||Me===e)Te.isActive&&Me!==e&&te.restart(!0);else{var n,o,i=(e-B)/N,a=O&&!ve?O.totalProgress():i,s=t?0:(a-_)/(at()-Ke)*1e3||0,l=He.utils.clamp(-i,1-i,ut(s/2)*s/.185),c=i+(!1===ue.inertia?0:l),u=ue.onStart,f=ue.onInterrupt,d=ue.onComplete;if(n=p(c,Te),Ua(n)||(n=c),o=Math.round(B+n*N),e<=q&&B<=e&&o!==e){if(r&&!r._initted&&r.data<=ut(o-e))return;!1===ue.inertia&&(l=n-i),A(o,{duration:g(ut(.185*Math.max(ut(c-a),ut(n-a))/s/.05||0)),ease:ue.ease||"power3",data:ut(o-e),onInterrupt:function onInterrupt(){return te.restart(!0)&&f&&f(Te)},onComplete:function onComplete(){Te.update(),Me=Ae(),O&&(ee?ee.resetTo("totalProgress",n,O._tTime/O._tDur):O.progress(n)),w=_=O&&!ve?O.totalProgress():Te.progress,h&&h(Te),d&&d(Te)}},e,l*N,o-e-l*N),u&&u(Te,A.tween)}}}).pause()),a&&(St[a]=Te),i=(i=(ie=Te.trigger=J(ie||!0!==ae&&ae))&&ie._gsap&&ie._gsap.stRevert)&&i(Te),ae=!0===ae?ie:J(ae),ct(S)&&(S={targets:ie,className:S}),ae&&(!1===se||se===mt||(se=!(!se&&ae.parentNode&&ae.parentNode.style&&"flex"===mb(ae.parentNode).display)&&bt),Te.pin=ae,(n=He.core.getCache(ae)).spacer?X=n.pinState:(l&&((l=J(l))&&!l.nodeType&&(l=l.current||l.nativeElement),n.spacerIsNative=!!l,l&&(n.spacerState=jc(l))),n.spacer=U=l||Xe.createElement("div"),U.classList.add("pin-spacer"),a&&U.classList.add("pin-spacer-"+a),n.pinState=X=jc(ae)),!1!==E.force3D&&He.set(ae,{force3D:!0}),Te.spacer=U=n.spacer,r=mb(ae),m=r[se+he.os2],j=He.getProperty(ae),b=He.quickSetter(ae,he.a,xt),gc(ae,U,r),V=jc(ae)),_e){e=Va(_e)?ob(_e,_t):_t,Y=Db("scroller-start",a,be,he,e,0),F=Db("scroller-end",a,be,he,e,0,Y),t=Y["offset"+he.op.d2];var u=J(z(be,"content")||be);I=this.markerStart=Db("start",a,u,he,e,t,0,de),L=this.markerEnd=Db("end",a,u,he,e,t,0,de),de&&(C=He.quickSetter([I,L],he.a,xt)),ye||Le.length&&!0===z(be,"fixedMarkers")||(function _makePositionable(e){var t=mb(e).position;e.style.position="absolute"===t||"fixed"===t?t:"relative"}(me?We:be),He.set([Y,F],{force3D:!0}),y=He.quickSetter(Y,he.a,xt),x=He.quickSetter(F,he.a,xt))}if(de){var f=de.vars.onUpdate,d=de.vars.onUpdateParams;de.eventCallback("onUpdate",function(){Te.update(0,0,1),f&&f.apply(de,d||[])})}if(Te.previous=function(){return Tt[Tt.indexOf(Te)-1]},Te.next=function(){return Tt[Tt.indexOf(Te)+1]},Te.revert=function(e,t){if(!t)return Te.kill(!0);var r=!1!==e||!Te.enabled,n=je;r!==Te.isReverted&&(r&&(re=Math.max(Ae(),Te.scroll.rec||0),Oe=Te.progress,ne=O&&O.progress()),I&&[I,L,Y,F].forEach(function(e){return e.style.display=r?"none":"block"}),r&&(je=Te).update(r),!ae||fe&&Te.isActive||(r?function _swapPinOut(e,t,r){Et(r);var n=e._gsap;if(n.spacerIsNative)Et(n.spacerState);else if(e._gsap.swappedIn){var o=t.parentNode;o&&(o.insertBefore(e,t),o.removeChild(t))}e._gsap.swappedIn=!1}(ae,U,X):gc(ae,U,mb(ae),Z)),r||Te.update(r),je=n,Te.isReverted=r)},Te.refresh=function(e,t,r,n){if(!je&&Te.enabled||t)if(ae&&e&&st)wb(ScrollTrigger,"scrollEnd",Ob);else{!rt&&Se&&Se(Te),je=Te,A.tween&&!r&&(A.tween.kill(),A.tween=0),ee&&ee.pause(),le&&O&&O.revert({kill:!1}).invalidate(),Te.isReverted||Te.revert(!0,!0),Te._subPinOffset=!1;var o,i,a,s,l,c,u,f,d,p,g,h,v,b=ke(),m=Pe(),y=de?de.duration():Qa(be,he),x=N<=.01,w=0,_=n||0,C=Va(r)?r.end:E.end,T=E.endTrigger||ie,S=Va(r)?r.start:E.start||(0!==E.start&&ie?ae?"0 0":"0 100%":0),k=Te.pinnedContainer=E.pinnedContainer&&J(E.pinnedContainer,Te),P=ie&&Math.max(0,Tt.indexOf(Te))||0,M=P;for(_e&&Va(r)&&(h=He.getProperty(Y,he.p),v=He.getProperty(F,he.p));M--;)(c=Tt[M]).end||c.refresh(0,1)||(je=Te),!(u=c.pin)||u!==ie&&u!==ae&&u!==k||c.isReverted||((p=p||[]).unshift(c),c.revert(!0,!0)),c!==Tt[M]&&(P--,M--);for(Ta(S)&&(S=S(Te)),S=Ca(S,"start",Te),B=mc(S,ie,b,he,Ae(),I,Y,Te,m,Ce,ye,y,de,Te._startClamp&&"_startClamp")||(ae?-.001:0),Ta(C)&&(C=C(Te)),ct(C)&&!C.indexOf("+=")&&(~C.indexOf(" ")?C=(ct(S)?S.split(" ")[0]:"")+C:(w=Cb(C.substr(2),b),C=ct(S)?S:(de?He.utils.mapRange(0,de.duration(),de.scrollTrigger.start,de.scrollTrigger.end,B):B)+w,T=ie)),C=Ca(C,"end",Te),q=Math.max(B,mc(C||(T?"100% 0":y),T,b,he,Ae()+w,L,F,Te,m,Ce,ye,y,de,Te._endClamp&&"_endClamp"))||-.001,w=0,M=P;M--;)(u=(c=Tt[M]).pin)&&c.start-c._pinPush<=B&&!de&&0<c.end&&(o=c.end-(Te._startClamp?Math.max(0,c.start):c.start),(u===ie&&c.start-c._pinPush<B||u===k)&&isNaN(S)&&(w+=o*(1-c.progress)),u===ae&&(_+=o));if(B+=w,q+=w,Te._startClamp&&(Te._startClamp+=w),Te._endClamp&&!rt&&(Te._endClamp=q||-.001,q=Math.min(q,Qa(be,he))),N=q-B||(B-=.01)&&.001,x&&(Oe=He.utils.clamp(0,1,He.utils.normalize(B,q,re))),Te._pinPush=_,I&&w&&((o={})[he.a]="+="+w,k&&(o[he.p]="-="+Ae()),He.set([I,L],o)),!ae||et&&Te.end>=Qa(be,he)){if(ie&&Ae()&&!de)for(i=ie.parentNode;i&&i!==We;)i._pinOffset&&(B-=i._pinOffset,q-=i._pinOffset),i=i.parentNode}else o=mb(ae),s=he===Fe,a=Ae(),G=parseFloat(j(he.a))+_,!y&&1<q&&(g={style:g=(me?Xe.scrollingElement||Je:be).style,value:g["overflow"+he.a.toUpperCase()]},me&&"scroll"!==mb(We)["overflow"+he.a.toUpperCase()]&&(g.style["overflow"+he.a.toUpperCase()]="scroll")),gc(ae,U,o),V=jc(ae),i=wt(ae,!0),f=ye&&K(be,s?Ye:Fe)(),se?((Z=[se+he.os2,N+_+xt]).t=U,(M=se===bt?qb(ae,he)+N+_:0)&&(Z.push(he.d,M+xt),"auto"!==U.style.flexBasis&&(U.style.flexBasis=M+xt)),Et(Z),k&&Tt.forEach(function(e){e.pin===k&&!1!==e.vars.pinSpacing&&(e._subPinOffset=!0)}),ye&&Ae(re)):(M=qb(ae,he))&&"auto"!==U.style.flexBasis&&(U.style.flexBasis=M+xt),ye&&((l={top:i.top+(s?a-B:f)+xt,left:i.left+(s?f:a-B)+xt,boxSizing:"border-box",position:"fixed"})[ft]=l.maxWidth=Math.ceil(i.width)+xt,l[dt]=l.maxHeight=Math.ceil(i.height)+xt,l[mt]=l[mt+ht]=l[mt+pt]=l[mt+vt]=l[mt+gt]="0",l[bt]=o[bt],l[bt+ht]=o[bt+ht],l[bt+pt]=o[bt+pt],l[bt+vt]=o[bt+vt],l[bt+gt]=o[bt+gt],W=function _copyState(e,t,r){for(var n,o=[],i=e.length,a=r?8:0;a<i;a+=2)n=e[a],o.push(n,n in t?t[n]:e[a+1]);return o.t=e.t,o}(X,l,fe),rt&&Ae(0)),O?(d=O._initted,$e(1),O.render(O.duration(),!0,!0),Q=j(he.a)-G+N+_,$=1<Math.abs(N-Q),ye&&$&&W.splice(W.length-2,2),O.render(0,!0,!0),d||O.invalidate(!0),O.parent||O.totalTime(O.totalTime()),$e(0)):Q=N,g&&(g.value?g.style["overflow"+he.a.toUpperCase()]=g.value:g.style.removeProperty("overflow-"+he.a));p&&p.forEach(function(e){return e.revert(!1,!0)}),Te.start=B,Te.end=q,D=R=rt?re:Ae(),de||rt||(D<re&&Ae(re),Te.scroll.rec=0),Te.revert(!1,!0),Ee=at(),te&&(Me=-1,te.restart(!0)),je=0,O&&ve&&(O._initted||ne)&&O.progress()!==ne&&O.progress(ne||0,!0).render(O.time(),!0,!0),(x||Oe!==Te.progress||de||le)&&(O&&!ve&&O.totalProgress(de&&B<-.001&&!Oe?He.utils.normalize(B,q,0):Oe,!0),Te.progress=x||(D-B)/N===Oe?0:Oe),ae&&se&&(U._pinOffset=Math.round(Te.progress*Q)),ee&&ee.invalidate(),isNaN(h)||(h-=He.getProperty(Y,he.p),v-=He.getProperty(F,he.p),qc(Y,he,h),qc(I,he,h-(n||0)),qc(F,he,v),qc(L,he,v-(n||0))),x&&!rt&&Te.update(),!oe||rt||H||(H=!0,oe(Te),H=!1)}},Te.getVelocity=function(){return(Ae()-R)/(at()-Ke)*1e3||0},Te.endAnimation=function(){Wa(Te.callbackAnimation),O&&(ee?ee.progress(1):O.paused()?ve||Wa(O,Te.direction<0,1):Wa(O,O.reversed()))},Te.labelToScroll=function(e){return O&&O.labels&&(B||Te.refresh()||B)+O.labels[e]/O.duration()*N||0},Te.getTrailing=function(t){var e=Tt.indexOf(Te),r=0<Te.direction?Tt.slice(0,e).reverse():Tt.slice(e+1);return(ct(t)?r.filter(function(e){return e.vars.preventOverlaps===t}):r).filter(function(e){return 0<Te.direction?e.end<=B:e.start>=q})},Te.update=function(e,t,r){if(!de||r||e){var n,o,i,a,s,l,c,u=!0===rt?re:Te.scroll(),f=e?0:(u-B)/N,d=f<0?0:1<f?1:f||0,p=Te.progress;if(t&&(R=D,D=de?Ae():u,ue&&(_=w,w=O&&!ve?O.totalProgress():d)),M&&ae&&!je&&!it&&st&&(!d&&B<u+(u-R)/(at()-Ke)*M?d=1e-4:1===d&&q>u+(u-R)/(at()-Ke)*M&&(d=.9999)),d!==p&&Te.enabled){if(a=(s=(n=Te.isActive=!!d&&d<1)!=(!!p&&p<1))||!!d!=!!p,Te.direction=p<d?1:-1,Te.progress=d,a&&!je&&(o=d&&!p?0:1===d?1:1===p?2:3,ve&&(i=!s&&"none"!==we[o+1]&&we[o+1]||we[o],c=O&&("complete"===i||"reset"===i||i in O))),ge&&(s||c)&&(c||P||!O)&&(Ta(ge)?ge(Te):Te.getTrailing(ge).forEach(function(e){return e.endAnimation()})),ve||(!ee||je||it?O&&O.totalProgress(d,!(!je||!Ee&&!e)):(ee._dp._time-ee._start!==ee._time&&ee.render(ee._dp._time-ee._start),ee.resetTo?ee.resetTo("totalProgress",d,O._tTime/O._tDur):(ee.vars.totalProgress=d,ee.invalidate().restart()))),ae)if(e&&se&&(U.style[se+he.os2]=m),ye){if(a){if(l=!e&&p<d&&u<q+1&&u+1>=Qa(be,he),fe)if(e||!n&&!l)oc(ae,U);else{var g=wt(ae,!0),h=u-B;oc(ae,We,g.top+(he===Fe?h:0)+xt,g.left+(he===Fe?0:h)+xt)}Et(n||l?W:V),$&&d<1&&n||b(G+(1!==d||l?0:Q))}}else b(Ia(G+Q*d));!ue||A.tween||je||it||te.restart(!0),S&&(s||ce&&d&&(d<1||!tt))&&Ve(S.targets).forEach(function(e){return e.classList[n||ce?"add":"remove"](S.className)}),!T||ve||e||T(Te),a&&!je?(ve&&(c&&("complete"===i?O.pause().totalProgress(1):"reset"===i?O.restart(!0).pause():"restart"===i?O.restart(!0):O[i]()),T&&T(Te)),!s&&tt||(k&&s&&Xa(Te,k),xe[o]&&Xa(Te,xe[o]),ce&&(1===d?Te.kill(!1,1):xe[o]=0),s||xe[o=1===d?1:3]&&Xa(Te,xe[o])),pe&&!n&&Math.abs(Te.getVelocity())>(Ua(pe)?pe:2500)&&(Wa(Te.callbackAnimation),ee?ee.progress(1):Wa(O,"reverse"===i?1:!d,1))):ve&&T&&!je&&T(Te)}if(x){var v=de?u/de.duration()*(de._caScrollDist||0):u;y(v+(Y._isFlipped?1:0)),x(v)}C&&C(-u/de.duration()*(de._caScrollDist||0))}},Te.enable=function(e,t){Te.enabled||(Te.enabled=!0,wb(be,"resize",Lb),me||wb(be,"scroll",Jb),Se&&wb(ScrollTrigger,"refreshInit",Se),!1!==e&&(Te.progress=Oe=0,D=R=Me=Ae()),!1!==t&&Te.refresh())},Te.getTween=function(e){return e&&A?A.tween:ee},Te.setPositions=function(e,t,r,n){if(de){var o=de.scrollTrigger,i=de.duration(),a=o.end-o.start;e=o.start+a*e/i,t=o.start+a*t/i}Te.refresh(!1,!1,{start:Da(e,r&&!!Te._startClamp),end:Da(t,r&&!!Te._endClamp)},n),Te.update()},Te.adjustPinSpacing=function(e){if(Z&&e){var t=Z.indexOf(he.d)+1;Z[t]=parseFloat(Z[t])+e+xt,Z[1]=parseFloat(Z[1])+e+xt,Et(Z)}},Te.disable=function(e,t){if(Te.enabled&&(!1!==e&&Te.revert(!0,!0),Te.enabled=Te.isActive=!1,t||ee&&ee.pause(),re=0,n&&(n.uncache=1),Se&&xb(ScrollTrigger,"refreshInit",Se),te&&(te.pause(),A.tween&&A.tween.kill()&&(A.tween=0)),!me)){for(var r=Tt.length;r--;)if(Tt[r].scroller===be&&Tt[r]!==Te)return;xb(be,"resize",Lb),me||xb(be,"scroll",Jb)}},Te.kill=function(e,t){Te.disable(e,t),ee&&!t&&ee.kill(),a&&delete St[a];var r=Tt.indexOf(Te);0<=r&&Tt.splice(r,1),r===Qe&&0<Mt&&Qe--,r=0,Tt.forEach(function(e){return e.scroller===Te.scroller&&(r=1)}),r||rt||(Te.scroll.rec=0),O&&(O.scrollTrigger=null,e&&O.revert({kill:!1}),t||O.kill()),I&&[I,L,Y,F].forEach(function(e){return e.parentNode&&e.parentNode.removeChild(e)}),ot===Te&&(ot=0),ae&&(n&&(n.uncache=1),r=0,Tt.forEach(function(e){return e.pin===ae&&r++}),r||(n.spacer=0)),E.onKill&&E.onKill(Te)},Tt.push(Te),Te.enable(!1,!1),i&&i(Te),O&&O.add&&!N){var v=Te.update;Te.update=function(){Te.update=v,B||q||Te.refresh()},He.delayedCall(.01,Te.update),N=.01,B=q=0}else Te.refresh();ae&&function _queueRefreshAll(){if(nt!==kt){var e=nt=kt;requestAnimationFrame(function(){return e===kt&&Pt(!0)})}}()}else this.update=this.refresh=this.kill=Ha},ScrollTrigger.register=function register(e){return s||(He=e||Ka(),Ja()&&window.document&&ScrollTrigger.enable(),s=lt),s},ScrollTrigger.defaults=function defaults(e){if(e)for(var t in e)Ct[t]=e[t];return Ct},ScrollTrigger.disable=function disable(t,r){lt=0,Tt.forEach(function(e){return e[r?"kill":"disable"](t)}),xb(Ne,"wheel",Jb),xb(Xe,"scroll",Jb),clearInterval(u),xb(Xe,"touchcancel",Ha),xb(We,"touchstart",Ha),vb(xb,Xe,"pointerdown,touchstart,mousedown",Fa),vb(xb,Xe,"pointerup,touchend,mouseup",Ga),c.kill(),Ra(xb);for(var e=0;e<Ie.length;e+=3)yb(xb,Ie[e],Ie[e+1]),yb(xb,Ie[e],Ie[e+2])},ScrollTrigger.enable=function enable(){if(Ne=window,Xe=document,Je=Xe.documentElement,We=Xe.body,He&&(Ve=He.utils.toArray,Ue=He.utils.clamp,x=He.core.context||Ha,$e=He.core.suppressOverwrites||Ha,w=Ne.history.scrollRestoration||"auto",Q=Ne.pageYOffset,He.core.globals("ScrollTrigger",ScrollTrigger),We)){lt=1,(_=document.createElement("div")).style.height="100vh",_.style.position="absolute",Yb(),function _rafBugFix(){return lt&&requestAnimationFrame(_rafBugFix)}(),k.register(He),ScrollTrigger.isTouch=k.isTouch,E=k.isTouch&&/(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent),b=1===k.isTouch,wb(Ne,"wheel",Jb),l=[Ne,Xe,Je,We],He.matchMedia?(ScrollTrigger.matchMedia=function(e){var t,r=He.matchMedia();for(t in e)r.add(t,e[t]);return r},He.addEventListener("matchMediaInit",function(){return Sb()}),He.addEventListener("matchMediaRevert",function(){return Rb()}),He.addEventListener("matchMedia",function(){Pt(0,1),U("matchMedia")}),He.matchMedia("(orientation: portrait)",function(){return Kb(),Kb})):console.warn("Requires GSAP 3.11.0 or later"),Kb(),wb(Xe,"scroll",Jb);var e,t,r=We.style,n=r.borderTopStyle,o=He.core.Animation.prototype;for(o.revert||Object.defineProperty(o,"revert",{value:function value(){return this.time(-.01,!0)}}),r.borderTopStyle="solid",e=wt(We),Fe.m=Math.round(e.top+Fe.sc())||0,Ye.m=Math.round(e.left+Ye.sc())||0,n?r.borderTopStyle=n:r.removeProperty("border-top-style"),u=setInterval(Ib,250),He.delayedCall(.5,function(){return it=0}),wb(Xe,"touchcancel",Ha),wb(We,"touchstart",Ha),vb(wb,Xe,"pointerdown,touchstart,mousedown",Fa),vb(wb,Xe,"pointerup,touchend,mouseup",Ga),f=He.utils.checkPrefix("transform"),ee.push(f),s=at(),c=He.delayedCall(.2,Pt).pause(),g=[Xe,"visibilitychange",function(){var e=Ne.innerWidth,t=Ne.innerHeight;Xe.hidden?(d=e,p=t):d===e&&p===t||Lb()},Xe,"DOMContentLoaded",Pt,Ne,"load",Pt,Ne,"resize",Lb],Ra(wb),Tt.forEach(function(e){return e.enable(0,1)}),t=0;t<Ie.length;t+=3)yb(xb,Ie[t],Ie[t+1]),yb(xb,Ie[t],Ie[t+2])}},ScrollTrigger.config=function config(e){"limitCallbacks"in e&&(tt=!!e.limitCallbacks);var t=e.syncInterval;t&&clearInterval(u)||(u=t)&&setInterval(Ib,t),"ignoreMobileResize"in e&&(b=1===ScrollTrigger.isTouch&&e.ignoreMobileResize),"autoRefreshEvents"in e&&(Ra(xb)||Ra(wb,e.autoRefreshEvents||"none"),h=-1===(e.autoRefreshEvents+"").indexOf("resize"))},ScrollTrigger.scrollerProxy=function scrollerProxy(e,t){var r=J(e),n=Ie.indexOf(r),o=La(r);~n&&Ie.splice(n,o?6:2),t&&(o?Le.unshift(Ne,t,We,t,Je,t):Le.unshift(r,t))},ScrollTrigger.clearMatchMedia=function clearMatchMedia(t){Tt.forEach(function(e){return e._ctx&&e._ctx.query===t&&e._ctx.kill(!0,!0)})},ScrollTrigger.isInViewport=function isInViewport(e,t,r){var n=(ct(e)?J(e):e).getBoundingClientRect(),o=n[r?ft:dt]*t||0;return r?0<n.right-o&&n.left+o<Ne.innerWidth:0<n.bottom-o&&n.top+o<Ne.innerHeight},ScrollTrigger.positionInViewport=function positionInViewport(e,t,r){ct(e)&&(e=J(e));var n=e.getBoundingClientRect(),o=n[r?ft:dt],i=null==t?o/2:t in H?H[t]*o:~t.indexOf("%")?parseFloat(t)*o/100:parseFloat(t)||0;return r?(n.left+i)/Ne.innerWidth:(n.top+i)/Ne.innerHeight},ScrollTrigger.killAll=function killAll(e){if(Tt.slice(0).forEach(function(e){return"ScrollSmoother"!==e.vars.id&&e.kill()}),!0!==e){var t=W.killAll||[];W={},t.forEach(function(e){return e()})}},ScrollTrigger);function ScrollTrigger(e,t){s||ScrollTrigger.register(He)||console.warn("Please gsap.registerPlugin(ScrollTrigger)"),x(this),this.init(e,t)}ne.version="3.12.5",ne.saveStyles=function(e){return e?Ve(e).forEach(function(e){if(e&&e.style){var t=j.indexOf(e);0<=t&&j.splice(t,5),j.push(e,e.style.cssText,e.getBBox&&e.getAttribute("transform"),He.core.getCache(e),x())}}):j},ne.revert=function(e,t){return Sb(!e,t)},ne.create=function(e,t){return new ne(e,t)},ne.refresh=function(e){return e?Lb():(s||ne.register())&&Pt(!0)},ne.update=function(e){return++Ie.cache&&Z(!0===e?2:0)},ne.clearScrollMemory=Tb,ne.maxScroll=function(e,t){return Qa(e,t?Ye:Fe)},ne.getScrollFunc=function(e,t){return K(J(e),t?Ye:Fe)},ne.getById=function(e){return St[e]},ne.getAll=function(){return Tt.filter(function(e){return"ScrollSmoother"!==e.vars.id})},ne.isScrolling=function(){return!!st},ne.snapDirectional=tb,ne.addEventListener=function(e,t){var r=W[e]||(W[e]=[]);~r.indexOf(t)||r.push(t)},ne.removeEventListener=function(e,t){var r=W[e],n=r&&r.indexOf(t);0<=n&&r.splice(n,1)},ne.batch=function(e,t){function Cp(e,t){var r=[],n=[],o=He.delayedCall(i,function(){t(r,n),r=[],n=[]}).pause();return function(e){r.length||o.restart(!0),r.push(e.trigger),n.push(e),a<=r.length&&o.progress(1)}}var r,n=[],o={},i=t.interval||.016,a=t.batchMax||1e9;for(r in t)o[r]="on"===r.substr(0,2)&&Ta(t[r])&&"onRefreshInit"!==r?Cp(0,t[r]):t[r];return Ta(a)&&(a=a(),wb(ne,"refresh",function(){return a=t.batchMax()})),Ve(e).forEach(function(e){var t={};for(r in o)t[r]=o[r];t.trigger=e,n.push(ne.create(t))}),n};function tc(e,t,r,n){return n<t?e(n):t<0&&e(0),n<r?(n-t)/(r-t):r<0?t/(t-r):1}function uc(e,t){!0===t?e.style.removeProperty("touch-action"):e.style.touchAction=!0===t?"auto":t?"pan-"+t+(k.isTouch?" pinch-zoom":""):"none",e===Je&&uc(We,t)}function wc(e){var t,r=e.event,n=e.target,o=e.axis,i=(r.changedTouches?r.changedTouches[0]:r).target,a=i._gsap||He.core.getCache(i),s=at();if(!a._isScrollT||2e3<s-a._isScrollT){for(;i&&i!==We&&(i.scrollHeight<=i.clientHeight&&i.scrollWidth<=i.clientWidth||!ie[(t=mb(i)).overflowY]&&!ie[t.overflowX]);)i=i.parentNode;a._isScroll=i&&i!==n&&!La(i)&&(ie[(t=mb(i)).overflowY]||ie[t.overflowX]),a._isScrollT=s}!a._isScroll&&"x"!==o||(r.stopPropagation(),r._gsapAllow=!0)}function xc(e,t,r,n){return k.create({target:e,capture:!0,debounce:!1,lockAxis:!0,type:t,onWheel:n=n&&wc,onPress:n,onDrag:n,onScroll:n,onEnable:function onEnable(){return r&&wb(Xe,k.eventTypes[0],se,!1,!0)},onDisable:function onDisable(){return xb(Xe,k.eventTypes[0],se,!0)}})}function Bc(e){function zq(){return o=!1}function Cq(){i=Qa(p,Fe),S=Ue(E?1:0,i),f&&(T=Ue(0,Qa(p,Ye))),l=kt}function Dq(){v._gsap.y=Ia(parseFloat(v._gsap.y)+b.offset)+"px",v.style.transform="matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, "+parseFloat(v._gsap.y)+", 0, 1)",b.offset=b.cacheID=0}function Jq(){Cq(),a.isActive()&&a.vars.scrollY>i&&(b()>i?a.progress(1)&&b(i):a.resetTo("scrollY",i))}Va(e)||(e={}),e.preventDefault=e.isNormalizer=e.allowClicks=!0,e.type||(e.type="wheel,touch"),e.debounce=!!e.debounce,e.id=e.id||"normalizer";var n,i,l,o,a,c,u,s,f=e.normalizeScrollX,t=e.momentum,r=e.allowNestedScroll,d=e.onRelease,p=J(e.target)||Je,g=He.core.globals().ScrollSmoother,h=g&&g.get(),v=E&&(e.content&&J(e.content)||h&&!1!==e.content&&!h.smooth()&&h.content()),b=K(p,Fe),m=K(p,Ye),y=1,x=(k.isTouch&&Ne.visualViewport?Ne.visualViewport.scale*Ne.visualViewport.width:Ne.outerWidth)/Ne.innerWidth,w=0,_=Ta(t)?function(){return t(n)}:function(){return t||2.8},C=xc(p,e.type,!0,r),T=Ha,S=Ha;return v&&He.set(v,{y:"+=0"}),e.ignoreCheck=function(e){return E&&"touchmove"===e.type&&function ignoreDrag(){if(o){requestAnimationFrame(zq);var e=Ia(n.deltaY/2),t=S(b.v-e);if(v&&t!==b.v+b.offset){b.offset=t-b.v;var r=Ia((parseFloat(v&&v._gsap.y)||0)-b.offset);v.style.transform="matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, "+r+", 0, 1)",v._gsap.y=r+"px",b.cacheID=Ie.cache,Z()}return!0}b.offset&&Dq(),o=!0}()||1.05<y&&"touchstart"!==e.type||n.isGesturing||e.touches&&1<e.touches.length},e.onPress=function(){o=!1;var e=y;y=Ia((Ne.visualViewport&&Ne.visualViewport.scale||1)/x),a.pause(),e!==y&&uc(p,1.01<y||!f&&"x"),c=m(),u=b(),Cq(),l=kt},e.onRelease=e.onGestureStart=function(e,t){if(b.offset&&Dq(),t){Ie.cache++;var r,n,o=_();f&&(n=(r=m())+.05*o*-e.velocityX/.227,o*=tc(m,r,n,Qa(p,Ye)),a.vars.scrollX=T(n)),n=(r=b())+.05*o*-e.velocityY/.227,o*=tc(b,r,n,Qa(p,Fe)),a.vars.scrollY=S(n),a.invalidate().duration(o).play(.01),(E&&a.vars.scrollY>=i||i-1<=r)&&He.to({},{onUpdate:Jq,duration:o})}else s.restart(!0);d&&d(e)},e.onWheel=function(){a._ts&&a.pause(),1e3<at()-w&&(l=0,w=at())},e.onChange=function(e,t,r,n,o){if(kt!==l&&Cq(),t&&f&&m(T(n[2]===t?c+(e.startX-e.x):m()+t-n[1])),r){b.offset&&Dq();var i=o[2]===r,a=i?u+e.startY-e.y:b()+r-o[1],s=S(a);i&&a!==s&&(u+=s-a),b(s)}(r||t)&&Z()},e.onEnable=function(){uc(p,!f&&"x"),ne.addEventListener("refresh",Jq),wb(Ne,"resize",Jq),b.smooth&&(b.target.style.scrollBehavior="auto",b.smooth=m.smooth=!1),C.enable()},e.onDisable=function(){uc(p,!0),xb(Ne,"resize",Jq),ne.removeEventListener("refresh",Jq),C.kill()},e.lockAxis=!1!==e.lockAxis,((n=new k(e)).iOS=E)&&!b()&&b(1),E&&He.ticker.add(Ha),s=n._dc,a=He.to(n,{ease:"power4",paused:!0,inherit:!1,scrollX:f?"+=0.1":"+=0",scrollY:"+=0.1",modifiers:{scrollY:pc(b,b(),function(){return a.pause()})},onUpdate:Z,onComplete:s.vars.onComplete}),n}var oe,ie={auto:1,scroll:1},ae=/(input|label|select|textarea)/i,se=function _captureInputs(e){var t=ae.test(e.target.tagName);(t||oe)&&(e._gsapAllow=!0,oe=t)};ne.sort=function(e){return Tt.sort(e||function(e,t){return-1e6*(e.vars.refreshPriority||0)+e.start-(t.start+-1e6*(t.vars.refreshPriority||0))})},ne.observe=function(e){return new k(e)},ne.normalizeScroll=function(e){if(void 0===e)return v;if(!0===e&&v)return v.enable();if(!1===e)return v&&v.kill(),void(v=e);var t=e instanceof k?e:Bc(e);return v&&v.target===t.target&&v.kill(),La(t.target)&&(v=t),t},ne.core={_getVelocityProp:L,_inputObserver:xc,_scrollers:Ie,_proxies:Le,bridge:{ss:function ss(){st||U("scrollStart"),st=at()},ref:function ref(){return je}}},Ka()&&He.registerPlugin(ne),e.ScrollTrigger=ne,e.default=ne;if (typeof(window)==="undefined"||window!==e){Object.defineProperty(e,"__esModule",{value:!0})} else {delete e.default}});


/*!
 * Lenis 1.0.45
 * https://lenis.darkroom.engineering/
 * 
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).Lenis=e()}(this,(function(){"use strict";var __assign=function(){return __assign=Object.assign||function __assign(t){for(var e,i=1,o=arguments.length;i<o;i++)for(var s in e=arguments[i])Object.prototype.hasOwnProperty.call(e,s)&&(t[s]=e[s]);return t},__assign.apply(this,arguments)};"function"==typeof SuppressedError&&SuppressedError;function clamp(t,e,i){return Math.max(t,Math.min(e,i))}class Animate{advance(t){if(!this.isRunning)return;let e=!1;if(this.lerp)this.value=function damp(t,e,i,o){return function lerp(t,e,i){return(1-i)*t+i*e}(t,e,1-Math.exp(-i*o))}(this.value,this.to,60*this.lerp,t),Math.round(this.value)===this.to&&(this.value=this.to,e=!0);else{this.currentTime+=t;const i=clamp(0,this.currentTime/this.duration,1);e=i>=1;const o=e?1:this.easing(i);this.value=this.from+(this.to-this.from)*o}e&&this.stop(),this.onUpdate?.(this.value,e)}stop(){this.isRunning=!1}fromTo(t,e,{lerp:i=.1,duration:o=1,easing:s=(t=>t),onStart:n,onUpdate:r}){this.from=this.value=t,this.to=e,this.lerp=i,this.duration=o,this.easing=s,this.currentTime=0,this.isRunning=!0,n?.(),this.onUpdate=r}}class Dimensions{constructor({wrapper:t,content:e,autoResize:i=!0,debounce:o=250}={}){this.wrapper=t,this.content=e,i&&(this.debouncedResize=function debounce(t,e){let i;return function(){let o=arguments,s=this;clearTimeout(i),i=setTimeout((function(){t.apply(s,o)}),e)}}(this.resize,o),this.wrapper===window?window.addEventListener("resize",this.debouncedResize,!1):(this.wrapperResizeObserver=new ResizeObserver(this.debouncedResize),this.wrapperResizeObserver.observe(this.wrapper)),this.contentResizeObserver=new ResizeObserver(this.debouncedResize),this.contentResizeObserver.observe(this.content)),this.resize()}destroy(){this.wrapperResizeObserver?.disconnect(),this.contentResizeObserver?.disconnect(),window.removeEventListener("resize",this.debouncedResize,!1)}resize=()=>{this.onWrapperResize(),this.onContentResize()};onWrapperResize=()=>{this.wrapper===window?(this.width=window.innerWidth,this.height=window.innerHeight):(this.width=this.wrapper.clientWidth,this.height=this.wrapper.clientHeight)};onContentResize=()=>{this.wrapper===window?(this.scrollHeight=this.content.scrollHeight,this.scrollWidth=this.content.scrollWidth):(this.scrollHeight=this.wrapper.scrollHeight,this.scrollWidth=this.wrapper.scrollWidth)};get limit(){return{x:this.scrollWidth-this.width,y:this.scrollHeight-this.height}}}class Emitter{constructor(){this.events={}}emit(t,...e){let i=this.events[t]||[];for(let t=0,o=i.length;t<o;t++)i[t](...e)}on(t,e){return this.events[t]?.push(e)||(this.events[t]=[e]),()=>{this.events[t]=this.events[t]?.filter((t=>e!==t))}}off(t,e){this.events[t]=this.events[t]?.filter((t=>e!==t))}destroy(){this.events={}}}const t=100/6;class VirtualScroll{constructor(t,{wheelMultiplier:e=1,touchMultiplier:i=1}){this.element=t,this.wheelMultiplier=e,this.touchMultiplier=i,this.touchStart={x:null,y:null},this.emitter=new Emitter,window.addEventListener("resize",this.onWindowResize,!1),this.onWindowResize(),this.element.addEventListener("wheel",this.onWheel,{passive:!1}),this.element.addEventListener("touchstart",this.onTouchStart,{passive:!1}),this.element.addEventListener("touchmove",this.onTouchMove,{passive:!1}),this.element.addEventListener("touchend",this.onTouchEnd,{passive:!1})}on(t,e){return this.emitter.on(t,e)}destroy(){this.emitter.destroy(),window.removeEventListener("resize",this.onWindowResize,!1),this.element.removeEventListener("wheel",this.onWheel,{passive:!1}),this.element.removeEventListener("touchstart",this.onTouchStart,{passive:!1}),this.element.removeEventListener("touchmove",this.onTouchMove,{passive:!1}),this.element.removeEventListener("touchend",this.onTouchEnd,{passive:!1})}onTouchStart=t=>{const{clientX:e,clientY:i}=t.targetTouches?t.targetTouches[0]:t;this.touchStart.x=e,this.touchStart.y=i,this.lastDelta={x:0,y:0},this.emitter.emit("scroll",{deltaX:0,deltaY:0,event:t})};onTouchMove=t=>{const{clientX:e,clientY:i}=t.targetTouches?t.targetTouches[0]:t,o=-(e-this.touchStart.x)*this.touchMultiplier,s=-(i-this.touchStart.y)*this.touchMultiplier;this.touchStart.x=e,this.touchStart.y=i,this.lastDelta={x:o,y:s},this.emitter.emit("scroll",{deltaX:o,deltaY:s,event:t})};onTouchEnd=t=>{this.emitter.emit("scroll",{deltaX:this.lastDelta.x,deltaY:this.lastDelta.y,event:t})};onWheel=e=>{let{deltaX:i,deltaY:o,deltaMode:s}=e;i*=1===s?t:2===s?this.windowWidth:1,o*=1===s?t:2===s?this.windowHeight:1,i*=this.wheelMultiplier,o*=this.wheelMultiplier,this.emitter.emit("scroll",{deltaX:i,deltaY:o,event:e})};onWindowResize=()=>{this.windowWidth=window.innerWidth,this.windowHeight=window.innerHeight}}var e=function(){function Lenis(t){var e=void 0===t?{}:t,i=e.wrapper,o=void 0===i?window:i,s=e.content,n=void 0===s?document.documentElement:s,r=e.wheelEventsTarget,l=void 0===r?o:r,h=e.eventsTarget,a=void 0===h?l:h,c=e.smoothWheel,p=void 0===c||c,u=e.syncTouch,d=void 0!==u&&u,m=e.syncTouchLerp,v=void 0===m?.075:m,f=e.touchInertiaMultiplier,g=void 0===f?35:f,S=e.duration,w=e.easing,y=void 0===w?function(t){return Math.min(1,1.001-Math.pow(2,-10*t))}:w,b=e.lerp,L=void 0===b?!S&&.1:b,_=e.infinite,z=void 0!==_&&_,E=e.orientation,T=void 0===E?"vertical":E,M=e.gestureOrientation,R=void 0===M?"vertical":M,O=e.touchMultiplier,W=void 0===O?1:O,x=e.wheelMultiplier,H=void 0===x?1:x,N=e.autoResize,k=void 0===N||N,C=e.__experimental__naiveDimensions,j=void 0!==C&&C,P=this;this.__isSmooth=!1,this.__isScrolling=!1,this.__isStopped=!1,this.__isLocked=!1,this.onVirtualScroll=function(t){var e=t.deltaX,i=t.deltaY,o=t.event;if(!o.ctrlKey){var s=o.type.includes("touch"),n=o.type.includes("wheel");if(P.options.syncTouch&&s&&"touchstart"===o.type&&!P.isStopped&&!P.isLocked)P.reset();else{var r=0===e&&0===i,l="vertical"===P.options.gestureOrientation&&0===i||"horizontal"===P.options.gestureOrientation&&0===e;if(!r&&!l){var h=o.composedPath();if(!(h=h.slice(0,h.indexOf(P.rootElement))).find((function(t){var e,i,o,r,l;return(null===(e=t.hasAttribute)||void 0===e?void 0:e.call(t,"data-lenis-prevent"))||s&&(null===(i=t.hasAttribute)||void 0===i?void 0:i.call(t,"data-lenis-prevent-touch"))||n&&(null===(o=t.hasAttribute)||void 0===o?void 0:o.call(t,"data-lenis-prevent-wheel"))||(null===(r=t.classList)||void 0===r?void 0:r.contains("lenis"))&&!(null===(l=t.classList)||void 0===l?void 0:l.contains("lenis-stopped"))})))if(P.isStopped||P.isLocked)o.preventDefault();else{if(P.isSmooth=P.options.syncTouch&&s||P.options.smoothWheel&&n,!P.isSmooth)return P.isScrolling=!1,void P.animate.stop();o.preventDefault();var a=i;"both"===P.options.gestureOrientation?a=Math.abs(i)>Math.abs(e)?i:e:"horizontal"===P.options.gestureOrientation&&(a=e);var c=s&&P.options.syncTouch,p=s&&"touchend"===o.type&&Math.abs(a)>5;p&&(a=P.velocity*P.options.touchInertiaMultiplier),P.scrollTo(P.targetScroll+a,__assign({programmatic:!1},c?{lerp:p?P.options.syncTouchLerp:1}:{lerp:P.options.lerp,duration:P.options.duration,easing:P.options.easing}))}}}}},this.onNativeScroll=function(){if(!P.__preventNextScrollEvent&&!P.isScrolling){var t=P.animatedScroll;P.animatedScroll=P.targetScroll=P.actualScroll,P.velocity=0,P.direction=Math.sign(P.animatedScroll-t),P.emit()}},window.lenisVersion="1.0.45",o!==document.documentElement&&o!==document.body||(o=window),this.options={wrapper:o,content:n,wheelEventsTarget:l,eventsTarget:a,smoothWheel:p,syncTouch:d,syncTouchLerp:v,touchInertiaMultiplier:g,duration:S,easing:y,lerp:L,infinite:z,gestureOrientation:R,orientation:T,touchMultiplier:W,wheelMultiplier:H,autoResize:k,__experimental__naiveDimensions:j},this.animate=new Animate,this.emitter=new Emitter,this.dimensions=new Dimensions({wrapper:o,content:n,autoResize:k}),this.toggleClassName("lenis",!0),this.velocity=0,this.isLocked=!1,this.isStopped=!1,this.isSmooth=d||p,this.isScrolling=!1,this.targetScroll=this.animatedScroll=this.actualScroll,this.options.wrapper.addEventListener("scroll",this.onNativeScroll,!1),this.virtualScroll=new VirtualScroll(a,{touchMultiplier:W,wheelMultiplier:H}),this.virtualScroll.on("scroll",this.onVirtualScroll)}return Lenis.prototype.destroy=function(){this.emitter.destroy(),this.options.wrapper.removeEventListener("scroll",this.onNativeScroll,!1),this.virtualScroll.destroy(),this.dimensions.destroy(),this.toggleClassName("lenis",!1),this.toggleClassName("lenis-smooth",!1),this.toggleClassName("lenis-scrolling",!1),this.toggleClassName("lenis-stopped",!1),this.toggleClassName("lenis-locked",!1)},Lenis.prototype.on=function(t,e){return this.emitter.on(t,e)},Lenis.prototype.off=function(t,e){return this.emitter.off(t,e)},Lenis.prototype.setScroll=function(t){this.isHorizontal?this.rootElement.scrollLeft=t:this.rootElement.scrollTop=t},Lenis.prototype.resize=function(){this.dimensions.resize()},Lenis.prototype.emit=function(){this.emitter.emit("scroll",this)},Lenis.prototype.reset=function(){this.isLocked=!1,this.isScrolling=!1,this.animatedScroll=this.targetScroll=this.actualScroll,this.velocity=0,this.animate.stop()},Lenis.prototype.start=function(){this.isStopped&&(this.isStopped=!1,this.reset())},Lenis.prototype.stop=function(){this.isStopped||(this.isStopped=!0,this.animate.stop(),this.reset())},Lenis.prototype.raf=function(t){var e=t-(this.time||t);this.time=t,this.animate.advance(.001*e)},Lenis.prototype.scrollTo=function(t,e){var i=this,o=void 0===e?{}:e,s=o.offset,n=void 0===s?0:s,r=o.immediate,l=void 0!==r&&r,h=o.lock,a=void 0!==h&&h,c=o.duration,p=void 0===c?this.options.duration:c,u=o.easing,d=void 0===u?this.options.easing:u,m=o.lerp,v=void 0===m?!p&&this.options.lerp:m,f=o.onComplete,g=o.force,S=void 0!==g&&g,w=o.programmatic,y=void 0===w||w;if(!this.isStopped&&!this.isLocked||S){if(["top","left","start"].includes(t))t=0;else if(["bottom","right","end"].includes(t))t=this.limit;else{var b=void 0;if("string"==typeof t?b=document.querySelector(t):(null==t?void 0:t.nodeType)&&(b=t),b){if(this.options.wrapper!==window){var L=this.options.wrapper.getBoundingClientRect();n-=this.isHorizontal?L.left:L.top}var _=b.getBoundingClientRect();t=(this.isHorizontal?_.left:_.top)+this.animatedScroll}}if("number"==typeof t){if(t+=n,t=Math.round(t),this.options.infinite?y&&(this.targetScroll=this.animatedScroll=this.scroll):t=clamp(0,t,this.limit),l)return this.animatedScroll=this.targetScroll=t,this.setScroll(this.scroll),this.reset(),void(null==f||f(this));if(!y){if(t===this.targetScroll)return;this.targetScroll=t}this.animate.fromTo(this.animatedScroll,t,{duration:p,easing:d,lerp:v,onStart:function(){a&&(i.isLocked=!0),i.isScrolling=!0},onUpdate:function(t,e){i.isScrolling=!0,i.velocity=t-i.animatedScroll,i.direction=Math.sign(i.velocity),i.animatedScroll=t,i.setScroll(i.scroll),y&&(i.targetScroll=t),e||i.emit(),e&&(i.reset(),i.emit(),null==f||f(i),i.__preventNextScrollEvent=!0,requestAnimationFrame((function(){delete i.__preventNextScrollEvent})))}})}}},Object.defineProperty(Lenis.prototype,"rootElement",{get:function(){return this.options.wrapper===window?document.documentElement:this.options.wrapper},enumerable:!1,configurable:!0}),Object.defineProperty(Lenis.prototype,"limit",{get:function(){return this.options.__experimental__naiveDimensions?this.isHorizontal?this.rootElement.scrollWidth-this.rootElement.clientWidth:this.rootElement.scrollHeight-this.rootElement.clientHeight:this.dimensions.limit[this.isHorizontal?"x":"y"]},enumerable:!1,configurable:!0}),Object.defineProperty(Lenis.prototype,"isHorizontal",{get:function(){return"horizontal"===this.options.orientation},enumerable:!1,configurable:!0}),Object.defineProperty(Lenis.prototype,"actualScroll",{get:function(){return this.isHorizontal?this.rootElement.scrollLeft:this.rootElement.scrollTop},enumerable:!1,configurable:!0}),Object.defineProperty(Lenis.prototype,"scroll",{get:function(){return this.options.infinite?function modulo(t,e){return(t%e+e)%e}(this.animatedScroll,this.limit):this.animatedScroll},enumerable:!1,configurable:!0}),Object.defineProperty(Lenis.prototype,"progress",{get:function(){return 0===this.limit?1:this.scroll/this.limit},enumerable:!1,configurable:!0}),Object.defineProperty(Lenis.prototype,"isSmooth",{get:function(){return this.__isSmooth},set:function(t){this.__isSmooth!==t&&(this.__isSmooth=t,this.toggleClassName("lenis-smooth",t))},enumerable:!1,configurable:!0}),Object.defineProperty(Lenis.prototype,"isScrolling",{get:function(){return this.__isScrolling},set:function(t){this.__isScrolling!==t&&(this.__isScrolling=t,this.toggleClassName("lenis-scrolling",t))},enumerable:!1,configurable:!0}),Object.defineProperty(Lenis.prototype,"isStopped",{get:function(){return this.__isStopped},set:function(t){this.__isStopped!==t&&(this.__isStopped=t,this.toggleClassName("lenis-stopped",t))},enumerable:!1,configurable:!0}),Object.defineProperty(Lenis.prototype,"isLocked",{get:function(){return this.__isLocked},set:function(t){this.__isLocked!==t&&(this.__isLocked=t,this.toggleClassName("lenis-locked",t))},enumerable:!1,configurable:!0}),Object.defineProperty(Lenis.prototype,"className",{get:function(){var t="lenis";return this.isStopped&&(t+=" lenis-stopped"),this.isLocked&&(t+=" lenis-locked"),this.isScrolling&&(t+=" lenis-scrolling"),this.isSmooth&&(t+=" lenis-smooth"),t},enumerable:!1,configurable:!0}),Lenis.prototype.toggleClassName=function(t,e){this.rootElement.classList.toggle(t,e),this.emitter.emit("className change",this)},Lenis}();return e}));
//# sourceMappingURL=lenis.min.js.map
function handleProductCardTag(productCard, product) {
  const cardMedia = productCard.querySelector('.rebuy-product-media');
  cardMedia.classList.add('relative');

  const tags = product.tags.split(', ');
  let badge = '';

  tags.forEach((tag) => {
    if (tag.includes('prodFlag-')) {
      const tagParts = tag.split('-');
      const tagOriginal = tagParts[tagParts.length - 1];
      
      if (tagOriginal !== 'prodFlag') {
        const tagWords = tagOriginal.split('_');
        tagWords.forEach((word, index) => {
          const capitalized = word.charAt(0).toUpperCase() + word.slice(1);
          if (index === 0) {
            badge = capitalized;
          } else {
            badge += ' ' + capitalized;
          }
        });
      }
    }
  });

  const productPrice = Number(product.selected_variant.price);
  const compareAtPrice = Number(product.selected_variant.compare_at_price);
  
  if (compareAtPrice > productPrice && badge !== 'Sale') {
    const discount = compareAtPrice - productPrice;
    const percentOff = Math.round((discount / compareAtPrice) * 100);
    badge = percentOff + '% Off';
  }

  if (badge) {
    const badgeElement = document.createElement('div');
    badgeElement.classList.add('product-card__badge');
    badgeElement.textContent = badge;
    cardMedia.appendChild(badgeElement);
  }
}

function handleProductCardTitle(productCard, product) {
  const cardTitle = productCard.querySelector('.rebuy-product-title');
  const sillhouetteName = product.metafields?.eby?.technology_name;

  if (cardTitle) {
    cardTitle.style.overflow = 'hidden';
    cardTitle.style.display = '-webkit-box';
    cardTitle.style.webkitBoxOrient = 'vertical';
    cardTitle.style.webkitLineClamp = '1';
  }
  
  if (sillhouetteName && cardTitle) {
    cardTitle.innerHTML = `${sillhouetteName}`;
  }
}

function handleProductCardPrice(productCard, product) {
  const cardPrice = productCard.querySelector('.rebuy-money');
  const moneyFormat = `${window.currency.symbol || "$"}{{no_trailing_zeros}}`;
  if (!cardPrice) return;

  const productPrice = Number(product.selected_variant.price) * 100;
  const compareAtPrice = Number(product.selected_variant.compare_at_price) * 100;
  const salePriceFlat = product.metafields?.seed?.sale_price_flat;
  const salePriceDollar = product.metafields?.seed?.sale_discount_dollar;
  const salePricePercentage = product.metafields?.seed?.sale_discount_percentage;
  const memberPrice = Number(product.metafields?.seed?.vip_member_price) * 100;
  const showMemberPrice = window.customer.activeSubscriber && memberPrice && memberPrice < productPrice;

  let salePrice = null;
  if (salePriceFlat || salePriceDollar || salePricePercentage) {
    if (salePriceFlat) {
      salePrice = Number(salePriceFlat) * 100;
    } else if (salePriceDollar) {
      const salePriceAdjustment = Number(salePriceDollar) * 100;
      salePrice = productPrice - salePriceAdjustment;
    } else if (salePricePercentage) {
      const salePriceAdjustment = (productPrice * Number(salePricePercentage)) / 100;
      salePrice = productPrice - salePriceAdjustment;
    }
  }

  let priceMarkup = '<span class="sr-only">Price</span>';

  if (compareAtPrice > productPrice) {
    priceMarkup += `<s class="price__compare text-gray">${theme.utils.formatMoney(compareAtPrice, moneyFormat)}</s><span class="price__regular ml-xs">${theme.utils.formatMoney(productPrice, moneyFormat)}</span>`;
  } else if (salePrice) {
    priceMarkup += `<s class="price__compare text-gray">${theme.utils.formatMoney(productPrice, moneyFormat)}</s><span class="price__regular ml-xs">${theme.utils.formatMoney(salePrice, moneyFormat)}</span>`;
  } else if (showMemberPrice) {
    priceMarkup += `<s class="price__compare text-gray">${theme.utils.formatMoney(productPrice, moneyFormat)}</s><span class="price__regular ml-xs">${theme.utils.formatMoney(memberPrice, moneyFormat)}</span>`;
  } else {
    priceMarkup += `<span class="price__regular">${theme.utils.formatMoney(productPrice, moneyFormat)}</span>`;
  }

  cardPrice.innerHTML = priceMarkup;
}

function moveProductOptions(productCard, product) {
  const cardOptions = productCard.querySelector('.rebuy-product-options');
  const mediaContainer = productCard.querySelector('.rebuy-product-media');

  if (!cardOptions || !mediaContainer) return;

  mediaContainer.appendChild(cardOptions);
}

function addPlaceholderOption(productCard, product) {
  const select = productCard.querySelector('.rebuy-product-options select');
  const atcButton = productCard.querySelector('.rebuy-product-actions button.rebuy-button[type="button"]');

  if (!select || !atcButton) return;

  if (!select.querySelector('option[value=""]')) {
    const placeholder = document.createElement('option');
    placeholder.textContent = 'Size';
    placeholder.value = '';
    placeholder.selected = true;
    placeholder.disabled = true;
    select.insertBefore(placeholder, select.firstChild);
  }

  select.value = '';

  // if (select.value === '') {
  //   atcButton.textContent = 'Add To Bag';
  // }

  const event = new Event('change', { bubbles: true });
  select.dispatchEvent(event);
}

// Customize product cards on widget load
document.addEventListener('rebuy.ready', function(event){
  const widget = event.detail.widget;

  if (!widget) return;
  
  const widgetId = widget.id;
  const widgetContainer = document.querySelector(`#rebuy-widget-${widgetId}`);
  const products = widget.data.products;

  if (!widgetContainer) {
    console.warn(`Widget container not found for widget ID: ${widgetId}`);
    return;
  }

  products.forEach((product) => {
    const productCard = widgetContainer.querySelector(`.rebuy-product-block.product-id-${product.id}`);
    
    if (!productCard) {
      console.warn(`Product card not found for product ID: ${product.id}`);
      return;
    }
    
    handleProductCardTag(productCard, product);
    handleProductCardTitle(productCard, product);
    handleProductCardPrice(productCard, product);

    moveProductOptions(productCard, product);
    addPlaceholderOption(productCard, product);
  });
});

// Render cart drawer on rebuy.add event
document.addEventListener('rebuy.add', function(event){
  const cart = document.querySelector('cart-drawer');
  const cartDrawer = document.querySelector('#CartDrawer');

  const data = {
    sections: cart.getSectionsToRender().map(section => section.id)
  };

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then((response) => response.json())
  .then((response) => {
    if (document.querySelector('cart-items')) {
      document.querySelector('cart-items').onCartUpdate();
    }

    cart.renderContents(response);
    cartDrawer.open();

  })
  .catch((e) => {
    console.log(e);
  })
});

/*================ Global ================*/
/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.formatMoney = function (a, f) {
    var b = "",
        d = /\{\{\s*(\w+)\s*\}\}/,
        e = f || this.money_format;
    function g(a, b) {
        return void 0 === a ? b : a;
    }
    function c(a, b, c, d) {
        if (((b = g(b, 2)), (c = g(c, ",")), (d = g(d, ".")), isNaN(a) || null == a)) return 0;
        var e = (a = (a / 100).toFixed(b)).split("."),
            f = e[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + c),
            h = e[1] ? d + e[1] : "";
        return f + h;
    }
    switch (("string" == typeof a && (a = a.replace(".", "")), e.match(d)[1])) {
        case "amount":
            b = c(a, 2);
            break;
        case "amount_no_decimals":
            b = c(a, 0);
            break;
        case "amount_with_comma_separator":
            b = c(a, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            b = c(a, 0, ".", ",");
    }
    return e.replace(d, b);
};
/**
 * Theme Configuration
 * ----------------------------------------------------------
 */
theme.config = {
  mediaQueries: {
    landscapeAll: 'screen and (orientation: landscape)',
    landscape: 'screen and (orientation: landscape), screen and (min-width: 48rem)',
    belowTablet: 'screen and (max-width: 47.99rem)',
    tablet: 'screen and (min-width: 48rem)',
    belowLaptop: 'screen and (max-width: 63.99rem)',
    laptop: 'screen and (min-width: 64rem)',
    belowDesktop: 'screen and (max-width: 64rem)',
    desktop: 'screen and (min-width: 64.01rem)',
    belowWidescreen: 'screen and (max-width: 79.99rem)',
    widescreen: 'screen and (min-width: 80rem)',
    belowExtrawide: 'screen and (max-width: 89.99rem)',
    extrawide: 'screen and (min-width: 90rem)'
  },
  money: {
    format: `${window.currency.symbol || "$"}{{amount}}`,
    currencySymbols: {
        USD: "$", // US Dollar
        CAD: "$", // CA Dollar
        EUR: "€", // Euro
        CRC: "₡", // Costa Rican Colón
        GBP: "£", // British Pound Sterling
        ILS: "₪", // Israeli New Sheqel
        INR: "₹", // Indian Rupee
        JPY: "¥", // Japanese Yen
        KRW: "₩", // South Korean Won
        NGN: "₦", // Nigerian Naira
        PHP: "₱", // Philippine Peso
        PLN: "zł", // Polish Zloty
        PYG: "₲", // Paraguayan Guarani
        THB: "฿", // Thai Baht
        UAH: "₴", // Ukrainian Hryvnia
        VND: "₫", // Vietnamese Dong
    }
  },
  upsellLimit: 6
};
/**
 * Global Utilities
 *
 * @summary a set of utility functions used throughout the theme
 * @namespace theme.utils
 * @memberof theme
 * @property {object} a11y - accessibility related utility functions
 */
theme.utils = {
  subscriptions: {
    subscribers: {},
    subscribe(eventName, callback) {
      if (theme.utils.subscriptions.subscribers[eventName] === undefined) {
        theme.utils.subscriptions.subscribers[eventName] = [];
      }

      theme.utils.subscriptions.subscribers[eventName] = [...theme.utils.subscriptions.subscribers[eventName], callback];

      return function unsubscribe() {
        theme.utils.subscriptions.subscribers[eventName] = theme.utils.subscriptions.subscribers[eventName].filter((cb) => {
          return cb !== callback;
        });
      };
    },
    publish(eventName, data) {
      if (theme.utils.subscriptions.subscribers[eventName]) {
        theme.utils.subscriptions.subscribers[eventName].forEach((callback) => {
          callback(data);
        });
      }
    }
  },
  a11y: {
    /**
     * Gets all focusable elements from a given container
     * @memberof theme.utils.a11y
     * @param {HTMLElement} container 
     * @returns {array} focusable elements
     */
    getFocusableElements(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    },

    /** @private */
    _trapFocusHandlers: {},

    /**
     * @memberof theme.utils.a11y
     * @param {HTMLElement} container 
     * @param {HTMLElement} [elementToFocus = container] - 1st element to focus in 
     */
    trapFocus(container, elementToFocus = container) {
      var elements = theme.utils.a11y.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];
    
      theme.utils.a11y.removeTrapFocus();
    
      theme.utils.a11y._trapFocusHandlers.focusin = (event) => {
        if (
          event.target !== container &&
          event.target !== last &&
          event.target !== first
        )
          return;
    
        document.addEventListener('keydown', theme.utils.a11y._trapFocusHandlers.keydown);
      };
    
      theme.utils.a11y._trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', theme.utils.a11y._trapFocusHandlers.keydown);
      };
    
      theme.utils.a11y._trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }
    
        //  On the first focusable element and tab backward, focus the last element.
        if (
          (event.target === container || event.target === first) &&
          event.shiftKey
        ) {
          event.preventDefault();
          last.focus();
        }
      };
    
      document.addEventListener('focusout', theme.utils.a11y._trapFocusHandlers.focusout);
      document.addEventListener('focusin', theme.utils.a11y._trapFocusHandlers.focusin);
    
      elementToFocus.focus();
    },

    /**
     * @memberof theme.utils.a11y
     * @param {HTMLElement} [elementToFocus = null] - 1st element to focus in after untrapping
     */
    removeTrapFocus(elementToFocus = null) {
      document.removeEventListener('focusin', theme.utils.a11y._trapFocusHandlers.focusin);
      document.removeEventListener('focusout', theme.utils.a11y._trapFocusHandlers.focusout);
      document.removeEventListener('keydown', theme.utils.a11y._trapFocusHandlers.keydown);
    
      if (elementToFocus) elementToFocus.focus();
    }
    
  },

  /**
   * Prepares transition to animate between display: none and display: block
   * @memberof theme.utils
   * @param {HTMLElement} element 
   */
  prepareTransition(element) {
    element.addEventListener('transitionend', () => {
      element.classList.remove('is-transitioning');
    })
  
    // check the various CSS properties to see if a duration has been set
    var cl = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
    let duration = 0;
    const computedStyles = getComputedStyle(element)
    cl.forEach((prop) => duration || (duration = parseFloat(computedStyles.getPropertyValue(prop))));
  
    // if I have a duration then add the class
    if (duration != 0) {
      element.classList.add('is-transitioning');
      element.offsetWidth; // check offsetWidth to force the style rendering
    }
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || theme.config.money.format);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = theme.utils.defaultTo(precision, 2);
      thousands = theme.utils.defaultTo(thousands, ',');
      decimal = theme.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      let centsAmount = parts[1] ? (decimal + parts[1]) : '';

      if (formatString.match(placeholderRegex)[1] == 'no_trailing_zeros' && centsAmount == '.00') {
        centsAmount = '';
      }

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'no_trailing_zeros':
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },

  /**
   * Similiar to jQuery.serialize
   * @param {HTMLElement} form 
   * @returns json object
   */
  serializeForm: form => {
    const obj = {};
    const formData = new FormData(form);

    for (const key of formData.keys()) {
      const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

      if (regex.test(key)) {
        obj.properties = obj.properties || {};
        obj.properties[regex.exec(key)[2]] = formData.get(key);
      } else {
        obj[key] = formData.get(key);
      }
    }

    return JSON.stringify(obj);
  },

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  },

  getSiblings(element, selector) {
    let siblings = [];
    let targets;
    
    if (selector) {
      targets = element.parentNode.querySelectorAll(':scope > ' + selector)
    } else {
      targets = element.parentNode.children;
    }

    
    for (let target of targets) {
      if (target !== element)
        siblings.push(target);
    }

    return siblings;
  },

  /**
   * Refreshes UI elements
   * @param {Array} selectors -
   * @param {HTMLDocument} newHTML 
   * @param {HTMLElement} container 
   */
  refreshElements(selectors, newHTML, container) {
    selectors.forEach(selector => {
      const newEls = newHTML.querySelectorAll(selector)
      const oldEls = container.querySelectorAll(selector)
      oldEls.forEach((oldEl, idx) => {
        if (newEls[idx]){
          if (oldEl.getAttribute('js-accordion-item') != null) {
            const oldHeaderStatus = oldEl.querySelector('[js-accordion-header]').getAttribute('aria-expanded')
            const oldContentStatus = oldEl.querySelector('[js-accordion-content]').getAttribute('aria-hidden')
            const newEl = newEls[idx]
            newEl.querySelector('[js-accordion-header]').setAttribute('aria-expanded', oldHeaderStatus);
            newEl.querySelector('[js-accordion-content]').setAttribute('aria-hidden', oldContentStatus);
            oldEl.innerHTML = newEl.innerHTML
          } else {
            oldEl.innerHTML = newEls[idx].innerHTML
          }
        } else {
          oldEl.remove();
        }
      })
    })
  },

  /* behaves like liquid handleize, for js matching purposes */
  handleize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
  },

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
}
/**
 * Focusable Widget Class
 * --------------------------------------------------------------
 * @summary High-level general Class for creating focusable widgets
 * (drawers, modals, etc). Provides css-based open/close/toggle
 * functionality, as well as programatically manipulation of the widget,
 * and handles a11y.
 *
 * @usage class widget extends FocusableWidget {...}
 *
 * @emits focusable-widget:open on document
 * @emits focusable-widget:close on document
 * @emits <config.name>:open on document
 * @emits <config.name>:close on document
 * @emits <#id>:open on document
 * @emits <#id>:close on document
 * @emits open on element
 * @emits close on element
 *
 * The following parameters are attributes that any children of FocusableWidget
 * element accepts
 * @param id - required
 * @param open - Query Selector to all the widget's open triggers
 * @param close - Query Selector to all the widget's close triggers
 * @param [open-class] - Optional class to add to widget when opened
 * @param [body-open-class] - Optional class to add to body when opened
 * @class
 */
class FocusableWidget extends HTMLElement {
  /**
   * Creates Focusable Widget
   * @param {Object} config - Configuration object
   * @param {String} config.name - widget name, used for classnames and for providing useful error messages
   * @param {String} config.background - query selector to widget background
   * @param {Array} [config.widgetOpenClasses] - optional classes to add to widget when opened
   * @param {Array} [config.bodyOpenClasses] - optional classes to add to body when widget is opened
   * @param {Object} [config.attributes] - optional attributes to add to element upon initialization.
   *                                       example: {'data-custom-attr': true }
   */
  constructor(config = {}) {
    super();

    if (!config.name)
      throw new Error(`Focusable Widget(${config.name}) must have a name`);
    if (!this.id) throw new Error(`${config.name} must have an id`);
    if (!config.background)
      throw new Error(
        `Focusable Widget(${config.name}) must have a background`
      );

    /**
     * Save client config for reinit method
     * @private
     */
    this._clientConfig = config;

    this._init(config);
  }

  /**
   * Opens widget. If already opened, does nothing.
   * @usage document.querySelector('[js-my-widget]').open()
   * @returns {HTMLElement} widget
   * @public
   */
  open = () => {
    if (this._isOpen) return;
    this._closeFocusableWidgets();
    return this.toggle();
  }

  /**
   * Closes widget. If already closed, does nothing.
   * @usage document.querySelector('[js-my-widget]').close()
   * @returns {HTMLElement} widget
   * @public
   */
  close = () => {
    if (!this._isOpen) return;
    return this.toggle();
  }

  /**
   * Toggles widget.
   * @usage document.querySelector('[js-my-widget]').toggle()
   * @returns {HTMLElement} widget
   * @public
   */
  toggle = () => {
    theme.utils.prepareTransition(this);
    this._toggleClasses();
    this._toggleAccessibilityAttributes();

    if (!this._isOpen) {
      theme.utils.a11y.trapFocus(
        this
      );
      this._bindEvents();
      this._dispatchEvents(this._events.open, ['open']);
    } else {
      theme.utils.a11y.removeTrapFocus(this);
      this._unbindEvents();
      this._dispatchEvents(this._events.close, ['close']);
    }

    this._isOpen = !this._isOpen;
    return this;
  }

  /**
   * Reinitializes the widget
   * @usage document.querySelector('[js-my-widget]').reinitWidget()
   * @public
   */
  reinitWidget = () => {
    this._init(this._clientConfig);
  }

  /**
   * @usage const open = document.querySelector('[js-my-widget]').isOpen;
   * @type {Boolean}
   * @public
   */
  get isOpen() {
    return this._isOpen;
  }

  // ======================================================== PRIVATE METHODS

  /**
   * Initializes entire logic and state
   * @param {Object} config - constructor config param
   * @private
   */
  _init({
    name,
    background,
    widgetOpenClasses = [],
    bodyOpenClasses = [],
    attributes = {},
  }) {
    /**
     * Widget name
     * @type {String} @private
     * */
    this._name = name;

    /** @type {Boolean} @private */
    this._isOpen = false;

    /**
     * @property {String} background - widget background selector
     * @property {String} open - selector to all open triggers
     * @property {String} close - selector to all close triggers
     * @private
     */
    this._selectors = {
      background,
      open: this.getAttribute("open"),
      close: this.getAttribute("close"),
    };

    /**
     * Nodes the widget depends on
     * @property {HTMLElement} background - widget background
     * @private
     */
    this._nodes = {
      background: document.querySelector(this._selectors.background),
    };

    /**
     * Widget events fired on actions to document
     * @private
     */
    this._events = {
      open: ["focusable-widget:open", `${name}:open`, `${this.id}:open`],
      close: ["focusable-widget:close", `${name}:close`, `${this.id}:close`],
    };

    /**
     * Private Widget configuration
     * @property {HTMLAllCollection} open - open triggers
     * @property {HTMLAllCollection} close - close triggers
     * @property {Array} attributes - attributes added to widget upon initialization
     * @property {Array} widgetOpenClasses - classes added to widget when opened
     * @property {String} bodyOpenClasses - classes added to body when widget opened
     * @private
     */
    this._config = {
      open: document.querySelectorAll(this._selectors.open),
      close: document.querySelectorAll(this._selectors.close),
      attributes: {
        "data-focusable-widget": "true",
        "aria-hidden": "true",
        tabindex: 0,
        ...attributes,
      },
      widgetOpenClasses: ["open", this.getAttribute("open-class")].concat(
        widgetOpenClasses
      ),
      bodyOpenClasses: [
        "js-focusable-widget-open",
        `js-${name}-open`,
        this.getAttribute("body-open-class"),
      ].concat(bodyOpenClasses),
    };

    this._validateConfig();
    this._addAccessibilityAttributes();
    this._setupListeners();
  }

  /**
   * Validates widget config, throwing useful errors if invalid
   * @private
   */
  _validateConfig() {
    if (!this._config.open || !this._config.open.length)
      console.warn(`WARN: ${this._name}: no open triggers found. Check your ${this._name} 'open' attribute, or add a trigger (if needed)`)

    if (!this._config.close || !this._config.close.length)
      throw new Error(
        `${this._name}: invalid close trigger selector, no elements found. Check your ${this._name} 'close' attribute`
      );
  }

  /**
   * Setups initialization event listeners
   * @private
   */
  _setupListeners() {
    this._config.open.forEach((open) =>
      open.addEventListener("click", this._open.bind(this))
    );
    this._config.close.forEach((close) =>
      close.addEventListener("click", this._close.bind(this))
    );
    this.addEventListener("click", (e) => e.stopPropagation());
  }

  /**
   * Internal open wrapper, to keep our public methods clean, internally deals with event object
   * @param {object} event
   * @private
   */
  _open(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.open();
  }

  /**
   * Internal close wrapper, to keep our public methods clean, internally deals with event object
   * @param {object} event
   * @private
   */
  _close = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.close();
  }

  /**
   * Closes any open focusable widgets
   * @private
   */
  _closeFocusableWidgets() {
    const openWidgets = document.querySelectorAll(
      "[data-focusable-widget].open"
    );
    openWidgets.forEach((widget) => widget.close());
  }

  /**
   * Dispatches an array of custom events on document
   * @param {Array} events - this._events.<event>
   */
  _dispatchEvents(globalEvents, elementEvents) {
    globalEvents.forEach(e => document.dispatchEvent(new CustomEvent(e)))
    if (elementEvents && elementEvents.length) 
    elementEvents.forEach(e => this.dispatchEvent(new CustomEvent(e)))
  }

  /**
   * Binds events needed for opened widget
   * @private
   */
  _bindEvents() {
    document.addEventListener("keyup", this._onKeyUp);
    this._nodes.background.addEventListener("click", this._close);
    this._nodes.background.addEventListener("touchmove", this._onTouchMove);
  }

  /**
   * Unbinds events added when widget was opened
   * @private
   */
  _unbindEvents() {
    document.removeEventListener("keyup", this._onKeyUp);
    this._nodes.background.removeEventListener("click", this._close);
    this._nodes.background.removeEventListener(
      "touchmove",
      this._onTouchMove
    );
  }

  /**
   * Toggles classes based on current widget state
   * @private
   */
  _toggleClasses() {
    if (this._isOpen) {
      // Body classes
      this._config.bodyOpenClasses.forEach((className) => {
        if (!className) return;
        document.body.classList.remove(className);
      });

      // Widget Classes
      this._config.widgetOpenClasses.forEach((className) => {
        if (!className) return;
        this.classList.remove(className);
      });
    } else {
      // Body classes
      this._config.bodyOpenClasses.forEach((className) => {
        if (!className) return;
        document.body.classList.add(className);
      });

      // Widget Classes
      this._config.widgetOpenClasses.forEach((className) => {
        if (!className) return;
        this.classList.add(className);
      });
    }
  }

  /**
   * Toggles a11y attributes based on current widget state
   * @private
   */
  _toggleAccessibilityAttributes() {
    if (this._isOpen) {
      this.setAttribute("aria-hidden", "true");
      this.setAttribute("tabindex", "-1");
      this._config.open.forEach((open) =>
        open.setAttribute("aria-expanded", "false")
      );
      this._config.close.forEach((close) =>
        close.setAttribute("aria-expanded", "false")
      );
    } else {
      this.setAttribute("aria-hidden", "false");
      this.setAttribute("tabindex", "0");
      this._config.open.forEach((open) =>
        open.setAttribute("aria-expanded", "true")
      );
      this._config.close.forEach((close) =>
        close.setAttribute("aria-expanded", "true")
      );
    }
  }

  /**
   * Adds a11y attributes to widget and triggers
   * @private
   */
  _addAccessibilityAttributes() {
    const addA11yAttributes = (el) => {
      el.setAttribute("tabindex", "0");
      el.setAttribute("aria-expanded", "false");
      el.setAttribute("aria-controls", this.id);
    };

    for (const attr in this._config.attributes) {
      this.setAttribute(attr, this._config.attributes[attr]);
    }
    this._config.open.forEach(addA11yAttributes);
    this._config.close.forEach(addA11yAttributes);
  }

  /**
   * Closes widget on esc key press
   * @param {object} event
   * @private
   */
  _onKeyUp = (event) => {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.close();
  }

  /**
   * Lock scrolling on mobile
   * @returns {Boolean}
   * @private
   */
  _onTouchMove = () => {
    return false;
  }
}


/*================ Components ================*/
/**
 * Drawer Component
 * --------------------------------------------------------------------
 * @summary drawer custom element component, must have an id, position and
 * specified open/close triggers. There must be a close trigger inside
 * the drawer container.
 *
 * See parent focusable-widget.js events and public methods for complete documentation.
 *
 * @usage <s-drawer id="MyDrawer" position="left" open="[open-my-drawer]" close="[close-my-drawer]">CONTENT</s-drawer>
 * @usage to manipulate programatically: document.querySelector('#MyDrawer').open();
 *
 * @emits drawer:open on document
 * @emits drawer:close on document
 * @emits <#id>:open on document
 * @emits <#id>:close on document
 * @emits open on element
 * @emits close on element
 * 
 * The following parameters are attributes that the <s-drawer> element takes
 * @param id - required
 * @param position - 'left', 'right', 'top', 'bottom'
 * @param open - Query Selector to all the drawer's open triggers
 * @param close - Query Selector to all the drawer's close triggers
 * @param [open-class] - Optional class to add to drawer when opened
 * @param [body-open-class] - Optional class to add to body when opened
 * @module
 *
 * If you must extend the drawer's functionality, use inheritance:
 * class Ajaxcart extends Drawer {...}
 */
class Drawer extends FocusableWidget {
  constructor() {
    super({
      name: "drawer",
      background: ".drawer-background"
    });

    const position = this.getAttribute("position");
    if (!position) throw new Error("drawer must have position attribute");

    /** @type {string} @private */
    this._position = position;

    // Add position class to body when drawer opens
    this._config.bodyOpenClasses.push(`js-drawer-${position}-open`);

    // This makes it persist if the widget gets re-initialized
    this._clientConfig.bodyOpenClasses = [`js-drawer-${position}-open`]
  }

  /**
   * Drawer position: 'top', 'right', 'bottom', 'left'
   * @usage const position = document.querySelector('[js-my-drawer]').position;
   * @type {string}
   * @public
   */
  get position() {
    return this._position;
  }
}

class DrawerMenu extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      mainMenu: '[js-main-menu]',
      submenus: '[js-sub-menu]',
      nextButtons: '[js-menu-next]',
      backButtons: '[js-menu-prev]',
      activeMenu: '[js-active-menu]'
    };

  }

  connectedCallback() {
    this.mainMenu = this.querySelector(this._selectors.mainMenu);
    this.submenus = this.querySelectorAll(this._selectors.submenus);
    this.nextButtons = this.querySelectorAll(this._selectors.nextButtons);
    this.backButtons = this.querySelectorAll(this._selectors.backButtons);

    this.submenus.forEach(submenu => {
      submenu.classList.add('hidden');
    });

    if (this.mainMenu) {
      this.mainMenu.setAttribute('js-active-menu', '');
    }

    this._initEventListeners();
  }

  disconnectedCallback() {
    this.nextButtons.forEach(button => {
      button.removeEventListener('click', this._handleNextButtonClick);
    });

    this.backButtons.forEach(button => {
      button.removeEventListener('click', this._handleBackButtonClick);
    });
  }

  _initEventListeners() {
    this._handleNextButtonClick = this._handleNextButtonClick.bind(this);
    this._handleBackButtonClick = this._handleBackButtonClick.bind(this);

    this.nextButtons.forEach(button => {
      button.addEventListener('click', this._handleNextButtonClick);
    });

    this.backButtons.forEach(button => {
      button.addEventListener('click', this._handleBackButtonClick);
    });
  }

  _handleNextButtonClick(event) {
    const button = event.currentTarget;
    const submenuId = button.getAttribute('data-submenu');
    this._openSubmenu(submenuId);
  }

  _handleBackButtonClick(event) {
    const button = event.currentTarget;
    const parentId = button.getAttribute('data-parent');
    this._closeSubmenu(parentId);
  }

  _openSubmenu(submenuId) {
    const activeMenu = this.querySelector(this._selectors.activeMenu);
    if (activeMenu) {
      activeMenu.removeAttribute('js-active-menu');
      activeMenu.classList.add('hidden');
    }

    const targetMenu = this.querySelector(`[data-menu="${submenuId}"]`);
    if (targetMenu) {
      targetMenu.classList.remove('hidden');
      requestAnimationFrame(() => {
        targetMenu.setAttribute('js-active-menu', '');
      });
    }
  }

  _closeSubmenu(parentId = 'main') {
    const activeSubmenu = this.querySelector(this._selectors.activeMenu);
    if (activeSubmenu) {
      activeSubmenu.removeAttribute('js-active-menu');
      activeSubmenu.addEventListener('transitionend', () => {
        activeSubmenu.classList.add('hidden');
        const parentMenu = this.querySelector(`[data-menu="${parentId}"]`);
        if (parentMenu) {
          parentMenu.classList.remove('hidden');
          parentMenu.setAttribute('js-active-menu', '');
        }
      }, { once: true });
    }
  }
}
/**
 * Modal Component
 * --------------------------------------------------------------------
 * @summary modal custom element component, must have an id and
 * specified open/close triggers. There must be a close trigger inside
 * the modal container.
 *
 * See parent focusable-widget.js events and public methods for complete documentation.
 *
 * @usage
 * <s-modal id="MyModal" class="{{styling classes}}" open="[open-my-modal]" close="[close-my-modal]">
 *   CONTENTS, make sure to include a close button in here.
 * </s-modal>
 * @usage to manipulate programatically: document.querySelector('#MyModal').open();
 *
 * @emits modal:open on document
 * @emits modal:close on document
 * @emits <#id>:open on document
 * @emits <#id>:close on document
 * @emits open on element
 * @emits close on element
 * 
 * The following parameters are attributes that the <modal> element takes
 * @param id - required
 * @param open - Query Selector to all the drawer's open triggers
 * @param close - Query Selector to all the drawer's close triggers
 * @param [open-class] - Optional class to add to drawer when opened
 * @param [body-open-class] - Optional class to add to body when opened
 */
class Modal extends FocusableWidget {
  constructor() {
    super({
      name: "modal",
      background: ".modal-background",
      bodyOpenClasses: 'js-modal-open'
    });

    const noBg = this.hasAttribute('data-no-modal-background');
    
    if (noBg) {
      this._config.bodyOpenClasses.push(`js-modal-no-bg-open`);
      this._clientConfig.bodyOpenClasses = [`js-modal-no-bg-open`];
    }
  }
}
/**
  * Accordion Component
  * --------------------------------------------------------------------
  * @summary accordion component, hides/shows elements based on header button click, auto-collapses sibling accordions by default
  *
  * @usage
  *   <s-accordion data-manual-collapse="false" js-accordion>
  *      <div class="accordion-item" js-accordion-item>
  *        <button class="accordion-header" aria-expanded="true" aria-controls="accordionID" js-accordion-header>Description</button>
  *        <div id="accordionID" class="accordion-content" aria-hidden="false" js-accordion-content>
  *          ...
  *        </div>
  *      </div>
  *    </s-accordion>
  *
  * The following parameters are attributes that the <s-accordion> element takes
  * @param data-manual-collapse - set attribute to "true" to disable auto-collapse siblings
  * @param data-manual-children - set attribute to "false" to disable auto-collapsing children accordions
  *
  * The following are selectors that the <s-accordion> searches for
  * [js-accordion] - required
  * [js-accordion-item] - required
  * [js-accordion-header] - required
  * [js-accordion-content] - required
  * [data-manual-collapse] - optional
  * 
  * .accordion-content[aria-hidden="false"] - this styling can be adjusted based on content + desired animation
*/

class Accordion extends HTMLElement {
  constructor() {
    super();   

    this._selectors = {
      accordion: '[js-accordion]',
      accordionItem: '[js-accordion-item]',
      accordionHeader: '[js-accordion-header]',
      accordionContent: '[js-accordion-content]'
    }
  }

  connectedCallback(){
    this.buttons = this.querySelectorAll(this._selectors.accordionHeader);
    this.buttons.forEach(button => {
      button.addEventListener('click', this._toggleContent)
    })

    this.content = this.querySelectorAll(this._selectors.accordionContent);
  }

  _toggleContent = (e) => {
    e.stopImmediatePropagation();
    const trigger = e.currentTarget;
    const content = this.querySelector(`#${trigger.getAttribute('aria-controls')}`);
    const siblings = theme.utils.getSiblings(trigger.parentElement, this._selectors.accordionItem)
    let isExpanded = trigger.getAttribute('aria-expanded');
    if (isExpanded == 'false') {
      trigger.setAttribute('aria-expanded', true);
      theme.utils.prepareTransition(content);
      this._expandSection(content);

      if (!this.dataset.manualCollapse || this.dataset.manualCollapse == 'false') {
        siblings.forEach((sibling) => {
          const siblingTrigger = sibling.querySelector(this._selectors.accordionHeader);
          const siblingContent = sibling.querySelector(`#${siblingTrigger.getAttribute('aria-controls')}`);
          if (siblingTrigger.getAttribute('aria-expanded') == 'true') {
            siblingTrigger.setAttribute('aria-expanded', false);
            this._collapseSection(siblingContent)
          }
        })
      }
    }else{
      trigger.setAttribute('aria-expanded', false);
      this._collapseSection(content);
    }
  }

  _collapseSection(element) {
    // mark the section as "currently hidden"
    element.setAttribute('aria-hidden', true);
  }

  _expandSection(element) {
    // mark the section as "currently not hidden"
    element.style.setProperty('--content-height', `${element.scrollHeight}px`);
    element.setAttribute('aria-hidden', false);
  }
}

/**
 * <s-tabs>
 *   <div class="tab__triggers" role="tablist" aria-orientation="horizontal" js-tablist>
 *     <button id="tab1-tab" class="tab__trigger" aria-controls="tab1-content-panel" role="tab" aria-selected="true" js-tab>Tab1</button>
 *     <button id="tab2-tab" class="tab__trigger" aria-controls="tab2-content-panel" role="tab" aria-selected="false" js-tab>Tab2</button>
 *     <button id="tab3-tab" class="tab__trigger" aria-controls="tab3-content-panel" role="tab" aria-selected="false" js-tab>Tab3</button>
 *   </div>
 *   <div id="tab1-content-panel" class="tab__panel" role="tabpanel" aria-labelledby="tab1-tab" aria-hidden="false"></div>
 *   <div id="tab2-content-panel" class="tab__panel" role="tabpanel" aria-labelledby="tab2-tab" aria-hidden="true"></div>
 *   <div id="tab3-content-panel" class="tab__panel" role="tabpanel" aria-labelledby="tab3-tab" aria-hidden="true"></div>
 * </s-tabs>
 **/

class Tabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._elements = {
      tabs: this.querySelectorAll('[js-tab]'),
      tabList: this.querySelectorAll('[js-tab-list]'),
      tabPanel: this.querySelectorAll('[js-tab-panel]')
    };

    this._tabEventListener();
    this._tabListListener();

    if (this.dataset.animate == 'true') {
      const selectedTab = this.querySelector('[js-tab][aria-selected="true"]');
      this._moveIndicator(selectedTab);
      
      this._resizeHandler = () => {
        const currentSelectedTab = this.querySelector('[js-tab][aria-selected="true"]');
        this._moveIndicator(currentSelectedTab);
      };
      window.addEventListener('resize', this._resizeHandler);
    }
  }

  disconnectedCallback() {
    // Clean up resize listener when component is removed
    if (this.dataset.animate == 'true' && this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
  }

  _tabEventListener = () => {
    const { tabs } = this._elements;
    tabs.forEach((tab) =>
      tab.addEventListener("click", this._showTabPanel)
    );
  }

  _showTabPanel = (el) => {
    const { tabs } = this._elements;
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].setAttribute('aria-selected', 'false');
    }
    el.target.setAttribute('aria-selected', 'true');
    var tabPanelToOpen = el.target.getAttribute('aria-controls');
    var tabPanels = document.querySelectorAll('[role=tabpanel]');
    for (let i = 0; i < tabPanels.length; i++) {
      tabPanels[i].setAttribute('aria-hidden', 'true');
    }
    document.getElementById(tabPanelToOpen).setAttribute('aria-hidden', 'false');
  
    if (this.dataset.animate == 'true') {
      this._moveIndicator(el.target);
    }
  }

  _moveIndicator(newTab) {
    if (!newTab) return;
    if (this._elements.tabList) {
      const newTabWidth = newTab.offsetWidth;
      this.style.setProperty('--left', newTab.offsetLeft + 'px');
      this.style.setProperty('--width', newTabWidth + 'px');
    }
  } 

  _tabListListener = () => {
    const { tabList } = this._elements;
    tabList.forEach((list) =>
      list.addEventListener("keydown", this._tabListKeydown)
    );
  }

  _tabListKeydown = (e) => {
    if (e.keyCode == 37) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault();
    }
    if (e.keyCode == 38) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault();
    }
    if (e.keyCode == 39) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
    if (e.keyCode == 40) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
  }

}
/**
 * Carousel Component
 * --------------------------------------------------------------------
 * @summary carousel, uses swiper, dots are optional, and arrows are optional
 *
 * See https://swiperjs.com/swiper-api#parameters for more carousel options
 *
 * @usage
 * 
 *     {%- capture carousel_options -%}
 *       {
 *         "slidesPerView": "auto",
 *         "loop": false,
 *         ...
 *       }
 *     {%- endcapture -%}
 *      <s-carousel data-options='{{carousel_options}}' data-init="{{breakpoint}}">
 *        <div id="{{custom_id}}" class="swiper" js-carousel>
 *          <div class="swiper-wrapper">
 *            <div class="swiper-slide" js-carousel-slide></div>
 *            ...
 *          </div>
 *          <div class="swiper-button-prev {{prev_button_class}}"></div>
 *          <div class="swiper-button-next {{next_button_class}}"></div>
 *          <div class="swiper-pagination {{pagination_class}}"></div>
 *        </div>
 *      </s-carousel>
 *
 * The following parameters are attributes that the <s-carousel> element takes
 * @param data-options - object containing swiper options
 *                       ex.{"slidesPerView":"auto", "loop":false}
 *                       only needed if modifying or extending on default options
 *                       be careful with syntax here you have to use single quote on the outside,
 *                       and double quotes in the capture so that the JSON.parse() doesn't error.
 *                       DEFAULT OPTIONS:
 *                          loop: true,
 *                          slidesPerView: 'auto',
 *                          grabCursor: true,
 *                          centeredSlides: false,
 *                          on: {init: this._onReady},
 * 
 * @param data-init - use to initialize or destroy carousel at certain widths.
 *                    pass in variable from theme.config.mediaQueries (/global/config.js)
 *                    
 *                    enquire match/unmatch is pretty specific, so follow the rules below:
 *                    if mobile = destroyed, higher width = initialized, use a max-width variable
 *                    if mobile = intialized, higher width = destroyed, use a min-width variable
 * 
 *                    if breakpoint does not exist, feel free to add to config.js
 *
 * The following are selectors that the <s-carousel> searches for
 * [js-carousel] - required, this contains the slides and the arrows.
 * id - required, should be same element as [js-carousel]
 * .swiper - required class
 * .swiper-wrapper - required class
 * [js-carousel-slide] - required, each slide element needs this (differentiates from the arrows)
 * .swiper-slide - required class
 * .swiper-pagination - optional, custom {{pagination_class}} required if using pagination
 * .swiper-button-prev - optional, custom {{prev_button_class}} required if using navigation
 * .swiper-button-next - optional, custom {{next_button_class}} required if using navigation
 */

 class Carousel extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      carousel: '[js-carousel]'
    }

    this.options = {
      loop: true,
      slidesPerView: 'auto',
      grabCursor: true,
      centeredSlides: false,
      navigation: false,
      pagination: false,
    }
  }

  connectedCallback() {
    const extendedOptions = this.dataset.options ? JSON.parse(this.dataset.options) : {}
    this.options = Object.assign(this.options, extendedOptions)
    this._initCarousel();
  }

  // Initialize carousel
  _initCarousel() {
    let id = `#${this.querySelector(this.selectors.carousel).id}`;
    if (typeof this.dataset.init !== 'undefined') {
      //do nothing initially, init at larger points
      enquire.register(theme.config.mediaQueries[this.dataset.init],{
        match: function(){
          this.carousel = new Swiper(id, this.options)
        }.bind(this),
        unmatch: function(){
          if (this.carousel.el.classList.contains('swiper-initialized')) {
            this.carousel.destroy(true, true);
          }
        }.bind(this)
      })
    }else{
      this.carousel = new Swiper(id, this.options)
    }
  }
}
class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      header: "#shopify-section-header",
      announcement: '#shopify-section-announcement-bar',
      headerMain: '[js-header-main]',
      menuTriggers: '[js-top-level-nav]',
      nav: '[js-header-nav]',
      megaMenus: '[js-mega-menu]',
      subscribe: '[js-subscribe]',
      navIndicators: '[js-nav-indicator]',
      cartCount: '[js-cart-count]',
      searchTrigger: '[js-search-trigger]',
      mobileDrawer: '#MobileNavDrawer',
      searchInput: '[js-mobile-search-input]'
    }

    this._state = {
      navHidden: false,
      navHeight: 0,
      lastScrollY: window.scrollY,
      scrollTimeout: null,
      isIndexPage: document.body.classList.contains('template-index')
    };
  }

  connectedCallback() {
    this.header = document.querySelector(this._selectors.header);
    this.announcement = document.querySelector(this._selectors.announcement);
    this.headerMain = this.querySelector(this._selectors.headerMain);
    this.menuTriggers = this.querySelectorAll(this._selectors.menuTriggers);
    this.nav = this.querySelector(this._selectors.nav);
    this.megaMenus = this.querySelectorAll(this._selectors.megaMenus);
    this.subscribe = this.querySelector(this._selectors.subscribe);
    this.navIndicators = this.querySelectorAll(this._selectors.navIndicators);
    this.cartCount = this.querySelector(this._selectors.cartCount);
    this.searchTrigger = this.querySelector(this._selectors.searchTrigger);
    this.mobileDrawer = document.querySelector(this._selectors.mobileDrawer);
    this.searchInput = document.querySelector(this._selectors.searchInput);

    if (this.nav) {
      this._state.navHeight = this.nav.offsetHeight;
    }

    this._setVariables();
    this._bindEvents();
    this._watchWindowResize();
    this._updateHeaderState(); // Set initial state first
    this._handleScrollDown();
  }

  _handleScrollDown = () => {
    let ticking = false;

    const scrollHandler = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          const scrollingDown = currentScrollY > this._state.lastScrollY;
          const scrollingUp = currentScrollY < this._state.lastScrollY;
          const announcementHeight = this.announcement ? this.announcement.clientHeight : 0;

          if (currentScrollY > announcementHeight) {
            if (scrollingDown) {
              this._handleScrollDirection(true);
            } else if (scrollingUp) {
              this._handleScrollDirection(false);
            }
          } else {
            this._handleScrollDirection(false);
          }
          
          this._updateHeaderState();
          this._state.lastScrollY = currentScrollY;
          ticking = false;
        });
        ticking = true;
      }
    };

    this._scrollHandler = scrollHandler;
    window.addEventListener('scroll', this._scrollHandler, { passive: true });
  }

  _handleScrollDirection = (scrollingDown) => {
    if (!this.headerMain) return;

    const hideMobile = this.headerMain.getAttribute('data-scroll-down-hide-mobile') === 'true';
    const hideDesktop = this.headerMain.getAttribute('data-scroll-down-hide-desktop') === 'true';

    const isMobile = window.matchMedia(theme.config.mediaQueries.belowTablet).matches;
    const isDesktop = window.matchMedia(theme.config.mediaQueries.desktop).matches;

    let shouldHide = false;
    
    if (isMobile && hideMobile && scrollingDown) {
      shouldHide = true;
    } else if (isDesktop && hideDesktop && scrollingDown) {
      shouldHide = true;
    }

    if (shouldHide) {
      this.headerMain.classList.add('header-hidden');
    } else {
      this.headerMain.classList.remove('header-hidden');
    }
  }

  _bindEvents = () => {
    if (!this.menuTriggers || !this.nav) return;

    this.menuTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', this._handleMenuTriggerHover);
      trigger.addEventListener('mouseleave', this._handleNavItemMouseLeave);
    });

    this.megaMenus.forEach(menu => {
      menu.addEventListener('mouseenter', this._handleMegaMenuHover);
      menu.addEventListener('mouseleave', this._handleMegaMenuLeave);
    });

    this.nav.addEventListener('mouseleave', this._handleNavMouseLeave);

    if (this.searchTrigger) {
      this.searchTrigger.addEventListener('click', this._handleSearchTriggerClick);
    }
  }

  _watchWindowResize = () => {
    window.addEventListener('resize', () => {
      this._setVariables();
      this._updateHeaderState();
      const announcementHeight = this.announcement ? this.announcement.clientHeight : 0;
      if (window.scrollY > announcementHeight) {
        const scrollingDown = window.scrollY > this._state.lastScrollY;
        this._handleScrollDirection(scrollingDown);
      } else {
        this._handleScrollDirection(false);
      }
    }, { passive: true });
  }

  _updateHeaderState = () => {
    if (!this.headerMain) return;

    const announcementHeight = this.announcement ? this.announcement.clientHeight : 0;
    const currentScrollY = window.scrollY;
    const isMobile = window.matchMedia(theme.config.mediaQueries.belowTablet).matches;
    const isDesktop = window.matchMedia(theme.config.mediaQueries.desktop).matches;

    const enableTransparentMobile = this.headerMain.getAttribute('data-enable-transparent-mobile') === 'true';
    const enableTransparentDesktop = this.headerMain.getAttribute('data-enable-transparent-desktop') === 'true';
    const isTransparentEnabled = (isMobile && enableTransparentMobile) || (isDesktop && enableTransparentDesktop);
    const isIndexPage = this.headerMain.getAttribute('data-is-index-page') === 'true';

    this.headerMain.classList.remove('header--at-top', 'header--scrolled', 'header--solid');

    // State 1: Transparent at top (only for index pages with transparent enabled)
    if (currentScrollY <= announcementHeight && isTransparentEnabled) {
      this.headerMain.classList.add('header--at-top');
    } 
    // State 2: On scroll (applies to all pages when scrolled)
    else if (currentScrollY > announcementHeight) {
      this.headerMain.classList.add('header--scrolled');
    } 
    // State 3: Non-transparent (solid background) - default state non-index pages or when transparent is disabled
    else {
      this.headerMain.classList.add('header--solid');
    }
  }

  _setVariables = () => {
    if (!this.header) return;
    const announcementHeight = this.announcement ? this.announcement.clientHeight : 0;
    document.documentElement.style.setProperty('--header-height', `${this.header.clientHeight + announcementHeight}px`)
  }

  _handleMenuTriggerHover = (event) => {
    if (!this.megaMenus) return;

    this.megaMenus.forEach(menu => {
      menu.classList.remove('is-visible');
    });

    const menuId = event.currentTarget.getAttribute('data-menu-trigger');
    const targetMenu = document.getElementById('mega-menu-' + menuId);
    if (targetMenu) {
      requestAnimationFrame(() => {
        targetMenu.classList.add('is-visible');
      });
    }

    const targetSpan = event.currentTarget.querySelector(this._selectors.navIndicators);
    if (targetSpan) {
      targetSpan.classList.add('h-xxs');
    }
  }

  _handleNavItemMouseLeave = (event) => {
    const targetSpan = event.currentTarget.querySelector(this._selectors.navIndicators);
    if (targetSpan && !event.currentTarget.hasAttribute('data-active')) {
      targetSpan.classList.remove('h-xxs');
    }
  }

  _handleMegaMenuHover = (event) => {
    const menuId = event.currentTarget.getAttribute('id').replace('mega-menu-', '');
    const trigger = this.querySelector(`[data-menu-trigger="${menuId}"]`);
    if (trigger) {
      const targetSpan = trigger.querySelector(this._selectors.navIndicators);
      if (targetSpan) {
        targetSpan.classList.add('h-xxs');
      }
    }
  }

  _handleMegaMenuLeave = (event) => {
    const menuId = event.currentTarget.getAttribute('id').replace('mega-menu-', '');
    const trigger = this.querySelector(`[data-menu-trigger="${menuId}"]`);
    if (trigger) {
      const targetSpan = trigger.querySelector(this._selectors.navIndicators);
      if (targetSpan && !event.currentTarget.hasAttribute('data-active')) {
        targetSpan.classList.remove('h-xxs');
      }
    }
  }

  _handleNavMouseLeave = () => {
    if (!this.megaMenus) return;

    this.megaMenus.forEach(menu => {
      menu.classList.remove('is-visible');
    });
  }

  _handleSearchTriggerClick = () => {
    if (this.mobileDrawer) {
      this.mobileDrawer.open();
      setTimeout(() => {
        if (this.searchInput) {
          this.searchInput.focus();
        }
      }, 300);
    }
  }
}
class Video extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      video: 'video',
      play: '[js-play]',
      pause: '[js-pause]',
      mute: '[js-mute]',
      unmute: '[js-unmute]'
    }
  }

  connectedCallback() {
    this.video = this.querySelector(this._selectors.video);
    this.playBtn = this.querySelector(this._selectors.play);
    this.pauseBtn = this.querySelector(this._selectors.pause);
    this.muteBtn = this.querySelector(this._selectors.mute);
    this.unmuteBtn = this.querySelector(this._selectors.unmute);

    if (!this.playBtn) {
      this.playBtn = this.querySelector('[js-video-play]');
    }
    if (!this.pauseBtn) {
      this.pauseBtn = this.querySelector('[js-video-pause]');
    }

    this.videoButton = this.querySelector('[js-video-button]');

    if (this.video) {
      this.bindEvents();
      this.syncButtonStates();
      
      this.video.addEventListener('play', () => this.syncButtonStates());
      this.video.addEventListener('pause', () => this.syncButtonStates());
      
      this.initVideoAutoplay();
    }
  }

  bindEvents() {
    if (this.videoButton) {
      this.videoButton.addEventListener('click', () => this.togglePlayPause());
    } else if (this.playBtn && this.pauseBtn) {
      this.playBtn.parentElement.addEventListener('click', () => this.togglePlayPause());
    }
    if (this.muteBtn && this.unmuteBtn) {
      this.muteBtn.parentElement.addEventListener('click', () => this.toggleMute());
    }
  }

  togglePlayPause() {
    if (!this.video) return;
    if (this.video.paused) {
      this.video.play().catch(error => {
        console.log('Video play failed:', error);
      });
      if (this.playBtn) this.playBtn.classList.add('hidden');
      if (this.pauseBtn) this.pauseBtn.classList.remove('hidden');
    } else {
      this.video.pause();
      if (this.playBtn) this.playBtn.classList.remove('hidden');
      if (this.pauseBtn) this.pauseBtn.classList.add('hidden');
    }
  }

  toggleMute() {
    if (!this.video) return;
    this.video.muted = !this.video.muted;
    if (this.video.muted) {
      this.muteBtn.classList.remove('hidden');
      this.unmuteBtn.classList.add('hidden');
    } else {
      this.muteBtn.classList.add('hidden');
      this.unmuteBtn.classList.remove('hidden');
    }
  }

  syncButtonStates() {
    if (!this.video || !this.playBtn || !this.pauseBtn) return;
    
    if (this.video.paused) {
      this.playBtn.classList.remove('hidden');
      this.pauseBtn.classList.add('hidden');
    } else {
      this.playBtn.classList.add('hidden');
      this.pauseBtn.classList.remove('hidden');
    }
  }

  initVideoAutoplay() {
    if (!this.video) return;

    const container = this.closest('[data-autoplay-video]');
    if (!container) return;

    const autoplayValue = container.dataset.autoplay;
    const shouldAutoplay = autoplayValue !== 'false';
    if (!shouldAutoplay) return;

    const fallbackImage = container.querySelector('.media-group__video-fallback');
    
    // Add iOS-specific attributes for autoplay
    this.video.setAttribute('playsinline', 'playsinline');
    this.video.setAttribute('webkit-playsinline', 'webkit-playsinline');
    this.video.setAttribute('x5-playsinline', 'x5-playsinline');
    this.video.setAttribute('preload', 'auto');
    
    // Remove controls attribute
    this.video.removeAttribute('controls');
    this.video.controls = false;

    // Ensure video is muted
    if (!this.video.hasAttribute('muted')) {
      this.video.setAttribute('muted', 'muted');
    }
    this.video.muted = true;

    // Handle video load and autoplay
    const handleVideoReady = () => {
      const playPromise = this.video.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            if (fallbackImage) {
              fallbackImage.classList.add('hidden');
            }
            this.video.classList.remove('hidden');
          })
          .catch((error) => {
            // Show fallback image if available
            if (fallbackImage) {
              this.video.classList.add('hidden');
              fallbackImage.classList.remove('hidden');
            } else {
              // If no fallback image, use the poster attribute
              const poster = this.video.getAttribute('poster');
              if (poster) {
                const img = document.createElement('img');
                img.src = poster;
                img.className = 'media-group__video-fallback w-full object-cover';
                img.style.position = 'absolute';
                img.style.top = '0';
                img.style.left = '0';
                img.style.width = '100%';
                img.style.height = '100%';
                img.style.objectFit = 'cover';
                container.appendChild(img);
                this.video.classList.add('hidden');
              }
            }
          });
      }
    };

    if (this.video.readyState >= 2) {
      handleVideoReady();
    } else {
      this.video.addEventListener('loadeddata', handleVideoReady, { once: true });
      this.video.addEventListener('canplay', handleVideoReady, { once: true });
    }
  }
}
/**
 * file: video-autoplay.js
 * ------------------------------------------------------
 * All code related to animations, including playing 
 * videos on scroll, fade in, smooth scrolling, etc.
 * 
 * Animations use gsap core + scroll trigger, and lenis
 * for smooth scrolling
 */

class VideoAutoplay extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      videoContainer: '[js-video-container]',
      fadeInBottom: '[data-fade-in-bottom][data-fade-in-defer="true"]',
    }
  }

  connectedCallback() {
    // Only initialize smooth scrolling if this component is present
    if (!window.lenis) {
      this.initSmoothScrolling();
    }
    
    this.eager = this.dataset.eager === 'true';
    this.videos = this.querySelectorAll(this.selectors.videoContainer);
    this.fadeInBottom = this.querySelectorAll(this.selectors.fadeInBottom);

    this.videos.forEach((video) => this.initAnimations(video));
    this.videos.forEach((video) => this.initReplay(video));

    this.initControls();
  }

  initSmoothScrolling() {
    const lenis = window.lenis = new Lenis()
    
    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0);
  }

  // Sync animations with video
  initAnimations(videoContainer) {
    const video = videoContainer.querySelector('video');

    // Animate after video is loaded
    if (video.readyState === 4) {
      this.animateElements(videoContainer)
    } else {
      video.addEventListener('loadeddata', () => {
        this.animateElements(videoContainer)
      })
    }
  }

  initReplay(videoContainer) {
    const replaySelector = videoContainer.dataset.replay;
    if (!replaySelector) return;
    const video = videoContainer.querySelector('video');
    const replayBtn = this.querySelector(replaySelector);
    if (replayBtn) {
      video?.addEventListener('ended', () => this.enableReplayBtn(video, replayBtn))
    }
  }

  initControls() {
    const play = this.querySelector('[js-play-pause-button]');
    const sound = this.querySelector('[js-sound-button]');

    console.log(play);
    console.log(sound);

    if (play || sound) {
      play.addEventListener('click', () => {
        const currentPlaying = play.getAttribute("aria-playing"); 
        play.setAttribute("aria-playing", currentPlaying === "true" ? "false" : "true");
      });
      sound.addEventListener('click', () => {
        const currentMute = play.getAttribute("aria-mute"); 
        play.setAttribute("aria-mute", currentExpanded === "true" ? "false" : "true");
      });
    }
  }

  enableReplayBtn(video, btn) {
    btn.addEventListener('click', () => {
      video.currentTime = 0;
      video.play();
    });
    btn.removeAttribute("disabled");
    btn.classList.add('active');
  }

  disableReplayBtn(btn) {
    btn.setAttribute("disabled", "true");
    btn.classList.remove('active');
  }

  animateElements(container) {
    const video = container.querySelector('video');
    const replaySelector = container.dataset.replay;
    const replayBtn = replaySelector && this.querySelector(replaySelector);
    
    const videoAnimationConfig = {
      opacity: 1,
      pointerEvents: 'auto',
    }

    const fadeInBottomConfig = {
      y: 0,
      opacity: 1,
      pointerEvents: 'auto',
      delay: 0.5
    }

    if (!this.eager) {
      videoAnimationConfig.scrollTrigger = {
        trigger: container,
        start: "top center+=250",
        // markers: true,
        onEnter: () => {
          video.currentTime = 0;
          if (replayBtn) {
            this.disableReplayBtn(replayBtn)
          }
        }
      }

      fadeInBottomConfig.scrollTrigger = {
        trigger: container,
        start: "top center",
      }
    }

    gsap.to(container, videoAnimationConfig)  
    this.fadeInBottom.forEach(el => {
      const delay = el.dataset.animationDelay
        ? parseFloat(el.dataset.animationDelay)
        : fadeInBottomConfig.delay;
      gsap.to(el, { ...fadeInBottomConfig, delay });  
    })
  }
}

/**
 * Global initialization
 */
(function() {
  registerGsapPlugins();
  initGlobalAnimations();

  function registerGsapPlugins() {
    gsap.registerPlugin(ScrollTrigger);
  }

  function initGlobalAnimations() {
    const selectors = {
      fadeIn: '[data-fade-in]',
      fadeInBottom: '[data-fade-in-bottom]',
      snap: '.animation--snap'
    }

    initFadeIn();

    function initFadeIn() {
      document.querySelectorAll(selectors.fadeInBottom).forEach((el) => {
        if (el.dataset.fadeInDefer === "true") return;
  
        gsap.to(el, {
          scrollTrigger: {
            trigger: el,
            start: 'top center+=200',
          },
          y: 0,
          opacity: 1,
          pointerEvents: 'auto',
        })  
      })
  
      document.querySelectorAll(selectors.fadeIn).forEach((el) => {
        if (el.dataset.fadeInDefer === "true") return;
  
        gsap.to(el, {
          scrollTrigger: {
            trigger: el,
            start: 'top center+=200',
          },
          opacity: 1,
          pointerEvents: 'auto',
        })  
      })
    }
  }
})();


class Toast extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      toastModal: '#ToastModal',
      toastInCart: '[js-toast-in-cart]',
      toastNotification: '[js-toast-notification]',
      toastImage: '[js-toast-image]',
      toastProductTitle: '[js-toast-product-title]',
      toastVariantInfo: '[js-toast-variant-info]',
      toastShippingThreshold: '[js-toast-shipping-threshold]'
    }
  }

  connectedCallback() {
    this.cart = document.querySelector('cart-drawer');
    this.toastModal = document.querySelector(this._selectors.toastModal);
    this.toastInCart = this.querySelector(this._selectors.toastInCart);
    this.toastNotification = this.querySelector(this._selectors.toastNotification);
    this.toastImage = this.querySelector(this._selectors.toastImage);
    this.toastProductTitle = this.querySelector(this._selectors.toastProductTitle);
    this.toastVariantInfo = this.querySelector(this._selectors.toastVariantInfo);
    this.toastShippingThreshold = this.querySelector(this._selectors.toastShippingThreshold);

    this.moneyFormat = `${window.currency.symbol || "$"}{{no_trailing_zeros}}`;
    
    this._setListeners();
  }

  _setListeners = () => {
    this.toastModal.addEventListener('open', () => {
      this.closeToast = setTimeout(() => {
        this.toastModal.close();
      }, 3000);
    });

    this.toastModal.addEventListener('close', () => {
      clearTimeout(this.closeToast);
    });

    this.toastModal.addEventListener('mouseover', () => {
      clearTimeout(this.closeToast);
    });

    this.toastModal.addEventListener('mouseout', () => {
      this.closeToast = setTimeout(() => {
        this.toastModal.close();
      }, 3000);
    });
  }

  openToast = (data, type, properties = null) => {
    switch (type) {
      case 'in-cart':
        this._updateInCartToast(data, properties);
        this._updateShippingThreshold();
        this._updateToastPosition();
        this.toastModal.open();
        break;
      case 'in-cart-bundle':
        this._updateInCartBundleToast(data, properties);
        this._updateShippingThreshold();
        this._updateToastPosition();
        this.toastModal.open();
        break;
      case 'notification':
        this._updateNotificationToast(data);
        requestAnimationFrame(() => {
          this._updateToastPosition();
          this.toastModal.open();
        });
        break;
    }
  }

  _updateToastPosition = () => {
    const mediaQuery = window.matchMedia(theme.config.mediaQueries.belowLaptop);
    if (mediaQuery.matches) {
      if (window.scrollY > 41) {
        this.toastModal.classList.add('mt-[-41px]');
      } else {
        this.toastModal.classList.remove('mt-[-41px]');
      }
    } else {
      if (window.scrollY > 52) {
        this.toastModal.classList.add('mt-[-52px]');
      } else {
        this.toastModal.classList.remove('mt-[-52px]');
      }
    }
  }

  _updateShippingThreshold = () => {
    const shippingMotivator = this.cart.querySelector('[js-shipping-motivator]');

    if (shippingMotivator) {
      const shippingMotivatorThreshold = parseInt(shippingMotivator.getAttribute('data-shipping-motivator-threshold'));
      const cartTotal = parseInt(shippingMotivator.getAttribute('data-cart-total'));

      if (cartTotal < shippingMotivatorThreshold) {
        const difference = theme.utils.formatMoney(shippingMotivatorThreshold - cartTotal, this.moneyFormat);

        this.toastShippingThreshold.textContent = `Add ${difference} to get free shipping`;
      } else if (cartTotal >= shippingMotivatorThreshold) {
        this.toastShippingThreshold.textContent = 'Free Shipping Achieved!';
      } else {
        this.toastShippingThreshold.textContent = '';
      }
    }
  }

  _updateInCartToast = (data, properties = null) => {
    if (properties && properties['Product Title']) {
      this.toastProductTitle.textContent = properties['Product Title']  + ' Added';
    } else if (data.product_title) {
      this.toastProductTitle.textContent = data.product_title + ' Added';
    }

    if (properties && properties['Product Image']) {
      this.toastImage.innerHTML = `<img class="w-full h-full object-cover" src="${properties['Product Image']}" loading="lazy" alt="${properties['Product Title']}"/>`;
    } else if (data.featured_image) {
      this.toastImage.innerHTML = `<img class="w-full h-full object-cover" src="${data.featured_image.url}" loading="lazy" alt="${data.product_title}"/>`;
    }

    this.toastVariantInfo.textContent = '';

    if (properties && properties['Color']) {
      this.toastVariantInfo.textContent = properties['Color'] + ' ';
    }

    if (properties && properties['Variant Title']) {
      this.toastVariantInfo.textContent += properties['Variant Title'].toUpperCase();
    } else if (data.variant_title) {
      this.toastVariantInfo.textContent += data.variant_title.toUpperCase();
    }

    this._showInCartToast();
  }

  _updateInCartBundleToast = (data, properties = null) => {
    if (properties && properties._title) {
      this.toastProductTitle.textContent = properties._title + ' Added';
    }

    if (properties && properties._image) {
      this.toastImage.innerHTML = `<img class="w-full h-full object-cover" src="${properties._image}" loading="lazy" alt="${properties._title}"/>`;
    }

    let variantText = '';

    Array.from(data.items).forEach((item, index) => {
      let itemText = '';
      if (item.properties._color_product) {
        itemText += item.properties._color_product + ' ';
      }

      if (item.properties._option_product) {
        itemText += item.properties._option_product.toUpperCase();
      }

      if (itemText) {
        if (index > 0) {
          variantText += ', ';
        }
        variantText += itemText;
      }
    });

    this.toastVariantInfo.textContent = variantText;

    this._showInCartToast();
  }

  _updateNotificationToast = (message) => {
    this.toastNotification.innerHTML = message;

    this._showNotificationToast();
  }

  _showInCartToast = () => {
    this.toastInCart.classList.remove('hidden');
    this.toastNotification.classList.add('hidden');
  }

  _showNotificationToast = () => {
    this.toastInCart.classList.add('hidden');
    this.toastNotification.classList.remove('hidden');
  }
}
/**
 * Countdown Component
 * --------------------------------------------------------------------------------
 * @summary Countdown timer that displays days, hours, minutes, and seconds
 * 
 * @usage
 * <s-countdown
 *  data-start-date="YYYY-MM-DD HH:MM:SS"
 *  data-end-date="YYYY-MM-DD HH:MM:SS"
 *  data-hide-on-complete="true"
 *  >
 *   <div class="countdown-item">
 *     <span class="countdown-unit" js-countdown-days>00</span>
 *     <span class="countdown-label">Days</span>
 *   </div>
 *   <div class="countdown-item">
 *     <span class="countdown-unit" js-countdown-hours>00</span>
 *     <span class="countdown-label">Hrs</span>
 *   </div>
 *   <div class="countdown-item">
 *     <span class="countdown-unit" js-countdown-minutes>00</span>
 *     <span class="countdown-label">Mins</span>
 *   </div>
 *   <div class="countdown-item">
 *     <span class="countdown-unit" js-countdown-seconds>00</span>
 *     <span class="countdown-label">Secs</span>
 *   </div>
 * </s-countdown>
 * 
 * @param data-end-date - Required. End date in format "YYYY-MM-DD HH:MM:SS" (Eastern timezone)
 * @param data-start-date - Optional. Start date in format "YYYY-MM-DD HH:MM:SS" (Eastern timezone). Countdown will be hidden until this date is reached
 * @param data-hide-on-complete - Optional. Set to "true" to hide the countdown when it reaches zero
 */

class Countdown extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      days: '[js-countdown-days]',
      hours: '[js-countdown-hours]',
      minutes: '[js-countdown-minutes]',
      seconds: '[js-countdown-seconds]'
    };

    this._state = {
      endDate: null,
      startDate: null,
      interval: null,
      hideOnComplete: false
    };
  }

  connectedCallback() {
    const endDateString = this.dataset.endDate;
    if (!endDateString) {
      console.warn('Countdown component requires data-end-date attribute');
      return;
    }

    this._state.endDate = this._convertEasternToUTC(endDateString);
    this._state.hideOnComplete = this.dataset.hideOnComplete === 'true';

    const startDateString = this.dataset.startDate;
    if (startDateString) {
      this._state.startDate = this._convertEasternToUTC(startDateString);
    }

    this.daysElement = this.querySelector(this._selectors.days);
    this.hoursElement = this.querySelector(this._selectors.hours);
    this.minutesElement = this.querySelector(this._selectors.minutes);
    this.secondsElement = this.querySelector(this._selectors.seconds);

    this._updateCountdown();
    this._state.interval = setInterval(() => this._updateCountdown(), 1000);
  }

  disconnectedCallback() {
    if (this._state.interval) {
      clearInterval(this._state.interval);
    }
  }

  /**
   * Get the current Eastern timezone offset (EST or EDT)
   * @returns {string} Timezone offset string (e.g., "-05:00" for EST, "-04:00" for EDT)
   */
  _getEasternTimezoneOffset() {
    const now = new Date();
    const easternTime = new Date(now.toLocaleString("en-US", {timeZone: "America/New_York"}));
    const utcTime = new Date(now.toLocaleString("en-US", {timeZone: "UTC"}));
    
    const diffMs = easternTime.getTime() - utcTime.getTime();
    const diffHours = Math.abs(diffMs / (1000 * 60 * 60));
    
    const offset = `-${diffHours.toString().padStart(2, '0')}:00`;

    return offset;
  }

  /**
   * Convert Eastern date string to UTC timestamp
   * @param {string} easternDateString - Date string in Eastern format "YYYY-MM-DD HH:MM:SS"
   * @returns {number} UTC timestamp in milliseconds
   */
  _convertEasternToUTC(easternDateString) {
    const timezoneOffset = this._getEasternTimezoneOffset();
    const dateWithTimezone = `${easternDateString}${timezoneOffset}`;

    const date = new Date(dateWithTimezone);
    const utcTimestamp = date.getTime();
    
    return utcTimestamp;
  }

  _updateCountdown() {
    const now = new Date().getTime();
    
    if (!this._state.startDate) {
      this.classList.remove('hidden');
    }

    if (this._state.startDate && now < this._state.startDate) {
      this.classList.add('hidden');
      return;
    } else if (this._state.startDate && now >= this._state.startDate) {
      this.classList.remove('hidden');
    }

    const distance = this._state.endDate - now;

    if (distance < 0) {
      if (this._state.hideOnComplete) {
        this.classList.add('hidden');
      }
      if (this._state.interval) {
        clearInterval(this._state.interval);
      }
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (this.daysElement) this.daysElement.textContent = days.toString().padStart(2, '0');
    if (this.hoursElement) this.hoursElement.textContent = hours.toString().padStart(2, '0');
    if (this.minutesElement) this.minutesElement.textContent = minutes.toString().padStart(2, '0');
    if (this.secondsElement) this.secondsElement.textContent = seconds.toString().padStart(2, '0');
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const timestamp = this.dataset.timestamp;

      if (timestamp) {
        cartItems.batchUpdateQuantity(this.dataset.index, 0, timestamp, 'remove');
        return;
      }

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    const debouncedOnChange = theme.utils.debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = theme.utils.subscriptions.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    this.checkGWP();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  checkGWP() {
  const node = document.querySelector('[js-gwp-node]');

  if(node) {
    //Changing Visuals

    const cartLevel = parseInt(node.dataset.cartLevel);
    const cartTotal = node.dataset.cartTotal;
    const sentence = node.getAttribute(`data-threshold-${cartLevel}-sentence`);
    const sentenceContainer = node.querySelector('[js-motivator-sentence]');


    const productOneThreshold = parseInt(node.getAttribute('data-2-threshold'));
    const productTwoThreshold = parseInt(node.getAttribute('data-3-threshold'));
    const productThreeThreshold = parseInt(node.getAttribute('data-4-threshold'));


    if(cartLevel !== 5) {
      const levelThreshold = node.getAttribute(`data-${cartLevel}-threshold`);
      const differenceToThreshold = parseInt(levelThreshold) - parseInt(cartTotal);
      const differenceToThresholdParsed = theme.utils.formatMoney(differenceToThreshold, this.moneyFormat)
      const sentenceParsed = sentence.replace('[PRICE]', `<strong>${differenceToThresholdParsed}</strong>`);

      sentenceContainer.innerHTML = sentenceParsed
    } else {
      sentenceContainer.innerHTML = sentence
    }

    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
  
      data.items.forEach((item, index) => {
        const itemLevel = parseInt(item.properties['_gwp_level'])
        const itemIndex = index + 1;

        if(itemLevel) {
          if(itemLevel >= cartLevel) {
            console.log('removing THIS item', item)
            this.updateQuantity(itemIndex, 0);
          }
        }
      })
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
  }

  }

  onChange(event) {
    if (event.target.dataset.timestamp) {
      this.batchUpdateQuantity(event.target.dataset.index, event.target.value, event.target.dataset.timestamp, 'update');
    } else {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=cart__main`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartPage-CartItems',
        section: document.getElementById('CartPage-CartItems').dataset.id,
        selector: '[js-cart-page-contents]',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...{method: 'POST',headers: { 'Content-Type': 'application/json', Accept: `application/json` },}, ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('[js-cart-item]');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        const cartDrawerWrapper = document.querySelector('cart-drawer');

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = `There was an error while updating your cart. Please try again.`;
          } else {
            message = `You can only add ${updatedValue} of this item to your cart.`;
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? theme.utils.a11y.trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          theme.utils.a11y.trapFocus(cartDrawerWrapper.querySelector('[js-empty-cart]'), cartDrawerWrapper.querySelector('[js-cart-continue-link]'));
        } else if (document.querySelector('[js-cart-item]') && cartDrawerWrapper) {
          theme.utils.a11y.trapFocus(cartDrawerWrapper, document.querySelector('[js-cart-item-image]'));
        }
        theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        
        // Force cart count to 0 
        setTimeout(() => {
          const emptyCartElement = document.querySelector('[js-empty-cart]');
          if (emptyCartElement) {
            const cartCountElement = document.getElementById('cart-count');
            if (cartCountElement) {
              cartCountElement.textContent = '0';
            }
          }
        }, 300);
      })
      .catch((error) => {
        console.log(error)
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = `There was an error while updating your cart. Please try again.`;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  batchUpdateQuantity(line, quantity, timestamp, action) {
    this.enableLoading(line);

    let itemsToUpdate = [];

    if (action === 'remove') {
      itemsToUpdate = this.querySelectorAll(`cart-remove-button[data-timestamp="${timestamp}"]`);
    } else if (action === 'update') {
      itemsToUpdate = this.querySelectorAll(`input[data-timestamp="${timestamp}"]`);
    }

    const updates = {};

    itemsToUpdate.forEach((item) => {
      updates[item.dataset.key] = quantity;
    });

    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body
    })
    .then(response => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);

      const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll('[js-cart-item]');

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      const cartDrawerWrapper = document.querySelector('cart-drawer');

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });

      const lineItem =
        document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper
          ? theme.utils.a11y.trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        theme.utils.a11y.trapFocus(cartDrawerWrapper.querySelector('[js-empty-cart]'), cartDrawerWrapper.querySelector('[js-cart-continue-link]'));
      } else if (document.querySelector('[js-cart-item]') && cartDrawerWrapper) {
        theme.utils.a11y.trapFocus(cartDrawerWrapper, document.querySelector('[js-cart-item-image]'));
      }
      theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      
      // Force cart count to 0 (BATCH)
      setTimeout(() => {
        const emptyCartElement = document.querySelector('[js-empty-cart]');
        if (emptyCartElement) {
          const cartCountElement = document.getElementById('cart-count');
          if (cartCountElement) {
            cartCountElement.textContent = '0';
          }
        }
      }, 300);
    })
    .catch((error) => {
      console.error(error);
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      errors.textContent = `There was an error while updating your cart. Please try again.`;
    })
    .finally(() => {
      this.disableLoading(line);
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.innerHTML = message;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('CartPage-CartItems') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} loading-spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} loading-spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((spinner) => spinner.setAttribute("loading", ""));

    document.activeElement.blur();
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('CartPage-CartItems') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} loading-spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} loading-spinner`);
    
    [...cartItemElements, ...cartDrawerItemElements].forEach((spinner) => spinner.removeAttribute("loading"));
  }
}

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'change',
      theme.utils.debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...{method: 'POST',headers: { 'Content-Type': 'application/json', Accept: `application/json` },}, ...{ body } });
      }, 500)
    );
  }
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const openCart = new URLSearchParams(window.location.search).get('viewcart');
    this.cartDrawer = document.querySelector('#CartDrawer');
    if (openCart === 'true'){
      this.cartDrawer.open();
    }

    // Dispatch resize event to render height of Rebuy widgets' Flickity carousel
    this.cartDrawer.addEventListener('open', () => {
      window.dispatchEvent(new Event('resize'));
    });

  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.rerenderRebuyWidgets();
  }

  rerenderRebuyWidgets() {
    const cartWidgets = document.querySelectorAll('[js-rebuy-cart-widget]');

    if (!cartWidgets) return;

    cartWidgets.forEach(cartWidget => {
      const rebuyWidget = window.Rebuy.widgets.find(widget => widget.id === `${cartWidget.dataset.rebuyId}`);
      if (rebuyWidget) {
        rebuyWidget.render();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart',
        selector: '#cart',
      },
      {
        id: 'cart-count'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'cart',
        section: 'cart',
        selector: '[js-cart-drawer-contents]',
      },
      {
        id: 'cart-count',
        section: 'cart-count',
        selector: '.shopify-section',
      }
    ];
  }
}
/**
 * Product Options Component
 * --------------------------------------------------------------------------------
 * @summary Component for handling variant selection through product's options. 
 * Fires events when a variant changes, and keeps a master variant select in sync 
 * (if one is provided as a param). Other parts of the code must listen for the events 
 * and react accordingly
 * 
 * @usage 
   <script type="application/json" id="ProductJSON">{{ product | json }}</script> 
   <product-options data-product='ProductJSON' master-select-id="MasterSelect">
    {% for option in product.options_with_values %}
      {% render 'product-option-selector' 
        option: 'swatch'
        type: option_type
        section_id: section.id
        product_id: product.id
      %}
    {% endfor %}
   </product-options
 * 
 * The following parameters are attributes that <product-options> take:
 * @param data-product - id of script that contains product JSON - required (if no product-handle)
 * @param data-product-handle - optional, alternatively to passing the product as
 *                              JSON, you can pass a product handle and the product
 *                              will be fetched upon first option select, this is 
 *                              less taxing on page load if there are multiple products. 
 * @param data-enable-history-state - default to false, updates url on variant change
 *                                    for product deep linking
 * 
 * @param master-select-id - optional id to a master variant selector, if 
 *                             provided, it will keep it in sync.
 * @param data-disable-option-binding - optional, by default, component checks which options
 *                                 are available according to user input and disable invalid
 *                                 options, with this param that feature is disabled.
 *                                 Only works for 2 options
 * 
 * These events bubble up from the input that was changed, so any ancestor
 * element can listen to it. 
 * @emits variant:change - event.detail.variant {Object} new variant
 *                       - event.detail.changedPrice {Boolean} if price has changed
 * 
 * Fetch events, fire upon first option selection. Only if you're using 
 * data-product-handle. These events don't include any data.
 * @emits variant:fetch:before 
 * @emits variant:fetch:after 
 * @emits variant:fetch:error 
 *
 * The following are selectors that the <product-options> searches for:
 * - [js-product-option-selector] - required, every option selector input must have
 * - every input must have data-index="option{{ option.position }}"
 * 
 * @scenario if you need more info than the variant event gives you (like
 * inventory qty), use a master select and grab data from that master select
 * on variant change.
 * 
 * @scenario if you need to dynamically render options using js, just adapt snippet 
 * markup, and on the component itself, don't pass data-product or data-product-handle,
 * do: 'this.querySelector('product-options').product = product' after you've render it
 * into the page, this avoids costly parsing/serializing.
 */

   class ProductOptions extends HTMLElement {
    constructor() {
      super();
  
      this._selectors = {
        singleOptionSelector: "[js-product-option-selector]",
      };
  
      this._events = {
        change: "variant:change",
        fetchBefore: "variant:fetch:before",
        fetchAfter: "variant:fetch:after",
        fetchError: "variant:fetch:error",
      };
    }
  
    connectedCallback() {
      this._handle = this.dataset.productHandle;
      this._masterSelect = document.getElementById(this.dataset.masterSelectId);
  
      this._checkAvailableOptions = !this.hasAttribute(
        "data-disable-option-binding"
      );

  
      this._prepackedBundle = this.hasAttribute("data-prepacked-bundle-binding");
  
      this._optionSelectors = [
        ...this.querySelectorAll(this._selectors.singleOptionSelector),
      ];
  
      if (this._checkAvailableOptions) {
        this._availableValues = {};
        this._lastSelectedOption = null
        this._option1Values = this._option2Values = null;
      }
  
      if (this.dataset.product) {
        const json = document.getElementById(this.dataset.product);
        if (json) this._product = JSON.parse(json.innerHTML);
      }
  
      if (this._product) {
        this._currentVariant = this._getVariantFromOptions();
        if (this._checkAvailableOptions)
          this._setupOptionsAvailability(this._product);
      }
  
      if (this._product || this._handle) this._setupListeners();
      
      if (Number(this.dataset.optionsSize) > 1) {
        this._optionSelectors.forEach((selector) =>
          selector.classList.remove('disabled', 'unavailable')
        );
      }
    }


    /* Standardise option values */
    _formatOptionLabel(option) {
      return option.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
    }

    _createVariantMatrix(product) {
      this._option1Values = new Set();
      this._option2Values = new Set();

      product.variants.forEach((variant) => {
        const { option1, option2 } = variant;
        if (option1) this._option1Values.add(this._formatOptionLabel(option1));
        if (option2) this._option2Values.add(this._formatOptionLabel(option2));
      });

      const matrix = new Map();

      const optionSets = [
        [...this._option1Values],
        [...this._option2Values].filter(Boolean)
      ].filter(set => set.length > 0);

      const createCombinations = (current = [], depth = 0) => {
        if (depth === optionSets.length) {
          const matchingVariants = product.variants.filter(variant =>
            current.every((value, i) => this._formatOptionLabel(variant[`option${i + 1}`]) === value)
          );
  
          const exists = matchingVariants.length > 0;
          const available = matchingVariants.some(v => v.available === true);
  
          matrix.set(JSON.stringify(current), { exists, available });
          return;
        }
  
        // Recursively loop through all option sets
        optionSets[depth].forEach(value => {
          createCombinations([...current, value], depth + 1);
        });
      };


      createCombinations();

      this._variantMatrix = matrix;
    }
  
    set product(product) {
      this._product = product;
      // reinit when product changes
      this.disconnectedCallback();
      this.connectedCallback();
    }
  
    _setupListeners() {
      this._optionSelectors.forEach((selector) =>
        selector.addEventListener("change", this._handleOptionChange)
      );
    }
  
    /* Find variant based on selected options */
    _getVariantFromOptions() {
      if (!this._product) return;
      const selectedOptions = this._getCurrentOptions();
      const { variants } = this._product;
  
      return variants.find((variant) =>
        selectedOptions.every((option) => option.value === variant[option.index].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''))
      );
    }
  
    /* Get the currently selected options */
    _getCurrentOptions() {
      return this._optionSelectors
        .map((selector) => {
          const type = selector.getAttribute("type");
          const currentOption = {};
  
          if (type === "radio" || type === "checkbox") {
            if (selector.checked) {
              currentOption.value = selector.value;
              currentOption.index = selector.dataset.index;
  
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = selector.value;
            currentOption.index = selector.dataset.index;
            return currentOption;
          }
        })
        .filter((option) => option); // filter falsy values
    }
  
    /** Prepares options values data, followed by refreshing the UI */
    _setupOptionsAvailability(product) {
      // set so we don't have duplicates
      this._option1Values = new Set();
      this._option2Values = new Set();
      product.variants.forEach((variant) => {
        const { option1, option2 } = variant;
        if (option1) this._option1Values.add(option1.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''));
        if (option2) this._option2Values.add(option2.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''));
      });
      // turn to array
      this._option1Values = [...this._option1Values];
      this._option2Values = [...this._option2Values];
  
      this._optionSelectors.forEach((option) => {
        if (this._lastSelectedOption == null && option.checked) {
          this._lastSelectedOption = {
            key: option.dataset.index,
            value: option.value,
          };
        }
      })
  
      this._availableValues = this._getAvailableValues(this._product, this._lastSelectedOption);
      this._refreshValuesUI(this._availableValues);
    }
  
    /* Dispatches variant events and makes necessary updates */
    _handleOptionChange = (e) => {
      if (!this._product) {
        this._fetchProduct(this._handle)
          .then((product) => { 
            this._product = product;
            if (this._checkAvailableOptions) this._setupOptionsAvailability(this._product);
            this._updateVariant(e)
          })
          .catch((e) => console.log(e));
      } else {
        this._updateVariant(e)
      }
  
  
      if (this._checkAvailableOptions) {
        this._lastSelectedOption[e.target.dataset.index] = e.target.value
        this._lastSelectedOption.lastSelected = e.target.dataset.index
  
        const availableValues = this._handleOptionsAvailability(
          this._lastSelectedOption
        );
  
        this._refreshValuesUI(availableValues);
        this._availableValues = availableValues;
      }
    };
  
    _handleOptionsAvailability() {
      let availableValues = this._getAvailableValues(this._product, this._lastSelectedOption);
      const lastSelectedKey = this._lastSelectedOption.lastSelected;
    
      if (this._availableValues[lastSelectedKey]) {
        const selectedOption = this._availableValues[lastSelectedKey].find(
          option => option.value === this._lastSelectedOption[lastSelectedKey]
        );
      }
      return availableValues;
    }
    
    _updateVariant(e) {
      this._lastSelectedOption = {
        key: e.target.dataset.index,
        value: e.target.value,
      };


      const variant = this._getVariantFromOptions();  
      // Update available values
      if (this._checkAvailableOptions) {
        const availableValues = this._getAvailableValues(
          this._product,
          this._lastSelectedOption
        );
        const updatedValues = this._getDifference(
          this._availableValues,
          availableValues
        );
        this._refreshValuesUI(updatedValues);
        this._availableValues = availableValues;
        if (!variant) {
          this._removeVariant()
        }
      }
  
      if (this.hasAttribute("data-enable-history-state"))
        this._updateHistoryState(variant);
      if (this._masterSelect) this._updateMasterSelect(variant);
  
      this._currentVariant = variant;
  
      this.dispatchEvent(
        new CustomEvent(this._events.change, {
          detail: {
            variant,
            priceChange: this._hasPriceChanged(variant),
          },
          bubbles: true,
        })
      );
    }
  
    /* Returns whether or not price has changed for new variant */
    _hasPriceChanged(variant) {
      if (!variant || !this._currentVariant) return false;
      return !(
        variant.price === this._currentVariant.price &&
        variant.compare_at_price === this._currentVariant.compare_at_price
      );
    }
  
    /**
     * Given the last selected option, goes through the other options values
     * and checks if they are valid/available. If no selected option, returns an object
     * with all values as available.
     * @return {Object} - Boolean object where the key is an options's value and the
     *                    value is a Boolean indicating whether that value is available
     *                    or not
     */
    _getAvailableValues(product, selectedOption) {
      if (selectedOption) {
        const availableValues = {};
        const optionsToExplore = ["option1", "option2"];
        const dictionary = {
          option1: this._option1Values,
          option2: this._option2Values,
        };
        // don't explore last selected option, use it as base
        const explore = optionsToExplore.find(
          (option) => option !== selectedOption.key
        );
  
        // Get available values based on last selected option
        const values = dictionary[explore];
        values.forEach((value) => {
          const available = product.variants.findIndex((variant) => {
            const baseMatch = 
              variant[selectedOption.key].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === selectedOption.value &&
              variant[explore].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === value;
            
            if (this._prepackedBundle) {
              const masterOption = this._masterSelect.querySelector(`option[value="${variant.id}"]`);
              const bundleUnavailable = masterOption.dataset.bundleUnavailable === 'true';
              return baseMatch && !bundleUnavailable;
            } else {
              return baseMatch && variant.available;
            }
          });
          availableValues[value] = available >= 0;
        });
  
        return availableValues;
      } else {
        // All values are possible
        return product.variants.reduce((values, variant) => {
          const { option1, option2 } = variant;
          if (option1) values[option1] = true;
          if (option2) values[option2] = true;
          return values;
        }, {});
      }
    }
  
    /**
     * Enabled/disable values given a values boolean object.
     *
     * If you need to add classes instead of disabling (or run
     * some other logic) here's the place to do it
     */
    _refreshValuesUI(values) {
      if (Number(this.dataset.optionsSize) < 2) {
        return;
      }

      let oppositeKey
      let matchingVariants
      let sameOptionVariants
      if (this._lastSelectedOption) {
        const {key, value} = this._lastSelectedOption
        oppositeKey = key === 'option1' ? 'option2' : 'option1';
        matchingVariants = this._product.variants.filter(variant =>
          this._formatOptionLabel(variant[key]) === value
        );
      }

      for (const key in values) {
        const value = this.querySelector(`[value="${key}"]`);
        if (matchingVariants) {
          sameOptionVariants = matchingVariants.filter(variant =>
            this._formatOptionLabel(variant[oppositeKey]) === key
          );
        }

        /** Update values as needed */
        if (value) {
          if (values[key]) {
            value.classList.remove('disabled');
            value.classList.remove('unavailable');
          } else {
            value.classList.add('disabled');
            if (sameOptionVariants) {
              if (!sameOptionVariants.length) {
                value.classList.add('unavailable');
              }
            }
          }
        }
      }
    }
  
    /* Update history state for product deeplinking */
    _updateHistoryState(variant) {
      if (!history.replaceState || !variant) return;
  
      const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    }
  
    /* Update hidden master select of variant change */
    _updateMasterSelect(variant) {
      if (variant) this._masterSelect.value = variant.id;
    }
  
    /* Fetch product by handle and return it. Fire fetch events */
    async _fetchProduct(handle) {
      this.dispatchEvent(
        new CustomEvent(this._events.fetchBefore, { bubbles: true })
      );
  
      try {
        const res = await fetch(`/products/${handle}.js`);
        const product = await res.json();
  
        this.dispatchEvent(
          new CustomEvent(this._events.fetchAfter, { bubbles: true })
        );
  
        return product;
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent(this._events.fetchError, {
            details: { error },
            bubbles: true,
          })
        );
      }
    }
  
    /** Gets difference from given boolean objects */
    _getDifference(obj1, obj2) {
      const result = {};
      if (!obj1 && !obj2) return result;
      if (!obj1) return obj2;
      if (!obj2) return obj1;
  
      for (const key in obj2) {
        if (obj2[key] !== obj1[key]) {
          result[key] = obj2[key];
        }
      }
  
      return result;
    }

    _removeVariant() {
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      url.search = '';
      window.history.pushState({}, document.title, url.toString());
      this.dispatchEvent(
        new CustomEvent(this._events.change, {
          detail: {
            variant: null,
            priceChange: true
          },
          bubbles: true,
        })
      );
  
      if (this.hasAttribute("data-enable-history-state")) this._updateHistoryState();
      if (this._masterSelect) this._updateMasterSelect();
      this._currentVariant = null;
    }
  
    /* Clean up */
    disconnectedCallback() {
      this._optionSelectors.forEach((selector) =>
        selector.removeEventListener("change", this._handleOptionChange)
      );
    }
  }
  
/**
  * Quantity Input Component
  * --------------------------------------------------------------------------------
  * @summary wrapper for quantity input and it's buttons.
  * @emits change
  * @usage
    <quantity-input class="quantity">
    <button class="quantity__button" name="minus" type="button">
      <span class="sr-only">Decrease quantity for {{ product.title }}</span>
      &minus;
    </button>
    <input class="quantity__input"
        type="number"
        name="quantity"
        id="Quantity-{{ section.id }}"
        min="1"
        value="1"
        form="{{ product_form_id }}"
      >
    <button class="quantity__button" name="plus" type="button">
      <span class="sr-only">Increase quantity for {{ product.title }}</span>
      &plus;
    </button>
  </quantity-input>
*/

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.isDouble = this.hasAttribute('data-double');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const step = this.isDouble ? 2 : 1;

    if (event.currentTarget.name === 'plus') {
      this.input.value = parseInt(this.input.value) + step;
    } else {
      this.input.value = parseInt(this.input.value) - step;
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

/**
 * Loading Spinner Component
 * --------------------------------------------------------------------------------
 * @summary Self-contained scoped loader with style hooks. Container must have 
 * position relative/absolute
 * 
 * @usage <loading-spinner class="bg-black" style="--background: 'inherit';"></loading-spinner
 * 
 * The loader accepts the following style hooks (and their defaults): 
 *  --loading-color (#fff), --background ('inherit'), --bg-opacity (50%), --size (5rem)
 * 
 * For the loader to show, add [loading] attribute to the component.
 */

class LoadingSpinner extends HTMLElement {
  constructor() {
    super();

    const html = `
    <style>
      :host {
        display: none;
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      }

      :host([loading]) {
        display: flex;
      }

      .background {
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        background: var(--background, 'transparent');
        z-index: 1;
      }

      .loading-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: var(--width, 20px);
        height: var(--height, 20px);
        color: var(--color, black);
        z-index: 2;
        animation: loading-spinner 1s linear infinite;
      }

      .loading-spinner svg{
        fill: currentColor;
        width: 100%;
      }

      @keyframes loading-spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    </style>

    <div class="background"></div>
    <div class="loading-spinner">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145 145">
        <path d="M72.5,145C32.6,145,.07,112.54,0,72.64H5c.07,37.14,30.35,67.36,67.5,67.36s67.5-30.28,67.5-67.5S109.72,5,72.5,5V0c39.98,0,72.5,32.52,72.5,72.5s-32.52,72.5-72.5,72.5Z" />
      </svg>
    </div>
    `

    const template = document.createElement('template'); 
    template.innerHTML = html;
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.appendChild(template.content.cloneNode(true))
  }
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[js-predictive-search]');

    this.input.addEventListener('input', theme.utils.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product,collection,article,page&resources[limit]=4&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }
}
class FilterSort extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      container: 'filter-sort',
      form: '[js-filter-form]',
      filter: '[js-filter]',
      clearAll: '[js-clear-all]',
      loader: 'loading-spinner'
    }

    this._events = {
      change: "filter:change"
    }

    this._cache = [];

    this._debouncedOnSubmit = theme.utils.debounce((event) => {
      this._onSubmitHandler(event);
    }, 500);
  }

  connectedCallback() {
    this._scope = this.dataset.scope;
    this._form = this.querySelector(this._selectors.form);
    this._clearAll = this.querySelector(this._selectors.clearAll);
    this._loader = this.querySelector(this._selectors.loader);
    this._setListeners();

    if (!this._scope) {
      throw new Error("filter-sort must have scope set. See file for docs.");
    }
  }

  _setListeners() {
    window.addEventListener('popstate', this._onHistoryChange);
    this._form.addEventListener('input', this._debouncedOnSubmit);
    this._clearAll.addEventListener('click', this._onClearAllHandler);
    document.addEventListener('filter:change', this._onFilterChange);
    document.addEventListener('filter:clearAll', this._onClearAllHandler);
  }

  _renderComponent(parsedHTML) {
    const scopedHTML = parsedHTML.querySelector(`${this._selectors.container}[data-scope="${this._scope}"]`) || parsedHTML.querySelector(this._selectors.container);
    theme.utils.refreshElements([this._selectors.filter], scopedHTML, this);

    this.querySelectorAll('s-accordion').forEach(accordion => {
      accordion.connectedCallback();
    });
  }

  _onSubmitHandler = evt => {
    evt.preventDefault();
    const formData = new FormData(this._form);
    const searchParams = new URLSearchParams(formData).toString();
    this._propagateChange(searchParams);
  }

  _onClearAllHandler = evt => {
    evt.preventDefault();
    const searchParams = '';
    this._propagateChange(searchParams);
  }

  _onFilterChange = evt => {
    const { parsedHTML, scope } = evt.detail;
    // If the scope is the same, it means this instance triggered the change,
    // so no need to re-render. Only update other instances of filter-sort
    if (scope !== this._scope) {
      this._renderComponent(parsedHTML);
    }
  }

  _onHistoryChange = evt => {
    const searchParams = evt.state ? evt.state.searchParams : FilterSort.searchParamsInitial;
    if (searchParams === FilterSort.searchParamsPrev) return;
    this._propagateChange(searchParams, false)
    // change didn't come from submit, so reset field
    this._onSubmitHandlerEvent = null; 
  }

  async _propagateChange(searchParams, updateURLHash = true) {
    this._loader.setAttribute('loading', '');
    const url = `${window.location.pathname}?${searchParams}`
    const filterDataUrl = element => element.url === url;
    const parsedHTML = this._cache.some(filterDataUrl) ? this._markupFromCache(filterDataUrl) : (await this._markupFromFetch(url));
    document.dispatchEvent(new CustomEvent('filter:change', {
      detail: { parsedHTML, scope: this._scope }
    }))
    this._renderComponent(parsedHTML) // re-render myself
    if (updateURLHash){
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);      
    };
    this._loader.removeAttribute('loading', '');
  }

  _markupFromCache(url) {
    const html = this._cache.find(url).html;
    return new DOMParser().parseFromString(html, 'text/html')
  }

  _markupFromFetch(url) {
    let cache = this._cache
    return fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        cache = [...cache, { html, url }];
        return parsedHTML;
      });
  }

}
// Class variables
FilterSort.searchParamsInitial = window.location.search.slice(1);
FilterSort.searchParamsPrev = window.location.search.slice(1);
class ActiveFilters extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      remove: '[js-remove]',
      clearAll: '[js-clear-all]'
    }

    this._refresh = [
      '[js-active-filter]'
    ]
  }

  connectedCallback() {
    document.addEventListener('filter:change', this._handleFilterChange);
    this._setListeners();
  }

  _setListeners() {
    const clearAll = this.querySelector(this._selectors.clearAll);
    if (clearAll) {
      clearAll.addEventListener('click', this._triggerClearAll);
    }
    
    this.querySelectorAll(this._selectors.remove).forEach(remove => remove.addEventListener('click', this._handleRemove))
  } 

  _handleRemove = (evt) => {
    evt.preventDefault();
    const { name, value } = evt.currentTarget.dataset;
    const input = document.querySelector(`filter-sort [name="${name}"][value="${value}"]`);
    if (input) input.click();
  }

  _handleFilterChange = (evt) => {
    const { parsedHTML } = evt.detail;
    const scopedHTML = parsedHTML.querySelector('active-filters')
    this.innerHTML = scopedHTML.innerHTML;
    this._setListeners();
  }

  _triggerClearAll = (evt) => {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    document.dispatchEvent(new CustomEvent('filter:clearAll'))
  }
}
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
class ProductCard extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      toast: 's-toast',
      productJSON: "[js-product-json]",
      relatedColors: '[js-related-colors]',
      variant: '[js-variant]',
      imageContainer: '[js-image-container]',
      productTitle: '[js-product-title]',
      price: '[js-price]',
      badge: '[js-badge]',
      quickAdd: '[js-quick-add]',
      optionSelector: '[js-product-option-selector]'
    };

    this.tooltip = ProductCard.getSharedTooltip();
  }

  static getSharedTooltip() {
    if (!ProductCard.tooltip) {
      ProductCard.tooltip = document.createElement('div');
      ProductCard.tooltip.className = 'product-tooltip fixed z-[9999] pointer-events-none hidden text-small px-xs py-xxs rounded whitespace-nowrap opacity-0 transition-opacity duration-200';
      document.body.appendChild(ProductCard.tooltip);
    }
    return ProductCard.tooltip;
  }

  _updateTooltipTheme() {
    const colorMode = this.dataset.colorMode || 'white';
    if (colorMode === 'black') {
      this.tooltip.classList.add('bg-white', 'text-black');
      this.tooltip.classList.remove('bg-black', 'text-white');
    } else {
      this.tooltip.classList.add('bg-black', 'text-white');
      this.tooltip.classList.remove('bg-white', 'text-black');
    }
  }

  connectedCallback() {
    this.imageContainer = this.querySelector(this._selectors.imageContainer);
    this.productTitle = this.querySelector(this._selectors.productTitle);
    this.price = this.querySelector(this._selectors.price);
    this.badge = this.querySelector(this._selectors.badge);

    this.toast = document.querySelector(this._selectors.toast);
    this.cart = document.querySelector('cart-drawer');
    this.cartDrawer = document.querySelector('#CartDrawer');
    this.quickAdd = this.querySelector(this._selectors.quickAdd);
    this.productJSON = JSON.parse(this.querySelector(this._selectors.productJSON).innerHTML);
    this.originalProduct = this.dataset.id;
    
    this.moneyFormat = `${window.currency.symbol || "$"}{{no_trailing_zeros}}`;
    
    this._initRelatedColors().then(() => {
      this.variants = this.querySelectorAll(this._selectors.variant);
      this.moreColorsButton = this.querySelector('[js-more-colors]');
      this._initListeners();
    });
  }

  disconnectedCallback() {
    if (document.querySelectorAll('product-card').length === 1) {
      ProductCard.tooltip?.remove();
      ProductCard.tooltip = null;
    }
  }

  _initListeners() {
    this.variants?.forEach(variant => {
      variant.addEventListener('click', (e) => {
        this._injectQuickAdd(e);
        this._updateProductCardInfo(e);
        this._updateProductCardImage(e);
      });

      this._initTooltipListeners(variant);
    })

    if (this.moreColorsButton) {
      this._initTooltipListeners(this.moreColorsButton);
    }

    this.addEventListener('variant:change', this._handleVariantChange);
  }

  _initTooltipListeners(variant) {
    variant.addEventListener('mouseenter', (e) => {
      if (window.innerWidth < 768) return;
      
      const swatchName = e.currentTarget.dataset.swatchName;
      this._updateTooltipTheme();
      this.tooltip.textContent = swatchName;
      this.tooltip.style.left = `${e.clientX}px`;
      this.tooltip.style.top = `${e.clientY - 45}px`;
      this.tooltip.style.transform = 'translateX(-50%)';
      this.tooltip.classList.remove('hidden');
      this.tooltip.style.opacity = '1';
    });

    variant.addEventListener('mousemove', (e) => {
      if (window.innerWidth < 768) return;
      this.tooltip.style.left = `${e.clientX}px`;
      this.tooltip.style.top = `${e.clientY - 35}px`;
    });
    
    variant.addEventListener('mouseleave', () => {
      this.tooltip.classList.add('hidden');
      this.tooltip.style.opacity = '0';
    });
  }

  _quickAddToCart = (e) => {
    if (e) {
      e.preventDefault();
    }

    const submitType = this.dataset.submitType;
    let data = {};

    if (submitType == 'prepacked-bundle') {
      data = this._handlePrepackedBundleSubmit();
    } else {
      data = this._handleRegularSubmit();
    }

    const masterSelect = this.quickAdd?.querySelector('select');
    const variantTitle = masterSelect?.options[masterSelect.selectedIndex]?.text?.trim() || '';
    
    const toastProperties = {
      'Product Title': this.productTitle.textContent,
      'Product Image': this.imageContainer.querySelector('img').src,
      'Variant Title': variantTitle,
      'Color': this.dataset.productColor
    };

    // Fetch post add to cart
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then((response) => {
      if (document.querySelector('cart-items')) {
        document.querySelector('cart-items').onCartUpdate();
      }
      this.cart.renderContents(response);
      this._resetQuickAddInputs();
      
      if (window.toast.enableAtc) {
        this.toast.openToast(data, 'in-cart', toastProperties);
      } else {
        this.cartDrawer.open();
      }
    })
    .catch((e) => {
      console.log(e);
    })
  }

  _getSelectedSize() {
    const masterSelect = this.querySelector('[js-master-select]');
    const selectedSize = masterSelect.options[masterSelect.selectedIndex].text;
    return selectedSize;
  }

  _getPrepackedVariants() {
    const prepackedProducts = this.querySelectorAll('[js-prepacked-product]');
    const sizeToMatch = this._getSelectedSize();
    const variants = [];

    prepackedProducts.forEach((product) => {
      const color = product.getAttribute('data-color');
      const prepackedProductJSON = JSON.parse(product.innerHTML);
      const selectedVariants = prepackedProductJSON.variants.filter(variant => 
        variant.title.toLowerCase() === sizeToMatch.toLowerCase()
      );
      variants.push(...selectedVariants.map(variant => ({
        ...variant,
        color
      })));
    });

    return variants;
  }

  _getPrepackedBundleProps(prepackedVariants) {
    const allVariants = prepackedVariants.map(variant => variant.id).join('::');

    const prepackedBundleProps = {
      [`_${this.dataset.productType}`]: true,
      '_isBundleSet': allVariants,
      '_typeBndlSet': this.dataset.productType,
      '_Shipping Option': 'Ecommerce WH',
      '_set_bundle_price': parseInt(this.dataset.productPrice),
      '_set_bundle_prods': this.dataset.productTitle,
      '_pdp_fabric_type': '',
      '_product_parent_id': this.dataset.productId
    }

    return prepackedBundleProps;
  }

  _getPackPrice(packPrice) {
    if (!packPrice.includes('::')) {
      return packPrice;
    }
    return packPrice.split('::');
  }

  _handlePrepackedBundleSubmit() {
    const timestamp = parseInt(Date.now().toString() + Math.floor(Math.random() * 10000));
    const prepackedVariants = this._getPrepackedVariants();
    const prepackedBundleProps = this._getPrepackedBundleProps(prepackedVariants);
    const packPrices = this._getPackPrice(this.dataset.packPrice);
    let quantity = 1;
    
    if (prepackedVariants.length === 1) {
      const prePackedItemCount = this.dataset.prePackedItemCount;
      quantity = prePackedItemCount ? parseInt(prePackedItemCount) : 2;
    }

    const data = {
      items: prepackedVariants.map((variant, index) => {
        return {
          id: variant.id,
          quantity: quantity,
          properties: { 
            [`_${quantity === 2 ? packPrices : packPrices[index]}`]: !0,
            ...prepackedBundleProps,
            '_Color': variant.color,
            '_timeStamp': String(timestamp),
            ...(quantity === 2 ? { '_hasDouble': !0 } : {})
          }
        };
      }),
      sections: this.cart.getSectionsToRender().map((section) => section.id)
    };

    return data;
  }

  _handleRegularSubmit() {
    const selectedVariantId = this.quickAdd.querySelector('select').value;

    let data;

    let properties = {
      '_Shipping Option': 'Ecommerce WH',
      '_Color': this.dataset.productColor
    };
    
    if (this.dataset.upsell) {
      properties = { '_isUpsell': this.dataset.upsell };
    }

    data = {
      items: [{ id: selectedVariantId, quantity: 1, properties }],
      sections: this.cart.getSectionsToRender().map((section) => section.id)
    };

    return data;
  }

  _checkSelectedOptions = (e) => {
    const productJSON = JSON.parse(this.querySelector(this._selectors.productJSON).innerHTML);
    const checkedOptions = this.querySelectorAll(`${this._selectors.optionSelector}:checked`);
    if (checkedOptions.length === productJSON.options.length) {
      this._quickAddToCart(e);
    }
  }

  _resetQuickAddInputs() {
    const checkedOptions = this.querySelectorAll(`${this._selectors.optionSelector}:checked`);
    checkedOptions.forEach(option => {
      option.checked = false;
    });
  }

  _injectQuickAdd = (e) => {
    const data = e.currentTarget;
    const product = data.dataset;
    // Find product JSON by checking which product contains this variant ID
    const productJSON = this.productJSONs.find(json => {
      return json.variants && json.variants.some(v => String(v.id) === String(product.variantId));
    });
    const originalJSON = this.querySelector(this._selectors.productJSON);
    
    if (!productJSON || !this.masterSelects) {
      return;
    }
    
    // Use product ID (from productJSON.id) not variant ID to find master select
    const productMasterSelect = Array.from(this.masterSelects).find(master => master.id == `RelatedColors-${productJSON.id}`);

    this.quickAdd.innerHTML = '';
    this.quickAdd.classList.toggle('hidden', product.available == 'false');
    if (product.available == 'false' || !productJSON || !productMasterSelect) return;

    this.removeEventListener('variant:change', this._handleVariantChange);

    originalJSON.id = `ProductJSON-${ product.variantId }-${this.originalProduct}`;
    originalJSON.innerHTML = JSON.stringify(productJSON);

    let masterOptionsMarkup = productMasterSelect.innerHTML;

    let masterVariantMarkup = `
      <select id="ProductCardMasterSelect-${product.variantId}-${this.originalProduct}" name="id" class="no-js" js-master-select>
        ${masterOptionsMarkup}
      </select>
    `;

    this.quickAdd.insertAdjacentHTML('beforeend', masterVariantMarkup);
    
    if (!productJSON.options || productJSON.options.length === 0 || !product.options || product.options.trim() === '') {
      this.addEventListener('variant:change', this._handleVariantChange);
      this._quickAddToCart();
      return;
    }
    
    const options = product.options.split(",");
    let optionsMarkup = `<product-options class="no-js-hidden flex flex-col gap-sm" data-product-handle='${product.handle}' data-master-select-id="ProductCardMasterSelect-${product.variantId}-${this.originalProduct}"  data-options-size="${productJSON.options.length}">`;

    options.forEach((option, index) => {
      let optionName = option.split('//')[0];
      let optionHandle = option.split('//')[1];

      let valuesKey = `data-values-${index + 1}`;
      let valuesAvailabilityKey = `data-values-${index + 1}-availability`;
      let valuesQtyKey = `data-values-${index + 1}-qty`;
      
      let values = [];
      let valuesAvailability = [];
      let valuesQty = [];
      
      if (data.getAttribute(valuesKey)) {
        values = data.getAttribute(valuesKey).split(',');
      }
      if (data.getAttribute(valuesAvailabilityKey)) {
        valuesAvailability = data.getAttribute(valuesAvailabilityKey).split(',');
      }
      if (data.getAttribute(valuesQtyKey)) {
        valuesQty = data.getAttribute(valuesQtyKey).split(',');
      }

      let valuesMarkup = values.map((value, i) => {
        let valueName = value.split('//')[0];
        let valueHandle = value.split('//')[1];
        let inputId = `swatch-${valueName}-ProductCard-${product.variantId}`
        let radioName = `swatch-${optionHandle}-ProductCard-${product.variantId}`

        return `
          <div class="product-swatch__group relative">
            <input
              id="${inputId}-${this.originalProduct}"
              class="product-swatch__input sr-only"
              type="radio"
              name="${radioName}"
              value="${valueHandle}"
              data-index="option${index + 1}"
              ${valuesAvailability[i] == 'false' ? 'disabled': ''}
              js-product-option-selector>
            <label
              for="${inputId}-${this.originalProduct}"
              class="product-swatch__label">
              ${valueName}
            </label>
          </div>`;
      }).join('');

      optionsMarkup = `${optionsMarkup}
        <div class="product-option">
          <div class="product-option__swatch product-swatch">
            <div class="product-swatch__header">${optionName}</div>
            <div class="product-swatch__container">
              ${valuesMarkup}
            </div>
          </div>
        </div>`;
    });

    optionsMarkup = `${optionsMarkup}</product-options>`

    this.quickAdd.insertAdjacentHTML('beforeend', optionsMarkup);

    this.addEventListener('variant:change', this._handleVariantChange);
  }

  _updateProductCardImage = (e) => {
    const data = e.currentTarget;
    const image = data.dataset.image;
    const hoverImage = data.dataset.hoverImage;
    const newLink = data.dataset.link

    let imageMarkup = `
      <a href="${newLink}" class="product-card__image">
        <img class="" src="${image}">
        ${hoverImage ?
          `<div class="product-card__image-secondary absolute top-0 left-0 w-full h-full">
            <img class="" src="${hoverImage}">
          </div>` : ''}
      </a>`

    this.imageContainer.innerHTML = imageMarkup;
  }

  _updateProductCardInfo = (e) => {
    const data = e.currentTarget;
    const title = data.getAttribute('aria-label');
    const newLink = data.dataset.link;
    const color = data.dataset.swatchName;

    const price = data.dataset.price;
    const compareAtPrice = data.dataset.compareAtPrice;
    const salePrice = data.dataset.salePrice;
    const vipMemberPrice = data.dataset.vipMemberPrice;
    const variantId = data.dataset.variantId;
    const badge = data.dataset.badge;

    let showVipMemberPrice = false;
    let priceMarkup = '';

    if (window.customer?.activeSubscriber && vipMemberPrice && Number(vipMemberPrice) < Number(price)) {
      showVipMemberPrice = true;
    }

    // Update which swatch is "active"
    this.variants.forEach(variant => {
      variant.setAttribute('aria-current', e.currentTarget === variant);
    });

    // Update title link + "view more colors" link
    this.productTitle.href = newLink;
    this.productTitle.innerHTML = title;
    if (this.moreColorsButton) {
      this.moreColorsButton.href = newLink;
    }

    // Update color in hidden input + data attr for ATC props
    const colorLip = this.querySelector('input[name="properties[_Color]"]');
    if (colorLip) colorLip.value = color;
    this.dataset.productColor = color;

    if (compareAtPrice && Number(compareAtPrice) > Number(price)) {
      priceMarkup = `
        <s class="product__price--compare text-gray-dark" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(compareAtPrice, this.moneyFormat)}
        </s>
        <span class="product__price" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(price, this.moneyFormat)}
        </span>
      `;
    } else if (salePrice) {
      priceMarkup = `
        <s class="product__price--sale text-gray-dark" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(price, this.moneyFormat)}
        </s>
        <span class="product__price" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(salePrice, this.moneyFormat)}
        </span>
      `;
    } else if (showVipMemberPrice) {
      priceMarkup = `
        <s class="product__price--vip text-gray-dark" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(price, this.moneyFormat)}
        </s>
        <span class="product__price" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(vipMemberPrice, this.moneyFormat)}
        </span>
      `;
    } else {
      priceMarkup = `
        <span class="product__price" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(price, this.moneyFormat)}
        </span>
      `;
    }

    this.price.innerHTML = priceMarkup;

    // Badge state
    const productJSONForBadge = this.productJSONs.find(json => {
      return json.variants && json.variants.some(v => String(v.id) === String(variantId));
    });

    let badgeMarkup = '';
    let hasAnyBadges = false;
    let promoHighlight = this.badge.dataset.promoHighlight;

    if (promoHighlight != null) {
      const promoHighlightTextColor = this.badge.dataset.promoHighlightTextColor;
      const promoHighlightBgColor = this.badge.dataset.promoHighlightBgColor;
      badgeMarkup += `<li class="product-card__badge text-[#1F1F1F] leading-none whitespace-nowrap p-xs w-fit capitalize text-10 tabletl:text-14" style="color: ${promoHighlightTextColor}; background-color: ${promoHighlightBgColor}">${promoHighlight.toLowerCase()}</li>`;
      hasAnyBadges = true;
    }

    if (badge && badge !== '') {
      badgeMarkup += `<li class="product-card__badge text-[#1F1F1F] leading-none whitespace-nowrap p-xs w-fit capitalize text-10 tabletl:text-14 bg-white">${badge}</li>`;
      hasAnyBadges = true;
    }

    this.badge.innerHTML = badgeMarkup;
    this.badge.classList.toggle('hidden', !hasAnyBadges);
    this.badge.classList.toggle('hide-on-hover', data.available == 'true');
  }


  async _initRelatedColors() {
    this.relatedColorsContainer = this.querySelector(this._selectors.relatedColors);
  
    if (!this.relatedColorsContainer || this.relatedColorsContainer.length < 1) {
      return;
    }
  
    const currentProductHandle = this.relatedColorsContainer.getAttribute('data-handle');
    const relatedColorsCollection = this.relatedColorsContainer.getAttribute('data-collection');
    const relatedColorsTag = this.relatedColorsContainer.getAttribute('data-tag');
  
    const targetURL = `/collections/${relatedColorsCollection}/${relatedColorsTag}/?view=json`;
    const { collectionJSON: relatedColorsJSON, productJSONs, masterSelects } = await this._getRelatedColorJSON(targetURL);
  
    this.productJSONs = productJSONs;
    this.masterSelects = masterSelects;
  
    let relatedColorsMarkup = '';
  
    if (relatedColorsJSON.length <= 1) {
      this.relatedColorsContainer.remove();
      return;
    }
  
    const maxVariants = window.productCard.relatedColorsMaxVariants || 6;
    const currentProductIndex = relatedColorsJSON.findIndex(product => product.handle === currentProductHandle);
    
    let variantsToShow;
    let hasMoreVariants;
    
    if (currentProductIndex === -1) {
      variantsToShow = relatedColorsJSON.slice(0, maxVariants);
      hasMoreVariants = relatedColorsJSON.length > maxVariants;
    } else {
      if (currentProductIndex < maxVariants) {
        variantsToShow = relatedColorsJSON.slice(0, maxVariants);
        hasMoreVariants = relatedColorsJSON.length > maxVariants;
      } else {
        const startIndex = Math.max(0, currentProductIndex - maxVariants + 1);
        variantsToShow = relatedColorsJSON.slice(startIndex, currentProductIndex + 1);
        hasMoreVariants = startIndex > 0 || currentProductIndex < relatedColorsJSON.length - 1;
      }
    }
  
    variantsToShow.forEach((product) => {
      const matchingJSON = productJSONs.find(p => String(p.id) === String(product.id));
      let firstAvailableVariantId = '';
  
      if (matchingJSON && matchingJSON.variants && matchingJSON.variants.length) {
        const firstAvail =
          matchingJSON.variants.find(v => v.available) || matchingJSON.variants[0];
        if (firstAvail) {
          firstAvailableVariantId = firstAvail.id;
        }
      }
  
      relatedColorsMarkup = `${relatedColorsMarkup}
        <div class="product-card__variant-wrapper leading-none">
          <button
            class="product-card__variant relative tooltip-container min-w-[16px] min-h-[16px] max-w-[16px] max-h-[16px] overflow-hidden"
            aria-current="${product.handle == currentProductHandle}"
            aria-label="${product.title}"
            data-handle="${product.handle}"
            data-link="${product.url}"
            data-variant-id="${firstAvailableVariantId}"
            data-available="${product.available}"
            data-price="${product.price}"
            ${product.compareAtPrice ? `data-compare-at-price="${product.compareAtPrice}"` : ''}
            ${product.salePrice ? `data-sale-price="${product.salePrice}"` : ''}
            ${product.vipMemberPrice ? `data-vip-member-price="${product.vipMemberPrice}"` : ''}
            data-has-only-default="${product.hasOnlyDefaultVariant}"
            data-options="${product.options}"
            data-values-1="${product.values_1}"
            data-values-1-availability="${product.values_1_availability}"
            data-values-1-qty="${product.values_1_qty}"
            data-swatch-name="${product.swatch_name}"
            ${product.values_2 ? `data-values-2="${product.values_2}" data-values-2-availability="${product.values_2_availability}"` : ''}
            ${product.values_3 ? `data-values-3="${product.values_3}" data-values-3-availability="${product.values_3_availability}"` : ''}
            data-badge="${product.badge}"
            data-image="${product.featured_image}"
            ${product.hover_image ? `data-hover-image="${product.hover_image}"` : ''}
            js-variant>
            <img
              class="min-w-[32px] min-h-[32px] max-w-[32px] max-h-[32px] object-none overflow-hidden"
              src="${product.swatch}"
              alt="${product.title}"
              ${product.swatch_border ? `style="border: 1px solid ${product.swatch_border}"` : ''}>
          </button>
        </div>`;
    });
  
    if (hasMoreVariants) {
      const remainingCount = relatedColorsJSON.length - variantsToShow.length;
      relatedColorsMarkup = `${relatedColorsMarkup}
        <a
          href="${this.productTitle.href}"
          class="product-card__variant product-card__variant--more relative flex justify-center items-center min-w-[16px] min-h-[16px] max-w-[16px] max-h-[16px] text-10 tabletl:text-12"
          aria-label="View ${remainingCount} more color${remainingCount > 1 ? 's' : ''}"
          data-swatch-name="View More"
          js-more-colors
        >
          <span class="leading-none text-[#7E7E7E]">+${remainingCount}</span>
        </a>`;
    }
  
    this.relatedColorsContainer.innerHTML = relatedColorsMarkup;
    this.relatedColorsContainer.classList.remove('hidden');
  }
  

  _getRelatedColorJSON(url) {
    return fetch(url)
      .then(response => response.text())
      .then((text) => {
        const html = text;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
        const collectionJSON = JSON.parse(JSONcontainer.innerHTML);

        const productJSONElements = parsedHTML.querySelectorAll('[js-product-json]');
        const productJSONs = Array.from(productJSONElements).map(el => JSON.parse(el.innerHTML));
  
        const masterSelects = parsedHTML.querySelectorAll('select[js-master-select]');

        return { collectionJSON, productJSONs, masterSelects };
      })
  }

  _handleVariantChange = (evt) => {
    const { variant } = evt.detail;
    this._checkSelectedOptions();
  
    if (variant) {
      
      const activeSwatch = this.querySelector('[js-variant][aria-current="true"]');
      const setType = this.getAttribute('data-product-type');
      const salePrice = setType ? this.getAttribute('data-sale-price') : activeSwatch?.getAttribute('data-sale-price');
      const vipMemberPrice = activeSwatch?.getAttribute('data-vip-member-price');

      this._updateCardPriceFromVariant(variant, salePrice, vipMemberPrice);
    }
  };
  
  _updateCardPriceFromVariant(variant, salePrice, vipMemberPrice) {
    const variantId = variant.id;
    const price = variant.price;
    let priceMarkup = '';
    
    let showVipMemberPrice = false;
    if (window.customer?.activeSubscriber && vipMemberPrice && Number(vipMemberPrice) < Number(price)) {
      showVipMemberPrice = true;
    }
    
    if (variant.compare_at_price && Number(variant.compare_at_price) > Number(price)) {
      priceMarkup = `
        <s class="product__price--compare text-gray-dark" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(variant.compare_at_price, this.moneyFormat)}
        </s>
        <span class="product__price" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(price, this.moneyFormat)}
        </span>
      `;
    } else if (salePrice) {
      priceMarkup = `
        <s class="product__price--sale text-gray-dark" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(price, this.moneyFormat)}
        </s>
        <span class="product__price" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(salePrice, this.moneyFormat)}
        </span>
      `;
    } else if (showVipMemberPrice) {
      priceMarkup = `
        <s class="product__price--vip text-gray-dark" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(price, this.moneyFormat)}
        </s>
        <span class="product__price" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(vipMemberPrice, this.moneyFormat)}
        </span>
      `;
    } else {
      priceMarkup = `
        <span class="product__price" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(price, this.moneyFormat)}
        </span>
      `;
    }
  
    this.price.innerHTML = priceMarkup;
  }
}
class ProductCardUpsell extends HTMLElement {
    constructor() {
      super();
  
      this._selectors = {
        productJSON: "[js-product-json]",
        relatedColors: '[js-related-colors]',
        variant: '[js-variant]',
        imageContainer: '[js-image-container]',
        productTitle: '[js-product-title]',
        price: '[js-price]',
        badge: '[js-badge]',
        quickAdd: '[js-quick-add]',
        quickAddAtc: '[js-quick-atc]',
        optionSelector: '[js-product-option-selector]'
      };
  
      this.tooltip = ProductCard.getSharedTooltip();
    }
  
    static getSharedTooltip() {
      if (!ProductCard.tooltip) {
        ProductCard.tooltip = document.createElement('div');
        ProductCard.tooltip.className = 'product-tooltip fixed z-[9999] pointer-events-none hidden text-small px-xs py-xxs rounded whitespace-nowrap opacity-0 transition-opacity duration-200';
        document.body.appendChild(ProductCard.tooltip);
      }
      return ProductCard.tooltip;
    }
  
    _updateTooltipTheme() {
      const colorMode = this.dataset.colorMode || 'white';
      if (colorMode === 'black') {
        this.tooltip.classList.add('bg-white', 'text-black');
        this.tooltip.classList.remove('bg-black', 'text-white');
      } else {
        this.tooltip.classList.add('bg-black', 'text-white');
        this.tooltip.classList.remove('bg-white', 'text-black');
      }
    }
  
    connectedCallback() {
      this.imageContainer = this.querySelector(this._selectors.imageContainer);
      this.productTitle = this.querySelector(this._selectors.productTitle);
      this.price = this.querySelector(this._selectors.price);
      this.badge = this.querySelector(this._selectors.badge);
  
      this.cart = document.querySelector('cart-drawer');
      this.cartDrawer = document.querySelector('#CartDrawer');
      this.quickAdd = this.querySelector(this._selectors.quickAdd);
      this.quickAddAtc = this.querySelector(this._selectors.quickAddAtc);
      this.productJSON = JSON.parse(this.querySelector(this._selectors.productJSON).innerHTML);
      this.originalProduct = this.dataset.id;
  
      this.moneyFormat = `${window.currency.symbol || "$"}{{no_trailing_zeros}}`;
      
      this._initRelatedColors().then(() => {
        this.variants = this.querySelectorAll(this._selectors.variant);
        this._initListeners();
      });
    }
  
    disconnectedCallback() {
      if (document.querySelectorAll('product-card').length === 1) {
        ProductCard.tooltip?.remove();
        ProductCard.tooltip = null;
      }
    }
  
    _initListeners() {
      this.variants?.forEach(variant => {
        variant.addEventListener('click', (e) => {
          this._injectQuickAdd(e);
          this._updateProductCardInfo(e);
          this._updateProductCardImage(e);
        });
        
        variant.addEventListener('mouseenter', (e) => {
          if (window.innerWidth < 768) return;
          
          const swatchName = e.currentTarget.dataset.swatchName;
          this._updateTooltipTheme();
          this.tooltip.textContent = swatchName;
          this.tooltip.style.left = `${e.clientX}px`;
          this.tooltip.style.top = `${e.clientY - 45}px`;
          this.tooltip.style.transform = 'translateX(-50%)';
          this.tooltip.classList.remove('hidden');
          this.tooltip.style.opacity = '1';
        });
  
        variant.addEventListener('mousemove', (e) => {
          if (window.innerWidth < 768) return;
          this.tooltip.style.left = `${e.clientX}px`;
          this.tooltip.style.top = `${e.clientY - 35}px`;
        });
        
        variant.addEventListener('mouseleave', () => {
          this.tooltip.classList.add('hidden');
          this.tooltip.style.opacity = '0';
        });
      })
  
      this.addEventListener('variant:change', this._checkSelectedOptions);
  
      this.quickAddAtc?.addEventListener('click', this._quickAddToCart);
    }
  
    _quickAddToCart = (e) => {
      e.preventDefault();
      const selectedVariantId = this.quickAdd.querySelector('select').value;
  
      // Create fetch data
      let data
      if (this.dataset.upsell) {
       data = {
        items: [{
          id: selectedVariantId,
          quantity: 1,
          properties: {
            '_isUpsell': this.dataset.upsell
          }
        }],
        sections: this.cart.getSectionsToRender().map((section) => section.id)
      };
    } else {
      data = {
        items: [{
          id: selectedVariantId,
          quantity: 1
        }],
        sections: this.cart.getSectionsToRender().map((section) => section.id)
      };
    }
  
      // Fetch post add to cart
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then((response) => response.json())
      .then((response) => {
        if (document.querySelector('cart-items')) {
          document.querySelector('cart-items').onCartUpdate();
        }
        this.cart.renderContents(response);
        
        if (this.cartDrawer.getAttribute('aria-hidden') == 'true') {
          this.cartDrawer.open();
        }
      })
      .catch((e) => {
        console.log(e);
      })
    }
  
    _checkSelectedOptions = (e) => {
      const productJSON = JSON.parse(this.querySelector(this._selectors.productJSON).innerHTML);
      const checkedOptions = this.querySelectorAll(`${this._selectors.optionSelector}:checked`);
      const quickAddAtc = this.querySelector(this._selectors.quickAddAtc);
      if (checkedOptions.length === productJSON.options.length) {
        quickAddAtc.removeAttribute('disabled');
        quickAddAtc.classList.remove('has-variants');
        quickAddAtc.textContent = 'Quick Add+'
      }
    }
  
    _injectQuickAdd = (e) => {
      const data = e.currentTarget;
      const product = data.dataset;

      this.currentSalePrice = product.salePrice || null;
      this.currentVipMemberPrice = product.vipMemberPrice || null;

      const productJSON = this.productJSONs.find(json => json.id == product.variantId);
      const originalJSON = this.querySelector(this._selectors.productJSON);
      const productMasterSelect = Array.from(this.masterSelects).find(master => master.id == `RelatedColors-${product.variantId}`);
  
      this.quickAdd.innerHTML = '';
      this.quickAdd.classList.toggle('hidden', product.available == 'false');
      if (product.available == 'false' || !productJSON) return;
  
      this.removeEventListener('variant:change', this._checkSelectedOptions);
      this.quickAddAtc?.removeEventListener('click', this._quickAddToCart);
  
      originalJSON.id = `ProductJSON-${ product.variantId }-${this.originalProduct}`;
      originalJSON.innerHTML = JSON.stringify(productJSON);
  
      let masterOptionsMarkup = productMasterSelect.innerHTML;
  
      let masterVariantMarkup = `
        <select id="ProductCardMasterSelect-${product.variantId}-${this.originalProduct}" name="id" class="visible upsell-variant-select">
          ${masterOptionsMarkup}
        </select>
      `;
  
      this.quickAdd.insertAdjacentHTML('beforeend', masterVariantMarkup);
      
      const options = product.options.split(",");
      let optionsMarkup = `<product-options class="no-js-hidden flex flex-col gap-sm" data-product-handle='${product.handle}' data-master-select-id="ProductCardMasterSelect-${product.variantId}-${this.originalProduct}"  data-options-size="${productJSON.options.length}">`;
  
      options.forEach((option, index) => {
        let optionName = option.split('//')[0];
        let optionHandle = option.split('//')[1];
  
        let valuesKey = `data-values-${index + 1}`;
        let valuesAvailabilityKey = `data-values-${index + 1}-availability`;
        let valuesQtyKey = `data-values-${index + 1}-qty`;
        
        let values = [];
        let valuesAvailability = [];
        let valuesQty = [];
        
        if (data.getAttribute(valuesKey)) {
          values = data.getAttribute(valuesKey).split(',');
        }
        if (data.getAttribute(valuesAvailabilityKey)) {
          valuesAvailability = data.getAttribute(valuesAvailabilityKey).split(',');
        }
        if (data.getAttribute(valuesQtyKey)) {
          valuesQty = data.getAttribute(valuesQtyKey).split(',');
        }
  
        let valuesMarkup = values.map((value, i) => {
          let valueName = value.split('//')[0];
          let valueHandle = value.split('//')[1];
          let inputId = `swatch-${valueName}-ProductCard-${product.variantId}`
          let radioName = `swatch-${optionHandle}-ProductCard-${product.variantId}`
  
          return `
            <div class="product-swatch__group relative">
              <input
                id="${inputId}-${this.originalProduct}"
                class="product-swatch__input sr-only"
                type="radio"
                name="${radioName}"
                value="${valueHandle}"
                data-index="option${index + 1}"
                ${Number(valuesQty[i]) < window.minimumStock ? 'disabled': ''}
                js-product-option-selector>
              <label
                for="${inputId}-${this.originalProduct}"
                class="product-swatch__label">
                ${valueName}
              </label>
            </div>`;
        }).join('');
  
        optionsMarkup = `${optionsMarkup}
          <div class="product-option">
            <div class="product-option__swatch product-swatch">
              <div class="product-swatch__header">${optionName}</div>
              <div class="product-swatch__container">
                ${valuesMarkup}
              </div>
            </div>
          </div>`;
      });
  
      optionsMarkup = `${optionsMarkup}</product-options>`
  
    //   this.quickAdd.insertAdjacentHTML('beforeend', optionsMarkup);
  
      let atcMarkup = `
        <button class="product-quick-add__atc btn uppercase ${product.hasOnlyDefault == 'false' ? 'has-variants transition-colors' : ''}" js-quick-atc>
          ${product.hasOnlyDefault == 'false' ? 'Select Size' : 'Quick Add+'}
        </button>`;
  
      this.quickAdd.insertAdjacentHTML('beforeend', atcMarkup);
      this.quickAddAtc = this.querySelector(this._selectors.quickAddAtc);
  
      // Reinit event listeners
      this.addEventListener('variant:change', this._checkSelectedOptions); 
      this.quickAddAtc?.addEventListener('click', this._quickAddToCart);
    }
  
    _updateProductCardImage = (e) => {
      const data = e.currentTarget;
      const image = data.dataset.image;
      const hoverImage = data.dataset.hoverImage;
      const newLink = data.dataset.link
  
      let imageMarkup = `
        <a href="${newLink}" class="product-card__image">
          <img class="" src="${image}">
          ${hoverImage ?
            `<div class="product-card__image-secondary absolute top-0 left-0 w-full h-full">
              <img class="" src="${hoverImage}">
            </div>` : ''}
        </a>`
  
      this.imageContainer.innerHTML = imageMarkup;
    }
  
    _updateProductCardInfo = (e) => {
      const data = e.currentTarget;
      const title = data.getAttribute('aria-label');
      const newLink = data.dataset.link;
      const price = data.dataset.price;
      const compareAtPrice = data.dataset.compareAtPrice;
      const badge = data.dataset.badge;
      
      const salePrice = data.dataset.salePrice;
      const vipMemberPrice = data.dataset.vipMemberPrice;
      
      // Store these for later use
      this.currentSalePrice = salePrice || null;
      this.currentVipMemberPrice = vipMemberPrice || null;
      
  
      let priceMarkup = '';
  
      this.variants.forEach(variant => {
        variant.setAttribute('aria-current', e.currentTarget === variant);
      })
  
      this.productTitle.href = newLink;
      this.productTitle.innerHTML = title;
  
      if (compareAtPrice && compareAtPrice > price) {
        priceMarkup = `<s class="price__compare text-gray">${theme.utils.formatMoney(compareAtPrice, this.moneyFormat)}</s><span class="price__regular">${theme.utils.formatMoney(price, this.moneyFormat)}</span>`;
      } else {
        priceMarkup = `<span class="price__regular">${theme.utils.formatMoney(price, this.moneyFormat)}</span>`;
      }
  
      this.price.innerHTML = priceMarkup;
  
      this.badge.classList.toggle('hidden', badge == '');
      this.badge.classList.toggle('hide-on-hover', data.dataset.available == 'true');
      this.badge.innerHTML = badge;
    }
  
    async _initRelatedColors() {
      this.relatedColorsContainer = this.querySelector(this._selectors.relatedColors);
  
      if (!this.relatedColorsContainer || this.relatedColorsContainer.length < 1) return;
  
      const currentProductHandle = this.relatedColorsContainer.getAttribute('data-handle');
      const relatedColorsCollection = this.relatedColorsContainer.getAttribute('data-collection');
      const relatedColorsTag = this.relatedColorsContainer.getAttribute('data-tag');
  
      const targetURL = `/collections/${relatedColorsCollection}/${relatedColorsTag}/?view=json`;
      const { collectionJSON: relatedColorsJSON, productJSONs, masterSelects } = await this._getRelatedColorJSON(targetURL);
  
      this.productJSONs = productJSONs;
      this.masterSelects = masterSelects;
  
      let relatedColorsMarkup = '';
  
      if (relatedColorsJSON.length <= 1) return;
  
      relatedColorsJSON.forEach((product, index) => {
        relatedColorsMarkup = `${relatedColorsMarkup}
          <div class="swiper-slide relative" js-carousel-slide>
            <div class="product-card__variant-wrapper">
              <button
                class="product-card__variant relative tooltip-container"
                aria-current="${product.handle == currentProductHandle}"
                aria-label="${product.title}"
                data-handle="${product.handle}"
                data-link="${product.url}"
                data-variant-id="${product.id}"
                data-available="${product.available}"
                data-price="${product.price}"
                data-has-only-default="${product.hasOnlyDefaultVariant}"
                data-options="${product.options}"
                data-values-1="${product.values_1}"
                data-values-1-availability="${product.values_1_availability}"
                data-values-1-qty="${product.values_1_qty}"
                data-swatch-name="${product.swatch_name}"
                ${product.values_2 ? `data-values-2="${product.values_2}" data-values-2-availability="${product.values_2_availability}"` : ''}
                ${product.values_3 ? `data-values-3="${product.values_3}" data-values-3-availability="${product.values_3_availability}"` : ''}
                ${product.compareAtPrice ? `data-compare-at-price="${product.compareAtPrice}"` : ''}
                data-badge="${product.badge}"
                data-image="${product.featured_image}"
                ${product.hover_image ? `data-hover-image="${product.hover_image}"` : ''}
                js-variant>
                <img class="min-w-[16px] min-h-[16px] max-w-[16px] max-h-[16px] bg-gray rounded-full overflow-hidden" src="${product.swatch}" alt="${product.title}" ${product.swatch_border ? `style="border: 1px solid ${product.swatch_border}"` : ''}>
              </button>
            </div>
          </div>`;
      });
  
      this.relatedColorsContainer.innerHTML = relatedColorsMarkup;
      this.relatedColorsContainer.classList.remove('hidden');
    }
  
    _getRelatedColorJSON(url) {
      return fetch(url)
        .then(response => response.text())
        .then((text) => {
          const html = text;
          const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  
          const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
          const collectionJSON = JSON.parse(JSONcontainer.innerHTML);
  
          const productJSONElements = parsedHTML.querySelectorAll('[js-product-json]');
          const productJSONs = Array.from(productJSONElements).map(el => JSON.parse(el.innerHTML));
    
          const masterSelects = parsedHTML.querySelectorAll('select[js-master-select]');
  
          return { collectionJSON, productJSONs, masterSelects };
        })
    }
  }
class ProductBundler extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      product: 'bundle-card',
      addToCart: '[js-bundle-atc]',
      toast: 's-toast',
      loader: "loading-spinner",
      bundledProducts: '[js-bundled-products]',
      selectorModule: '[js-selector-module]',
      cardSlide: '[js-card-slide]',
      moduleTrigger: '[js-module-trigger]',
      closeModule: '[js-close-module]',
      imageCarousel: '[js-image-carousel]',
      infoCarousel: '[js-info-carousel]',
      masterSelect: 'select[js-master-select]',
      productOptions: 'product-options'
    }

    this._isSyncing = false;
  }

  connectedCallback() {
    this.parentProduct = this.closest('s-product');
    this.cart = document.querySelector('cart-drawer');
    this.cartDrawer = document.querySelector('#CartDrawer');
    this.toast = document.querySelector(this._selectors.toast);
    this.button = this.querySelector(this._selectors.addToCart);
    this.bundledProducts = this.querySelector(this._selectors.bundledProducts);
    this.products = this.bundledProducts.querySelectorAll(this._selectors.product);
    this.selectorModule = this.querySelector(this._selectors.selectorModule);
    this.cardSlides = this.querySelectorAll(this._selectors.cardSlide);
    this.moduleTrigger = this.querySelector(this._selectors.moduleTrigger);
    this.closeModule = this.querySelector(this._selectors.closeModule);
    this.imageCarousel = this.querySelector(this._selectors.imageCarousel);
    this.infoCarousel = this.querySelector(this._selectors.infoCarousel);

    this.bundleType = this.dataset.bundleType;
    this.bundleDiscount = this.dataset.bundleDiscount;

    const mainMasterSelect = this.parentProduct.dataset.masterSelectId;
    this.singleProductOptions = this.parentProduct.querySelector(`${this._selectors.productOptions}[data-master-select-id="${mainMasterSelect}"]`);
    
    this._connectCarousels();
    this._setListeners();
    this._toggleModuleCloseButton();
  }

  _setListeners() {
    this.button.addEventListener('click', this._addToCart.bind(this));

    this.moduleTrigger.addEventListener('click', this._handleModuleAction);

    this.closeModule.addEventListener('click', this._closeModule);

    // Listen to variant changes from main product
    if (this.singleProductOptions) {
      this.singleProductOptions.addEventListener('variant:change', (e) => this._handleVariantSync(e, 'single'));
    }
  }

  _syncSelectedSwatch() {
    const mainProduct = this.bundledProducts.children[0];
    const moduleProducts = this.selectorModule.querySelectorAll('bundle-card');
    const selectedSwatch = mainProduct.querySelector('[js-related-colors-current]');
    const swatchName = selectedSwatch?.getAttribute('aria-label');
    
    if (!selectedSwatch || !swatchName) return;
    
    moduleProducts.forEach((product) => {
      const swatches = product.querySelectorAll('[js-variant]');
      swatches.forEach((swatch) => {
        if (swatch.getAttribute('aria-label') === swatchName) {
          swatch.click();
        }
      })
    })

    this._updateActiveSlide(swatchName);
  }

  _updateActiveSlide(swatchName) {
    const imageSwiper = this.imageCarousel.swiper;
    const params = imageSwiper.params;
    const slides = this.imageCarousel.querySelectorAll('[js-carousel-slide]');

    imageSwiper.destroy();

    slides.forEach((slide) => {
      if (slide.dataset.swatchName == swatchName) {
        this.imageCarousel.querySelector('.swiper-wrapper').prepend(slide);
      }
    });

    const newImageSwiper = new Swiper(this.imageCarousel, params);
    newImageSwiper.on('activeIndexChange', () => {
      const activeSlide = newImageSwiper.slides[newImageSwiper.activeIndex];
      const productId = activeSlide.querySelector('[data-product-id]').getAttribute('data-product-id');
      this.cardSlides.forEach((card) => {
        card.classList.add('hidden');
        card.setAttribute('aria-hidden', 'true');
        if (card.getAttribute('data-product-id') === productId) {
          card.classList.remove('hidden');
          card.setAttribute('aria-hidden', 'false');
          const colorLabel = card.querySelector('bundle-card').querySelector('[js-color-label]');
          colorLabel.innerHTML = card.querySelector('bundle-card').dataset.productColor;
        }
      })
    });
  }

  _handleVariantSync(e, source) {
    const { variant } = e.detail;
    if (!variant) return;

    // Prevent infinite loop by checking if we're already syncing
    if (this._isSyncing) return;

    this._isSyncing = true;

    // Get all bundler components on the page
    const allBundlers = document.querySelectorAll('product-bundler');
    
    // Get the source options and master select
    const sourceOptions = source === 'single' 
      ? this.singleProductOptions.querySelectorAll('[js-product-option-selector]')
      : e.target.querySelectorAll('[js-product-option-selector]');
    
    const sourceMasterSelect = source === 'single'
      ? this.singleProductOptions.querySelector(this._selectors.masterSelect)
      : e.target.querySelector(this._selectors.masterSelect);

    // Sync to all other bundler components' first bundle cards
    allBundlers.forEach(bundler => {
      if (bundler === this) return;

      const firstBundleCard = bundler.querySelector('bundle-card[data-in-bundle]');
      if (!firstBundleCard) return;

      const targetOptions = firstBundleCard.querySelector(this._selectors.productOptions);
      if (!targetOptions) return;

      const targetMasterSelect = targetOptions.querySelector(this._selectors.masterSelect);
      const targetOptionSelectors = targetOptions.querySelectorAll('[js-product-option-selector]');

      // Sync master select
      if (sourceMasterSelect && targetMasterSelect) {
        targetMasterSelect.value = sourceMasterSelect.value;
        targetMasterSelect.dispatchEvent(new Event('change'));
      }

      // Sync option selectors
      sourceOptions.forEach((sourceOption, index) => {
        const targetOption = targetOptionSelectors[index];
        if (!targetOption) return;

        if (sourceOption.type === 'radio') {
          if (sourceOption.checked) {
            targetOption.checked = true;
            targetOption.dispatchEvent(new Event('change'));
          }
        } else {
          targetOption.value = sourceOption.value;
          targetOption.dispatchEvent(new Event('change'));
        }
      });
    });

    this._isSyncing = false;
  }

  _connectCarousels() {
    const imageSwiper = this.imageCarousel.swiper;

    imageSwiper.on('activeIndexChange', () => {
      const activeSlide = imageSwiper.slides[imageSwiper.activeIndex];
      const productId = activeSlide.querySelector('[data-product-id]').getAttribute('data-product-id');

      this.cardSlides.forEach((card) => {
        card.classList.add('hidden');
        card.setAttribute('aria-hidden', 'true');
        if (card.getAttribute('data-product-id') === productId) {
          card.classList.remove('hidden');
          card.setAttribute('aria-hidden', 'false');
          const colorLabel = card.querySelector('bundle-card').querySelector('[js-color-label]');
          colorLabel.innerHTML = card.querySelector('bundle-card').dataset.productColor;
        }
      })
    });
  }

  _includeModuleProduct() {
    const activeSlide = Array.from(this.cardSlides).find(slide => slide.getAttribute('aria-hidden') === 'false');
    const bundleCard = activeSlide?.querySelector('bundle-card');
    if (!bundleCard) return;

    return bundleCard.handleBundleAdd();
  }

  _checkAllOptionsSelected() {
    this.products = Array.from(this.bundledProducts.querySelectorAll(this._selectors.product));
    const allOptionsSelected = !Array.from(this.products).some((product) => !product._checkSelectedOptions());
    return allOptionsSelected;
  }

  _addToCart() {
    const allOptionsSelected = this._checkAllOptionsSelected();
    if (!allOptionsSelected) {
      this.toast.openToast('Please select sizes before adding to cart.', 'notification');
      return;
    }

    // Add selected product to bundle if selector module is open
    // Returns new bundle-card element or undefined, updates this.products
    let addedProduct;
    if (this.selectorModule.getAttribute('aria-hidden') === 'false') {
      addedProduct = this._includeModuleProduct();
      if (!addedProduct) return;
      addedProduct.classList.add('hidden');
      this.products = Array.from(this.bundledProducts.querySelectorAll(this._selectors.product));
    }

    this._disableButtons();

    // Create bundle properties
    const timestamp = parseInt(Date.now().toString() + Math.floor(Math.random() * 10000));
    const bundleData = {
      bundleId: this.dataset.bundleId,
      bundleTitle: this.dataset.bundleTitle,
      bundleImage: this.dataset.bundleImage,
      bundleDiscount: this.dataset.bundleDiscount
    };

    const properties = {
      '_parentProduct': bundleData.bundleId,
      '_title': bundleData.bundleTitle,
      '_image': bundleData.bundleImage,
      '_timeStamp': String(timestamp),
      '_bundleDiscount': bundleData.bundleDiscount,
      '_Shipping Option': 'Ecommerce WH'
    };

    // Create fetch data
    const data = {
      items: this.products.map((product) => ({
        id: product.querySelector('select[js-master-select]')?.value,
        quantity: 1,
        properties: {...properties,
          '_title_product': product.dataset.productTitle,
          '_image_product': product.dataset.productImage,
          '_color_product': product.dataset.productColor,
          '_option_product': product.dataset.productOption,
          '_original_price': product.dataset.productPrice
        }
      })),
      sections: this.cart.getSectionsToRender().map((section) => section.id)
    };

    // Fetch post add to cart
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then((response) => {
      this.error = false;

      if (response.status) {
        this.error = true;
        this.handleErrorMessage(response);
        if (this.cartDrawer.getAttribute('aria-hidden') == 'true') {
          this.cartDrawer.open();
        }
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (this.error == false) {
        if (document.querySelector('cart-items')) {
          document.querySelector('cart-items').onCartUpdate();
        }
        this.handleErrorMessage();
        this.cart.renderContents(response);
        
        if (window.toast.enableAtc) {
          this.toast.openToast(data, 'in-cart-bundle', properties);
        } else {
          this.cartDrawer.open();
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if (addedProduct) {
        addedProduct.remove();
      }
      this._enableButtons();
    });
  }

  handleErrorMessage(response = null) {
    this.errorMessageWrapper = this.cart.querySelector('#CartDrawer-CartErrors');
    let errorMessage = 'There was a problem adding the bundle to your cart.'
      
    if (response) {
      console.log(response)
      this.errorMessageWrapper.innerText = errorMessage;
      this.errorMessageWrapper.classList.remove('hidden')
    } else {
      this.errorMessageWrapper.classList.add('hidden')
    }
  }

  _disableButtons() {
    this.button.setAttribute('disabled', '');
    const loader = this.button.querySelector(this._selectors.loader);
    if (loader) loader.setAttribute('loading', '');
  }

  _enableButtons() {
    this.button.removeAttribute('disabled');
    const loader = this.button.querySelector(this._selectors.loader);
    if (loader) loader.removeAttribute('loading');
  }

  _confirmSelection = () => {
    const allOptionsSelected = !Array.from(this.products).some((product) => !product._checkSelectedOptions());
  
    if (!allOptionsSelected) {
      this.toast.openToast('Please select sizes before adding additional items.', 'notification');
      return;
    }

    const activeSlide = Array.from(this.cardSlides).find(slide => slide.getAttribute('aria-hidden') === 'false');
    const bundleCard = activeSlide?.querySelector('bundle-card');

    if (!activeSlide || !bundleCard) return;

    bundleCard.handleBundleAdd();
    this._resetModule();
  }

  /**
   * Handles either opening the module or confirming selections
   * If the module is already open:
   * - Confirms the current selection
   * - Resets the module state
   * If the module is closed:
   * - Opens the module to allow selection
   */
  _handleModuleAction = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const isHidden = this.selectorModule.getAttribute('aria-hidden') === 'true';
    if (!isHidden) {  
      this._confirmSelection();
    } else {
      this.selectorModule.setAttribute('aria-hidden', 'false');
    }
    
    this._toggleModuleCloseButton();
    e.currentTarget.blur();
  }

  _closeModule = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.selectorModule.setAttribute('aria-hidden', 'true');
    this._resetModule();
  }

  _toggleModuleCloseButton() {
    if (this.bundledProducts.children.length === 1) {
      this.closeModule.classList.add('hidden');
    } else {
      this.closeModule.classList.remove('hidden');
    }
  }

  _resetModule() {
    const imageSwiper = this.imageCarousel.swiper;
    imageSwiper.slideToLoop(1, 0, true);

    this.selectorModule.querySelectorAll('bundle-card').forEach((card) => {
      card._resetOptions();
    })
  }
}

class BundleCard extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      bundler: 'product-bundler',
      bundledProducts: '[js-bundled-products]',
      productJSON: '[js-product-json]',
      addToBundleBtn: '[js-add-to-bundle]',
      addMessage: '[js-add-message]',
      removeBtn: '[js-remove-btn]',
      bundleError: '[js-bundle-error]',
      loader: "loading-spinner",
      variant: '[js-variant]',
      options: '[js-options]',
      masterSelect: 'select[js-master-select]',
      optionSelector: '[js-product-option-selector]',
      relatedColorsParent: '[js-bundle-related-colors-parent-container]',
      relatedColors: '[js-bundle-related-colors]',
      colorLabel: '[js-color-label]',
      imageContainer: '[js-image-container]',
      productTitle: '[js-product-title]',
      price: '[js-price]',
      sizeGuideTrigger: '[js-open-size-guide-modal]'
    };
  }

  connectedCallback() {
    this.bundler = this.closest(this._selectors.bundler);
    this.bundledProducts = this.bundler.querySelector(this._selectors.bundledProducts);
    this.productJSON = JSON.parse(this.querySelector(this._selectors.productJSON).innerHTML);
    this.options = this.querySelector(this._selectors.options);
    this.button = this.querySelector(this._selectors.addToBundleBtn);
    this.addMessage = this.querySelector(this._selectors.addMessage);
    this.bundleError = this.querySelector(this._selectors.bundleError);
    this.removeBtn = this.querySelector(this._selectors.removeBtn);
    this.sizeGuideTriggers = this.querySelectorAll(this._selectors.sizeGuideTrigger);
    this.allOptionsSelected = false;

    this.imageContainer = this.querySelector(this._selectors.imageContainer);
    if (!this.hasAttribute('data-in-bundle')) {
      this.originalProductId = this.dataset.productId;
      this.slideImage = document.querySelector(`product-bundler div[js-image-carousel] div[data-product-id="${this.originalProductId}"]`);
    }
    
    this.productTitle = this.querySelector(this._selectors.productTitle);
    this.price = this.querySelector(this._selectors.price);
    this.moneyFormat = `${window.currency.symbol || "$"}{{no_trailing_zeros}}`;

    this._initRelatedColors().then(() => {
      this.variants = this.querySelectorAll(this._selectors.variant);
      this.colorLabel = this.querySelector(this._selectors.colorLabel);

      this._initListeners();

      if(this.bundledProducts.children[0] === this) {
        this.bundler._syncSelectedSwatch();
      } else if (!this.bundledProducts.contains(this)) {
        this._syncSelectedSwatch();
      }
    });
  }
  
  _initListeners() {
    this.variants?.forEach(variant => {
      variant.addEventListener('click', (e) => {
        this._injectProductOptions(e);
        this._updateProductCardInfo(e);
        this._updateProductCardImage(e);

        if(this.bundledProducts.children[0] === this) this.bundler._syncSelectedSwatch();
      });
    })

    const firstBundleCardVariants = this.closest('product-bundler').querySelector('bundle-card[data-in-bundle]').querySelectorAll(this._selectors.variant);
    firstBundleCardVariants.forEach(variant => {
      variant.addEventListener('click', (e) => {
        const colorLabels = this.bundler.querySelector('[js-selector-module]').querySelectorAll(this._selectors.colorLabel);
        colorLabels.forEach((label) => {
          label.innerHTML = variant.getAttribute('aria-label');
        });
      });
    })

    this.addEventListener('variant:change', this._handleVariantChange);

    this.button?.addEventListener('click', this.handleBundleAdd);

    this.removeBtn.addEventListener('click', this._removeCard.bind(this));

    this.sizeGuideTriggers.forEach((trigger) => {
      trigger.addEventListener('click', this._openSizeGuideModal);
    });
  }

  _syncSelectedSwatch() {
    const mainProduct = this.bundledProducts.children[0];
    const selectedSwatch = mainProduct.querySelector('[js-related-colors-current]');
    const swatchName = selectedSwatch?.getAttribute('aria-label');

    const colorLabels = this.bundler.querySelector('[js-selector-module]').querySelectorAll(this._selectors.colorLabel);
    colorLabels.forEach((label) => {
      label.innerHTML = swatchName
    });
    
    if (!selectedSwatch || !swatchName) return;

    const swatches = this.querySelectorAll(this._selectors.variant);
    swatches.forEach((swatch) => {
      if (swatch.getAttribute('aria-label') === swatchName) {
        swatch.click();
      }
    })
  }

  _openSizeGuideModal(e) {
    e.preventDefault();
    const productType = e.currentTarget.getAttribute('data-product-type');
    const sizeGuideModal = document.querySelector('#SizeGuideModal');
    const sizeGuideBra = sizeGuideModal.querySelector('[js-bra-size-guide]');
    const sizeGuidePanty = sizeGuideModal.querySelector('[js-panty-size-guide]');
    const sizeGuideTank = sizeGuideModal.querySelector('[js-tank-size-guide]');

    if (productType === 'bra' || productType === 'fit') {
      const sizeChart = sizeGuideModal.querySelector('.sizeGuideNew24');
      const howToMeasure = sizeGuideModal.querySelector('.sizeMeasureNew24');
      const sizeChartElements = sizeGuideModal.querySelector('.size-guid-id-mesr24');
      const howToMeasureElements = sizeGuideModal.querySelector('.size-guid-id-braSize24');
      
      if (productType === 'fit') {
        sizeChartElements.classList.remove('hide');
        howToMeasureElements.classList.add('hide');

        sizeChart.classList.remove('size-guide-top-toggle-item-drk');
        sizeChart.classList.add('size-guide-top-toggle-item-light');
        howToMeasure.classList.add('size-guide-top-toggle-item-drk');
        howToMeasure.classList.remove('size-guide-top-toggle-item-light');
      } else {
        sizeChartElements.classList.add('hide');
        howToMeasureElements.classList.remove('hide');

        sizeChart.classList.add('size-guide-top-toggle-item-drk');
        sizeChart.classList.remove('size-guide-top-toggle-item-light');
        howToMeasure.classList.remove('size-guide-top-toggle-item-drk');
        howToMeasure.classList.add('size-guide-top-toggle-item-light');
      }

      sizeGuideBra.classList.remove('hidden');
      sizeGuidePanty.classList.add('hidden');
      sizeGuideTank.classList.add('hidden');
    } else if (productType === 'panty') {
      sizeGuidePanty.classList.remove('hidden');
      sizeGuideBra.classList.add('hidden');
      sizeGuideTank.classList.add('hidden');
    } else if (productType === 'tank') {
      sizeGuideTank.classList.remove('hidden');
      sizeGuidePanty.classList.add('hidden');
      sizeGuideBra.classList.add('hidden');
    }
  }

  _handleVariantChange = (evt) => {
    const { variant } = evt.detail

    if (variant) this.setAttribute('data-product-option', variant.title);
  };

  handleBundleAdd = () => {
    this.allOptionsSelected = this._checkSelectedOptions();

    if (!this.allOptionsSelected) {
      this.bundler.toast.openToast('Please select sizes before adding additional items.', 'notification');
      return false;
    }
    
    this._disableButtons();

    const product = this._cloneProduct();
    this.bundledProducts.insertAdjacentElement('beforeend', product);
    
    this._enableButtons();

    return product;
  }

  _checkSelectedOptions() {
    const checkedOptions = this.querySelectorAll(
      `${this._selectors.optionSelector}:checked,
      ${this._selectors.optionSelector} option:checked:not([value=""])`
    );

    if (checkedOptions.length === this.productJSON.options.length) {
      if (this.button) {
        this.bundleError.classList.add('hidden');
        this.button.classList.remove('pointer-events-none');
        this.button.removeAttribute('disabled');
      }
      return true;
    }
    return false;
  }

  _removeCard() {
    this.remove();
    this.bundler._toggleModuleCloseButton();
  }

  _cloneProduct() {
    const clone = this.cloneNode(true);
    const uniqueId = Date.now();
    const bundleType = this.bundler.bundleType;

    const originalMasterSelect = this.querySelector(this._selectors.masterSelect);
    const originalSelects = this.querySelectorAll(`select${this._selectors.optionSelector}`);
    const originalRadio = this.querySelector(`input[type="radio"]${this._selectors.optionSelector}:checked`);
    const originalActiveSwatch = this.querySelector(`${this._selectors.variant}[aria-current="true"]`)?.dataset.handle;

    const clonedJson = clone.querySelector(this._selectors.productJSON);
    const clonedMasterSelect = clone.querySelector(this._selectors.masterSelect);
    const clonedMasterSelectId = `${clonedMasterSelect.id}-${bundleType}-${uniqueId}`
    const clonedProductOptions = clone.querySelector('product-options');
    const clonedSelects = clone.querySelectorAll(`select${this._selectors.optionSelector}`);
    const clonedRadios = clone.querySelectorAll(`input[type="radio"]${this._selectors.optionSelector}`);
    const clonedRelatedSwatches = clone.querySelector(this._selectors.relatedColors);

    // Update visual information of cloned card
    clone.setAttribute('data-in-bundle', '')
    clone.querySelector('[js-card-top]').classList.add('grid', 'grid-cols-3', 'gap-x-12', 'tabletl:gap-x-md');
    clone.querySelector(this._selectors.imageContainer).classList.remove('hidden');
    clone.querySelector(this._selectors.removeBtn).classList.remove('hidden');
    clone.querySelector('[js-card-footer]').remove();

    clonedRelatedSwatches?.setAttribute('data-handle', originalActiveSwatch)

    // Update product variant options to use unique IDs
    if (clonedJson) {
      clonedJson.id = `${clonedJson.id}-${bundleType}-${uniqueId}`
    }

    if (originalMasterSelect && clonedMasterSelect) {
      clonedMasterSelect.id = clonedMasterSelectId;
      clonedMasterSelect.value = originalMasterSelect.value;
    }

    if (clonedProductOptions) {
      clonedProductOptions.setAttribute('data-product', `${clonedProductOptions.dataset.product}-${bundleType}-${uniqueId}`);
      clonedProductOptions.setAttribute('data-master-select-id', clonedMasterSelectId);
    }

    if (originalSelects && clonedSelects) {
      clonedSelects.forEach((select, index) => {
        const uniqueSelectId = `${select.id}-${bundleType}-${uniqueId}`;
        const label = clone.querySelector(`label[for="${select.id}"]`);

        label.setAttribute('for', uniqueSelectId);
        select.id = uniqueSelectId;
        select.value = originalSelects[index].value;
      })
    }

    if (clonedRadios) {
      clonedRadios.forEach((radio) => {
        const uniqueRadioId = `${radio.id}-${bundleType}-${uniqueId}`;
        const label = clone.querySelector(`label[for="${radio.id}"]`);
        const radioName = radio.getAttribute('name')

        label.setAttribute('for', uniqueRadioId);
        radio.setAttribute('name', `${radioName}-${bundleType}-${uniqueId}`)
        radio.id = uniqueRadioId;
      })
    }

    if (originalRadio) {
      const clonedRadio = clone.querySelector(`input[type="radio"][value="${originalRadio.value}"]${this._selectors.optionSelector}`);
      if (clonedRadio) clonedRadio.checked = true;
    }

    return clone;
  }

  _resetOptions() {
    const relatedColors = this.querySelector(this._selectors.relatedColors);
    const radioOption = this.querySelector(`input[type="radio"]${this._selectors.optionSelector}:checked`);
    const selectOptions = this.querySelectorAll(`select${this._selectors.optionSelector}`);

    if (relatedColors) relatedColors.querySelector(this._selectors.variant).click();
    if (radioOption) radioOption.checked = false;
    if (selectOptions) {
      selectOptions.forEach((option) => {
        option.value = '';
      })
    }
  }

  _injectProductOptions = (e) => {
    const data = e.currentTarget;
    const product = data.dataset;
    const productJSON = this.productJSONs.find(json => json.id == product.variantId);
    const originalJSON = this.querySelector(this._selectors.productJSON);
    const productMasterSelect = Array.from(this.masterSelects).find(master => master.id == `RelatedColors-${product.variantId}`);
    const bundleType = this.bundler.bundleType;

    if (!productJSON) return;
    
    this.options.innerHTML = '';

    // Remove original listeners
    this.removeEventListener('variant:change', this._handleVariantChange);
    this.button?.removeEventListener('click', this.handleBundleAdd);

    // ProductJSON
    const uniqueId = Date.now();
    originalJSON.id = `ProductJSON-${product.variantId}-${bundleType}-${uniqueId}`;
    originalJSON.innerHTML = JSON.stringify(productJSON);

    // Master variant select
    let masterOptionsMarkup = productMasterSelect.innerHTML;

    let masterVariantMarkup = `
      <select id="BundleCardMasterSelect-${product.variantId}-${bundleType}-${uniqueId}" name="id" class="no-js" js-master-select>
        ${masterOptionsMarkup}
      </select>
    `;

    this.options.insertAdjacentHTML('beforeend', masterVariantMarkup);

    // Product options selector
    const options = product.options.split(",");
    const useSelect = options.length > 1;
    let optionsMarkup = `<product-options class="no-js-hidden ${useSelect ? 'grid grid-cols-2 gap-xs' : ''}" data-product='${originalJSON.id}' data-master-select-id="BundleCardMasterSelect-${product.variantId}-${bundleType}-${uniqueId}" ${useSelect ? '' : 'data-disable-option-binding'}" data-options-size="${productJSON.options.length}">`;

    if (useSelect) {
      options.forEach((option, index) => {
        let optionName = option.split('//')[0];
        let optionHandle = option.split('//')[1];
        let optionId = `option-${optionHandle}-BundleCard-${bundleType}-${uniqueId}`
  
        let valuesKey = `data-values-${index + 1}`;
        let values = data.getAttribute(valuesKey).split(',');

        let valuesMarkup = values.map((value, i) => {
          let valueName = value.split('//')[0];
          let valueHandle = value.split('//')[1];
          return `
            <option value="${valueHandle}">${valueName}</option>
          `
        }).join('');

        optionsMarkup = `${optionsMarkup}
          <div class="product-option flex justify-between w-full py-xs px-12 text-14 border border-black rounded-sm">
            <label for="${optionId}" class="visually-hidden">${optionName}</label>
            <select
              id="${optionId}"
              class="w-full"
              data-index="option${index + 1}"
              js-product-option-selector>
              <option value="" selected disabled>${optionName}</option>
              ${valuesMarkup}
            </select>
          </div>
        `
      })
    } else {
      const option = options[0]
      let optionName = option.split('//')[0];
      let optionHandle = option.split('//')[1];

      let valuesKey = `data-values-1`;
      let valuesAvailabilityKey = `data-values-1-availability`;
      let valuesQtyKey = `data-values-1-qty`;
      let values = data.getAttribute(valuesKey).split(',');
      let valuesAvailability = data.getAttribute(valuesAvailabilityKey).split(',');
      let valuesQty = data.getAttribute(valuesQtyKey).split(',');

      let valuesMarkup = values.map((value, i) => {
        let valueName = value.split('//')[0];
        let valueHandle = value.split('//')[1];
        let inputId = `swatch-${valueName}-BundleCard-${bundleType}-${uniqueId}`
        let radioName = `swatch-${optionHandle}-BundleCard-${bundleType}-${uniqueId}`

        return `
          <div class="product-swatch__group relative mt-[-1px] ml-[-1px]">
            <input
              id="${inputId}"
              class="product-swatch__input sr-only ${valuesAvailability[i] == 'false' ? 'disabled': ''}"
              type="radio"
              name="${radioName}"
              value="${valueHandle}"
              data-index="option1"
              ${valuesAvailability[i] == 'false' ? 'disabled': ''}
              js-product-option-selector>
            <label
              for="${inputId}"
              class="product-swatch__label flex justify-center items-center w-full h-full p-xxs text-14 uppercase border border-black ${valuesAvailability[i] == 'false' ? 'pointer-events-none': ''}">
              ${valueName}
            </label>
          </div>`;
      }).join('');

      optionsMarkup = `${optionsMarkup}
        <div class="product-option">
          <div class="product-option__swatch product-swatch">
            <div class="product-swatch__header mb-12 text-small font-700">${optionName}</div>
            <div class="product-swatch__container">
              ${valuesMarkup}
            </div>
          </div>
        </div>`;
    }

    optionsMarkup = `${optionsMarkup}</product-options>`

    this.options.insertAdjacentHTML('beforeend', optionsMarkup);

    // Reinit event listeners and selectors
    this.productJSON = JSON.parse(this.querySelector(this._selectors.productJSON).innerHTML);
    this.addEventListener('variant:change', this._handleVariantChange);
    this.button?.addEventListener('click', this.handleBundleAdd);
  }

  _updateProductCardInfo = (e) => {
    const data = e.currentTarget;
    const title = data.dataset.title;
    const newLink = data.dataset.link;
    const price = data.dataset.price;
    const compareAtPrice = data.dataset.compareAtPrice;
    const bundleDiscount = this.bundler.bundleDiscount;
    const discountedPriceInCents = Math.round(price * (100 - bundleDiscount) / 100);
    const roundedToNearestDollar = Math.round(discountedPriceInCents / 100) * 100;
    const salePrice = roundedToNearestDollar;

    let priceMarkup = '';

    // Update active variant
    this.relatedColorsContainer.setAttribute('data-handle', e.currentTarget.dataset.handle)
    this.variants.forEach(variant => {
      variant.setAttribute('aria-current', e.currentTarget === variant);
      if (e.currentTarget === variant) {
        variant.setAttribute('js-related-colors-current', '');
        variant.removeAttribute('js-related-colors-related');
      } else {
        variant.setAttribute('js-related-colors-related', '');
        variant.removeAttribute('js-related-colors-current');
      }
    })

    // Update title
    this.productTitle.href = newLink;
    this.productTitle.innerHTML = title;

    // Update color label
    this.currentColor = this.querySelector('[js-related-colors-current]');

    // Update price
    priceMarkup = `<s class="price__compare text-gray text-small font-700">${theme.utils.formatMoney(price, this.moneyFormat)}</s><span class="price__regular text-small text-red font-700">${theme.utils.formatMoney(salePrice, this.moneyFormat)}</span>`;
    // if (compareAtPrice && compareAtPrice > price) {
    //   priceMarkup = `<s class="price__compare text-gray text-small font-700">${theme.utils.formatMoney(compareAtPrice, this.moneyFormat)}</s><span class="price__regular text-small font-700">${theme.utils.formatMoney(price, this.moneyFormat)}</span>`;
    // } else {
    //   priceMarkup = `<span class="price__regular text-small font-700">${theme.utils.formatMoney(price, this.moneyFormat)}</span>`;
    // }

    // Update data attributes
    this.setAttribute('data-product-title', title);
    this.setAttribute('data-product-color', this.currentColor.getAttribute('aria-label'));
    this.setAttribute('data-product-price', price);

    this.price.innerHTML = priceMarkup;
  }

  _updateProductCardImage = (e) => {
    if (!this.imageContainer) return;

    const data = e.currentTarget;
    const image = data.dataset.image;
    const newLink = data.dataset.link
    const color = data.getAttribute('aria-label');

    let imageMarkup = `
      <a href="${newLink}" class="bundle-card__image-link absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-full h-auto">
        <img src="${image}">
      </a>`;

    this.imageContainer.innerHTML = imageMarkup;

    if (this.slideImage) {
      let slideMarkup = `<img src="${image}" class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-full h-auto">`;
      this.slideImage.innerHTML = slideMarkup;
      this.slideImage.closest('[js-carousel-slide]').dataset.swatchName = color;
    }

    // Update data attribute
    this.setAttribute('data-product-image', image);
  }

  _disableButtons() {
    this.button.setAttribute('disabled', '');
    const loader = this.button.querySelector(this._selectors.loader);
    if (loader) loader.setAttribute('loading', '');
  }

  _enableButtons() {
    this.button.removeAttribute('disabled');
    const loader = this.button.querySelector(this._selectors.loader);
    if (loader) loader.removeAttribute('loading');
  }

  _handleColorHover(){
    this.currentColor = this.querySelector('[js-related-colors-current]');

    this.relatedColorsContainer.addEventListener('mouseover', (e) => {
      const target = e.target.closest('[js-related-colors-related]');
      if (target) this.colorLabel.innerText = target.getAttribute('aria-label');
    });

    this.relatedColorsContainer.addEventListener('mouseout', (e) => {
      const target = e.target;
      if (target) this.colorLabel.innerText = this.currentColor.getAttribute('aria-label');
    });
  }

  async _initRelatedColors() {
    this.relatedColorsParent = this.querySelector(this._selectors.relatedColorsParent);
    this.relatedColorsContainer = this.querySelector(this._selectors.relatedColors);

    if (!this.relatedColorsParent || !this.relatedColorsContainer || this.relatedColorsContainer.length < 1) {
      return;
    }

    const currentProductHandle = this.relatedColorsContainer.getAttribute('data-handle');
    const relatedColorsCollection = this.relatedColorsContainer.getAttribute('data-collection');
    const relatedColorsTag = this.relatedColorsContainer.getAttribute('data-tag');

    const targetURL = `/collections/${relatedColorsCollection}/${relatedColorsTag}/?view=json`;
    const { collectionJSON: relatedColorsJSON, productJSONs, masterSelects } = await this._getRelatedColorJSON(targetURL);

    this.productJSONs = productJSONs;
    this.masterSelects = masterSelects;

    let relatedColorsMarkup = '';

    if (relatedColorsJSON.length <= 1) {
      this.relatedColorsParent.remove();
      return;
    }

    relatedColorsJSON.forEach((product) => {
      relatedColorsMarkup = `${relatedColorsMarkup}
        <button
          class="product-card__variant bundle-card__variant relative pr-12"
          aria-current="${product.handle == currentProductHandle}"
          aria-label="${product.swatch_name}"
          data-title="${product.title}"
          data-handle="${product.handle}"
          data-link="${product.url}"
          data-variant-id="${product.id}"
          data-available="${product.available}"
          data-price="${product.price}"
          data-has-only-default="${product.hasOnlyDefaultVariant}"
          data-options="${product.options}"
          data-values-1="${product.values_1}"
          data-values-1-availability="${product.values_1_availability}"
          data-values-1-qty="${product.values_1_qty}"
          ${product.values_2 ? `data-values-2="${product.values_2}" data-values-2-availability="${product.values_2_availability}"` : ''}
          ${product.values_3 ? `data-values-3="${product.values_3}" data-values-3-availability="${product.values_3_availability}"` : ''}
          ${product.compareAtPrice ? `data-compare-at-price="${product.compareAtPrice}"` : ''}
          data-image="${product.featured_image}"
          ${product.handle == currentProductHandle ? 'js-related-colors-current' : 'js-related-colors-related'}
          js-variant>
          <img class="min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px] bg-gray rounded-full overflow-hidden" src="${product.swatch}" alt="${product.title}" ${product.swatch_border ? `style="border: 1px solid ${product.swatch_border}"` : ''}>
        </button>`;
    });

    this.relatedColorsContainer.innerHTML = relatedColorsMarkup;
    this.relatedColorsContainer.classList.remove('hidden');

    this._handleColorHover()
  }

  _getRelatedColorJSON(url) {
    return fetch(url)
      .then(response => response.text())
      .then((text) => {
        const html = text;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
        const collectionJSON = JSON.parse(JSONcontainer.innerHTML);

        const productJSONElements = parsedHTML.querySelectorAll(this._selectors.productJSON);
        const productJSONs = Array.from(productJSONElements).map(el => JSON.parse(el.innerHTML));
        
        const masterSelects = parsedHTML.querySelectorAll(this._selectors.masterSelect);

        return { collectionJSON, productJSONs, masterSelects };
      })
  }
}
class SubscriptionModule extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      modal: 's-modal[js-subscription-modal]',
      modalLimit: 's-modal[js-subscription-modal-limit]',
      modalOpen: '[js-open-subscription-modal]',
      module: '[js-module]',
      page: '[js-module-page]',
      prevPage: '[js-prev-page]',
      nextPage: '[js-next-page]',
      auxTitle: '[js-aux-title]',
      auxPageTrigger: '[js-open-aux-page]',
      boxSelection: '[js-box-selection]',
      boxTypeSelection: '[js-box-type-selection]',
      pantyPreferenceSelection: '[js-panty-preference-selection]',
      sizeSelectTitle: '[js-size-select-title]',
      braSizeContainer: '[js-bra-size-container]',
      pantySizeContainer: '[js-panty-size-container]',
      bandSizeSelectors: '[js-band-size-selectors]',
      cupSizeSelectors: '[js-cup-size-selectors]',
      pantySizeSelectors: '[js-panty-size-selectors]',
      bandSizeSelector: '[js-band-size-selector]',
      cupSizeSelector: '[js-cup-size-selector]',
      pantySizeSelector: '[js-panty-size-selector]',
      braStatusText: '[js-bra-status-text]',
      pantyStatusText: '[js-panty-status-text]',
      productSelectionTitle: '[js-product-selection-title]',
      productFilter: '[js-product-filter]',
      braCollectionContainer: '[js-bra-collection-container]',
      pantyCollectionContainer: '[js-panty-collection-container]',
      productQueue: '[js-product-queue]',
      queuedProduct: '[js-queued-product]',
      productCard: '[js-product-card]',
      loader: "loading-spinner",
      colorProfileSelection: '[js-color-profile-selection]',
      selectionSummary: '[js-selection-summary]',
      subscriptionProduct: '[js-subscription-product]',
      submitOrder: '[js-submit-order]'
    }

    this.origin = null;
    this.hasInitialized = false;
  }

  shouldInitialize() {
    // Only auto-initialize if we're not on an account page
    const isAccountPage = document.body.classList.contains('template-account');
    return !isAccountPage;
  }

  connectedCallback(force = false) {
    // Skip if already initialized
    if (this.hasInitialized) {
      return;
    }

    // Only proceed if forced or should auto-initialize
    if (!force && !this.shouldInitialize()) {
      return;
    }

    /* Initialize global module elements */
    this.modal = this.closest(this._selectors.modal);
    this.modalLimit = document.querySelector(this._selectors.modalLimit);
    this.modalOpeners = document.querySelectorAll(this._selectors.modalOpen);
    this.module = this.querySelector(this._selectors.module);
    this.pages = this.querySelectorAll(this._selectors.page);
    this.prevPageBtn = this.querySelector(this._selectors.prevPage);
    this.nextPageBtns = this.querySelectorAll(this._selectors.nextPage);
    this.auxPageTriggers = this.querySelectorAll(this._selectors.auxPageTrigger);
    this.auxTitle = this.querySelector(this._selectors.auxTitle);
    this.cart = document.querySelector('cart-drawer');
    this.cartDrawer = document.querySelector('#CartDrawer');

    this.state = {}
    this.state.pagesVisited = [1];

    /* Page 1 -- Box selection page elements */
    this.boxSelections = this.querySelectorAll(this._selectors.boxSelection);

    /* Page 2 -- Box type selection page elements */
    this.boxTypeSelections = this.querySelectorAll(this._selectors.boxTypeSelection);

    /* Page 3 -- Panty preference selection page elements */
    this.pantyPreferenceSelections = this.querySelectorAll(this._selectors.pantyPreferenceSelection);

    /* Page 4 -- Size selection page elements */
    this.sizeSelectTitle = this.querySelector(this._selectors.sizeSelectTitle);
    this.braSizeContainer = this.querySelector(this._selectors.braSizeContainer);
    this.pantySizeContainer = this.querySelector(this._selectors.pantySizeContainer);
    this.bandSizeSelectors = this.querySelector(this._selectors.bandSizeSelectors);
    this.cupSizeSelectors = this.querySelector(this._selectors.cupSizeSelectors);
    this.pantySizeSelectors = this.querySelector(this._selectors.pantySizeSelectors);
    this.bandSizeRadios = this.querySelectorAll(this._selectors.bandSizeSelector);
    this.cupSizeRadios = this.querySelectorAll(this._selectors.cupSizeSelector);
    this.pantySizeRadios = this.querySelectorAll(this._selectors.pantySizeSelector);
    this.braStatusText = this.querySelector(this._selectors.braStatusText);
    this.pantyStatusText = this.querySelector(this._selectors.pantyStatusText);

    this.state.sizes = {
      bandSize: null,
      cupSize: null,
      pantySize: null,
      pantySizeDisplay: null,
      pantySizeNumeric: null
    }

    /* Page 5 -- Product selection page elements */
    this.productSelectionTitle = this.querySelector(this._selectors.productSelectionTitle);
    this.productQueue = this.querySelector(this._selectors.productQueue);
    this.productFilters = this.querySelectorAll(this._selectors.productFilter);
    this.braCollectionContainer = this.querySelector(this._selectors.braCollectionContainer);
    this.pantyCollectionContainer = this.querySelector(this._selectors.pantyCollectionContainer);
    this.moneyFormat = `${window.currency.symbol || "$"}{{no_trailing_zeros}}`;

    /* Page 6 -- Color profile page elements */
    this.colorProfileSelections = this.querySelectorAll(this._selectors.colorProfileSelection);
    /* Page 7 -- Selection summary page elements */
    this.selectionSummary = this.querySelector(this._selectors.selectionSummary);

    /* Page 7/8 -- Checkout page elements */
    this.subscriptionProduct = this.querySelector(this._selectors.subscriptionProduct);
    this.submitOrder = this.querySelector(this._selectors.submitOrder);

    /* Initialize listeners */
    this._setListeners();
    this.hasInitialized = true;
  }

  initialize() {
    this.connectedCallback(true);
  }

  _setListeners() {
    /* Global event listeners */
    this.addEventListener('active-page-change', this._handleActivePageChange);

    this.modalOpeners.forEach(btn => {
      btn.addEventListener('click', this._handleOpenModal.bind(this));
    });

    document.addEventListener(`${this.modal.id}:close`, this._handleCloseModal.bind(this));

    this.prevPageBtn.addEventListener('click', this._prevPage.bind(this));

    this.nextPageBtns.forEach(btn => {
      btn.addEventListener('click', this._nextPage.bind(this));
    });

    this.auxPageTriggers.forEach(btn => {
      btn.addEventListener('click', this._openAuxPage.bind(this));
    });

    /* Page 1 -- Box selection page event listeners */
    this.boxSelections.forEach(btn => {
      btn.addEventListener('click', this._selectBox);
    });

    /* Page 2 -- Box type selection page event listeners */
    this.boxTypeSelections.forEach(btn => {
      btn.addEventListener('click', this._selectBoxType);
    });

    /* Page 3 -- Panty preference selection page event listeners */
    this.pantyPreferenceSelections.forEach(btn => {
      btn.addEventListener('click', this._selectPantyPreference);
    });

    /* Page 4 -- Size selection page event listeners */
    this.bandSizeSelectors.addEventListener('change', (e) => this._selectSize('bandSize', e));
    this.cupSizeSelectors.addEventListener('change', (e) => this._selectSize('cupSize', e));
    this.pantySizeSelectors.addEventListener('change', (e) => this._selectSize('pantySize', e));

    /* Page 6 -- Color profile page event listeners */
    this.colorProfileSelections.forEach(btn => {
      btn.addEventListener('click', this._selectColorProfile);
    });
  }

  /* Global methods */
  _handleActivePageChange(e) {
    const { targetPage, previousPage } = e.detail;

    if (targetPage < 5) {
      this._resetProductSelectionPage();
    } else if (targetPage < 7) {
      this._resetCheckoutPageUI();
    }

    switch (targetPage) {
      case 4:
        this._initSizeSelectPage();
        break;
      case 5:
        if (previousPage < 5) {
          this._initProductSelectionPage();
        }
        break;
      case 7:
        this._initSummaryPage();
        this._initCheckoutPage();
        break;
      case 8:
        this._initCheckoutPage();
      // Add more cases as needed for other pages
    }
  }

  _prevPage() {
    const previousPage = this._getPreviousPage();
    
    if (previousPage) this._updatePage(previousPage);
  }

  _getPreviousPage() {
    const currentPage = this._getActivePage();
    const pagesVisited = this.state.pagesVisited;
    const currentIndex = pagesVisited.indexOf(currentPage);
    
    if (currentIndex > 0) return pagesVisited[currentIndex - 1];
    
    return null;
  }

  _nextPage() {
    const currentPage = this._getActivePage();
    const targetPage = parseInt(currentPage) + 1;
    this._updatePage(targetPage);
  }

  _updatePage(target, auxTitle = null) {
    document.activeElement?.blur();

    const targetPage = parseInt(target);
    
    const pagesVisited = this.state.pagesVisited;
    const previousPage = this._getActivePage();
    
    if (pagesVisited.includes(targetPage)) {
      const targetIndex = pagesVisited.indexOf(targetPage);
      this.state.pagesVisited = pagesVisited.slice(0, targetIndex + 1);
    } else {
      this.state.pagesVisited.push(targetPage);
    }

    this.module.setAttribute('data-active-page', targetPage);
    this._dispatchActivePageChange(targetPage, previousPage);

    this.pages.forEach(page => {
      const pageNumber = parseInt(page.getAttribute('data-page'));
      if (pageNumber === targetPage) {
        page.setAttribute('aria-hidden', 'false');
      } else {
        page.setAttribute('aria-hidden', 'true');
      }
    });

    if (this._getActivePage() === 1 || (this.origin == 'account-dashboard' && this._getActivePage() === 4)) {
      this.prevPageBtn.classList.add('invisible');
      this.prevPageBtn.setAttribute('disabled', '');
    } else {
      this.prevPageBtn.classList.remove('invisible');
      this.prevPageBtn.removeAttribute('disabled');
    }

    if (auxTitle) {
      this.auxTitle.textContent = auxTitle;
      this.auxTitle.classList.remove('hidden');
    } else {
      this.auxTitle.classList.add('hidden');
    }

  }

  _openAuxPage(e) {
    const target = e.currentTarget;
    const targetPage = target.getAttribute('data-target');
    const auxTitle = target.getAttribute('data-aux-title');
    this._updatePage(targetPage, auxTitle);
  }

  _getActivePage() {
    return parseInt(this.module.getAttribute('data-active-page'));
  }

  _dispatchActivePageChange(targetPage, previousPage) {
    const activePageChangeEvent = new CustomEvent('active-page-change', {
      detail: {
        targetPage: targetPage,
        previousPage: previousPage
      }
    });

    this.dispatchEvent(activePageChangeEvent);
  }

  async _handleOpenModal(e) {
    e.preventDefault();

    const target = e.currentTarget;
    const targetPage = target.getAttribute('data-module-target');
    const box = targetPage === 'matching-set' ? 'matching-set' : '3-panties';
    const isASubscriber = this.modal.dataset.customerTags.split('|').indexOf("Active Subscriber") > -1;

    try {
      await this._checkExistingSubscriptionBox();
      if (this.hasExistingSubscriptionBox && !isASubscriber) {
        this._showLimitModal();
        return;
      }
    } catch (error) {
      console.error('Check existing subscription error:', error);
    }

    if (targetPage) {
      this.dataset.box = box;
      this.state.box = box;
      this.state.collections = {
        set: this.getAttribute('data-set-collection'),
        panty: this.getAttribute('data-panty-collection')
      }
      this.state.products = [];
      this.state.boxType = null;
      this.state.colorProfile = null;
      this.state.sizes = {
        bandSize: null,
        cupSize: null,
        pantySize: null,
        pantySizeDisplay: null,
        pantySizeNumeric: null
      };

      if (targetPage === 'matching-set') {
        this._updatePage(4);
      } else if (targetPage === '3-panties') {
        this._updatePage(2);
      } else if (targetPage === '3-panties--account') {
        this.origin = 'account-dashboard';
        this.state.box = '3-panties';
        this.state.boxType = 'choose-your-own';
        this._updatePage(4);
      } else if (targetPage === 'matching-set--account') {
        this.origin = 'account-dashboard';
        this.state.box = 'matching-set';
        this._updatePage(4);
      }
    }

    this.modal.open();
  }

  _handleCloseModal() {
    this._updatePage(1);
    this.state = {};
    this.state.pagesVisited = [1];
  }

  async _checkExistingSubscriptionBox() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.hasExistingSubscriptionBox = cart.items.filter(item => item.product_type === 'Subscription Box').length > 0;
    } catch (error) {
      console.error('Fetch cart error:', error);
    }
  }

  _showLimitModal() {
    this.modalLimit.open();
  }

  _disableButton(target) {
    const loader = target.querySelector(this._selectors.loader);
    if (loader) loader.setAttribute('loading', '');
    if (target.tagName.toLowerCase() === 'button') target.setAttribute('disabled', '');
  }

  _enableButton(target) {
    const loader = target.querySelector(this._selectors.loader);
    if (loader) loader.removeAttribute('loading');
    if (target.tagName.toLowerCase() === 'button') target.removeAttribute('disabled');
  }

  /* Page 1 -- Box selection page methods */
  _selectBox = (e) => {
    const target = e.currentTarget;
    const boxSelection = target.getAttribute('data-box');

    this.state.box = boxSelection;
    this.dataset.box = boxSelection;
    this.state.collections = {
      set: this.getAttribute('data-set-collection'),
      panty: this.getAttribute('data-panty-collection')
    }
    this.state.products = [];
    this.state.boxType = null;
    this.state.colorProfile = null;
    this.state.sizes = {
      bandSize: null,
      cupSize: null,
      pantySize: null,
      pantySizeDisplay: null,
      pantySizeNumeric: null
    };

    if (boxSelection === 'matching-set') {
      this._updatePage(4);
    } else if (boxSelection === '3-panties') {
      this._updatePage(2);
    }
  }

  /* Page 2 -- Box type selection page methods */
  _selectBoxType = (e) => {
    const target = e.currentTarget;
    const boxType = target.getAttribute('data-box-type');

    this.state.boxType = boxType;

    if (boxType === 'choose-your-own') {
      this.state.colorProfile = null;
      this._updatePage(4);
    } else if (boxType === 'surprise-me') {
      this._updatePage(3);
    }
  }

  /* Page 3 -- Panty preference selection page methods */
  _selectPantyPreference = (e) => {
    const target = e.currentTarget;
    const pantyPreference = target.getAttribute('data-panty-preference');

    this.state.pantyPreference = pantyPreference;

    this._updatePage(4);
  }

  /* Page 4 -- Size selection page methods */
  _initSizeSelectPage() {
    // Initialize individual size trackers
    this.sizesSelected = {
      bandSize: false,
      cupSize: false,
      pantySize: false
    };
    
    this.bandSizeRadios.forEach(radio => { radio.checked = false; });
    this.cupSizeRadios.forEach(radio => { radio.checked = false; });
    this.pantySizeRadios.forEach(radio => { radio.checked = false; });
    
    this._updateSizeSelectUI();
    this._updateStatusTexts();
  }

  _selectSize(sizeType, e) {
    this.state.sizes[sizeType] = e.target.value;
    
    this.sizesSelected[sizeType] = true;
    
    if (sizeType === 'pantySize') {
      this.state.sizes.pantySizeDisplay = e.target.getAttribute('data-panty-size-display');
      this.state.sizes.pantySizeNumeric = e.target.getAttribute('data-panty-size-numeric');
    }
    
    this._updateStatusTexts();
    this._checkSizesSelected();
  }

  _updateStatusTexts() {
    if (this.state.box === 'matching-set') {
      const { bandSize, cupSize, pantySize } = this.sizesSelected;
      const allBraSizesSelected = bandSize && cupSize;
      const partialBraSelection = bandSize || cupSize;


      // Update bra status text
      if (allBraSizesSelected) {
        this.braStatusText.textContent = `Selected: ${this.state.sizes.bandSize}${this.state.sizes?.cupSize?.toUpperCase()}`;
        this.braStatusText.classList.remove('text-red');
        this.braStatusText.classList.add('font-500');
        this.braStatusText.style.color = 'black';
      } else if (partialBraSelection) {
        // Error state: partial bra selection + panty selected - be specific about what's missing
        if (bandSize && !cupSize) {
          this.braStatusText.textContent = 'Select your cup size';
        } else if (cupSize && !bandSize) {
          this.braStatusText.textContent = 'Select your band size';
        }

        if (pantySize) {
          this.braStatusText.classList.add('text-red');
          this.braStatusText.classList.remove('font-500');
          this.braStatusText.style.color = '';
        }

      } else {
        this.braStatusText.textContent = 'Select band and cup size';
        if (pantySize) {
          this.braStatusText.classList.add('text-red');
          this.braStatusText.classList.remove('font-500');
          this.braStatusText.style.color = '';
        } else {
          this.braStatusText.classList.remove('text-red');
          this.braStatusText.classList.remove('font-500');
          this.braStatusText.style.color = '#5E616F';
        }
      }

      // Update panty status text
      if (pantySize) {
        // Use the display size (M) instead of the value (md)
        const pantyDisplaySize = this.state.sizes.pantySizeDisplay || this.state.sizes.pantySize?.toUpperCase();
        this.pantyStatusText.textContent = `Selected: ${pantyDisplaySize}`;
        this.pantyStatusText.classList.remove('text-red');
        this.pantyStatusText.classList.add('font-500');
        this.pantyStatusText.style.color = 'black';
      } else {
        this.pantyStatusText.textContent = 'Select panty size';
        this.pantyStatusText.classList.remove('text-red', 'font-500');
        this.pantyStatusText.style.color = '#5E616F';
      }
    } else if (this.state.box === '3-panties') {
      // For 3-panties box, only update panty status
      if (this.sizesSelected.pantySize) {
        // Use the display size (M) instead of the value (md)
        const pantyDisplaySize = this.state.sizes.pantySizeDisplay || this.state.sizes.pantySize?.toUpperCase();
        this.pantyStatusText.textContent = `Selected: ${pantyDisplaySize}`;
        this.pantyStatusText.classList.remove('text-red');
        this.pantyStatusText.classList.add('font-500');
        this.pantyStatusText.style.color = 'black';
      } else {
        this.pantyStatusText.textContent = 'Select panty size';
        this.pantyStatusText.classList.remove('text-red', 'font-500');
        this.pantyStatusText.style.color = '#5E616F';
      }
    }
  }

  _checkSizesSelected() {
    if (this.state.box === 'matching-set') {
      const { bandSize, cupSize, pantySize } = this.sizesSelected;
      const allBraSizesSelected = bandSize && cupSize;
      const partialBraSelection = (bandSize || cupSize) && !(bandSize && cupSize);

      // Prevent progression if there's a partial bra selection and panty is selected
      if (partialBraSelection && pantySize) {
        return; // Don't proceed to next page
      }

      if (allBraSizesSelected) {
        const braSize = `${this.state.sizes.bandSize}${this.state.sizes.cupSize}`;
        const validBraSize = this._transformBraSize(braSize);
        
        if (!validBraSize) {
          alert('Invalid bra size. \nPlease select the correct cup and band size according to our size guide.');
          return;
        }
      }

      if (allBraSizesSelected && pantySize) {
        this._updatePage(5);
      }
    } else if (this.state.box === '3-panties') {
      if (this.sizesSelected.pantySize) {
        if (this.state.boxType === 'choose-your-own') {
          this._updatePage(5);
        } else if (this.state.boxType === 'surprise-me') {
          this._updatePage(6);
        }
      }
    }
  }

  _updateSizeSelectUI() {
    if (this.state.box === 'matching-set') {
      this.sizeSelectTitle.textContent = 'Tell Us Your Size';
      this.braSizeContainer.classList.remove('hidden');
      this.pantySizeContainer.querySelector('h3').classList.remove('hidden');
    } else if (this.state.box === '3-panties') {
      this.sizeSelectTitle.textContent = 'Tell Us Your Panty Size';
      this.braSizeContainer.classList.add('hidden');
      this.pantySizeContainer.querySelector('h3').classList.add('hidden');
    }
  }

  /* Page 5 -- Product selection page methods */
  _resetProductSelectionPage() {
    this.state.products = [];

    this.queuedProducts?.forEach(product => {
      product.removeEventListener('click', this._removeQueuedProduct);

      product.setAttribute('disabled', '');
      product.removeAttribute('data-product-id');
      product.removeAttribute('data-product-title');
      product.removeAttribute('data-product-swatch-name');
      product.removeAttribute('data-product-image');
      product.classList.remove('queued-product--active');
    });

    this.productQueue.innerHTML = '';

    this.productCards?.forEach(card => {
      card.removeEventListener('click', this._selectProduct);
    });    

    if (this.braCollectionContainer) this.braCollectionContainer.innerHTML = '';
    if (this.pantyCollectionContainer) this.pantyCollectionContainer.innerHTML = '';
  }

  async _initProductSelectionPage() {
    if (!this.state.products) this.state.products = [];

    const currentPage = this.querySelector(`${this._selectors.page}[data-page="${this._getActivePage()}"]`);

    this._updateProductSelectionTitle();
    this._populateProductQueue();
    await this._loadCollections(currentPage);
  }

  async _loadCollections(currentPage) {
    if (this.state.box === 'matching-set') {
      // Show bra collection first, hide panty collection

      this.productFilters.forEach(filter => {
        const filterType = filter.getAttribute('data-filter-type');
        if (filterType === 'bra') {
          filter.value = 'all';
          filter.dispatchEvent(new Event('change', { bubbles: true }));
          filter.classList.remove('hidden');
        } else {
          filter.classList.add('hidden');
        }
      });

      if (this.braCollectionContainer && this.pantyCollectionContainer) {
        this.braCollectionContainer.setAttribute('aria-selected', 'true');
        this.pantyCollectionContainer.setAttribute('aria-selected', 'false');
      }
      
      this._disableButton(currentPage);
      try {

        const braHasProducts = await this._injectCollection(this.state.collections.set, this.braCollectionContainer);
        if (!braHasProducts) {
          this._productSelectionError('No bras available in this size', this.braCollectionContainer);
        }

        const pantyHasProducts = await this._injectCollection(this.state.collections.set, this.pantyCollectionContainer);
        if (!pantyHasProducts) {
          this._productSelectionError('No panties available in this size', this.pantyCollectionContainer);
        }
        
        this.productCards = this.querySelectorAll(this._selectors.productCard);

        this._initProductSelectionPageListeners();
      } catch (error) {
        console.error('Error loading collections:', error);
        this._productSelectionError('Error loading products');
      } finally {
        this._enableButton(currentPage);
      }
    } else {
      // Show panty collection only

      this.productFilters.forEach(filter => {
        const filterType = filter.getAttribute('data-filter-type');
        if (filterType === 'panty') {
          filter.value = 'all';
          filter.dispatchEvent(new Event('change', { bubbles: true }));
          filter.classList.remove('hidden');
        } else {
          filter.classList.add('hidden');
        }
      });

      if (this.braCollectionContainer) this.braCollectionContainer.setAttribute('aria-selected', 'false');
      if (this.pantyCollectionContainer) this.pantyCollectionContainer.setAttribute('aria-selected', 'true');
      
      this._disableButton(currentPage);

      try {
        const pantyHasProducts = await this._injectCollection(this.state.collections.panty, this.pantyCollectionContainer);
        if (!pantyHasProducts) {
          this._productSelectionError('No panties available in this size', this.pantyCollectionContainer);
        }
        
        this.productCards = this.querySelectorAll(this._selectors.productCard);
        this._initProductSelectionPageListeners();
      } catch (error) {
        console.error('Error loading panty collection:', error);
        this._productSelectionError('Error loading panties', this.pantyCollectionContainer);
      } finally {
        this._enableButton(currentPage);
      }
    }
  }

  async _injectCollection(collectionHandle, container) {
    if (!container) return;
    const targetURL = `/collections/${collectionHandle}/?view=json`;
    const { collectionJSON, productJSONElements } = await this._getCollectionJSON(targetURL);
    const productJSONs = Array.from(productJSONElements);

    let collectionMarkup = '';
    let targetSize = null;
    let containerType = null;

    if (collectionJSON.length <= 1) return;

    if (container === this.braCollectionContainer) {
      targetSize = `${this.state.sizes.bandSize} / ${this.state.sizes.cupSize}`;
      containerType = 'bra';
    } else {
      targetSize = this.state.sizes.pantySize;
      containerType = 'panty';
    }

    collectionJSON.forEach(product => {
      const productJSON = JSON.parse(productJSONs.find(item => item.id === `ProductJSON-${product.id}`).innerHTML);
      const optionsArray = product.options.split(',');
      const optionsSize = optionsArray.length;

      if (container === this.braCollectionContainer && product.type === 'panty') return;
      if (container === this.pantyCollectionContainer && product.type === 'bra') return;

      if (container === this.braCollectionContainer && optionsSize === 1) {
        targetSize = this.state.sizes.braSize ? this.state.sizes.braSize : this._transformBraSize(`${this.state.sizes.bandSize}${this.state.sizes.cupSize}`);
      }

      const variant = productJSON.variants.find(variant =>
        variant.title.toLowerCase() === targetSize.toLowerCase()
      );

      if (!variant || variant.available === false) return;

      const variantId = variant.id;

      collectionMarkup = `${collectionMarkup}
        <button
          class="product-card__sub-box relative flex flex-col justify-start"
          type="button"
          data-product-id="${product.id}"
          data-product-variant-id="${variantId}"
          data-product-title="${product.title}"
          ${product.swatch_name ? `data-product-swatch-name="${product.swatch_name}"` : ''}
          ${product.braletteType ? `data-product-bralette-type="${product.braletteType}"` : ''}
          data-product-image="${product.featured_image}"
          data-product-container-type="${containerType}"
          data-product-type="${product.type}"
          data-product-style="${product.rechargeStyle}"
          data-product-subscription-offer="${product.subscription_offer}"
          js-product-card
          >
          <loading-spinner style="--width: 24px; --height: 24px;"></loading-spinner>
          <div class="product-card__image-container relative rounded-lg overflow-hidden">
            <img class="product-card__image" src="${product.featured_image}" alt="${product.title}">
            ${product.hover_image ? `<img class="product-card__image-secondary absolute top-0 left-0 flex items-center justify-center w-full h-full" src="${product.hover_image}" alt="${product.title}">` : ''}
          </div>
          <div class="product-card__info mt-12">
            <h3 class="product-card__title text-14 leading-4 font-500 text-left">${product.title}</h3>
            ${product.swatch_name ? `<div class="product-card__swatch-name mt-xs text-14 leading-4 text-left">${product.swatch_name}</div>` : ''}
          </div>
        </button>
      `;
    });

    container.innerHTML = collectionMarkup;
    return collectionMarkup !== '';
  }

  _filterProducts(e) {
    const target = e.currentTarget;
    const filterType = target.getAttribute('data-filter-type');
    const filterValue = target.value.split('-')[0].charAt(0).toUpperCase() + target.value.split('-')[0].slice(1);

    if (filterType === 'panty') {
      const productCards = this.pantyCollectionContainer.querySelectorAll(this._selectors.productCard);
      productCards.forEach(card => {
        if (filterValue === 'All') {
          card.classList.remove('hidden');
        } else {
          const productType = card.getAttribute('data-product-title');
          if (!productType.includes(filterValue)) {
            card.classList.add('hidden');
          } else {
            card.classList.remove('hidden');
          }
        }
      });
    } else if (filterType === 'bra') {
      const productCards = this.braCollectionContainer.querySelectorAll(this._selectors.productCard);
      productCards.forEach(card => {
        if (filterValue === 'All') {
          card.classList.remove('hidden');
        } else {
          const productType = card.getAttribute('data-product-title');
          if (!productType.includes(filterValue)) {
            card.classList.add('hidden');
          } else {
            card.classList.remove('hidden');
          }
        }
      });
    }    
  }

  _initProductSelectionPageListeners() {
    this.productCards.forEach(card => {
      card.addEventListener('click', this._selectProduct);
    });

    this.queuedProducts.forEach(product => {
      product.addEventListener('click', this._removeQueuedProduct);
    });   
    
    this.productFilters.forEach(filter => {
      filter.addEventListener('change', this._filterProducts.bind(this));
    });
  }

  _populateProductQueue() {
    let limit = 0;
    this.state.box === 'matching-set' ? limit = 2 : limit = 3;

    this.productQueue.innerHTML = '';

    for (let i = 0; i < limit; i++) {
      this.productQueue.innerHTML += `
        <button class="page__queued-product relative w-[36px] h-[36px] rounded-full bg-gray-light" disabled="disabled" js-queued-product></button>
      `;
    }

    this.queuedProducts = this.querySelectorAll(this._selectors.queuedProduct);
  }

  _transformBraSize(size) {
    const sizeCategories = {
      XS: ["32A", "32B", "32C"],
      SM: ["32D", "34A", "34B", "34C"],
      MD: ["34D", "36A", "36B", "36C"],
      LG: ["36D", "38A", "38B", "38C"],
      XL: ["38D", "40B", "40C", "40D"],
      SDD: ["32DD", "32DDD", "32G", "34DD", "34DDD"],
      MDD: ["34G", "36DD", "36DDD"],
      LDD: ["36G", "38DD", "38DDD", "38G"],
      XLDD: ["40DD", "40DDD", "40G", "42C", "42D", "42DD"],
      '2XLDD': ["42DDD", "42G", "44D", "44DD", "44DDD"]
    };

    for (const [category, sizes] of Object.entries(sizeCategories)) {
      if (sizes.includes(size.toUpperCase())) {
        this.state.sizes.braSize = category.toLowerCase();
        return category.toLowerCase();
      }
    }
    return null;
  }

  _updateProductSelectionTitle(title = null) {
    if (title) {
      this.productSelectionTitle.innerHTML = title;
    } else {
      this.productSelectionTitle.innerHTML = this.state.box === 'matching-set' ? 'Add A Bra To Your Set' : 'Choose 3 Panties';
    }
  }

  _productSelectionError(message = 'No products of this size are available', container = null) {
    if (container) {
      container.innerHTML = `<div class="collection-error col-span-full text-center text-red">${message}</div>`;
    } else {
      this.productSelectionTitle.innerHTML = `<div class="collection-error col-span-full text-center text-red">${message}</div>`;
    }
  }

  _removeQueuedProduct = (e) => {
    const target = e.currentTarget;
    const variantId = target.getAttribute('data-product-variant-id');
    const index = target.getAttribute('data-product-index');
    const queuedProduct = Array.from(this.queuedProducts).find(product => 
      product.getAttribute('data-product-variant-id') === variantId && 
      product.getAttribute('data-product-index') === index
    );
    const productContainerType = target.getAttribute('data-product-container-type');

    if (!variantId) return;
    
    if (this.state.products) {
      if (index !== -1) {
        this.state.products[index] = null;
      }
    }

    queuedProduct.setAttribute('disabled', '');
    queuedProduct.removeAttribute('data-product-id');
    queuedProduct.removeAttribute('data-product-variant-id');
    queuedProduct.removeAttribute('data-product-title');
    queuedProduct.removeAttribute('data-product-image');
    queuedProduct.removeAttribute('data-product-swatch-name');
    queuedProduct.removeAttribute('data-product-container-type');
    queuedProduct.removeAttribute('data-product-index');
    queuedProduct.classList.remove('queued-product--active');

    queuedProduct.innerHTML = '';

    if (this.state.box === 'matching-set') {
      this._switchProductSelectionPage(productContainerType);
      if (productContainerType == 'bra') {
        this._updateProductSelectionTitle('Add A Bra To Your Set');
      } else {
        this._updateProductSelectionTitle('Add A Panty To Your Set');
      }
    }
  }

  _selectProduct = (e) => {
    const product = e.currentTarget;

    let queuePosition = -1;
    for (let i = 0; i < this.queuedProducts.length; i++) {
      if (!this.queuedProducts[i].hasAttribute('data-product-id')) {
        queuePosition = i;
        break;
      }
    }

    if (queuePosition === -1) {
      alert('Maximum amount of products reached.\nPlease remove a product before adding another.');
      return;
    }

    this.state.products[queuePosition] = {
      id: product.getAttribute('data-product-id'),
      variantId: product.getAttribute('data-product-variant-id'),
      title: product.getAttribute('data-product-title'),
      swatch_name: product.getAttribute('data-product-swatch-name'),
      featured_image: product.getAttribute('data-product-image'),
      containerType: product.getAttribute('data-product-container-type'),
      braletteType: product.getAttribute('data-product-bralette-type'),
      type: product.getAttribute('data-product-type'),
      style: product.getAttribute('data-product-style'),
      subscription_offer: product.getAttribute('data-product-subscription-offer'),
      index: queuePosition
    };

    this._disableButton(product);
    this._addProductToQueue(this.state.products[queuePosition], queuePosition);
    this._enableButton(product);
    const allProductsSelected = this._checkQueuedProducts();
    if (!allProductsSelected && this.state.box === 'matching-set') {
      this._switchProductSelectionPage();
      if (this.state.products[queuePosition].containerType == 'bra') {
        this._updateProductSelectionTitle('Add A Panty To Your Set');
      } else {
        this._updateProductSelectionTitle('Add A Bra To Your Set');
      }
    }
  }

  _switchProductSelectionPage(targetContainer = null) {
    const showBra = targetContainer ? targetContainer === 'bra' : this.braCollectionContainer.getAttribute('aria-selected') !== 'true';
    this.braCollectionContainer.setAttribute('aria-selected', showBra);
    this.pantyCollectionContainer.setAttribute('aria-selected', !showBra);

    this.productFilters.forEach(filter => {
      const filterType = filter.getAttribute('data-filter-type');
      filter.value = 'all';
      filter.dispatchEvent(new Event('change', { bubbles: true }));
      if (showBra) {
        if (filterType === 'bra') {
          filter.classList.remove('hidden');
        } else {
          filter.classList.add('hidden');
        }
      } else {
        if (filterType === 'panty') {
          filter.classList.remove('hidden');
        } else {
          filter.classList.add('hidden');
        }
      }
    });
  }

  _addProductToQueue(product, position) {
    const queuedProduct = this.queuedProducts[position];
    if (!queuedProduct) return;
    queuedProduct.removeAttribute('disabled');
    queuedProduct.setAttribute('data-product-id', product.id);
    queuedProduct.setAttribute('data-product-variant-id', product.variantId);
    queuedProduct.setAttribute('data-product-title', product.title);
    queuedProduct.setAttribute('data-product-swatch-name', product.swatch_name);
    queuedProduct.setAttribute('data-product-image', product.featured_image);
    queuedProduct.setAttribute('data-product-container-type', product.containerType);
    queuedProduct.setAttribute('data-product-index', position);

    queuedProduct.innerHTML = `
      <span class="sr-only">Remove ${product.title}</span>
      <div class="queued-product__image flex items-center justify-center w-full h-full rounded-full overflow-hidden">
        <img class="queued-product__image" src="${product.featured_image}" alt="${product.title}">
      </div>
    `;

    queuedProduct.classList.add('queued-product--active');
  }

  _checkQueuedProducts() {
    const queuedProducts = this.querySelectorAll(this._selectors.queuedProduct);
    const allProductsSelected = Array.from(queuedProducts).every(product => 
      product.hasAttribute('data-product-id')
    );

    if (allProductsSelected) {
      // this._initSummaryPage();
      this._populateSelectionSummary();
      this._updatePage(7);
    }

    return allProductsSelected;
  }

  /* Page 6 -- Color profile page methods */
  _selectColorProfile = (e) => {
    const target = e.currentTarget;
    const colorProfile = target.getAttribute('data-color-profile');

    this.state.colorProfile = colorProfile;
    this._updatePage(7);
  }

  /* Page 7 -- Selection summary page methods */  
  _initSummaryPage() {
    if (!this.selectionSummary) return;

    // Prevent duplicate initialization
    if (this.selectionSummary.hasAttribute('data-initialized')) return;

    this._initSummaryPageButton();
    this._populateSelectionSummary();
    requestAnimationFrame(() => {
      this._setSelectionSummaryListeners();
    });

    // Mark as initialized
    this.selectionSummary.setAttribute('data-initialized', 'true');
  }
  
  _initSummaryPageButton() {
    const nextButton = this.querySelector(`#SelectionSummary ${this._selectors.nextPage}`);
    this.confirmSelectionsBtn = this.querySelector(`#SelectionSummary button[js-confirm-recharge-selections]`);
    this.submitOrder = this.querySelector(`#SelectionSummary ${this._selectors.submitOrder}`);

    if (this.origin === 'account-dashboard') {
      // For account dashboard, show confirm selections button
      nextButton.classList.add('hidden');
      this.confirmSelectionsBtn.classList.remove('hidden');
      this.submitOrder.classList.add('hidden');
    } else {
      // For regular users, show Add to Bag button
      nextButton.classList.add('hidden');
      this.confirmSelectionsBtn.classList.add('hidden');
      this.submitOrder.classList.remove('hidden');
    }
  }

  _populateSelectionSummary() {
    this.selectionSummary.innerHTML = this.state.products.map(product => {
      let sizeDisplay = '';
      const braDisplay = this.state.sizes.braSize ? this.state.sizes.braSize : this._transformBraSize(`${this.state.sizes.bandSize}${this.state.sizes.cupSize}`);
      if (product.containerType === 'bra') {
        sizeDisplay = `${braDisplay} (${this.state.sizes.bandSize}${this.state.sizes.cupSize})`;
      } else {
        sizeDisplay = `${this.state.sizes.pantySizeDisplay} (${this.state.sizes.pantySizeNumeric})`;
      }

      return `
        <div class="selection-summary__item relative grid grid-cols-3 gap-12">
          <div class="selection-summary__image-container relative flex items-center justify-center aspect-square rounded-lg overflow-hidden">
            <img class="selection-summary__image w-full h-auto" src="${product.featured_image}" alt="${product.title}">
          </div>
          <div class="selection-summary__info flex flex-col justify-start gap-xs col-span-2">
            <div class="selection-summary__header flex justify-between items-start gap-12">
              <h3 class="selection-summary__title text-14 font-700">${product.title}</h3>
              <button class="selection-summary__remove-btn link text-small" aria-label="Remove ${product.title}" data-product-id="${product.id}" data-product-variant-id="${product.variantId}" data-product-container-type="${product.containerType}" data-product-index="${product.index}" js-remove-selected-product>Remove</button>
            </div>
            ${product.swatch_name ? `<div class="selection-summary__swatch-name text-14 leading-4 text-left">${product.swatch_name}</div>` : ''}
            <div class="selection-summary__size text-14 leading-4 text-left uppercase">${sizeDisplay}</div>
          </div>
        </div>
      `;
    }).join('');
  }

  _setSelectionSummaryListeners() {
    this.removeSelectedProducts = this.querySelectorAll('[js-remove-selected-product]');
    
    this.removeSelectedProducts?.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this._removeQueuedProduct(e);
        this._prevPage();
      });
    });

    if (this.confirmSelectionsBtn) {
      this.confirmSelectionsBtn.addEventListener('click', (e) => {
        this._confirmRechargeSelections();
      });
    }

    // Set up submit order listener for page 7
    if (this.submitOrder && this.origin !== 'account-dashboard') {
      this.submitOrder.addEventListener('click', this._submitOrder);
    }
  }

  _getProductData(box, size, braType = null) {
    if (box === 'matching-set') {
      return {
        'data[shopify_customer_id]': window.customer_id,
        'data[size]': `${this.state.sizes.pantySize.toLowerCase()} / ${size}`,
        'data[sizeBra]': size,
        'data[braType]': braType,
        'data[freqPlan]': sessionStorage.getItem("fdp-sub_freq"),
        'data[product_1][product_id]': this.state.products[0].id,
        'data[product_1][variant_id]': this.state.products[0].variantId,
        'data[product_2][product_id]': this.state.products[1].id,
        'data[product_2][variant_id]': this.state.products[1].variantId,
        'data[prodFill][0][name]': this.state.products[0].title,
        'data[prodFill][0][style]': this.state.products[0].rechargeStyle,
        'data[prodFill][0][id]': this.state.products[0].id,
        'data[prodFill][0][color]': this.state.products[0].swatch_name,
        'data[prodFill][0][variantId]':this.state.products[0].variantId,
        'data[prodFill][0][image]': this.state.products[0].featured_image,
        'data[prodFill][0][type]': this.state.products[0].type,
        'data[prodFill][1][name]': this.state.products[1].title,
        'data[prodFill][1][style]': this.state.products[1].rechargeStyle,
        'data[prodFill][1][id]': this.state.products[1].id,
        'data[prodFill][1][color]': this.state.products[1].swatch_name,
        'data[prodFill][1][variantId]': this.state.products[1].variantId,
        'data[prodFill][1][image]': this.state.products[1].featured_image,
        'data[prodFill][1][type]': this.state.products[1].type,
        'data[productCounter]': 1
      };
    } else if (box === '3-panties') {
      return {
        'data[shopify_customer_id]': window.customer_id,
        'data[size]': size,
        'data[product_1][product_id]': this.state.products[0].id,
        'data[product_1][variant_id]': this.state.products[0].variantId,
        'data[product_2][product_id]': this.state.products[1].id,
        'data[product_2][variant_id]': this.state.products[1].variantId,
        'data[product_3][product_id]': this.state.products[2].id,
        'data[product_3][variant_id]': this.state.products[2].variantId,
        'data[prodFill][0][name]': this.state.products[0].title,
        'data[prodFill][0][style]': this.state.products[0].rechargeStyle,
        'data[prodFill][0][id]': this.state.products[0].id,
        'data[prodFill][0][color]': this.state.products[0].swatch_name,
        'data[prodFill][0][variantId]': this.state.products[0].variantId,
        'data[prodFill][0][image]': this.state.products[0].featured_image,
        'data[prodFill][0][type]': this.state.products[0].type,
        'data[prodFill][1][name]': this.state.products[1].title,
        'data[prodFill][1][style]': this.state.products[1].rechargeStyle,
        'data[prodFill][1][id]': this.state.products[1].id,
        'data[prodFill][1][color]': this.state.products[1].swatch_name,
        'data[prodFill][1][variantId]': this.state.products[1].variantId,
        'data[prodFill][1][image]': this.state.products[1].featured_image,
        'data[prodFill][1][type]': this.state.products[1].type,
        'data[prodFill][2][name]': this.state.products[2].title,
        'data[prodFill][2][style]': this.state.products[2].rechargeStyle,
        'data[prodFill][2][id]': this.state.products[2].id,
        'data[prodFill][2][color]': this.state.products[2].swatch_name,
        'data[prodFill][2][variantId]': this.state.products[2].variantId,
        'data[prodFill][2][image]': this.state.products[2].featured_image,
        'data[prodFill][2][type]': this.state.products[2].type,
        'data[productCounter]': '1'
      }
    }
  }

  _getBraType(products) {
    if (products.some(product => product.braletteType?.includes('relief'))) {
      return 'relief';
    } else if (products.some(product => product.braletteType?.includes('support'))) {
      return 'support';      
    } else if (products.some(product => product.braletteType?.includes('scoop'))) {
      return 'sheer';
    } else {
      return 'support';
    }
  }

  _confirmRechargeSelections() {
    console.log('confirmRechargeSelections');

    this._disableButton(this.confirmSelectionsBtn);

    let url = null;
    let size = null;
    let productData = null;

    if (this.state.box === 'matching-set') {
      const braType = this._getBraType(this.state.products);
      url = `https://api.join-eby.com/other/custom_set_${braType}_v5.php`;
      size = this.state.sizes.braSize.toLowerCase();
      productData = this._getProductData(this.state.box, size, braType);
    } else if (this.state.box === '3-panties') {
      url = 'https://api.join-eby.com/other/custom_box_v5.php';
      size = `${this.state.sizes.pantySize.toLowerCase()} / xs`;
      productData = this._getProductData(this.state.box, size);
    }

    fetch(url, {
      method: "POST",
      headers: {
        'Accept': 'application/json, text/javascript, */*; q=0.01',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Origin': 'https://shop.join-eby.com',
        'Referer': 'https://shop.join-eby.com/'
      },
      body: new URLSearchParams(productData).toString()
    })
    .then(response => response.json())
    .then(response => {
      console.log(response);

      if (!response.success) {
        throw new Error('Failed to confirm selections: ' + (response.message || 'Unknown error'));
      }
      window.location.href = window.routes.account_url;
    })
    .catch(error => {
      console.error('Error confirming selections:', error);
      alert('Error confirming selections.');
    })
    .finally(() => {
      this._enableButton(this.confirmSelectionsBtn);
      this.modal.close();
      console.log('confirmRechargeSelections END');
    });
  }

  /* Page 7/8 -- Checkout page methods */
  async _initCheckoutPage() {
    const { subscriptionBoxParent, subscriptionBoxVariant, subscriptionBoxChildren, subscriptionBoxParentMetafields } = await this._setSubscriptionBox();

    if (this.state.currentSubscriptionBox) this.state.currentSubscriptionBox = null;

    this.state.currentSubscriptionBox = {
      parent: subscriptionBoxParent,
      variant: subscriptionBoxVariant,
      children: subscriptionBoxChildren,
      parentMetafields: subscriptionBoxParentMetafields
    }

    this._updateCheckoutPageUI();
    this._setSubmitOrderListener();
  }

  _setSubmitOrderListener() {
    this.submitOrder.addEventListener('click', this._submitOrder);
  }

  async _getSellingPlanData(handle) {
    const url = window.Shopify.routes.root + "products/" + handle + ".js";
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const json = await response.json();
      return json.selling_plan_groups?.[1]?.selling_plans?.[0]?.id;
    } catch (error) {
      console.error('Error fetching selling plan data:', error);
      return null;
    }
  }

  _submitOrder = async (e) => {
    e.preventDefault();

    this._disableButton(this.submitOrder);

    const timestamp = parseInt(Date.now().toString() + Math.floor(Math.random() * 10000));
    let childrenProperties = {};
    let membershipProperties = {};
    let transformTitle = '';
    let sizeBoxTitles = `${this.state.sizes.braSize ? `${this.state.sizes.braSize} (${this.state.sizes.bandSize}${this.state.sizes.cupSize}) / ` : ''}${this.state.sizes.pantySizeDisplay} (${this.state.sizes.pantySizeNumeric})`;
    let renewalPrice = `${theme.utils.formatMoney(this.state.currentSubscriptionBox.variant.price, this.moneyFormat)}`;
    let subPrice = `${theme.utils.formatMoney(this.state.currentSubscriptionBox.variant.price / 2, this.moneyFormat)}`;
    let currentBoxisCustomBox = this.state.box === 'matching-set' || this.state.boxType === 'choose-your-own' ? 'Choose My Own' : '';
    let currentBoxFreq = this.state.box === 'matching-set' ? '1 matching set' : '3 panties';

    if (this.state.boxType === 'surprise-me') {
      childrenProperties = {
        _included_in_membershipbox: 'true',
        _product_type: 'Sub Subscription',
        '_Shipping Option': 'pickup Subscription WH'
      }

      transformTitle = 'Panty';
    } else {
      childrenProperties = {
        _included_in_custombox: 'true',
        '_Shipping Option': 'pickup Ecommerce WH'
      }
    }

    const sellingPlanId = await this._getSellingPlanData(this.state.currentSubscriptionBox.parent.handle);

    membershipProperties = {
      '_product_type' : 'Main Subscription',
      '_Shipping Option' : "pickup Subscription WH",
      "_box_pref" : this.state.currentSubscriptionBox.parent.title + " - " + this.state.currentSubscriptionBox.variant.title,
      "_box_measurements" : this.state.currentSubscriptionBox.variant.title,
      "_box_v4_color":  this.state.colorProfile,
      "_box_v4_sizes": sizeBoxTitles,
      "_box_v4_renews": renewalPrice,
      "_box_v4_isCustom": currentBoxisCustomBox,
      "_box_v4_freq": currentBoxFreq,
      "_box_perk" : this.state.currentSubscriptionBox.parent.title,
      '_shipping_interval_unit_type' : "month",
      "_shipping_interval_frequency" : 3,
      "_subs_version": "4.0",
      '_tiertwo_sub_price_enabled' : "true",
      "_tierfour_sub_price" : subPrice,
      "_intro_sub_offer" : this.state.currentSubscriptionBox.parentMetafields.subscription_offer
    };

    membershipProperties['_subscription_ids'] = this.state.currentSubscriptionBox.children
      .map(child => child.variantId || child.selectedVariant.id)
      .join(',');

    // Create fetch data
    const data = {
      attributes: {
        'has_curated_membership': true
      },
      items: [
        ...this.state.currentSubscriptionBox.children.map(child => ({
          id: child.variantId || child.selectedVariant.id,
          quantity: 1,
          properties: {
            '_timeStamp': String(timestamp),
            "_intro_sub_offer": child.subscription_offer,
            ...childrenProperties,
            ...(transformTitle && { '_transformTitle': transformTitle })
          }
        })),
        {
          id: this.state.currentSubscriptionBox.variant.id,
          quantity: 1,
          properties: {
            '_timeStamp': String(timestamp),
            ...membershipProperties,
            '_subscriptionBox': true
          },
          selling_plan: sellingPlanId
        }
      ],
      sections: this.cart.getSectionsToRender().map(section => section.id)
    };
    
    // Fetch post add to cart
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then((response) => {
      if (document.querySelector('cart-items')) {
        document.querySelector('cart-items').onCartUpdate();
      }
      this.cart.renderContents(response);
      
      if (this.cartDrawer.getAttribute('aria-hidden') == 'true') {
        this.cartDrawer.open();
      }
    })
    .catch((e) => {
      console.log(e);
    })
    .finally(() => {
      this._enableButton(this.submitOrder);
      this._updatePage(1);
    })
  }

  async _setSubscriptionBox() {
    try {
      let collectionHandle = null;

      if (this.state.box === 'matching-set') {
        collectionHandle = this.getAttribute('data-set-collection');
      } else if (this.state.boxType === 'choose-your-own') {
        collectionHandle = this.getAttribute('data-panty-collection');
      } else if (this.state.boxType === 'surprise-me') {
        if (this.state.pantyPreference) {
          if (this.state.pantyPreference === 'full-coverage') {
            collectionHandle = this.getAttribute('data-full-coverage-collection');
          } else {
            collectionHandle = this.getAttribute('data-mixed-coverage-collection');
          }
        }
      }

      const targetURL = `/collections/${collectionHandle}/?view=json`;
      const { productJSONs, collectionJSON } = await this._getCollectionJSON(targetURL);

      if (!productJSONs) {
        throw new Error('Invalid collection JSON data');
      }

      const subscriptionBoxParentMetafields = this._getParentProductMetafields(collectionJSON);

      const { subscriptionBoxParent, subscriptionBoxVariant } = this._getSubscriptionBoxParent(productJSONs);

      let subscriptionBoxChildren = null;
      if (this.state.box === 'matching-set' || this.state.boxType === 'choose-your-own') {
        subscriptionBoxChildren = this.state.products;
      } else {
        subscriptionBoxChildren = this._getSubscriptionBoxChildren(productJSONs);
      }

      if (!subscriptionBoxParent && !subscriptionBoxChildren) {
        throw new Error('Subscription box product not found in collection');
      }

      return { subscriptionBoxParent, subscriptionBoxVariant, subscriptionBoxChildren, subscriptionBoxParentMetafields };
    } catch (error) {
      console.error('Error getting subscription box product:', error);
      return null;
    }
  }
  _getParentProductMetafields(collectionJSON) {
    if (this.state.box === 'matching-set') {
      let subscriptionBoxParentMetafields = null;

      if (this.state.products.some(product => product.braletteType?.includes('relief'))) {
        subscriptionBoxParentMetafields = collectionJSON.find(product => product.handle.includes('relief-set-subscription-box'));
      } else if (this.state.products.some(product => product.braletteType?.includes('support'))) {
        subscriptionBoxParentMetafields = collectionJSON.find(product => product.handle.includes('support-set-subscription-box'));
      } else if (this.state.products.some(product => product.braletteType?.includes('scoop'))) {
        subscriptionBoxParentMetafields = collectionJSON.find(product => product.handle.includes('custom-set-subscription-box'));
      } else if (this.state.products.some(product => product.braletteType?.includes('wireless'))) {
        subscriptionBoxParentMetafields = collectionJSON.find(product => product.handle.includes('wireless-set-subscription-box'));
      }

      return subscriptionBoxParentMetafields;

    } else {
      subscriptionBoxParentMetafields = collectionJSON.find(product => product.handle.includes('subscription-box'));
      return subscriptionBoxParentMetafields;
    }
  }

  _getSubscriptionBoxParent(productJSONs) {

    if (this.state.box === 'matching-set') {
      let subscriptionBoxParent = null;

      if (this.state.products.some(product => product.braletteType?.includes('relief'))) {
        subscriptionBoxParent = productJSONs.find(product => product.handle.includes('relief-set-subscription-box'));
      } else if (this.state.products.some(product => product.braletteType?.includes('support'))) {
        subscriptionBoxParent = productJSONs.find(product => product.handle.includes('support-set-subscription-box'));
      } else if (this.state.products.some(product => product.braletteType?.includes('scoop'))) {
        subscriptionBoxParent = productJSONs.find(product => product.handle.includes('custom-set-subscription-box'));
      } else if (this.state.products.some(product => product.braletteType?.includes('wireless'))) {
        subscriptionBoxParent = productJSONs.find(product => product.handle.includes('wireless-set-subscription-box'));
      }

      const subscriptionBoxVariant = subscriptionBoxParent.variants.find(variant => 
        variant.title.toLowerCase() === `${this.state.sizes.pantySize.toLowerCase()} / ${this.state.sizes.braSize}` && 
        variant.available === true
      );

      return { subscriptionBoxParent, subscriptionBoxVariant };
    } else {
      const subscriptionBoxParent = productJSONs.find(product => product.handle.includes('subscription-box'));
      const braSize = this._getEquivalentBraVariant(this.state.sizes.pantySize.toLowerCase()) || this.state.sizes.pantySize.toLowerCase();
      
      const subscriptionBoxVariant = subscriptionBoxParent.variants.find(variant => 
        variant.title.toLowerCase() === `${this.state.sizes.pantySize.toLowerCase()} / ${braSize}` && 
        variant.available === true
      );
      
      return { subscriptionBoxParent, subscriptionBoxVariant };
    }
  }

  _getEquivalentBraVariant(size) {
    const sizeMapping = {
      '2x': 'mdd',
      '3x': 'ldd',
      '4x': 'xldd'
    };

    return sizeMapping[size.toLowerCase()] || null;
  }

  _getSubscriptionBoxChildren(productJSONs) {
    try {
      const matchingProducts = [];
      
      for (const productJSON of productJSONs) {
        if (productJSON.handle.includes('subscription-box')) continue;
        
        const matchingVariant = productJSON.variants.find(variant => 
          variant.title.toLowerCase() === this.state.sizes.pantySize.toLowerCase() && 
          variant.available === true
        );

        if (matchingVariant) {
          matchingProducts.push({
            selectedVariant: matchingVariant
          });
        }

        if (matchingProducts.length === 3) break;
      }

      return matchingProducts.length ? matchingProducts : null;
    } catch (error) {
      console.error('Error getting subscription box children:', error);
      return null;
    }
  }

  _resetCheckoutPageUI() {
    this.subscriptionProduct.classList.add('hidden');
    this.submitOrder.setAttribute('disabled', 'disabled');
  }

  _updateCheckoutPageUI() {
    if (!this.state.currentSubscriptionBox && this.subscriptionProduct) return;

    let boxTitle = this._formatTitle(this.state.box);
    let boxType = this.state.boxType ? this._formatTitle(this.state.boxType) : null;
    let sizeDisplay = `${this.state.sizes.braSize ? `${this.state.sizes.braSize} (${this.state.sizes.bandSize}${this.state.sizes.cupSize}), ` : ''}${this.state.sizes.pantySizeDisplay} (${this.state.sizes.pantySizeNumeric})`;
    let colorProfile = this.state.colorProfile ? this._formatTitle(this.state.colorProfile) : null;

    this.subscriptionProduct.innerHTML = `
      <div class="subscription-product__image-container relative rounded-lg overflow-hidden">
        <img class="subscription-product__image" src="${this.state.currentSubscriptionBox.parent.featured_image}" alt="${this.state.currentSubscriptionBox.parent.title}">
      </div>
      <div class="subscription-product__info flex flex-col justify-start gap-xxs col-span-2">
        <h3 class="subscription-product__title text-14 font-700">Subscription Box</h3>
        <div class="subscription-product__info-text flex flex-col justify-start gap-xxs text-small leading-4">
          <p class="subscription-product__info-text-item">${boxTitle}</p>
          ${boxType ? `<p class="subscription-product__info-text-item">${boxType}</p>` : ''}
          ${colorProfile ? `<p class="subscription-product__info-text-item">${colorProfile}</p>` : ''}
          <p class="subscription-product__info-text-item">${sizeDisplay.toUpperCase()}</p>
        </div>
      </div>
    `;

    this.subscriptionProduct.classList.remove('hidden');
    this.submitOrder.removeAttribute('disabled');
  }

  /* Helper methods */
  _getCollectionJSON(url) {
    return fetch(url)
      .then(response => response.text())
      .then((text) => {
        const html = text;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
        const collectionJSON = JSON.parse(JSONcontainer.innerHTML);

        const productJSONElements = parsedHTML.querySelectorAll('[js-product-json]');
        const productJSONs = Array.from(productJSONElements).map(el => JSON.parse(el.innerHTML));

        return { collectionJSON, productJSONElements, productJSONs };
      })
  }

  _formatTitle(string) {
    return string
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
class MysteryGiftSelector extends HTMLElement {
  constructor() {
    super();
    
    this.sizeDropdown = this.querySelector('[js-mystery-gift-size]');
    this.statusElement = this.querySelector('[js-mystery-gift-status]');
    this.collectionHandle = this.dataset.collectionHandle;
    this.mysteryPrice = this.dataset.mysteryPrice;
    this.mysteryItemTitle = this.dataset.mysteryItemTitle;
    this.mysteryImage = this.dataset.mysteryImage;
    if(this.dataset.gwpLevel) {
      this.gwpLvl = this.dataset.gwpLevel
    } else {
    }
    if(this.dataset.isGwp) {
      this.isGwp = true;
    } else {
      this.isGwp = false;
    }

    if(this.dataset.gwpThreshold) {
      this.isGwp = true;
    } else {
      this.isGwp = false;
    }
    
    this.cart = document.querySelector('cart-drawer');
    this.cartDrawer = document.querySelector('#CartDrawer');
    
    this.init();
  }
  
  async init() {
    if (!this.collectionHandle) {
      console.error('Mystery gift collection handle not found');
      return;
    }
    
    await this.loadCollectionProducts();
    this.bindEvents();
  }
  
  async loadCollectionProducts() {
    try {
      const response = await fetch(`/collections/${this.collectionHandle}/products.json`);
      const data = await response.json();
      this.products = data.products;
      
      this.populateSizeOptions();
    } catch (error) {
      console.error('Error loading mystery gift collection:', error);
    }
  }
  
  populateSizeOptions() {
    if (!this.products || this.products.length === 0) {
      return;
    }
    
    // Get all available sizes from all products in the collection
    const availableSizes = new Set();
    
    this.products.forEach(product => {
      product.variants.forEach(variant => {
        if (variant.available && variant.option1) {
          // Assuming size is the first option
          availableSizes.add(variant.option1);
        }
      });
    });
    
    
    // Define size order
    const sizeOrder = ["xs", "sm", "md", "lg", "xl", "1x", "2x", "3x", "4x"];
    
    // Sort sizes according to the defined order
    const sortedSizes = Array.from(availableSizes).sort((a, b) => {
      const aIndex = sizeOrder.indexOf(a.toLowerCase());
      const bIndex = sizeOrder.indexOf(b.toLowerCase());
      
      // If both sizes are in the order array, sort by their position
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      
      // If only one size is in the order array, prioritize it
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
      
      // If neither size is in the order array, sort alphabetically
      return a.localeCompare(b);
    });
    
    // Create options array for dropdown
    const options = sortedSizes.map(size => ({
      value: size,
      text: size,
      html: size
    }));
    
    // Set options using dropdown API
    this.sizeDropdown.setOptions(options);
  }
  
  bindEvents() {
    this.sizeDropdown?.addEventListener('dropdown:change', this.onSizeChange.bind(this));
  }
  
  async onSizeChange(event) {

    const selectedSize = event.detail.value;
    
    if (!selectedSize) {
      return;
    }
    
    // Show loading status
    this.showStatus('Adding mystery gift...');
    this.sizeDropdown.disable();
    
    try {
      const mysteryProduct = this.findFirstAvailableProduct(selectedSize);
      
      if (!mysteryProduct) {
        throw new Error('No available mystery gift found in selected size');
      }
      if(this.isGwp) {
        console.log('New FUNCTION')
        await this.addMysteryGWP(mysteryProduct, this.gwpLvl, this.gwpThreshold)
      } else {
        console.log('OLD FUNCTION')
        await this.addMysteryGiftToCart(mysteryProduct);
      }
      

      
    } catch (error) {
      console.error('Error adding mystery gift:', error);
      this.showError('Unable to add mystery gift. Please try again.');
      // Reset the dropdown to allow retry
      this.sizeDropdown.setValue('');
      this.sizeDropdown.enable();
    }
  }
  
  findFirstAvailableProduct(size) {
    for (const product of this.products) {
      const variant = product.variants.find(v => 
        v.available && 
        v.option1 === size
      );
      
      if (variant) {
        return {
          product: product,
          variant: variant
        };
      }
    }
    
    return null;
  }
  
  async addMysteryGiftToCart(mysteryProduct) {
    const { product, variant } = mysteryProduct;
    
    const data = {
      items: [{
        id: variant.id,
        quantity: 1,
        properties: {
          "_Shipping Option": "Ecommerce WH",
          '_mystery_gift': 'true',
          '_mystery_original_product_id': product.id,
          '_mystery_original_variant_id': variant.id,
          '_mystery_original_title': product.title,
          '_mystery_original_image': product.featured_image,
          '_mystery_original_price': variant.price,
          '_mystery_display_price': this.mysteryPrice,
          '_mystery_item_title': this.mysteryItemTitle,
          '_mystery_display_image': this.mysteryImage
        }
      }],
      sections: this.cart.getSectionsToRender().map((section) => section.id)
    };
    
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    
    const result = await response.json();
    
    if (result.status) {
      throw new Error(result.description || 'Failed to add mystery gift to cart');
    }
    
    // Update cart UI
    if (document.querySelector('cart-items')) {
      document.querySelector('cart-items').onCartUpdate();
    }
    
    this.cart.renderContents(result);
    
    // Show success message and hide upsell
    this.showSuccess('Mystery gift added to cart!');
  }

  async addMysteryGWP(mysteryProduct, level, threshold) {
    const gwpLvl = level
    const gwpThreshold = threshold
    const { product, variant } = mysteryProduct;
    
    const data = {
      items: [{
        id: variant.id,
        quantity: 1,
        properties: {
          '_gwp': 'true',
          '_gwp_id': variant.id,
          '_gwp_level': gwpLvl,
          '_gwp_threshold': gwpThreshold,
          '_gwp_discount': variant.price,
          '_gwp_original_price': variant.price,
          '_gwp_original_title': product.title,
          '_gwp_original_image': product.featured_image,
          '_mystery_gift': 'true',
          '_mystery_display_price': this.mysteryPrice,
          '_mystery_item_title': this.mysteryItemTitle,
          '_mystery_display_image': this.mysteryImage
        }
      }],
      sections: this.cart.getSectionsToRender().map((section) => section.id)
    };

    
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    
    const result = await response.json();
    
    if (result.status) {
      throw new Error(result.description || 'Failed to add mystery gift to cart');
    }
    
    // Update cart UI
    if (document.querySelector('cart-items')) {
      document.querySelector('cart-items').onCartUpdate();
    }
    
    this.cart.renderContents(result);
    
    // Show success message and hide upsell
    this.showSuccess('GWP added to cart!');
  }
  
  showStatus(message) {
    if (this.statusElement) {
      this.statusElement.textContent = message;
      this.statusElement.style.display = 'block';
    }
  }
  
  hideStatus() {
    if (this.statusElement) {
      this.statusElement.style.display = 'none';
    }
  }
  
  showError(message) {
    console.error(message);
    if (this.statusElement) {
      this.statusElement.textContent = message;
      this.statusElement.style.display = 'block';
      this.statusElement.style.color = '#dc2626'; // red color
    }
  }
  
  showSuccess(message) {
    console.log(message);
    // Hide the entire mystery gift upsell after successful addition
    console.log('THIS', this.closest('.mystery-gift-upsell'))
    this.closest('.mystery-gift-upsell')?.remove();
  }
}


class Dropdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.trigger = this.querySelector('[data-dropdown-trigger]');
    this.dropdown = this.querySelector('[data-dropdown-menu]');
    this.hiddenInput = this.querySelector('[data-dropdown-input]');
    this.caret = this.querySelector('[data-dropdown-caret]');
    
    this.isOpen = false;
    this.selectedIndex = -1;
    this.options = [];
    
    
    this.init();
  }
  
  init() {
    this.setupOptions();
    this.bindEvents();
    this.setupAccessibility();
  }
  
  setupOptions() {
    const optionElements = this.querySelectorAll('[data-dropdown-option]');
    this.options = Array.from(optionElements).map((el, index) => ({
      element: el,
      value: el.dataset.value || '',
      text: el.textContent.trim(),
      html: el.innerHTML,
      index: index
    }));

    
    // Set initial selected option if there's a value
    const initialValue = this.hiddenInput?.value;
    if (initialValue) {
      const option = this.options.find(opt => opt.value === initialValue);
      if (option) {
        this.selectOption(option.index, false);
      }
    }
  }
  
  setupAccessibility() {
    // Set up ARIA attributes
    this.trigger.setAttribute('role', 'combobox');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.trigger.setAttribute('aria-haspopup', 'listbox');
    this.trigger.setAttribute('tabindex', '0');
    
    this.dropdown.setAttribute('role', 'listbox');
    this.dropdown.setAttribute('aria-hidden', 'true');
    
    // Set up option ARIA attributes
    this.options.forEach((option, index) => {
      option.element.setAttribute('role', 'option');
      option.element.setAttribute('tabindex', '-1');
      option.element.id = `${this.id || 'dropdown'}-option-${index}`;
    });
    
    // Generate unique IDs if needed
    if (!this.dropdown.id) {
      this.dropdown.id = `dropdown-menu-${Math.random().toString(36).substr(2, 9)}`;
    }
    
    this.trigger.setAttribute('aria-controls', this.dropdown.id);
  }
  
  bindEvents() {
    // Trigger events
    
    // Store bound functions for later removal
    this.boundToggle = this.toggle.bind(this);
    this.boundHandleTriggerKeydown = this.handleTriggerKeydown.bind(this);
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this);
    this.boundHandleEscape = (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    };
    
    this.trigger.addEventListener('click', this.boundToggle);
    this.trigger.addEventListener('keydown', this.boundHandleTriggerKeydown);
    
    // Option events
    this.options.forEach((option, index) => {
      option.element.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.selectOption(index);
      });
      option.element.addEventListener('mouseenter', () => this.highlightOption(index));
    });
    
    // Close on outside click
    document.addEventListener('click', this.boundHandleOutsideClick);
    
    // Close on escape
    document.addEventListener('keydown', this.boundHandleEscape);
  }

  unbindEvents() {
    
    // Remove trigger events if they exist
    if (this.boundToggle) {
      this.trigger.removeEventListener('click', this.boundToggle);
    }
    if (this.boundHandleTriggerKeydown) {
      this.trigger.removeEventListener('keydown', this.boundHandleTriggerKeydown);
    }
    
    // Don't need to remove option events since they'll be recreated
    // The options array will be repopulated in setupOptions()
    
    // // Remove document events if they exist
    // if (this.boundHandleOutsideClick) {
    //   document.removeEventListener('click', this.boundHandleOutsideClick);
    // }
    // if (this.boundHandleEscape) {
    //   document.removeEventListener('keydown', this.boundHandleEscape);
    // }
    
    // Clear the options array
    this.options = [];
  }
  
  toggle(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
  
  open() {
    if (this.isOpen) return;
    
    this.isOpen = true;
    this.dropdown.classList.remove('hidden');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.dropdown.setAttribute('aria-hidden', 'false');
    
    // Rotate caret
    if (this.caret) {
      this.caret.style.transform = 'rotate(180deg)';
    }
    
    // Focus first option or selected option
    const focusIndex = this.selectedIndex >= 0 ? this.selectedIndex : 0;
    if (this.options[focusIndex]) {
      this.highlightOption(focusIndex);
    }
    // Close all other open dropdowns when this one opens
    document.querySelectorAll('s-dropdown, dropdown').forEach(dropdownEl => {
      if (dropdownEl !== this && typeof dropdownEl.close === 'function' && dropdownEl.isOpen) {
        dropdownEl.close();
      }
    });
    // Dispatch open event
    this.dispatchEvent(new CustomEvent('dropdown:open'));

  }
  
  close() {
    if (!this.isOpen) return;
    
    this.isOpen = false;
    this.dropdown.classList.add('hidden');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.dropdown.setAttribute('aria-hidden', 'true');
    
    // Reset caret
    if (this.caret) {
      this.caret.style.transform = 'rotate(0deg)';
    }
    
    // Clear highlights
    this.clearHighlight();
    
    // Return focus to trigger
    this.trigger.focus();
    
    // Dispatch close event
    this.dispatchEvent(new CustomEvent('dropdown:close'));
  }
  
  selectOption(index, shouldClose = true) {
    if (index < 0 || index >= this.options.length) return;
    
    const option = this.options[index];
    
    // Update selected index
    this.selectedIndex = index;
    
    // Update trigger text
    const triggerText = this.trigger.querySelector('[data-dropdown-text]');
    triggerText.innerHTML = option.html;
    
    // Update hidden input
    if (this.hiddenInput) {
      this.hiddenInput.value = option.value;
      
      // Trigger change event on hidden input
      this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    // Update ARIA
    this.trigger.setAttribute('aria-activedescendant', option.element.id);
    
    // Update option states
    this.options.forEach((opt, i) => {
      opt.element.setAttribute('aria-selected', i === index ? 'true' : 'false');
      opt.element.classList.toggle('selected', i === index);
    });
    
    if (shouldClose) {
      this.close();
    }
    
    // Dispatch change event
    this.dispatchEvent(new CustomEvent('dropdown:change', {
      detail: { 
        value: option.value, 
        text: option.text,
        index: index,
        option: option
      }
    }));
  }
  
  highlightOption(index) {
    this.clearHighlight();
    
    if (index >= 0 && index < this.options.length) {
      this.options[index].element.classList.add('highlighted');
      this.options[index].element.scrollIntoView({ block: 'nearest' });
    }
  }
  
  clearHighlight() {
    this.options.forEach(option => {
      option.element.classList.remove('highlighted');
    });
  }
  
  handleTriggerKeydown(e) {
    switch (e.key) {
      case 'Enter':
      case ' ':
        e.preventDefault();
        this.toggle();
        break;
      case 'ArrowDown':
        e.preventDefault();
        if (!this.isOpen) {
          this.open();
        } else {
          const nextIndex = this.getHighlightedIndex() + 1;
          this.highlightOption(nextIndex < this.options.length ? nextIndex : 0);
        }
        break;
      case 'ArrowUp':
        e.preventDefault();
        if (!this.isOpen) {
          this.open();
        } else {
          const prevIndex = this.getHighlightedIndex() - 1;
          this.highlightOption(prevIndex >= 0 ? prevIndex : this.options.length - 1);
        }
        break;
      case 'Enter':
        if (this.isOpen) {
          e.preventDefault();
          const highlightedIndex = this.getHighlightedIndex();
          if (highlightedIndex >= 0) {
            this.selectOption(highlightedIndex);
          }
        }
        break;
    }
  }
  
  getHighlightedIndex() {
    return this.options.findIndex(option => option.element.classList.contains('highlighted'));
  }
  
  handleOutsideClick(e) {
    // Don't close if clicking inside the dropdown component
    if (this.isOpen && !this.contains(e.target)) {
      this.close();
    }
  }
  
  // Public API methods
  setOptions(options) {
    // Clear existing options
    const optionsContainer = this.dropdown.querySelector('[data-dropdown-options]') || this.dropdown;
    optionsContainer.innerHTML = '';
    
    // Add new options
    options.forEach((option, index) => {
      const optionEl = document.createElement('div');
      optionEl.setAttribute('data-dropdown-option', '');
      optionEl.setAttribute('data-value', option.value || '');
      optionEl.className = 'dropdown-option';
      optionEl.innerHTML = option.html || option.text || '';
      
      optionsContainer.appendChild(optionEl);
    });
    
    // Reinitialize
    this.unbindEvents(); // Remove old events first
    this.setupOptions(); // Set up new options array
    this.setupAccessibility(); // Set up ARIA
    this.bindEvents(); // Bind events to new options
  }
  
  getValue() {
    return this.hiddenInput?.value || '';
  }
  
  setValue(value) {
    const option = this.options.find(opt => opt.value === value);
    if (option) {
      this.selectOption(option.index, false);
    }
  }
  
  getSelectedOption() {
    return this.selectedIndex >= 0 ? this.options[this.selectedIndex] : null;
  }
  
  disable() {
    this.trigger.setAttribute('disabled', '');
    this.trigger.setAttribute('tabindex', '-1');
    this.classList.add('disabled');
  }
  
  enable() {
    this.trigger.removeAttribute('disabled');
    this.trigger.setAttribute('tabindex', '0');
    this.classList.remove('disabled');
  }
}


customElements.define("s-drawer", Drawer);
customElements.define("s-drawer-menu", DrawerMenu);
customElements.define("s-modal", Modal);
customElements.define("s-accordion", Accordion);
customElements.define("s-tabs", Tabs);
customElements.define("s-carousel", Carousel);
customElements.define("s-video", Video);
customElements.define("s-toast", Toast);
customElements.define('s-dropdown', Dropdown);
customElements.define("s-countdown", Countdown);
customElements.define("video-autoplay", VideoAutoplay);
customElements.define('subscription-module', SubscriptionModule);
customElements.define('cart-remove-button', CartRemoveButton);
customElements.define('cart-items', CartItems);
customElements.define('cart-note', CartNote);
customElements.define('cart-drawer', CartDrawer);
customElements.define('cart-drawer-items', CartDrawerItems);
customElements.define('mystery-gift-selector', MysteryGiftSelector);

customElements.define("s-header", SiteHeader);

customElements.define("product-options", ProductOptions);
customElements.define("quantity-input", QuantityInput);
customElements.define("loading-spinner", LoadingSpinner);
customElements.define("predictive-search", PredictiveSearch);
customElements.define("filter-sort", FilterSort);
customElements.define('active-filters', ActiveFilters);
customElements.define('price-range', PriceRange);
customElements.define('product-card', ProductCard);
customElements.define('product-card--upsell', ProductCardUpsell);
customElements.define('product-bundler', ProductBundler);
customElements.define('bundle-card', BundleCard);

/*================ Sections ================*/
/**
 * Main Collection Section Logic (filter and sorting)
 * ------------------------------------------------------------------------
 * Ajax-enhanced collection grid with uniform DESKTOP row heights only.
 */

class CollectionGrid extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      productGrid: '[js-products-grid]',
      filterSort: '[js-filter-sort]',
      sortTrigger: '[js-collection-sort-trigger]',
      filterTrigger: '[js-filter-trigger]',
      filterTriggerText: '[js-filter-trigger-text]',
      nextPage: '[js-next-page]',
      gridItems: '.collection-grid__product, .collection-grid__tile',
      productLis: '.collection-grid__product'
    };

    this._refresh = [
      '[js-products-grid]',
      '[js-collection-sort-trigger]',
      '[js-pagination]',
    ];

    this._cache = [];

    // Enforce only at desktop (match your Tailwind "desktop" ≈ 1024px)
    this._DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');

    this._measureRaf = null;
    this._measureTimer = null;

    this._resizeObserver = null;
    this._mutationObserver = null;

    // Infinite-scroll internals
    this._io = null;
    this._sentinel = null;
    this._loading = false;
  }

  connectedCallback() {
    this.productGrid = this.querySelector(this._selectors.productGrid);

    this.sortTrigger = this.querySelector(this._selectors.sortTrigger);
    this.filterTrigger = this.querySelector(this._selectors.filterTrigger);
    this.filterTriggerText = this.querySelector(this._selectors.filterTriggerText);

    this._setListeners();
    this._initInfiniteScroll();
    this._retainHistory();

    // Normalize heights (desktop only)
    this._initRowHeightNormalization();
    
    // Adjust sort trigger width to fit text
    this._adjustSortTriggerWidth();
  }

  disconnectedCallback() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
    if (this._mutationObserver) this._mutationObserver.disconnect();
    if (this._io) { this._io.disconnect(); this._io = null; }

    window.removeEventListener('resize', this._scheduleMeasure);
    document.removeEventListener('filter:change', this._handleFilterChange);
    if (this._DESKTOP_MQ.removeEventListener) {
      this._DESKTOP_MQ.removeEventListener('change', this._measureNowBound);
    } else {
      this._DESKTOP_MQ.onchange = null;
    }
  }

  _setListeners() {
    document.addEventListener('filter:change', this._handleFilterChange);

    if (this.sortTrigger) {
      this.sortTrigger.addEventListener('change', this._handleSortTrigger);
    }
    if (this.filterTrigger) {
      this.filterTrigger.addEventListener('click', this._togglefilterDrawer);
    }
    window.addEventListener('resize', this._scheduleMeasure);
  }

  _togglefilterDrawer = (e) => {
    const source = e.currentTarget;
    const target = this.querySelector(`#${source.getAttribute('aria-controls')}`);
    if (!target) return;

    const hidden = target.getAttribute('aria-hidden') == 'true';
    target.setAttribute('aria-hidden', hidden ? 'false' : 'true');
    if (this.filterTriggerText) this.filterTriggerText.textContent = hidden ? 'Hide Filters' : 'Show Filters';
  }

  _handleSortTrigger = (evt) => {
    evt.preventDefault();
    const mainSort = document.querySelector('[js-filter-form] [js-sort]');
    const sortInputToClick = mainSort && mainSort.querySelector(`input[value="${evt.currentTarget.value}"]`);
    if (sortInputToClick) sortInputToClick.click();
    this._adjustSortTriggerWidth();
  }

  _adjustSortTriggerWidth() {
    if (!this.sortTrigger) return;
    
    const selectedOption = this.sortTrigger.options[this.sortTrigger.selectedIndex];
    if (!selectedOption) return;
    
    const tempElement = document.createElement('span');
    tempElement.style.visibility = 'hidden';
    tempElement.style.position = 'absolute';
    tempElement.style.whiteSpace = 'nowrap';
    tempElement.style.fontSize = window.getComputedStyle(this.sortTrigger).fontSize;
    tempElement.style.fontFamily = window.getComputedStyle(this.sortTrigger).fontFamily;
    tempElement.style.fontWeight = window.getComputedStyle(this.sortTrigger).fontWeight;
    tempElement.textContent = selectedOption.text;
    
    document.body.appendChild(tempElement);
    const textWidth = tempElement.offsetWidth;
    document.body.removeChild(tempElement);
    
    this.sortTrigger.style.width = `${textWidth + 28}px`;
  }

  _handleFilterChange = (evt) => {
    const { parsedHTML } = evt.detail;
    const scopedHTML = parsedHTML.querySelector(`[data-id="${this.dataset.id}"]`);
    theme.utils.refreshElements(this._refresh, scopedHTML, this);

    // re-cache product grid after refresh
    this.productGrid = this.querySelector(this._selectors.productGrid);

    // re-init infinite scroll and re-measure
    this._initInfiniteScroll();
    this._hookImageLoads();
    this._scheduleMeasure();
  }

  _retainHistory = () => {
    if (!history.state) return;
    if (history.state.products && this.productGrid) {
      this.productGrid.innerHTML = history.state.products;
      this._hookImageLoads();
      this._scheduleMeasure();
      
      this._initInfiniteScroll();
    }
  }

  _updateHistory(key, value, url) {
    let state = history.state ? history.state : {};
    state[key] = value;
    if (url) history.pushState(state, '', url);
    else history.pushState(state, '');
  }

  
  _getProducts = (url) => {
    return fetch(url)
      .then(response => response.text())
      .then((text) => new DOMParser().parseFromString(text, 'text/html'));
  }

  
  _normalizeUrl = (href) => {
    try {
      return new URL(href, window.location.origin).toString();
    } catch (e) {
      return '';
    }
  }

  _extractNextUrl = (root) => {
    if (!root) return '';

    const sn = root.querySelector?.('[js-next-page]');
    const ds = sn?.dataset?.url || sn?.getAttribute?.('data-url');
    if (ds) return this._normalizeUrl(ds);

    const linkNext = root.querySelector?.('link[rel="next"]')?.getAttribute('href');
    if (linkNext) return this._normalizeUrl(linkNext);

    const nextA =
      root.querySelector?.('[js-pagination] a[rel="next"]') ||
      root.querySelector?.('[js-pagination] a.pagination__next, .pagination__item--next a') ||
      root.querySelector?.('[js-pagination] a[aria-label="Next"], a[aria-label*="Next"]') ||
      root.querySelector?.('a[href*="page="][rel="next"]');

    const href = nextA?.getAttribute?.('href');
    if (href) return this._normalizeUrl(href);

    return '';
  }

  _initInfiniteScroll = () => {
    if (this._io) { this._io.disconnect(); this._io = null; }
    this._sentinel = null;

    const nextPage = this.querySelector(this._selectors.nextPage);
    if (!nextPage) return;

    if (!nextPage.dataset.url) {
      const seed = this._extractNextUrl(document);
      if (seed) nextPage.dataset.url = seed;
    }

    if (!nextPage.dataset.url || nextPage.dataset.url === 'null') {
      nextPage.remove();
      return;
    }

    this._sentinel = nextPage;

    this._io = new IntersectionObserver(async (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        if (this._loading) return;

        const url = this._sentinel?.dataset?.url;
        if (!url || url === 'null') {
          this._io.disconnect();
          this._sentinel?.remove();
          this._sentinel = null;
          return;
        }

        this._loading = true;
        try {
          await this._addProducts(this._sentinel);
        } finally {
          this._loading = false;
        }
      }
    }, {
      root: null,
      rootMargin: '400px 0px',
      threshold: 0
    });

    this._io.observe(this._sentinel);
  }

  _addProducts = async (nextPage) => {
    const url = nextPage?.dataset?.url;
    if (!url || url === 'null') {
      nextPage?.remove();
      return;
    }

    const parsedHTML = await this._getProducts(url);

    const parsedGrid = parsedHTML.querySelector(this._selectors.productGrid);
    if (!parsedGrid) {
      console.warn('[infinite] product grid not found in response for', url);
      return;
    }

    const newProductsHTML = parsedGrid.innerHTML;

    const respSentinel = parsedHTML.querySelector(this._selectors.nextPage);
    const newNextUrl =
      respSentinel?.dataset?.url ||
      respSentinel?.getAttribute?.('data-url') ||
      this._extractNextUrl(parsedHTML) ||
      '';

    if (this.productGrid.contains(nextPage)) {
      nextPage.insertAdjacentHTML('beforebegin', newProductsHTML);
    } else {
      this.productGrid.insertAdjacentHTML('beforeend', newProductsHTML);
    }

    if (newNextUrl) {
      nextPage.dataset.url = this._normalizeUrl(newNextUrl);
    } else {
      if (this._io) this._io.disconnect();
      nextPage.remove();
      this._sentinel = null;
    }

    this._updateHistory('products', this.productGrid.innerHTML, url);
    this._hookImageLoads();
    this._scheduleMeasure();
  }

  /* ------------------------------------------------------------------
   * Row-height normalization (DESKTOP ONLY)
   * ------------------------------------------------------------------ */

  _initRowHeightNormalization() {
    this._scheduleMeasure = this._scheduleMeasure.bind(this);
    this._measureNowBound = this._measureNow.bind(this);

    // initial passes
    this._scheduleMeasure();
    if (document.readyState === 'complete') {
      this._scheduleMeasure();
    } else {
      window.addEventListener('load', this._scheduleMeasure, { once: true });
    }

    // respond to breakpoint change
    if (this._DESKTOP_MQ.addEventListener) {
      this._DESKTOP_MQ.addEventListener('change', this._measureNowBound);
    } else {
      this._DESKTOP_MQ.onchange = this._measureNowBound;
    }

    // observe grid size changes
    if (window.ResizeObserver) {
      this._resizeObserver = new ResizeObserver(() => this._scheduleMeasure());
      if (this.productGrid) this._resizeObserver.observe(this.productGrid);
    }

    // observe DOM changes within the grid (AJAX refresh, lazy content)
    this._mutationObserver = new MutationObserver(() => this._scheduleMeasure());
    if (this.productGrid) {
      this._mutationObserver.observe(this.productGrid, { childList: true, subtree: true });
    }

    // hook current images
    this._hookImageLoads();
  }

  _hookImageLoads() {
    if (!this.productGrid) return;
    const imgs = this.productGrid.querySelectorAll('img');
    imgs.forEach(img => {
      if (!img.complete) {
        img.addEventListener('load', this._scheduleMeasure, { once: true });
      }
    });
  }

  _getProductLis() {
    if (!this.productGrid) return [];
    return [...this.productGrid.querySelectorAll(this._selectors.productLis)]
      .filter(el => el && el.offsetParent !== null);
  }

  _clearRowEnforcement() {
    if (!this.productGrid) return;
    this.productGrid.style.removeProperty('--pc-row-h');
    this.productGrid.style.gridAutoRows = '';
    const items = this.productGrid.querySelectorAll(this._selectors.gridItems);
    items.forEach(li => {
      li.style.height = '';
      li.style.overflow = '';
    });
  }

  _applyRowHeightsPerRow(rows) {
    if (!this.productGrid) return;
    this.productGrid.style.removeProperty('--pc-row-h');
    this.productGrid.style.gridAutoRows = '';

    const binSize = 8;
    rows.forEach(row => {
      const heights = row.map(li => li.getBoundingClientRect().height).filter(h => h > 0);
      if (heights.length === 0) return;
      
      const maxHeight = Math.max(...heights);
      const targetHeight = Math.max(0, Math.round(maxHeight / binSize) * binSize);
      
      row.forEach(li => {
        li.style.height = `${targetHeight}px`;
        li.style.aspectRatio = '';
      });
    });
  }

  _measureNow() {
    if (!this.productGrid) return;

    // DESKTOP ONLY: clear enforcement entirely on smaller screens
    if (!this._DESKTOP_MQ.matches) {
      this._clearRowEnforcement();
      return;
    }

    // Clear before measuring to get natural heights
    this._clearRowEnforcement();

    const lis = this._getProductLis();
    if (!lis.length) return;

    // Group items by row based on their top position
    // Items with similar top positions (within 2px tolerance) are in the same row
    const rows = [];
    const tolerance = 2;
    
    lis.forEach(li => {
      const rect = li.getBoundingClientRect();
      const top = Math.round(rect.top);
      
      let foundRow = rows.find(row => {
        if (row.length === 0) return false;
        const rowTop = Math.round(row[0].getBoundingClientRect().top);
        return Math.abs(top - rowTop) <= tolerance;
      });
      
      if (foundRow) {
        foundRow.push(li);
      } else {
        rows.push([li]);
      }
    });

    // Sort rows by top position to maintain order
    rows.sort((a, b) => {
      const aTop = a[0].getBoundingClientRect().top;
      const bTop = b[0].getBoundingClientRect().top;
      return aTop - bTop;
    });

    // Apply tallest height per row (bin to nearest 8px)
    this._applyRowHeightsPerRow(rows);
  }

  _scheduleMeasure() {
    if (this._measureRaf) cancelAnimationFrame(this._measureRaf);
    if (this._measureTimer) clearTimeout(this._measureTimer);

    this._measureRaf = requestAnimationFrame(() => {
      this._measureTimer = setTimeout(() => this._measureNow(), 120);
    });
  }
}
class CollectionPLPCarousel extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      container: '[js-container]'
    };

    this._resizeObserver = null;
    this._carouselWrapper = null;
    this._swiper = null;
  }

  connectedCallback() {
    this.container = this.querySelector(this._selectors.container);
    this._initCarouselLayout();
  }
  
  _initCarouselLayout() {
    const carouselWrapper = this.querySelector('[data-carousel-wrapper]');
    if (!carouselWrapper) return;

    // Wait for carousel to be initialized
    const checkCarousel = setInterval(() => {
      const swiperElement = carouselWrapper.querySelector('[js-carousel]');
      if (swiperElement && swiperElement.swiper) {
        clearInterval(checkCarousel);
        this._carouselWrapper = carouselWrapper;
        this._swiper = swiperElement.swiper;
        
        this._matchHeroHeight(carouselWrapper);
        this._handleCarouselCenterAlignment(swiperElement.swiper, carouselWrapper);
        
        // Listen for carousel slide changes to update center alignment
        swiperElement.swiper.on('slideChange', () => {
          this._handleCarouselCenterAlignment(swiperElement.swiper, carouselWrapper);
        });
        
        // Use ResizeObserver to watch for element size changes
        this._watchResize(swiperElement);
      }
    }, 100);

    setTimeout(() => clearInterval(checkCarousel), 5000);
  }

  _matchHeroHeight(carouselWrapper) {
    if (!this.container) return;

    const heroContainer = this.container.querySelector('[data-hero-container]');
    const swiperElement = carouselWrapper.querySelector('[js-carousel]');
    
    if (!heroContainer || !swiperElement) return;
    
    if (window.innerWidth < 1024) {
      heroContainer.style.height = '20vh';
      heroContainer.classList.remove('opacity-0');
      return;
    }

    const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
    if (!swiperWrapper) return;
    
    const actualCarouselHeight = swiperElement.offsetHeight;
    if (actualCarouselHeight > 0) {
      heroContainer.style.height = `${actualCarouselHeight}px`;
      heroContainer.classList.remove('opacity-0');
    }
  }

  _handleCarouselCenterAlignment(swiper, carouselWrapper) {
    const swiperWrapper = carouselWrapper.querySelector('.swiper-wrapper');
    if (!swiperWrapper) return;

    // Center-align on desktop when slides don't fill the viewport
    if (window.innerWidth < 1024) {
      swiperWrapper.classList.remove('swiper-wrapper-center');
      return;
    }

    // Check if all slides fit in the viewport
    const slidesPerView = swiper.params.slidesPerView || 1;
    const totalSlides = swiper.slides.length;
    
    // Center align when fewer slides than viewport capacity
    if (totalSlides <= slidesPerView) {
      swiperWrapper.classList.add('swiper-wrapper-center');
    } else {
      swiperWrapper.classList.remove('swiper-wrapper-center');
    }
  }

  _watchResize(swiperElement) {
    if (!this._carouselWrapper || !swiperElement) return;

    this._resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        if (this._carouselWrapper) {
          this._matchHeroHeight(this._carouselWrapper);
        }
        if (this._swiper && this._carouselWrapper) {
          this._handleCarouselCenterAlignment(this._swiper, this._carouselWrapper);
        }
      });
    });
    this._resizeObserver.observe(swiperElement);
  }

  disconnectedCallback() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
  }
}
class ProductMain extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      reload: '[js-swatch-reload]',
      productJSON: "[js-product-json]",
      addToCart: "[js-add-to-cart]",
      bisTrigger: '[js-open-klaviyo-bis-modal]',
      rebuyContainer: '[js-rebuy-container]',
      toast: 's-toast',
      optionSelector: '[js-product-option-selector]',
      masterSelect: 'select[js-master-select]',
      colorLip: 'input[name="properties[_Color]"]',
      relatedColorsParent: '[js-related-colors-parent-container]',
      relatedColors: '[js-related-colors]',
      swatch: '[js-swatch]',
      error: '[js-error-message]',
      form: "[js-product-form]",
      loader: "loading-spinner",
      sizeGuideOpen: '.product-options__button[js-open-size-guide-modal]'
    };

    this._klaviyoBis = {
      modal: '[js-klaviyo-bis-modal]',
      productTitle: '[js-bis-product-title]',
      productColor: '[js-bis-product-color]',
      productSize: '[js-bis-product-size]',
      form: '[js-bis-email-form]',
      email: 'input[type="email"]',
      submit: '[js-bis-submit]',
      success: '[js-bis-success]',
      error: '[js-bis-error]'
    }

    this._reload = {
      badges: '[js-badges]',
      images: '[js-product-images]',
      price: '[js-price]',
      colorLabel: '[js-color-label]',
      options: '[js-options]',
      stockMessage: '[js-stock-message]',
      prepackedSetProduct: '[js-prepacked-set-product]',
      prepackedSetOptions: '[js-prepacked-set-options]',
      prepackedSetImage: '[js-prepacked-set-image]',
      prepackedSetTitle: '[js-prepacked-set-title]',
      prepackedSetColorLabel: '[js-prepacked-set-color-label]'
    }

    Object.keys(this._reload).forEach(key => {
      this._reload[key] = `${this._selectors.reload}${this._reload[key]}`;
    });
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll(this._selectors.addToCart);
    this.productJSON = JSON.parse(this.querySelector(this._selectors.productJSON).innerHTML);
    this.prepackedSetsJSON = this.querySelectorAll('[js-prepacked-product]');
    this.prepackedSetProducts = this.querySelectorAll('[js-prepacked-set-product]');
    this.toast = document.querySelector(this._selectors.toast);
    this.options = this.querySelector(this._reload.options);
    this.sizeGuideOpeners = this.querySelectorAll(this._selectors.sizeGuideOpen);
    this.rebuyContainer = this.querySelector(this._selectors.rebuyContainer);

    this.productId = this.dataset.productId;
    this.color = this.dataset.productColor;
    this.allOptionsSelected = false;

    this.moneyFormat = `${window.currency.symbol || "$"}{{no_trailing_zeros}}`;

    this.bisTrigger = this.querySelector(this._selectors.bisTrigger);
    this.bisModal = document.querySelector(this._klaviyoBis.modal);
    this.bisSubmit = this.bisModal.querySelector(this._klaviyoBis.submit);

    this.addEventListener('variant:change', this._handleVariantChange);
    this._setListeners();
    this._initProductForm();
    this._checkSelectedOptions();
    this._initRelatedColors().then(() => {
      this._setSwatchListeners();
    });

    const openTab = new URLSearchParams(window.location.search).get('mode');
    if (openTab) {
      this._openTab(openTab);
    }
  }

  _setListeners() {
    this.sizeGuideOpeners?.forEach((button) => {
      button.addEventListener('click', this._openSizeGuideModal);
    });

    this.bisSubmit.addEventListener('click', this._handleBisSubmit.bind(this));
  }

  _setSwatchListeners() {
    this.swatches = this.querySelectorAll(this._selectors.swatch);

    this.swatches.forEach((swatch) => {
      swatch.addEventListener('click', this._handleSwatchClick.bind(this));
    });
  }

  _openTab(tab) {
    const tabId = `FormTab-${tab.charAt(0).toUpperCase() + tab.slice(1).toLowerCase()}-${this.productId}`;
    const tabElement = this.querySelector(`#${tabId}`);
    if (tabElement) {
      tabElement.click();
    }
  }

  _initProductForm() {
    this.form = this.querySelector(this._selectors.form);
    this.boundOnSubmitHandler = this.onSubmitHandler.bind(this);
    this.form.addEventListener('submit', this.boundOnSubmitHandler);
    this.cart = document.querySelector('cart-drawer');
    this.cartDrawer = document.querySelector('#CartDrawer');
  }

  _handleBisSubmit() {
    const email = this.bisModal.querySelector(this._klaviyoBis.email).value;
    const variantId = this.bisSubmit.getAttribute('data-variant-id');
    const submitId = '$shopify:::$default:::' + variantId;
    const testId = '$shopify:::$default:::43850333126700'

    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": email,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": submitId
            }
          }
        }
      }
    }
    
    var requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-06-15"
        },
        body: JSON.stringify(payload),
    };
    
    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=L32yAn",requestOptions)
        .then(result => {
          if (result.ok) {
            const bisSuccess = this.bisModal.querySelector(this._klaviyoBis.success);
            const bisForm = this.bisModal.querySelector(this._klaviyoBis.form);
            bisSuccess.classList.remove('hidden');
            bisForm.classList.add('hidden');
          } else {
            const bisError = this.bisModal.querySelector(this._klaviyoBis.error);
            bisError.classList.remove('hidden');
          }
        })
        .catch(error => {
          console.log('error', error);
          const bisError = this.bisModal.querySelector(this._klaviyoBis.error);
          bisError.classList.remove('hidden');
        });
  }

  _setActiveSwatch(target) {
    this.swatches.forEach((swatch) => {
      swatch.setAttribute('aria-current', swatch === target);

      if (swatch === target) {
        swatch.removeAttribute('js-related-colors-related');
        swatch.setAttribute('js-related-colors-current', '');
      } else {
        swatch.removeAttribute('js-related-colors-current');
        swatch.setAttribute('js-related-colors-related', '');
      }
    });
  }

  _updateColorLabel(target) {
    const colorLabel = this.querySelector(this._reload.colorLabel);
    const colorLip = this.querySelector(this._selectors.colorLip);
    colorLip.value = target.getAttribute('aria-label');
    colorLabel.innerText = target.getAttribute('aria-label');
    this.dataset.productColor = target.getAttribute('aria-label');
    this.color = target.getAttribute('aria-label');
  }

  _updateSwatchPrice(target) {
    const priceContainers = this.querySelectorAll(this._reload.price);

    const newPrice = target.getAttribute('data-price');
    const newComparePrice = target.getAttribute('data-compare-at-price');
    const salePrice = target.getAttribute('data-sale-price');
    const vipMemberPrice = target.getAttribute('data-vip-member-price');
    const variantId = target.getAttribute('data-variant-id') || '';

    let showVipMemberPrice = false;
    let priceMarkup = '';

    if (window.customer?.activeSubscriber && vipMemberPrice && vipMemberPrice < newPrice) {
      showVipMemberPrice = true;
    }

    if (newComparePrice && Number(newComparePrice) > Number(newPrice)) {
      priceMarkup = `
        <s class="product__price-compare text-gray text-24" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(newComparePrice, this.moneyFormat)}
        </s>
        <span class="product__price text-24 text-red compare" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(newPrice, this.moneyFormat)}
        </span>
      `;
    }
    else if (salePrice) {
      priceMarkup = `
        <s class="product__price-compare text-gray text-24" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(newPrice, this.moneyFormat)}
        </s>
        <span class="product__price text-24 text-red sale" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(salePrice, this.moneyFormat)}
        </span>
      `;
    }
    else if (showVipMemberPrice) {
      priceMarkup = `
        <s class="product__price-compare text-gray text-24" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(newPrice, this.moneyFormat)}
        </s>
        <span class="product__price text-24 text-red vip" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(vipMemberPrice, this.moneyFormat)}
        </span>
      `;
    }
    else {
      priceMarkup = `
        <span class="product__price text-24" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(newPrice, this.moneyFormat)}
        </span>
      `;
    }

    priceContainers.forEach((priceContainer) => {
      priceContainer.innerHTML = priceMarkup;
    });
  }

  _getImageSlideMarkup(media, pictureClasses) {
    return `
      <div class="relative w-full ${pictureClasses}">
        <img src="${media.url}" alt="${media.alt || ''}" class="w-full h-full object-cover" loading="lazy">
      </div>
    `;
  }

  _getVideoSlideMarkup(media) {
    const mp4Source = media.sources.find(source => source.type === 'video/mp4');
    return `
      <s-video class="swiper-slide__video block">
        <video 
          autoplay="autoplay" 
          loop="loop" 
          muted="muted"
          playsinline="playsinline"
          preload="metadata"
          aria-label="${media.alt}"
          poster="${media.poster}"
        >
          <source src="${mp4Source?.url || ''}" type="video/mp4">
          <img src="${media.poster}" alt="${media.alt}">
        </video>
        <div class="video-controls-container z-[1] absolute flex flex-row w-full justify-between px-md bottom-md tabletl:px-lg ">
          <button class="text-white w-md">
            <div js-mute>
              <svg class="icon icon--sound-off" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <title>Sound Off</title>
                <path d="M17.8286 32.9999H23.5858L29.8787 39.2927C31.7686 41.1826 35 39.8442 35 37.1714V15.8284L33 17.8284V37.1714C33 38.0623 31.9229 38.5085 31.2929 37.8785L24.4142 30.9999H19.8286L17.8286 32.9999ZM33 12.1716V10.8283C33 9.93737 31.9229 9.49121 31.2929 10.1212L24.4142 16.9999H13V30.9999H14.1717L12.1717 32.9999H11V14.9999H23.5858L29.8787 8.70696C31.6212 6.96442 34.5042 7.96647 34.9432 10.2283L33 12.1716Z"/>
                <path  d="M7.29297 39.293L39.293 7.29297L40.7072 8.70718L8.70718 40.7072L7.29297 39.293Z"/>
              </svg>
            </div>
            <div js-unmute class="hidden">
              <svg class="icon icon--sound-on" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <title>Sound On</title>
                <path d="M29.8787 8.70696C31.7686 6.81706 35 8.15558 35 10.8283V37.1714C35 39.8441 31.7686 41.1826 29.8787 39.2927L23.5858 32.9999H11V14.9999H23.5858L29.8787 8.70696ZM33 10.8283C33 9.93737 31.9229 9.49121 31.2929 10.1212L24.4142 16.9999H13V30.9999H24.4142L31.2929 37.8785C31.9229 38.5085 33 38.0623 33 37.1714V10.8283Z"/>
              </svg>
            </div>
          </button>
          <button class="bg-white/50 rounded-full text-white text-13 font-500 h-lg w-[79px] px-xxs">
            <div js-play class="hidden flex items-center pr-xs justify-center">
              <div class="w-md">
                <svg class="icon icon--play" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <title>Play</title>	
                  <path d="M18.75 12L8.25 18L8.25 6L18.75 12Z"></path>
                </svg>
              </div>
              Play
            </div>
            <div js-pause class="flex items-center pr-xs justify-center">
              <div class="w-md">
                <svg class="icon icon--pause" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <title>Pause</title>
                  <path d="M10.5 6H7.5V18H10.5V6ZM16.5 6H13.5V18H16.5V6Z" ></path>
                </svg>
              </div>
              Pause
            </div>
          </button>
        </div>
      </s-video>
    `;
  }

  _updateSwatchMedia(target) {
    const mediaContainer = this.querySelector(this._reload.images);
    const carousel = mediaContainer.querySelector('s-carousel');
    const swiper = mediaContainer.querySelector('[js-carousel]').swiper;
    const carouselSlides = mediaContainer.querySelectorAll('[js-carousel-slide]');
    const newMediaData = JSON.parse(target.getAttribute('data-media') || '[]');
    const swiperWrapper = mediaContainer.querySelector('.swiper-wrapper');

    let mediaIndex = 0;

    // Add transition class and set opacity to 0
    mediaContainer.classList.add('opacity-0');

    // Wait for opacity transition before updating content
    setTimeout(() => {
      carouselSlides.forEach((slide) => {
        slide.remove();
      });

      if (swiper) {
        swiper.destroy(true, true);
      }

      newMediaData.forEach((media) => {
        if (media.url?.includes('FEED')) {
          return;
        }

        mediaIndex++;
        const modulo = mediaIndex % 3;
        
        let imageSpan = '';
        let pictureClasses = '';
        
        if (modulo === 0) {
          imageSpan = 'relative extrawide:col-span-2';
          if (media.type === 'image') {
            imageSpan += ' extrawide:aspect-video extrawide:overflow-hidden';
          }
          pictureClasses = 'extrawide:absolute extrawide:top-1/2 extrawide:-translate-y-1/2';
        }

        const slide = document.createElement('div');
        slide.setAttribute('js-carousel-slide', '');
        slide.classList.add('swiper-slide');

        if (imageSpan) {
          slide.classList.add(...imageSpan.split(' '));
        }

        if (media.type === 'image') {
          const imageHtml = this._getImageSlideMarkup(media, pictureClasses);
          slide.innerHTML = imageHtml;
        } else if (media.type === 'video') {
          const videoHtml = this._getVideoSlideMarkup(media);
          slide.innerHTML = videoHtml;
        }

        swiperWrapper.appendChild(slide);
      });

      if (swiper) {
        carousel.connectedCallback();
      }

      // Remove opacity-0 after content is updated
      mediaContainer.classList.remove('opacity-0');
    }, 150);
  }

  _updateBadges(target) {
    const badgeContainer = this.querySelectorAll(this._reload.badges);
    const badges = target.dataset.badges;
    const badgesArray = badges?.split(',');

    if (!badgesArray || badgesArray.length === 0) {
      return;
    }

    badgeContainer.forEach((badge) => {
      badge.innerHTML = '';
    });

    let badgeMarkup = '';

    badgesArray.forEach((badge) => {
      badgeMarkup = `${badgeMarkup}
        <div class="product__badge whitespace-nowrap px-xs py-xxs text-small bg-gray-lighter rounded-sm">
          ${badge}
        </div>
      `;
    });

    badgeContainer.forEach((badge) => {
      badge.innerHTML += badgeMarkup;
    });
  }

  _updatePrepackedProducts(target) {
    const data = target;

    if (!this.prepackedProductJSONs) return;

    const prepackedBundleProducts = data.getAttribute('data-prepacked-bundle-products');
    const prepackedBundleProductsArray = prepackedBundleProducts.split(',');

    this.querySelectorAll('[js-prepacked-product]').forEach((product) => {
      product.remove();
    });
    
    prepackedBundleProductsArray.forEach((productId) => {
      const prepackedProduct = Array.from(this.prepackedProductJSONs).find(json => json.id == `PrepackedProductJSON-${productId}`);
      this.insertAdjacentElement('beforeend', prepackedProduct);
    });

    if (this.form.dataset.submitType === 'prepacked-set') {
      this._updatePrepackedSet(prepackedBundleProductsArray);
    }
  }

  _updatePrepackedSet(prepackedBundleProductsArray) {
    if (!this.prepackedSetProducts) return;

    this.prepackedSetProducts.forEach((product) => {
      const index = Array.from(this.prepackedSetProducts).indexOf(product);
      const productData = this.prepackedProductData.find(data => {
        return data.id == prepackedBundleProductsArray[index];
      });

      if (!productData) return;

      // Update JSON
      const originalJson = product.querySelector(this._selectors.productJSON);
      const prepackedJson = Array.from(this.prepackedProductJSONs).find(json => json.id == `PrepackedProductJSON-${prepackedBundleProductsArray[index]}`);

      if (!originalJson || !prepackedJson) return;

      // Create new script element with prepacked product data
      const newJsonElement = document.createElement('script');
      newJsonElement.type = 'application/json';
      newJsonElement.id = `PrepackedSetProductJSON-${productData.id}`;
      newJsonElement.setAttribute('js-product-json', '');
      newJsonElement.textContent = prepackedJson.textContent;

      // Remove original elements and insert new one
      originalJson.remove();
      product.insertAdjacentElement('beforeend', newJsonElement);

      // Update master variant select
      const productMasterSelect = Array.from(this.masterSelects).find(master => master.id == `PrepackedProduct-${productData.id}`);
      const optionsContainer = product.querySelector(this._reload.prepackedSetOptions);
      optionsContainer.innerHTML = '';

      let masterOptionsMarkup = productMasterSelect.innerHTML;
      let masterVariantMarkup = `
        <select id="PrepackedSetMasterSelect-${productData.id}" name="id" class="no-js" js-master-select>
          ${masterOptionsMarkup}
        </select>
      `;

      optionsContainer.insertAdjacentHTML('beforeend', masterVariantMarkup);

      // Product options selector
      const options = productData.options.split(',');
      const useSelect = false;
      let productOptionsHeader = '';

      if (useSelect) {
        productOptionsHeader = `
          <div class="product-options__header mb-12">
            <span class="product-options__title inline-block text-small font-700">Size</span>
          </div>`;
      }

      let optionsMarkup = `${useSelect ? productOptionsHeader : ''}
        <product-options class="no-js-hidden mb-12 ${useSelect ? 'grid grid-cols-2 gap-xs' : ''}" data-product='PrepackedSetProductJSON-${productData.id}' data-master-select-id="PrepackedSetMasterSelect-${productData.id}"  data-options-size="${prepackedJson.options.length}">`;

      if (useSelect) {
        options.forEach((option, index) => {
          let optionName = option.split('//')[0]; 
          let optionHandle = option.split('//')[1];
          let optionId = `option-${optionHandle}-PrepackedSetCard-${productData.id}`;
  
          let valuesKey = `data-values-${index + 1}`;
          let values = data.getAttribute(valuesKey).split(',');
  
          let valuesMarkup = values.map((value, i) => {
            let valueName = value.split('//')[0];
            let valueHandle = value.split('//')[1];
            return `
              <option value="${valueHandle}">${valueName}</option>
            `
          }).join('');
  
          optionsMarkup = `${optionsMarkup}
            <div class="product-option flex justify-between w-full py-xs px-12 text-14 border border-black rounded-sm">
              <label for="${optionId}" class="visually-hidden">${optionName}</label>
              <select
                id="${optionId}"
                class="w-full"
                data-index="option${index + 1}"
                js-product-option-selector>
                <option value="" selected disabled>${optionName}</option>
                ${valuesMarkup}
              </select>
            </div>
          `;
        })
      } else {
        const option = options[0];
        let optionName = option.split('//')[0];
        let optionHandle = option.split('//')[1];
  
        let values = productData.values_1.split(',');
        let valuesAvailability = productData.values_1_availability.split(',');
  
        let valuesMarkup = values.map((value, i) => {
          let valueName = value.split('//')[0];
          let valueHandle = value.split('//')[1];
          let inputId = `swatch-${valueName}-PrepackedSetCard-${productData.id}`;
          let radioName = `swatch-${optionHandle}-PrepackedSetCard-${productData.id}`;
  
          return `
            <div class="product-swatch__group relative mt-[-1px] ml-[-1px]">
              <input
                id="${inputId}"
                class="product-swatch__input sr-only ${valuesAvailability[i] == 'false' ? 'disabled': ''}"
                type="radio"
                name="${radioName}"
                value="${valueHandle}"
                data-index="option1"
                js-product-option-selector>
              <label
                for="${inputId}"
                class="product-swatch__label flex justify-center items-center w-full h-full p-xxs text-14 uppercase border border-black ${valuesAvailability[i] == 'false' ? 'pointer-events-none': ''}">
                ${valueName}
              </label>
            </div>
          `;
        }).join('');
  
        optionsMarkup = `${optionsMarkup}
          <div class="product-option mb-12">
            <div class="product-option__swatch product-swatch">
              <div class="product-swatch__header mb-12 text-small font-700">${optionName}</div>
              <div class="product-swatch__container">
                ${valuesMarkup}
              </div>
            </div>
          </div>
        `;
      }

      optionsMarkup = `${optionsMarkup}</product-options>`;

      optionsContainer.insertAdjacentHTML('beforeend', optionsMarkup);

      // Update image
      const image = product.querySelector(this._reload.prepackedSetImage);
      image.setAttribute('href', productData.url);
      image.innerHTML = `<img src="${productData.image}" alt="${productData.title}" class="w-full h-full object-cover">`;

      // Update title
      const title = product.querySelector(this._reload.prepackedSetTitle);
      title.setAttribute('href', productData.url);
      title.innerHTML = productData.title;

      // Update color label
      const colorLabel = product.querySelector(this._reload.prepackedSetColorLabel);
      colorLabel.innerHTML = productData.swatch_name;
    });
  }

  _updateProductForm(target) {
    const data = target;
    const product = data.dataset;
    const productId = product.id;
    const productJSON = this.productJSONs.find(json => json.id == productId);
    const originalJSON = this.querySelector(this._selectors.productJSON);
    const productMasterSelect = Array.from(this.masterSelects).find(master => master.id == `RelatedColors-${productId}`);

    const salePrice = data.dataset.salePrice;
    const vipMemberPrice = data.dataset.vipMemberPrice;
    
    // Store these for later use
    this.currentSalePrice = salePrice || null;
    this.currentVipMemberPrice = vipMemberPrice || null;

    if (!productJSON || !productMasterSelect) return;

    this.options.innerHTML = '';

    // Remove original listeners
    this.removeEventListener('variant:change', this._handleVariantChange);
    if (this.boundOnSubmitHandler) {
      this.form.removeEventListener('submit', this.boundOnSubmitHandler);
    }

    // ProductJSON
    const uniqueId = Date.now();
    originalJSON.id = `ProductJSON-${productId}-${uniqueId}`;
    originalJSON.innerHTML = JSON.stringify(productJSON);

    // Master variant select
    let masterOptionsMarkup = productMasterSelect.innerHTML;

    let masterVariantMarkup = `
      <select id="SwatchMasterSelect-${productId}-${uniqueId}" name="id" class="no-js" js-master-select>
        ${masterOptionsMarkup}
      </select>
    `;

    this.options.insertAdjacentHTML('beforeend', masterVariantMarkup);

    // Product options selector
    const options = product.options.split(",");
    const useSelect = false;
    let productOptionsHeader = '';

    if (useSelect) {
      productOptionsHeader = `
        <div class="product-options__header mb-12">
          <span class="product-options__title inline-block text-small font-700">Size</span>
        </div>`;
    }

    let optionsMarkup = `${useSelect ? productOptionsHeader : ''}
      <product-options class="no-js-hidden mb-12 ${useSelect ? 'grid grid-cols-2 gap-xs' : ''}" data-product='${originalJSON.id}' data-master-select-id="SwatchMasterSelect-${productId}-${uniqueId}" data-options-size="${productJSON.options.length}">`;

    if (useSelect) {
      options.forEach((option, index) => {
        let optionName = option.split('//')[0]; 
        let optionHandle = option.split('//')[1];
        let optionId = `option-${optionHandle}-SwatchMasterSelect-${productId}-${uniqueId}`;

        let valuesKey = `data-values-${index + 1}`;
        let values = data.getAttribute(valuesKey).split(',');

        let valuesMarkup = values.map((value, i) => {
          let valueName = value.split('//')[0];
          let valueHandle = value.split('//')[1];
          return `
            <option value="${valueHandle}">${valueName}</option>
          `
        }).join('');

        optionsMarkup = `${optionsMarkup}
          <div class="product-option flex justify-between w-full py-xs px-12 text-14 border border-black rounded-sm">
            <label for="${optionId}" class="visually-hidden">${optionName}</label>
            <select
              id="${optionId}"
              class="w-full"
              data-index="option${index + 1}"
              js-product-option-selector>
              <option value="" selected disabled>${optionName}</option>
              ${valuesMarkup}
            </select>
          </div>
        `;
      })
    } else {
      for (let i = 0; i < options.length; i++) {
        const option = options[i];
        let optionName = option.split('//')[0];
        let optionHandle = option.split('//')[1];

        let valuesKey = `data-values-${i + 1}`;
        let valuesAvailabilityKey = `data-values-${i + 1}-availability`;
        let values = data.getAttribute(valuesKey).split(',');
        let valuesAvailability = data.getAttribute(valuesAvailabilityKey).split(',');

        let valuesMarkup = values.map((value, j) => {
          let valueName = value.split('//')[0];
          let valueHandle = value.split('//')[1];
          let inputId = `swatch-${valueName}-SwatchMasterSelect-${productId}-${uniqueId}`;
          let radioName = `swatch-${optionHandle}-SwatchMasterSelect-${productId}-${uniqueId}`;

          return `
            <div class="product-swatch__group relative mt-[-1px] ml-[-1px]">
              <input
                id="${inputId}"
                class="product-swatch__input sr-only ${valuesAvailability[j] == 'false' ? 'disabled' : ''}"
                type="radio"
                name="${radioName}"
                value="${valueHandle}"
                data-index="option${i + 1}"
                js-product-option-selector>
              <label
                for="${inputId}"
                class="product-swatch__label flex justify-center items-center w-full h-full p-xxs text-14 uppercase border border-black">
                ${valueName}
              </label>
            </div>
          `
        }).join('');
        optionsMarkup = `${optionsMarkup}
        <div class="product-option mb-12">
          <div class="product-option__swatch product-swatch">
            <div class="product-swatch__header mb-12 text-small font-700">${optionName}</div>
            <div class="product-swatch__container">
              ${valuesMarkup}
            </div>
          </div>
        </div>
      `;
      }
    }

    optionsMarkup = `${optionsMarkup}</product-options>`;

    this.options.insertAdjacentHTML('beforeend', optionsMarkup);

    if (this.form.dataset.submitType === 'prepacked-bundle') {
      this._updatePrepackedProducts(target);
    }

    // Reinit event listeners and selectors
    this.productJSON = JSON.parse(this.querySelector(this._selectors.productJSON).innerHTML);
    this.productOptions = this.querySelector('product-options');
    this.productOptions.connectedCallback();
    this.addEventListener('variant:change', this._handleVariantChange);
    this.form.addEventListener('submit', this.boundOnSubmitHandler);
  }

  _updateStockMessage(target) {
    const stockMessage = target.getAttribute('data-stock-message');
    const stockMessageElement = this.querySelector(this._reload.stockMessage);
    stockMessageElement.innerHTML = stockMessage;
  }

  _updateSwatchAddToCart() {
    const buttons = this.querySelectorAll(this._selectors.addToCart);

    this.bisTrigger.classList.add('hidden');
    buttons.forEach((btn) => {
      btn.textContent = "Select Size";
      btn.classList.remove('hidden');
    });
  }

  _syncBundlerSwatches(target) {
    const bundlers = this.querySelectorAll('product-bundler');
    const targetColor = target.getAttribute('aria-label');

    bundlers.forEach((bundler) => {
      const firstCard = bundler.querySelector('bundle-card');
      const firstCardSwatches = firstCard.querySelectorAll('[js-variant]');

      firstCardSwatches.forEach((swatch) => {
        if (swatch.getAttribute('aria-label') === targetColor) {
          swatch.click();
        }
      });
    });
  }

  _updateUrl(target) {
    const url = target.getAttribute('data-url');
    const rootUrl = window.location.origin;
    window.history.replaceState({}, '', `${rootUrl}${url}`);
  }

  _updateRebuyUpsell(target) {
    if (!this.rebuyContainer) return;

    const rebuyMarkup = `<div class="rebuy-widget__container" data-rebuy-id="${target.dataset.rebuyId}" data-rebuy-shopify-product-ids="${target.dataset.id}"></div>`
    this.rebuyContainer.innerHTML = rebuyMarkup;

    const widget = window.Rebuy.widgets[2];
    widget.getWidgetProducts(()=>{
      console.log("New products fetched!");
    });
  }

  _handleSwatchClick(e) {
    const target = e.currentTarget;

    this._updateRebuyUpsell(target);
    this._updateUrl(target);
    this._setActiveSwatch(target);
    this._updateColorLabel(target);

    this._updateSwatchMedia(target);
    this._updateStockMessage(target);
    this._updateBadges(target);

    if (this.form.dataset.submitType === 'prepacked-set') {
      this._updatePrepackedProducts(target);
    } else {
      this._updateProductForm(target);
    }

    this._updateSwatchPrice(target);

    this._updateSwatchAddToCart();
    this._syncBundlerSwatches(target);
  }

  _openSizeGuideModal(e) {
    e.preventDefault();
    const productType = e.currentTarget.getAttribute('data-product-type');
    const sizeGuideModal = document.querySelector('#SizeGuideModal');
    const sizeGuideBra = sizeGuideModal.querySelector('[js-bra-size-guide]');
    const sizeGuidePanty = sizeGuideModal.querySelector('[js-panty-size-guide]');
    const sizeGuideTank = sizeGuideModal.querySelector('[js-tank-size-guide]');

    if (productType === 'bra' || productType === 'fit') {
      const sizeChart = sizeGuideModal.querySelector('.sizeGuideNew24');
      const howToMeasure = sizeGuideModal.querySelector('.sizeMeasureNew24');
      const sizeChartElements = sizeGuideModal.querySelector('.size-guid-id-mesr24');
      const howToMeasureElements = sizeGuideModal.querySelector('.size-guid-id-braSize24');
      
      if (productType === 'fit') {
        sizeChartElements.classList.remove('hide');
        howToMeasureElements.classList.add('hide');

        sizeChart.classList.remove('size-guide-top-toggle-item-drk');
        sizeChart.classList.add('size-guide-top-toggle-item-light');
        howToMeasure.classList.add('size-guide-top-toggle-item-drk');
        howToMeasure.classList.remove('size-guide-top-toggle-item-light');
      } else {
        sizeChartElements.classList.add('hide');
        howToMeasureElements.classList.remove('hide');

        sizeChart.classList.add('size-guide-top-toggle-item-drk');
        sizeChart.classList.remove('size-guide-top-toggle-item-light');
        howToMeasure.classList.remove('size-guide-top-toggle-item-drk');
        howToMeasure.classList.add('size-guide-top-toggle-item-light');
      }

      sizeGuideBra.classList.remove('hidden');
      sizeGuidePanty.classList.add('hidden');
      sizeGuideTank.classList.add('hidden');
    } else if (productType === 'panty') {
      sizeGuidePanty.classList.remove('hidden');
      sizeGuideBra.classList.add('hidden');
      sizeGuideTank.classList.add('hidden');
    } else if (productType === 'tank') {
      sizeGuideTank.classList.remove('hidden');
      sizeGuidePanty.classList.add('hidden');
      sizeGuideBra.classList.add('hidden');
    }
  }

  async _initRelatedColors() {
    this.relatedColorsParent = this.querySelector(this._selectors.relatedColorsParent);
    this.relatedColorsContainer = this.querySelector(this._selectors.relatedColors);
  
    if (!this.relatedColorsParent || !this.relatedColorsContainer || this.relatedColorsContainer.length < 1) {
      return;
    }
  
    const currentProductHandle = this.relatedColorsContainer.getAttribute('data-handle');
    const relatedColorsCollection = this.relatedColorsContainer.getAttribute('data-collection');
    const relatedColorsTag = this.relatedColorsContainer.getAttribute('data-tag');
    
    const targetURL = `/collections/${relatedColorsCollection}/${relatedColorsTag}/?view=json`;
    const {
      collectionJSON: relatedColorsJSON,
      productJSONs,
      masterSelects,
      prepackedProductJSONElements,
      prepackedProductData
    } = await this._getRelatedColorJSON(targetURL);
    
    this.productJSONs = productJSONs;
    this.masterSelects = masterSelects;
    this.prepackedProductJSONs = prepackedProductJSONElements;
    this.prepackedProductData = prepackedProductData;
    let relatedColorsMarkup = '';
  
    if (relatedColorsJSON.length <= 1) {
      this.relatedColorsParent.remove();
      return;
    }
  
    relatedColorsJSON.forEach((product) => {
      const matchingJSON = productJSONs.find(p => String(p.id) === String(product.id));
      let firstAvailableVariantId = '';
  
      if (matchingJSON && matchingJSON.variants && matchingJSON.variants.length) {
        const firstAvailableVariant =
          matchingJSON.variants.find(v => v.available) || matchingJSON.variants[0];
        if (firstAvailableVariant) {
          firstAvailableVariantId = firstAvailableVariant.id;
        }
      }
  
      relatedColorsMarkup = `${relatedColorsMarkup}
        <button
          type="button"
          class="product-related-colors tooltip-container"
          aria-current="${product.handle == currentProductHandle}"
          aria-label="${product.swatch_name}"
          data-id="${product.id}"
          data-variant-id="${firstAvailableVariantId}"
          data-url="${product.url}"
          data-available="${product.available}"
          data-price="${product.price}"
          ${product.rebuyId ? `data-rebuy-id="${product.rebuyId}"` : ''}
          ${product.compareAtPrice ? `data-compare-at-price="${product.compareAtPrice}"` : ''}
          ${product.salePrice ? `data-sale-price="${product.salePrice}"` : ''}
          ${product.vipMemberPrice ? `data-vip-member-price="${product.vipMemberPrice}"` : ''}
          data-media='${JSON.stringify(product.media)}'
          data-options="${product.options}"
          data-values-1="${product.values_1}"
          data-values-1-availability="${product.values_1_availability}"
          data-values-1-qty="${product.values_1_qty}"
          data-stock-message="${product.stock_message}"
          ${product.values_2 ? `data-values-2="${product.values_2}" data-values-2-availability="${product.values_2_availability}"` : ''}
          ${product.values_3 ? `data-values-3="${product.values_3}" data-values-3-availability="${product.values_3_availability}"` : ''}
          ${product.prepacked_bundle_products ? `data-prepacked-bundle-products="${product.prepacked_bundle_products}"` : ''}
          ${product.pre_packed_item_count ? `data-pre-packed-item-count="${product.pre_packed_item_count}"` : ''}
          ${product.technologyHighlights ? `data-badges="${product.technologyHighlights}"` : ''}
          js-swatch
          ${product.handle == currentProductHandle ? 'js-related-colors-current' : 'js-related-colors-related'}
        >
          <img
            class="min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px] rounded-full overflow-hidden"
            src="${product.swatch}"
            alt="${product.swatch_name}"
            ${product.swatch_border ? `style="border: 1px solid ${product.swatch_border}"` : ''}/>
          <span class="tooltip">
            ${product.swatch_name}
          </span>
        </button>`;
    });
  
    this.relatedColorsContainer.innerHTML = relatedColorsMarkup;
    this.relatedColorsContainer.classList.remove('hidden');
  }
  

  _getRelatedColorJSON(url) {
    return fetch(url)
      .then(response => response.text())
      .then((text) => {
        const html = text;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
        const collectionJSON = JSON.parse(JSONcontainer.innerHTML);

        const productJSONElements = parsedHTML.querySelectorAll(this._selectors.productJSON);
        const productJSONs = Array.from(productJSONElements).map(el => JSON.parse(el.innerHTML));

        const prepackedProductJSONElements = parsedHTML.querySelectorAll('[js-prepacked-product]');
        const prepackedProductData = JSON.parse(parsedHTML.querySelector('[js-prepacked-product-data]').innerHTML);
        
        const masterSelects = parsedHTML.querySelectorAll(this._selectors.masterSelect);

        return { collectionJSON, productJSONs, masterSelects, prepackedProductJSONElements, prepackedProductData };
      })
  }

  _getSubmitType() {
    const submitType = this.form.getAttribute('data-submit-type');
    return submitType;
  }

  _getSelectedSize() {
    const masterSelect = this.querySelector('[js-master-select]');
    const selectedSize = masterSelect.options[masterSelect.selectedIndex].text;
    return selectedSize;
  }

  _getPrepackedVariants() {
    const prepackedProducts = this.querySelectorAll('[js-prepacked-product]');
    const variants = [];
    
    if (this.form.dataset.submitType === 'prepacked-bundle') {
      const sizeToMatch = this._getSelectedSize();

      prepackedProducts.forEach((product) => {
        const color = product.getAttribute('data-color');
        const prepackedProductJSON = JSON.parse(product.innerHTML);
        const selectedVariants = prepackedProductJSON.variants.filter(variant => 
          variant.title.toLowerCase() === sizeToMatch.toLowerCase()
        );
        variants.push(...selectedVariants.map(variant => ({
          ...variant,
          color
        })));
      });
    } else if (this.form.dataset.submitType === 'prepacked-set') {
      const prepackedMasterSelects = this.querySelectorAll('[js-master-select]');
      let variantIds = [];

      prepackedMasterSelects.forEach((select) => {
        variantIds.push(select.value);
      });

      const prepackedProductsArray = Array.from(prepackedProducts);
      prepackedProductsArray.forEach((product) => {
        const color = product.getAttribute('data-color');
        const prepackedProductJSON = JSON.parse(product.innerHTML);
        const selectedVariant = prepackedProductJSON.variants.find(variant => 
          variant.id === parseInt(variantIds[prepackedProductsArray.indexOf(product)])
        );

        if (selectedVariant) {
          variants.push({
            ...selectedVariant,
            color
          });
        }
      });
    }

    return variants;
  }

  _getPrepackedBundleProps(prepackedVariants) {
    const allVariants = prepackedVariants.map(variant => variant.id).join('::');

    const prepackedBundleProps = {
      [`_${this.dataset.productType}`]: true,
      '_isBundleSet': allVariants,
      '_typeBndlSet': this.dataset.productType,
      '_Shipping Option': 'Ecommerce WH',
      '_set_bundle_price': parseInt(this.dataset.productPrice),
      '_set_bundle_prods': this.dataset.productTitle,
      '_pdp_fabric_type': '',
      '_product_parent_id': this.dataset.productId
    }

    return prepackedBundleProps;
  }

  _getPackPrice(packPrice) {
    if (!packPrice.includes('::')) {
      return packPrice;
    }
    return packPrice.split('::');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    
    if (this.allOptionsSelected == false) return;

    const submitType = this._getSubmitType();
    this.handleErrorMessage();
    this._disableButtons();

    const toastProperties = {
      'Color': this.color,
      'Product Title': this.querySelector('[js-product-title]').textContent,
      'Product Image': submitType === 'prepacked-bundle' || submitType === 'prepacked-set' ? this.querySelector('[js-product-images] img').src : null
    }

    const config = {
      method: 'POST',
      headers: { Accept: `application/javascript`, 'X-Requested-With': 'XMLHttpRequest' },
    }

    const formData = new FormData(this.form);

    if (submitType === 'prepacked-bundle' || submitType === 'prepacked-set' && this.cart) {
      this._handlePrepackedBundleSubmit(config);
    } else {
      this._handleRegularSubmit(config, formData);
    }

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          this.cart.renderContents(response);
          if (window.toast.enableAtc) {
            this.toast.openToast(response, 'in-cart', toastProperties);
          } else {
            this.cartDrawer.open();
          }
        })
        .catch((e) => {
          this.handleErrorMessage(e.description)
          console.error(e);
        })
      .finally(() => {
        this._enableButtons();
      });
  }

  _handlePrepackedBundleSubmit(config) {
    const timestamp = parseInt(Date.now().toString() + Math.floor(Math.random() * 10000));
    const prepackedVariants = this._getPrepackedVariants();
    const prepackedBundleProps = this._getPrepackedBundleProps(prepackedVariants);
    const packPrices = this._getPackPrice(this.dataset.packPrice);
    let quantity = 1;
    
    if (prepackedVariants.length === 1) {
      const prePackedItemCount = this.dataset.prePackedItemCount;
      quantity = prePackedItemCount ? parseInt(prePackedItemCount) : 2;
    }

    if (!prepackedVariants || prepackedVariants.length === 0) {
      this.handleErrorMessage('There was an error adding the bundle to your cart. Please try again.');
      return;
    }

    const bundleData = {
      items: prepackedVariants.map((variant, index) => {
        return {
          id: variant.id,
          quantity: quantity,
          properties: {
            [`_${quantity === 2 ? packPrices : packPrices[index]}`]: !0,
            ...prepackedBundleProps,
            '_Color': variant.color,
            '_timeStamp': String(timestamp),
            ...(quantity === 2 ? { '_hasDouble': !0 } : {})
          }
        };
      }).reverse(),
      sections: this.cart.getSectionsToRender().map((section) => section.id)
    };

    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify(bundleData);
  }

  _handleRegularSubmit(config, formData) {
    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    // Add line item properties
    const lineItemProperties = {
      '_Shipping Option': 'Ecommerce WH'
    };

    // Add each property to the form data
    Object.entries(lineItemProperties).forEach(([key, value]) => {
      formData.append(`properties[${key}]`, value);
    });
  
    config.body = formData;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.querySelector(this._selectors.error)

    if (errorMessage) {
      this.errorMessageWrapper.innerHTML = errorMessage;
      this.errorMessageWrapper.classList.remove('hidden');
    }else{
      this.errorMessageWrapper.classList.add('hidden');
    }
  }

  _checkSelectedOptions = () => {
    const checkedOptions = this.form.querySelectorAll(
      `${this._selectors.optionSelector}:checked,
      ${this._selectors.optionSelector} option:checked:not([value=""])`
    );
    let optionsLength = 0;

    if (this.form.dataset.submitType === 'prepacked-set') {
      this.prepackedSetsJSON.forEach((product) => {
        const productJSON = JSON.parse(product.innerHTML);
        optionsLength += productJSON.options.length;
      });
    } else {
      optionsLength = this.productJSON.options.length;
    }

    if (checkedOptions.length === optionsLength && checkedOptions.length > 0) {
      this.allOptionsSelected = true;
      this.buttons.forEach((button) => {
        button.classList.remove('pointer-events-none');
        button.textContent = 'Add to Bag';
      });
    }
  }

  _handleVariantChange = (evt) => {
    const { variant } = evt.detail;

    this._checkSelectedOptions();

    if (variant) {
      this._updatePrice(variant);

      if (this.allOptionsSelected) {
        this._updateAddToCartState(variant);
      }
    } else {
      this._updateAddToCartState(variant);
    }
  };


  _updateKlaviyoBisModal(variant) {
    const modal = this.bisModal;
    const bisSubmit = this.bisSubmit;
    const bisSuccess = modal.querySelector(this._klaviyoBis.success);
    const bisError = modal.querySelector(this._klaviyoBis.error);
    const bisForm = modal.querySelector(this._klaviyoBis.form);
    const bisColor = modal.querySelector(this._klaviyoBis.productColor);
    const bisSize = modal.querySelector(this._klaviyoBis.productSize);

    const variantColor = this.color;
    const variantSize = variant.title.toUpperCase();
    const variantId = variant.id;

    if (variantColor) {
      bisColor.textContent = variantColor;
      bisColor.classList.remove('hidden');
    }

    if (variantSize) {
      bisSize.textContent = variantSize;
      bisSize.classList.remove('hidden');
    }

    if (variantId) {
      bisSubmit.setAttribute('data-variant-id', variantId);
    }

    if (bisSuccess) {
      bisSuccess.classList.add('hidden');
    }

    if (bisError) {
      bisError.classList.add('hidden');
    }

    if (bisForm && bisForm.classList.contains('hidden')) {
      bisForm.classList.remove('hidden');
    }
  }

  _updateAddToCartState(variant) {
    const buttons = this.querySelectorAll(this._selectors.addToCart);

    if (variant) {
      if (this.form.dataset.submitType === 'prepacked-bundle') {
        this.bisTrigger.classList.add('hidden');

        buttons.forEach((btn) => {
          btn.textContent = "Add To Bag";
          btn.removeAttribute("disabled");
          btn.classList.remove('hidden');
        });
      } else {
        if (variant.available) {
          this.bisTrigger.classList.add('hidden');

          buttons.forEach((btn) => {
            btn.textContent = "Add To Bag";
            btn.removeAttribute("disabled");
            btn.classList.remove('hidden');
          });
        } else {
          this._updateKlaviyoBisModal(variant);
          this.bisTrigger.classList.remove('hidden');

          buttons.forEach((btn) => {
            btn.textContent = "Sold out";
            btn.setAttribute("disabled", "");
            btn.classList.add('hidden');
          });
        }
      }
    } else {
      buttons.forEach((btn) => {
        btn.textContent = "Unavailable";
        btn.setAttribute("disabled", "");
        btn.classList.remove('hidden');
        this.bisTrigger.classList.add('hidden');
      });
    }
  }

  _updatePrice(variant) {
    const priceContainers = this.querySelectorAll(this._reload.price);
    const newPrice = target.getAttribute('data-price');
    const newComparePrice = target.getAttribute('data-compare-at-price');
    const salePrice = target.getAttribute('data-sale-price');
    const vipMemberPrice = target.getAttribute('data-vip-member-price');
    const variantId = target.getAttribute('data-variant-id') || '';

    let showVipMemberPrice = false;
    let priceMarkup = '';

    if (window.customer?.activeSubscriber && vipMemberPrice && vipMemberPrice < variant.price) {
      showVipMemberPrice = true;
    }

    if (salePrice) {
      priceMarkup = `
        <s class="product__price--sale text-gray text-24">
          ${theme.utils.formatMoney(variant.price, this.moneyFormat)}
        </s>
        <span class="product__price text-24 text-red sale" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(salePrice, this.moneyFormat)}
        </span>
      `;
    }
    else if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
      priceMarkup = `
        <s class="product__price-compare text-gray text-24">
          ${theme.utils.formatMoney(variant.compare_at_price, this.moneyFormat)}
        </s>
        <span class="product__price text-24 text-red compare" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(variant.price, this.moneyFormat)}
        </span>
      `;
    } else if (showVipMemberPrice) {
      priceMarkup = `
        <s class="product__price--vip text-gray text-24">
          ${theme.utils.formatMoney(variant.price, this.moneyFormat)}
        </s>
        <span class="product__price text-24 text-red vip" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(vipMemberPrice, this.moneyFormat)}
        </span>
      `;
    }
    else {
      priceMarkup = `
        <span class="product__price text-24" data-variant-id="${variantId}">
          ${theme.utils.formatMoney(variant.price, this.moneyFormat)}
        </span>
      `;
    }

    priceContainers.forEach((priceContainer) => {
      priceContainer.innerHTML = priceMarkup;
    });
  }



  _disableButtons() {
    this.buttons.forEach((button) => {
      button.setAttribute("disabled", "");
      const loader = button.querySelector(this._selectors.loader);
      if (loader) {
        loader.setAttribute("loading", "");
      }
    });
  }

  _enableButtons() {
    this.buttons.forEach((button) => {
      button.removeAttribute("disabled");
      const loader = button.querySelector(this._selectors.loader);
      if (loader) {
        loader.removeAttribute("loading");
      }
    });
  }
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}
class Hero extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      cta: '[js-cta]'
    };

  }

  connectedCallback() {
    this._initCTA();
  }

  _initCTA() {
    this.cta = this.querySelectorAll(this._selectors.cta);

    // Setting CTA widths to be the same
    if (this.dataset.setCtasSameWidth && this.cta.length > 1) {
        let ctaWidth = Math.ceil(this.cta[0].offsetWidth);
        this.cta.forEach(cta => {
            if (ctaWidth < cta.offsetWidth) {
                ctaWidth = Math.ceil(cta.offsetWidth);
            }
        });
        ctaWidth += 1;
        this.cta.forEach(cta => {
            cta.style.width = `${ctaWidth}px`;
        });
    }
  }
}


class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      carousel: 's-carousel',
      pauseButton: '[js-control]',
      pauseIcon: '[js-pause]',
      playIcon: '[js-play]'
    };

    this.swiperInstance = null;
    this.isPaused = false;
  }

  connectedCallback() {
    this._waitForCarousel();
  }

  _waitForCarousel() {
    const carouselElement = this.querySelector(this.selectors.carousel);
    
    if (!carouselElement) {
      return;
    }

    // Check if carousel is initialized
    if (carouselElement.carousel) {
      this.swiperInstance = carouselElement.carousel;
      this._initControls();
    } else {
      const checkInterval = setInterval(() => {
        if (carouselElement.carousel) {
          this.swiperInstance = carouselElement.carousel;
          this._initControls();
          clearInterval(checkInterval);
        }
      }, 100);
      setTimeout(() => {
        clearInterval(checkInterval);
      }, 5000);
    }
  }

  _initControls() {
    const pauseButton = this.querySelector(this.selectors.pauseButton);
    const pauseIcon = this.querySelector(this.selectors.pauseIcon);
    const playIcon = this.querySelector(this.selectors.playIcon);

    if (!this.swiperInstance || !pauseButton) {
      return;
    }

    // Toggle pause/play button click
    pauseButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (!this.swiperInstance || !this.swiperInstance.autoplay) {
        return;
      }

      if (this.isPaused) {
        // Resume autoplay
        this.swiperInstance.autoplay.start();
        this.isPaused = false;
        this._toggleIcons(pauseIcon, playIcon, false);
        pauseButton.setAttribute('aria-label', 'Pause Slide');
      } else {
        // Pause autoplay
        this.swiperInstance.autoplay.stop();
        this.isPaused = true;
        this._toggleIcons(pauseIcon, playIcon, true);
        pauseButton.setAttribute('aria-label', 'Resume Slide');
      }
    });
  }

  _toggleIcons(pauseIcon, playIcon, isPaused) {
    if (isPaused) {
      if (pauseIcon) pauseIcon.classList.add('hidden');
      if (playIcon) playIcon.classList.remove('hidden');
    } else {
      if (pauseIcon) pauseIcon.classList.remove('hidden');
      if (playIcon) playIcon.classList.add('hidden');
    }
  }
}

customElements.define("s-hero", Hero);
customElements.define("s-collection-grid", CollectionGrid);
customElements.define("s-collection-plp-carousel", CollectionPLPCarousel);
customElements.define("s-announcement-bar", AnnouncementBar);

// end of collection elements

customElements.define('s-product', ProductMain)
customElements.define('product-recommendations', ProductRecommendations);

/*================ Templates ================*/
class Account extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      addressCountrySelect: '[js-country-select]',
      editAddressModal: '[js-edit-address-modal]',
      editAddressOpen: '[js-edit-address]',
      editAddressForm: '[js-edit-address-form]',
      deleteAddressButton: '[js-delete-address]',
      ordersContainer: '[js-orders]',
      ordersPagination: '[js-next-page]',
      order: '[js-order]',
      accountLinks: '[js-account-link]',
      accordionContent: '#account-accordion-menu',
      accordionHeader: '[aria-controls="account-accordion-menu"]'
    }
  }

  connectedCallback() {
    this.countrySelects = this.querySelectorAll(this._selectors.addressCountrySelect);
    this.editAddressModal = this.querySelector(this._selectors.editAddressModal);
    this.openEditAddress = this.querySelectorAll(this._selectors.editAddressOpen);
    this.editAddressForms = this.querySelectorAll(this._selectors.editAddressForm);
    this.deleteAddressButtons = this.querySelectorAll(this._selectors.deleteAddressButton);
    this.ordersContainer = this.querySelector(this._selectors.ordersContainer);
    this.ordersPagination = this.querySelector(this._selectors.ordersPagination);
    this.accountLinks = this.querySelectorAll(this._selectors.accountLinks);

    this._setupCountries();
    this._setupEventListeners();
    this._setupScrollBehavior();
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    if (this.ordersPagination) {
      this.ordersPagination.addEventListener('click', this._addOrders);  
    }

    this.openEditAddress.forEach((button) => {
      button.addEventListener('click', this._handleOpenEditAddress);
    });

    this.deleteAddressButtons.forEach((button) => {
      button.addEventListener('click', this._handleDeleteAddress);
    })

    this.editAddressModal.addEventListener('close', this._handleCloseEditAddress);
  }

  _setupScrollBehavior() {
    this.accountLinks.forEach(link => {
      link.addEventListener('click', this._handleScroll);
    });
  }

  _handleScroll = (e) => {
    // Skip scroll behavior for logout link
    if (e.currentTarget.getAttribute('href') === '/account/logout') {
      return; // Let the default link behavior happen
    }
    
    e.preventDefault();
    const targetId = e.currentTarget.getAttribute('href');
    const targetSection = document.querySelector(targetId);
    
    if (targetSection) {
      // Check if we're on mobile
      const isMobile = window.innerWidth < 768; // tabletl breakpoint
      
      // Check if subscription sections exist (customer has subscription)
      const hasSubscription = document.querySelector('#subscription-section') !== null;
      
      // Use different offsets based on mobile and subscription status
      let headerOffset;
      if (isMobile) {
        headerOffset = hasSubscription ? 350 : 250;
      } else {
        headerOffset = hasSubscription ? 100 : 100;
      }
      
      const elementPosition = targetSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      // Use requestAnimationFrame for smoother scrolling
      requestAnimationFrame(() => {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });

      // Close the mobile accordion after clicking a link
      const accordionContent = document.getElementById('account-accordion-menu');
      if (accordionContent && accordionContent.getAttribute('aria-hidden') === 'false') {
        const accordionHeader = document.querySelector('[aria-controls="account-accordion-menu"]');
        if (accordionHeader) {
          accordionHeader.click();
        }
      }
    }
  }

  _addOrders = async () => {
    const url = this.ordersPagination.dataset.url;
    const parsedHTML = await this._getOrders(url);
    const newOrders = parsedHTML.querySelector(this._selectors.ordersContainer).innerHTML;
    const newPagination = parsedHTML.querySelector(this._selectors.ordersPagination);

    this.ordersContainer.insertAdjacentHTML('beforeend', newOrders)

    if (newPagination) {
      this.ordersPagination.dataset.url = newPagination.dataset.url;
    }else{
      this.ordersPagination.remove();
    }

    this.ordersContainer.connectedCallback();
  }

  _getOrders(url) {
    return fetch(url)
      .then(response => response.text())
      .then((text) => {
        const html = text;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        return parsedHTML;
      })
  }

  _handleOpenEditAddress = (e) => {
    e.stopPropagation();
    const formID = e.currentTarget.dataset.form;
    const editForm = document.querySelector('#address_form_'+ formID)
    editForm.classList.remove('hidden');
    this.editAddressModal.open();
    editForm.querySelector('[name="address[first_name]"]').focus();
  }

  _handleDeleteAddress = (e) => {
    const form = e.currentTarget.dataset.target;
    if (confirm('Are you sure you want to delete this address?')) {
      Shopify.postLink(form, {
        parameters: { _method: 'delete' },
      });
    }
  }

  _handleCloseEditAddress = (e) => {
    this.editAddressForms.forEach((form) => {
      form.classList.add('hidden')
    });
  }
}


customElements.define("s-account", Account);
